/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Cents: { input: any; output: any };
  Time: { input: any; output: any };
  UUID: { input: any; output: any };
};

export type ActorKind = 'ANY' | 'DEVICE' | 'USER';

export type ActorRoleBinding = {
  __typename?: 'ActorRoleBinding';
  role: Role;
  scope: Scope;
};

export type AdjustUserPointsInput = {
  /** Required justification; stored on the ledger line and shown in the audit trail. */
  note: Scalars['String']['input'];
  /** Signed. Negative values are allowed and the balance may go negative. */
  points: Scalars['Int']['input'];
  userId: Scalars['UUID']['input'];
};

/** Admin ticket row. Omits claimUrl / qrPayload / claim_token_hash on purpose. */
export type AdminTicket = {
  __typename?: 'AdminTicket';
  /** The block history, newest first. Empty when the ticket was never blocked. */
  blocks: Array<TicketBlock>;
  /** Who paid. Unchanged when the ticket is sent on. */
  buyerEmail?: Maybe<Scalars['String']['output']>;
  claim?: Maybe<TicketClaim>;
  claimedAt?: Maybe<Scalars['Time']['output']>;
  /** The person who will use the ticket: the buyer on their own ticket. Null on a spare nobody has been sent or has claimed yet. */
  claimerEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  /** The open block while `status` is `BLOCKED`, else null. */
  currentBlock?: Maybe<TicketBlock>;
  emailChanges: Array<TicketEmailChange>;
  entranceLogs: Array<EntranceLog>;
  /** The Stager barcode when the ticket was imported from Stager's history, else null. */
  externalCode?: Maybe<Scalars['String']['output']>;
  feePrice: Scalars['Float']['output'];
  holdExpiresAt?: Maybe<Scalars['Time']['output']>;
  /** `claimerEmail` when set, else `buyerEmail`. */
  holderEmail: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  kind: TicketKind;
  nightId: Scalars['UUID']['output'];
  /** So the grid can name the night without a second query. */
  nightTitle: Scalars['String']['output'];
  orderId?: Maybe<Scalars['UUID']['output']>;
  payments: Array<AdminTicketPayment>;
  purchasedAt?: Maybe<Scalars['Time']['output']>;
  recognitionDate: Scalars['String']['output'];
  refundedAt?: Maybe<Scalars['Time']['output']>;
  releasedAt?: Maybe<Scalars['Time']['output']>;
  /** How the ticket was sold (see `TicketSaleChannel`). Never changes after the sale. */
  saleChannel: TicketSaleChannel;
  stageId: Scalars['UUID']['output'];
  stageName: Scalars['String']['output'];
  status: TicketStatus;
  ticketPrice: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  /** Claim holder or the users row matching `holderEmail`, when one exists. */
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type AdminTicketConnection = {
  __typename?: 'AdminTicketConnection';
  nodes: Array<AdminTicket>;
  pageInfo: PageMeta;
};

/**
 * Payment on the ticket's order. Enough to link to `/payments/:id` without
 * requiring `payment:read` on the ticket grid itself.
 */
export type AdminTicketPayment = {
  __typename?: 'AdminTicketPayment';
  amount: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  paymentMethod: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AdyenDropInSession = {
  __typename?: 'AdyenDropInSession';
  amountCents: Scalars['Cents']['output'];
  clientKey: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /** `test` or `live`. */
  environment: Scalars['String']['output'];
  merchantAccount: Scalars['String']['output'];
  returnUrl: Scalars['String']['output'];
  sessionData: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type AgendaConnection = {
  __typename?: 'AgendaConnection';
  nodes: Array<AgendaEntry>;
  pageInfo: CursorPageInfo;
};

/**
 * One agenda row for the ExpoApp Home hero and Agenda tab. Wraps
 * `PublicNight` rather than `Night` so the customer surface cannot leak
 * an internal flag.
 */
export type AgendaEntry = {
  __typename?: 'AgendaEntry';
  /** True when this customer already holds at least one non-released ticket. */
  hasTicket: Scalars['Boolean']['output'];
  /** Set when a held/purchased ticket order is still awaiting its PSP result (4.3). */
  hasTicketAwaitingPayment: Scalars['Boolean']['output'];
  night: PublicNight;
  ticketCount: Scalars['Int']['output'];
};

/**
 * Authentication Method Reference — *how* the session was established, carried as
 * the `amr` JWT claim.
 *
 * Authorization (permissions) and authentication strength are separate concerns: a
 * permission flagged `requires_strong_auth` returns FORBIDDEN when `amr` is not
 * PASSKEY, however well-permissioned the caller is. See `internal/loyalty/README.md`
 * for which codes carry the flag.
 */
export type Amr = 'MAGIC_LINK' | 'PASSKEY';

export type AttachTicketOrderBuyerInput = {
  /** The buyer's own address. Every ticket on the order is pointed at it. */
  email: Scalars['String']['input'];
  /**
   * Marketing checkbox, default off. Checking it **is** consent (7.1) — no
   * double opt-in. Never pre-checked, never implied by receiving tickets.
   */
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Staff-only alternative to `token`; requires `ticket:manage` in the order's scope. */
  orderId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * The hand-off capability from the scanned QR. Omit it and pass `orderId`
   * instead to let a `ticket:manage` actor unblock a register whose buyer left.
   */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type AttachTicketOrderBuyerPayload = {
  __typename?: 'AttachTicketOrderBuyerPayload';
  /**
   * Signed order access token (90 days), the same shape `createTicketOrder`
   * returns. The www buyer page stores it in its session and redirects to the
   * checkout's paid claim flow.
   */
  accessToken: Scalars['String']['output'];
  /** The www checkout page of the order, `{WWW_PUBLIC_BASE_URL}/checkout?order_id={orderId}`, where the paid claim flow continues. */
  checkoutUrl: Scalars['String']['output'];
  email: Scalars['String']['output'];
  orderId: Scalars['UUID']['output'];
  /**
   * One entry per ticket, each with a freshly minted claim link (on the www
   * host) so the buyer's phone can open the claim form immediately. Nothing is
   * mailed at attach: the Manage & Claim mail follows from the claim reminder
   * sweep, ten minutes or more later.
   */
  tickets: Array<AttachedTicket>;
};

export type AttachedTicket = {
  __typename?: 'AttachedTicket';
  claimUrl: Scalars['String']['output'];
  nightTitle: Scalars['String']['output'];
  stageName: Scalars['String']['output'];
  ticketId: Scalars['UUID']['output'];
};

/**
 * How the ExpoApp should authenticate this email.
 *
 * The account's type (re-derived from ACL bindings, not a possibly-stale
 * `users.type` column) chooses the path — there is no staff self-declare toggle.
 */
export type AuthMethod =
  /** Customer (`type` is NULL). Magic link only. */
  | 'MAGIC_LINK'
  /** Admin (by type or by ACL bindings). Passkey only; magic link is refused. */
  | 'PASSKEY'
  /**
   * Employee / contractor. Passkey is primary on ExpoApp; magic link is allowed
   * when this device has none, after which the onboarding guard forces registration.
   */
  | 'PASSKEY_OR_MAGIC_LINK'
  /** No account (or an IMPORTED or PROVISIONAL row). Collect first name + T&C, then requestMagicLink. */
  | 'SIGNUP'
  /**
   * The account cannot obtain a session (BLOCKED or DELETED). One value for both
   * so the response does not leak which status.
   */
  | 'UNAVAILABLE';

/**
 * Public email-first login routing.
 *
 * Deliberately reveals whether an email is known and roughly what kind of account
 * it is (the same accepted enumeration oracle as `requestMagicLink`). It does
 * **not** return a name, status, scope, or passkey identifier.
 */
export type AuthMethodDiscovery = {
  __typename?: 'AuthMethodDiscovery';
  /**
   * True only for PASSKEY_OR_MAGIC_LINK when at least one passkey is registered
   * anywhere. False in every other case — including PASSKEY (admin) — so this
   * field never leaks credential existence outside the employee/contractor path.
   * An employee with hasPasskey=false has no passkey on any device and must use
   * the magic-link path, after which the onboarding guard (1.3) forces registration.
   */
  hasPasskey: Scalars['Boolean']['output'];
  method: AuthMethod;
  /**
   * True when this email already has marketing consent (`users.marketing_opt_in`
   * or `email_marketing_consents.opted_in`). ExpoApp must skip the 3.1 checkbox.
   * Does not return extra PII. Unknown emails with no consent row are false.
   */
  skipMarketingCheckbox: Scalars['Boolean']['output'];
};

/**
 * Result of a completed login ceremony.
 *
 * Mirrors what `POST /webauthn/login/verify` returns today, plus `amr` (1.5). It is
 * deliberately a separate type from `Session`: `Session` is the staff shape reached
 * through `refreshSession`, and adding a required `amr` to it would change a
 * contract React admin already depends on.
 */
export type AuthPayload = {
  __typename?: 'AuthPayload';
  accessToken: Scalars['String']['output'];
  /**
   * Null for customers — a customer JWT carries no `scope_id` (1.7). Non-null when
   * a staff or admin user logs in, since their token still embeds one active scope.
   */
  activeScope?: Maybe<Scope>;
  amr: Amr;
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type BlockTicketInput = {
  id: Scalars['UUID']['input'];
  /** Optional free text. A blank note is stored as no note. */
  note?: InputMaybe<Scalars['String']['input']>;
  reason: TicketBlockReason;
};

/**
 * The dateless template of a recurring night. Deliberately has **no `startsAt`** — it is not a dated night. Blueprints are not Customer.io objects and never appear on www or the
 * ExpoApp agenda.
 */
export type Blueprint = {
  __typename?: 'Blueprint';
  createdAt: Scalars['Time']['output'];
  /**
   * Default doors-close time of day, `HH:MM`. Required. When it is less than or
   * equal to `doorsOpen` the close is on the **next calendar day**
   * (e.g. `16:00` -> `04:00`).
   */
  doorsClose: Scalars['String']['output'];
  /**
   * Default doors-open **time of day**, Europe/Amsterdam, as `HH:MM`
   * (24-hour). Required. No date and no timezone offset. It is the default the
   * admin form prefills a new night's `doorsOpen` from (the night's own window is
   * what is saved: later edits here never rewrite it), and the reference the
   * template stages' entry-window defaults are checked against.
   *
   * Intentionally a plain `String` rather than a new scalar — the schema already
   * carries dates and times as `String` (`Order.createdAt`, `taxReport`
   * `recognitionDate`), and one more scalar would have to be taught to every
   * client for a field only React Admin writes.
   */
  doorsOpen: Scalars['String']['output'];
  /**
   * Shown on the website's Good to know and in the app; empty = "None, come as you are". The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 100 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  dresscode?: Maybe<Scalars['String']['output']>;
  /** Default events in night order (a time earlier than `doorsOpen` is after midnight and comes last). Copied onto each night made from this blueprint. */
  events: Array<BlueprintEvent>;
  id: Scalars['UUID']['output'];
  /** False hides the blueprint from pickers; existing nights are not rewritten. */
  isActive: Scalars['Boolean']['output'];
  minimumAge?: Maybe<Scalars['Int']['output']>;
  /** Number of nights that were snapshotted from this blueprint. */
  nightCount: Scalars['Int']['output'];
  requireTicket: Scalars['Boolean']['output'];
  /** Default stages, ordered by `sort`. Only meaningful when `requireTicket`. */
  stages: Array<BlueprintStage>;
  /**
   * Shown to the holder of a claimed ticket on the ticket e-mail, PDF, the www ticket pages and the app. Never public, never before the claim. The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 1000 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  ticketText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type BlueprintConnection = {
  __typename?: 'BlueprintConnection';
  nodes: Array<Blueprint>;
  pageInfo: PageMeta;
};

/**
 * A default event on a Blueprint ("Karaoke Contest" 18:00-20:00). Times
 * are **times of day**, `HH:MM` Europe/Amsterdam, like `Blueprint.doorsOpen`. They are
 * projected onto each night's date when it is created from the blueprint: a time
 * earlier than the doors open is after midnight and belongs to the next calendar
 * day. A default event must fit the blueprint's doors window, bounds inclusive:
 * start >= doors open, start < doors close, end after start and end <= doors close.
 * Changing the blueprint's doors so that one falls outside is refused. Later edits never
 * rewrite nights already made from the blueprint.
 */
export type BlueprintEvent = {
  __typename?: 'BlueprintEvent';
  blueprintId: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** `HH:MM`; null shows only the start. */
  endTime?: Maybe<Scalars['String']['output']>;
  /** Display-only admission copy, e.g. Free till 12, after €5. Null when unset. */
  entrancePriceLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** At most one default event per blueprint offers tickets. */
  offersTickets: Scalars['Boolean']['output'];
  /** The poster image at the asked size; the original when the size has no variant. */
  posterUrl?: Maybe<Scalars['String']['output']>;
  /** `HH:MM` Europe/Amsterdam. */
  startTime: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/**
 * A default event on a Blueprint ("Karaoke Contest" 18:00-20:00). Times
 * are **times of day**, `HH:MM` Europe/Amsterdam, like `Blueprint.doorsOpen`. They are
 * projected onto each night's date when it is created from the blueprint: a time
 * earlier than the doors open is after midnight and belongs to the next calendar
 * day. A default event must fit the blueprint's doors window, bounds inclusive:
 * start >= doors open, start < doors close, end after start and end <= doors close.
 * Changing the blueprint's doors so that one falls outside is refused. Later edits never
 * rewrite nights already made from the blueprint.
 */
export type BlueprintEventPosterUrlArgs = {
  size?: InputMaybe<PosterSize>;
};

/**
 * The whole default event form: create and update both take it. `startTime` is
 * required, `endTime` optional (empty clears it), an omitted `offersTickets` is false.
 * `description`, `posterPath` and `entrancePriceLabel` are left alone when omitted on
 * update and cleared when blank. Refusals are `BAD_USER_INPUT`: outside the blueprint's
 * doors window (also an end that is not after the start), a malformed time, a second
 * default event that offers tickets.
 */
export type BlueprintEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  entrancePriceLabel?: InputMaybe<Scalars['String']['input']>;
  offersTickets?: InputMaybe<Scalars['Boolean']['input']>;
  /** From `createPosterUploadUrl`. */
  posterPath?: InputMaybe<Scalars['String']['input']>;
  /** Required `HH:MM` Europe/Amsterdam. */
  startTime: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BlueprintFilter = {
  createdAt?: InputMaybe<DateRangeInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  requireTicket?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BlueprintSort = {
  direction?: SortDirection;
  field: BlueprintSortField;
};

export type BlueprintSortField = 'CREATED_AT' | 'TITLE' | 'UPDATED_AT';

/**
 * A default stage on a Blueprint.
 *
 * There is deliberately **no `startsAt` / `endsAt` sale window here** (5.1): a sale
 * window is only meaningful relative to a date, and a Blueprint has no date. Sale
 * windows exist on `NightStage` only.
 */
export type BlueprintStage = {
  __typename?: 'BlueprintStage';
  /** Listed and buyable on ExpoApp public checkout. Independent of `websiteSale`. */
  appSale: Scalars['Boolean']['output'];
  blueprintId: Scalars['UUID']['output'];
  /** Available for door sale on iPad / Android POS (6.3). */
  door: Scalars['Boolean']['output'];
  /**
   * Entry window start as a time of day, `HH:MM` Europe/Amsterdam, projected on the
   * night's date at snapshot, against the night's doors window. Either
   * bound is optional; null = the night's doors open.
   */
  entryFrom?: Maybe<Scalars['String']['output']>;
  /** Entry window end as a time of day, `HH:MM` Europe/Amsterdam. Null = the night's doors close. */
  entryUntil?: Maybe<Scalars['String']['output']>;
  /** Booking fee per ticket (euros, admin). */
  feePrice: Scalars['Float']['output'];
  feePriceCents: Scalars['Cents']['output'];
  id: Scalars['UUID']['output'];
  /** False hides this template from snapshot copies; dated night stages stay. */
  isActive: Scalars['Boolean']['output'];
  /** `lateFeeCents` in euros (admin). */
  lateFee?: Maybe<Scalars['Float']['output']>;
  /** Fee for arriving after the entry window, copied onto the night stage at snapshot. Null = none set. */
  lateFeeCents?: Maybe<Scalars['Cents']['output']>;
  /**
   * Bought only through its own URL (`NightStage.linkUrl` on the dated stage); listed on no
   * other channel. Cannot be combined with website / app / pos / door.
   */
  linkSale: Scalars['Boolean']['output'];
  /** Optional max sold count. Null = uncapped. */
  maxAmount?: Maybe<Scalars['Int']['output']>;
  /**
   * DB flag only, set by the admin "Create member sale" flow — never a free-form
   * checkbox in the stage editor.
   */
  memberSale: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Listed and buyable on the iPad hamburger Tickets sale (6.3). Independent of website / app / door. */
  posSale: Scalars['Boolean']['output'];
  sort: Scalars['Int']['output'];
  /** Admission price (euros, admin). */
  ticketPrice: Scalars['Float']['output'];
  ticketPriceCents: Scalars['Cents']['output'];
  /** Listed and buyable on www public checkout. Independent of `appSale`. */
  websiteSale: Scalars['Boolean']['output'];
};

/**
 * Channel checkboxes (`websiteSale` / `appSale` / `posSale` / `door` / `linkSale`),
 * no tax fields. Two rules, both `BAD_USER_INPUT`: Link cannot be combined with other
 * channels; Website requires App. Stages carry **prices only** — the ticket tax rate is one
 * setting per scope (5.2, `scopeTicketSettings`).
 */
export type BlueprintStageInput = {
  appSale?: Scalars['Boolean']['input'];
  door?: Scalars['Boolean']['input'];
  /**
   * `HH:MM` Europe/Amsterdam, projected on the night date at snapshot against
   * the night's doors window; either bound optional. A malformed time is
   * `BAD_USER_INPUT`.
   */
  entryFrom?: InputMaybe<Scalars['String']['input']>;
  entryUntil?: InputMaybe<Scalars['String']['input']>;
  feePriceCents?: Scalars['Cents']['input'];
  isActive?: Scalars['Boolean']['input'];
  /** Fee for arriving after the entry window; >= 0. Required for the snapshot when the window ends before doors close. */
  lateFeeCents?: InputMaybe<Scalars['Cents']['input']>;
  /** Bought only through its own URL. Cannot be combined with the other channels. */
  linkSale?: Scalars['Boolean']['input'];
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  posSale?: Scalars['Boolean']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  ticketPriceCents: Scalars['Cents']['input'];
  websiteSale?: Scalars['Boolean']['input'];
};

export type BulkFailure = {
  __typename?: 'BulkFailure';
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

/** Outcome of a bulk mutation. */
export type BulkResult = {
  __typename?: 'BulkResult';
  failed: Array<BulkFailure>;
  succeeded: Array<Scalars['ID']['output']>;
};

/**
 * Vertical profile_business (1.1 / 7.2). Contractor Exact CRM fields live here.
 * `exactOnlineId` is Exact's Account GUID, written by SyncContractorToExact.
 */
export type BusinessProfile = {
  __typename?: 'BusinessProfile';
  chamberOfCommerce?: Maybe<Scalars['String']['output']>;
  exactOnlineId?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

/** Client supplies the order UUID (generated on-device). */
export type CalculateOrderInput = {
  discountId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  items: Array<OrderItemInput>;
  tabId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Scanned voucher (6.1). Max **one** per order, and it stacks with `discountId`.
   *
   * The id, not a code: the ExpoApp voucher QR encodes the voucher's static id
   * (2.3), so POS scans a UUID and there is no separate human-typed code to invent.
   *
   * A voucher is a **discount-trigger attribute**: POS and Android must take the
   * `calculateOrder` path and may not price a draft carrying one on-device
   * (`internal/ordering/README.md` §2). Clients never send money amounts — Go
   * resolves the voucher's value, checks that the scanning device's scope equals
   * the voucher's `scope_id`, and applies it.
   */
  voucherId?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * What a claim token resolves to, shown to the guest BEFORE anything is linked.
 *
 * 3.0 makes this a hard requirement, not UX polish: on iOS a deferred deep link is
 * resolved by probabilistic fingerprint matching, and many guests share one public
 * IP on FERRY Free WiFi on similar phones within minutes of each other — the
 * weakest possible case for that matching. A silent wrong link would hand one
 * guest's points to another, so the app must show the venue, amount and time
 * ("Link the card you paid EUR 12.50 with at 23:14?") and link only on explicit
 * confirmation. A deferred token is a hint, never an authorization.
 */
export type CardClaimPreview = {
  __typename?: 'CardClaimPreview';
  amountCents?: Maybe<Scalars['Cents']['output']>;
  cardBin?: Maybe<Scalars['String']['output']>;
  cardScheme?: Maybe<Scalars['String']['output']>;
  /** True when minted for the store-install path, which carries the extended TTL (3.0). */
  deferred: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  paidAt?: Maybe<Scalars['Time']['output']>;
  /** Set when valid is false; the app falls back to plain signup rather than a dead end. */
  rejection?: Maybe<CardClaimRejection>;
  /** Venue of the payment the token resolves to. This scope also decides which scope issues the first-card-linked voucher (2.3). */
  scope?: Maybe<ScopeRef>;
  valid: Scalars['Boolean']['output'];
};

export type CardClaimRejection =
  /** Account cannot hold a card (imported / provisional / blocked / deleted). Created (unverified) accounts may still confirm a terminal claim token (2.1). */
  | 'ACCOUNT_NOT_ACTIVE'
  /** Already consumed. Claim tokens are strictly single-use. */
  | 'ALREADY_USED'
  /** This card already belongs to someone else. A card links to at most one user (2.1). */
  | 'CARD_ALREADY_LINKED'
  /** The guest declined the confirmation; the token was invalidated immediately. */
  | 'DECLINED'
  | 'EXPIRED'
  | 'NOT_FOUND';

export type Category = {
  __typename?: 'Category';
  /** Deprecated alias kept for POS compatibility. */
  active: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  /**
   * When true, the POS renders one synthetic door-ticket button per eligible
   * door phase (inside the night doors window) instead of catalog products.
   */
  isDoor: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  products: Array<Product>;
  showInMenu: Scalars['Boolean']['output'];
  sort: Scalars['Int']['output'];
};

export type ChartBucket = 'FIVE_MIN' | 'TEN_MIN' | 'THIRTY_MIN' | 'TWO_MIN';

export type ChartPreset =
  | 'AVERAGE_TRANSACTION_VALUE'
  /**
   * Consumed door scans (valid + refused) per bucket, one series per sale stage
   * plus Door (door sales) and Golden ticket, last. Replays and other invalid
   * attempts do not count.
   */
  | 'ENTRANCE_SCANS'
  | 'SALES_PER_CATEGORY'
  | 'SALES_PER_DEVICE'
  | 'SALES_PER_PAYMENT_METHOD'
  | 'SALES_PER_PRODUCT'
  | 'TIPS'
  | 'TOTAL_SALES'
  | 'TRANSACTIONS_PER_DEVICE'
  | 'TRANSACTIONS_PER_PAYMENT_METHOD';

export type ChartSeries = {
  __typename?: 'ChartSeries';
  availableWindowEnd?: Maybe<Scalars['String']['output']>;
  availableWindowStart?: Maybe<Scalars['String']['output']>;
  bucket: ChartBucket;
  categories: Array<Scalars['String']['output']>;
  preset: ChartPreset;
  recognitionDate: Scalars['String']['output'];
  series: Array<ChartSeriesItem>;
};

export type ChartSeriesItem = {
  __typename?: 'ChartSeriesItem';
  data: Array<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

/**
 * Same claim fields as `claimTicket`, without an invite token. The caller's
 * verified email must match the entry.
 */
export type ClaimGuestListForCustomerInput = {
  /** Attestation checkbox: name matches original ID / has read the house rules. Must be true. */
  attested: Scalars['Boolean']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** `YYYY-MM-DD`. Claimants under **18** are rejected (6.6). */
  dateOfBirth: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** 3.1 checkbox. Claiming is not itself marketing consent. */
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['UUID']['input'];
};

/**
 * Deferred claim identity (6.6). When the caller is signed in, empty
 * `users.first_name` and `profile_personal` columns (last name, date of birth,
 * phone, city, country) are filled from these values. Existing profile values
 * are never overwritten. The ticket's holder is its `claimerEmail`; `email` names
 * it only on a copied or shared link that has none yet, and nothing here changes
 * the account e-mail.
 */
export type ClaimTicketInput = {
  /** Attestation checkbox: name matches original ID / has read the house rules. Must be true. */
  attested: Scalars['Boolean']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** `YYYY-MM-DD`. Claimants under **18** are rejected (6.6). */
  dateOfBirth: Scalars['String']['input'];
  /**
   * The claimer's e-mail: the address of the person who will use the ticket. Required
   * on a copied or shared link, i.e. when the ticket has no claimer yet
   * (`TicketClaimView.needsEmail`); it becomes the claimer and the door QR is mailed
   * there. It must be a bare address of at most 254 bytes. It is unverified, so the
   * marketing box typed with it records no consent. Refused on a link that already
   * names its claimer (mailed to someone, or the buyer's own ticket). A signed-in
   * claim uses the account's address instead. One address is the claimer of at
   * most one live (purchased or claimed) ticket per night.
   */
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /**
   * Manage-page capability (`m.…`, the token in `/tickets/manage/{token}`). With
   * `ticketId` it claims that ticket for the token's address, which must be the
   * ticket's holder (`claimerEmail`, else `buyerEmail`); any other address is
   * refused. The one-claim-per-night rule still applies. Rate-limited by IP.
   */
  manageToken?: InputMaybe<Scalars['String']['input']>;
  /** 3.1 checkbox. Claiming is not itself marketing consent. */
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Signed-in holder path. The caller must hold the ticket (their account address is
   * its claimer, else its buyer).
   * Same tickets as `myTickets`.
   */
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Email Manage & Claim capability. Omit it and pass `ticketId` when the signed-in
   * buyer claims from the Tickets tab, which carries no claim link. Supply one of `token` or `ticketId`.
   */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CompletenessStatus = 'ACTION_REQUIRED' | 'COMPLETE';

export type ConsumptionReport = {
  __typename?: 'ConsumptionReport';
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
  rows: Array<ConsumptionReportRow>;
};

export type ConsumptionReportProductLine = {
  __typename?: 'ConsumptionReportProductLine';
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  qtySold: Scalars['Int']['output'];
  unitAmount: Scalars['Float']['output'];
  unitsContributed: Scalars['Float']['output'];
};

export type ConsumptionReportRow = {
  __typename?: 'ConsumptionReportRow';
  consumptionName: Scalars['String']['output'];
  lines: Array<ConsumptionReportProductLine>;
  totalUnits: Scalars['Float']['output'];
  unitLabel: Scalars['String']['output'];
};

export type CreateBlueprintInput = {
  doorsClose: Scalars['String']['input'];
  /** Required `HH:MM` time of day, Europe/Amsterdam. A blank or malformed value is `BAD_USER_INPUT`. */
  doorsOpen: Scalars['String']['input'];
  /**
   * Shown on the website's Good to know and in the app; empty = "None, come as you are". The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 100 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  dresscode?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  requireTicket?: Scalars['Boolean']['input'];
  /**
   * Shown to the holder of a claimed ticket on the ticket e-mail, PDF, the www ticket pages and the app. Never public, never before the claim. The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 1000 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  ticketText?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateCategoryInput = {
  isActive?: Scalars['Boolean']['input'];
  isDoor?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  showInMenu?: Scalars['Boolean']['input'];
};

export type CreateDeviceInput = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  role: DeviceStatus;
  scopeId: Scalars['UUID']['input'];
};

export type CreateDiscountInput = {
  /** JSON-encoded configuration. */
  configuration: Scalars['String']['input'];
  isActive?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/**
 * POS door sale. One night, one `door` stage, a quantity within the caps.
 * Carries no money: the stage price is authoritative. Tickets are **held** until
 * PIN/cash succeeds; admission (`valid` entrance_log) is written at payment time.
 */
export type CreateDoorTicketOrderInput = {
  nightId: Scalars['UUID']['input'];
  /** `pin` or `cash` only — the existing terminal flow. No online Drop-in at the door. */
  paymentMethod: PaymentMethod;
  quantity: Scalars['Int']['input'];
  stageId: Scalars['UUID']['input'];
  /** Optional, when the walk-up is a known customer: makes the admission count toward their stats. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Reserves `quantity` tickets (uncapped: no night or stage limit applies) and
 * opens the hidden €0 Guest list stage on the first entry. The email is not marketing consent.
 */
export type CreateGuestListEntryInput = {
  email: Scalars['String']['input'];
  nightId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
};

export type CreateLinkInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/**
 * Creates one `member` stage on a night and mints its secret checkout URL.
 * The stage is excluded from every public listing regardless of `websiteSale` /
 * `appSale` / `posSale`.
 */
export type CreateMemberSaleInput = {
  /**
   * Admin-typed buyer address. This is **not** marketing consent (7.1) — it only
   * receives the member-sale invite, sent as a Customer.io transactional mail with
   * `send_to_unsubscribed`.
   */
  buyerEmail: Scalars['String']['input'];
  endsAt?: InputMaybe<Scalars['Time']['input']>;
  feePriceCents?: Scalars['Cents']['input'];
  /** Optional stage cap, on top of `maxQuantity`. */
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Hard cap on how many tickets this buyer may take. */
  maxQuantity: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  nightId: Scalars['UUID']['input'];
  startsAt?: InputMaybe<Scalars['Time']['input']>;
  ticketPriceCents: Scalars['Cents']['input'];
};

/**
 * Create a night either **from a Blueprint** (`blueprintId` set: title,
 * `requireTicket`, `minimumAge`, `ticketText`, `dresscode`, default stages and default
 * events are copied from the blueprint, the stages' entry windows and the
 * events' times projected onto the Europe/Amsterdam calendar date of `doorsOpen`
 * against this input's doors window; a time before `doorsOpen` lands on the next day.
 * If this input's doors exclude a default event, `createNight` is refused
 * with `BAD_USER_INPUT` (outside the doors window) and nothing is stored) or **empty**
 * (`blueprintId` null: every field comes from this input). The doors window is always
 * this input's: it is required, and the blueprint's time-of-day defaults only
 * prefill the admin form.
 *
 * Any field supplied here overrides the snapshotted value. Creating a ticketed
 * night with no copied stages seeds a `Regular` stage with `websiteSale` and
 * `appSale` both true (5.1 / 5.2). POS is opt-in (`posSale` defaults false).
 */
export type CreateNightInput = {
  blueprintId?: InputMaybe<Scalars['UUID']['input']>;
  doorsClose: Scalars['Time']['input'];
  /** Required. `doorsClose` must be after `doorsOpen`; a zero bound is `BAD_USER_INPUT` with `extensions.reason` `DOORS_WINDOW_REQUIRED`. */
  doorsOpen: Scalars['Time']['input'];
  /**
   * Shown on the website's Good to know and in the app; empty = "None, come as you are". The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 100 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  dresscode?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  /** Creating a night already published is refused (`BAD_USER_INPUT`): a new night is created unpublished, even from a Blueprint with default events. Use `publishNight`. */
  published?: Scalars['Boolean']['input'];
  requireTicket?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Shown to the holder of a claimed ticket on the ticket e-mail, PDF, the www ticket pages and the app. Never public, never before the claim. The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 1000 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  ticketText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePosTicketOrderInput = {
  /**
   * The phases the cashier pressed. No spill: a phase that cannot serve the whole
   * quantity is refused, never silently swapped. Lines may span nights; the
   * 6-ticket cap applies to each night's lines (6 per night, not per basket).
   * At most 60 lines per request, else `BAD_USER_INPUT` ("too many lines in one order").
   */
  lines: Array<PosTicketLineInput>;
  /** `pin` or `cash` only — never the online Drop-in. */
  paymentMethod: PaymentMethod;
};

export type CreateProductInput = {
  allowTable?: Scalars['Boolean']['input'];
  cashTrade?: Scalars['Boolean']['input'];
  consumptionName?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  isBottomBar?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  tax: Scalars['Float']['input'];
  unitAmount?: InputMaybe<Scalars['Float']['input']>;
  unitLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRefundInput = {
  amountCents: Scalars['Cents']['input'];
  id: Scalars['UUID']['input'];
  paymentId: Scalars['UUID']['input'];
  /** cash or pin — selected refund tender (PIN source payments may refund as cash). */
  paymentMethod: Scalars['String']['input'];
};

export type CreateRoleInput = {
  actorKind: ActorKind;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissionCodes: Array<Scalars['String']['input']>;
};

export type CreateTabInput = {
  discountId?: InputMaybe<Scalars['UUID']['input']>;
  /** Exact CRM Account GUID; required when isInvoice is true. */
  exactAccountId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  tableId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateTableInput = {
  isActive?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateTerminalInput = {
  isActive?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  poiid: Scalars['String']['input'];
};

/**
 * Carries **no money fields at all**, by design. Prices, fees, totals and tax come
 * from the night stage and the scope's ticket tax rate server-side.
 */
export type CreateTicketOrderInput = {
  /**
   * Required for public checkout (6.6 needs somewhere to send the manage/claim
   * mail). Omitted when an authenticated customer buys in ExpoApp, where the
   * account email is used.
   */
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  channel: SalesChannel;
  /**
   * One line per stage. The lines may span several nights of **one
   * venue**, which become one order and one payment. Mixing venues is rejected
   * (`BAD_USER_INPUT`). The 6-ticket cap is per night: 4 + 3
   * across two nights is fine, 4 + 3 on one night is not. A buyer who already
   * holds a ticket for any of the nights is refused the whole order. At most 60
   * lines per request, else `BAD_USER_INPUT` ("too many lines in one order").
   */
  lines: Array<TicketOrderLine>;
  /**
   * Link-sale checkout: every line must name this stage and it must be a link
   * stage; a link stage is never sold without it; cannot be combined with
   * memberSaleToken.
   */
  linkStageId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * The 3.1 marketing checkbox on the checkout email step. Default off; skipped by
   * the client when this email already has consent (7.1). Not required to buy.
   */
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Capability token from a member-sale secret URL. Required to buy a `member`
   * stage and rejected on any other stage.
   */
  memberSaleToken?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  allowedScopeIds: Array<Scalars['ID']['input']>;
  defaultPage?: InputMaybe<Scalars['String']['input']>;
  defaultScopeId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  /** Written to profile_personal. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Omit for a customer. Must agree with the ACL role bindings (1.1 invariant). */
  type?: InputMaybe<UserType>;
};

export type CreateVoucherRuleInput = {
  active?: Scalars['Boolean']['input'];
  /** Euros. Required for AMOUNT. */
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Whole percent. Required for PERCENTAGE. */
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  discountType: VoucherDiscountType;
  /** Customer copy (app tile, voucher mail, ticket voucher line). Max 80 characters; empty = no line. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Internal admin name and register chip. Max 80 characters. */
  name: Scalars['String']['input'];
  /** TICKET_CLAIMED: required. Needs ticket:read in the night's venue (also to switch the rule on or re-aim it). */
  nightId?: InputMaybe<Scalars['UUID']['input']>;
  /** Required for FREE_PRODUCT. */
  productId?: InputMaybe<Scalars['UUID']['input']>;
  /** TICKET_CLAIMED only (ticket mail and ticket QR screens). Max 200 characters; cleared for other triggers. */
  promotionLabel?: InputMaybe<Scalars['String']['input']>;
  /** TICKET_CLAIMED: subset of that night's active stages; empty or null = every stage. */
  stageIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Required when trigger is POINTS_THRESHOLD; rejected otherwise. */
  thresholdPoints?: InputMaybe<Scalars['Int']['input']>;
  trigger: VoucherRuleTrigger;
  /** TICKET_CLAIMED: YYYY-MM-DD, required for AFTER_CLAIM and AFTER_NIGHT, ignored (cleared) for NIGHT. */
  validUntil?: InputMaybe<Scalars['String']['input']>;
  validityDays?: Scalars['Int']['input'];
  /** TICKET_CLAIMED: required. */
  validityMode?: InputMaybe<VoucherValidityMode>;
};

/**
 * Cursor pagination metadata for the public, cross-scope agenda queries. The admin
 * grids use the offset-based `PageMeta` instead; the public feeds are keyed on
 * `startsAt` and paged forward only, so a cursor is both cheaper and stable while
 * admins keep publishing new nights.
 */
export type CursorPageInfo = {
  __typename?: 'CursorPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

/**
 * AVG/GDPR data export (1.6), inlined rather than served as a signed URL.
 *
 * `json` is the full document: profile, consent, points ledger, and the
 * `user_value_stats` atoms. Returning it inside the authenticated response keeps
 * the export behind `@isCustomer` — a capability URL like `ExportJob` would be a
 * second, weaker path to the same personal data.
 */
export type CustomerDataExport = {
  __typename?: 'CustomerDataExport';
  generatedAt: Scalars['Time']['output'];
  /** JSON-encoded export document. */
  json: Scalars['String']['output'];
};

export type CustomerIoTemplateInput = {
  kind: CustomerIoTemplateKind;
  templateName?: InputMaybe<Scalars['String']['input']>;
  /** Null clears the mapping, which returns that kind to fail-closed. */
  transactionalMessageId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Every Ferry mail kind that needs a Customer.io template. Sending a kind with no
 * mapped template **fails closed** — Ferry never posts an uncategorized body.
 */
export type CustomerIoTemplateKind =
  | 'CLAIM_LINK_REVOKED'
  | 'COMPANION_TICKETS'
  | 'CONTACT_GUEST'
  | 'CONTACT_STAFF'
  | 'GOLDEN_TICKET_ASSIGNED'
  | 'GUEST_LIST_INVITE'
  | 'MAGIC_LINK'
  | 'MEMBER_SALE_INVITE'
  | 'PAYMENT_FAILED'
  | 'RECEIPT'
  | 'TICKET_CLAIM_REMINDER_HOLDER'
  | 'TICKET_HANDED_OVER'
  | 'TICKET_MANAGE_CLAIM'
  | 'TICKET_QR'
  | 'VOUCHER'
  | 'VOUCHER_EXPIRY_REMINDER';

/**
 * One kind -> template mapping.
 *
 * The mapping is **global**, unlike the Exact mapping which is per scope: Ferry runs
 * one Customer.io workspace.
 */
export type CustomerIoTemplateMapping = {
  __typename?: 'CustomerIoTemplateMapping';
  configured: Scalars['Boolean']['output'];
  kind: CustomerIoTemplateKind;
  /** Template name captured when it was selected, so the UI needs no App API round trip. */
  templateName?: Maybe<Scalars['String']['output']>;
  /**
   * The integer `transactional_message_id` from Customer.io. Null when unmapped.
   * Never a hand-typed trigger name — a typo there fails silently at send time.
   */
  transactionalMessageId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  updatedByUserId?: Maybe<Scalars['UUID']['output']>;
};

/**
 * One option in the picker, from the Customer.io App API `GET /v1/transactional`.
 * Options show name **and** id; there are no hand-typed ids anywhere in this UI.
 */
export type CustomerIoTransactionalTemplate = {
  __typename?: 'CustomerIoTransactionalTemplate';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * Whether the template has "Send to unsubscribed" enabled. Every Ferry
   * transactional template must, since these mails are contractual, not marketing.
   */
  sendToUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** `draft` / `active` as reported by Customer.io, so the admin can avoid drafts. */
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * Customer-safe equivalent of `me`.
 *
 * `me` is `scope:read`-gated and returns the admin `User` graph (role bindings,
 * allowed scopes, passkeys), none of which a customer has or should see. This type
 * exposes only what the ExpoApp needs.
 */
export type CustomerMe = {
  __typename?: 'CustomerMe';
  city?: Maybe<Scalars['String']['output']>;
  /** Drives the onboarding gate and the 'You're n% you' homepage notice (4.1). */
  completeness: ProfileCompleteness;
  country?: Maybe<Scalars['String']['output']>;
  /** When the account was created (users.created_at). */
  createdAt: Scalars['Time']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** 4.2: date_of_birth is editable at most once per 365 days. Clients use this to disable the field. */
  dateOfBirthUpdatedAt?: Maybe<Scalars['Time']['output']>;
  email: Scalars['String']['output'];
  /** Non-null after a Customer.io bounce; drives the 'fix your email' banner in ExpoApp. */
  emailBouncedAt?: Maybe<Scalars['Time']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  marketingOptIn: Scalars['Boolean']['output'];
  marketingOptInAt?: Maybe<Scalars['Time']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Global points balance (2.2). */
  pointsBalance: Scalars['Int']['output'];
  /** Used verbatim in app UI and emails when set (4.2). */
  pronouns?: Maybe<Scalars['String']['output']>;
  pushOnRewardUnlock: Scalars['Boolean']['output'];
  status: UserStatus;
  /** Null for a customer. Non-null when staff use ExpoApp, which changes the auth rules that apply to them. */
  type?: Maybe<UserType>;
};

export type CustomerNightIntent =
  | 'NIGHT_CREATED'
  | 'NIGHT_DELETED'
  | 'NIGHT_GOING_ADDED'
  | 'NIGHT_GOING_REMOVED'
  | 'NIGHT_UPDATED'
  | 'TICKET_PURCHASED'
  | 'TICKET_REFUNDED'
  | 'TICKET_RELEASED';

export type CustomerNightUpdate = {
  __typename?: 'CustomerNightUpdate';
  intent: CustomerNightIntent;
  /**
   * Hydrated for the receiving customer (`isGoing` is theirs). Null when the
   * night is no longer public (unpublished, inactive, or deleted) — the app must
   * drop it from agenda / coming-up.
   */
  night?: Maybe<PublicNight>;
  nightId: Scalars['UUID']['output'];
};

export type CustomerReceipt = {
  __typename?: 'CustomerReceipt';
  amountCanceledCents: Scalars['Cents']['output'];
  amountDueCents: Scalars['Cents']['output'];
  amountPaidCents: Scalars['Cents']['output'];
  amountRefundedCents: Scalars['Cents']['output'];
  createdAt: Scalars['Time']['output'];
  grandTotalCents: Scalars['Cents']['output'];
  id: Scalars['UUID']['output'];
  items: Array<CustomerReceiptItem>;
  kind: Scalars['String']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  scope: CustomerReceiptScope;
};

export type CustomerReceiptItem = {
  __typename?: 'CustomerReceiptItem';
  description: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  taxAmountCents: Scalars['Cents']['output'];
  taxPercentage: Scalars['Float']['output'];
  totalCents: Scalars['Cents']['output'];
  unitPriceCents: Scalars['Cents']['output'];
};

export type CustomerReceiptScope = {
  __typename?: 'CustomerReceiptScope';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

/**
 * What the ExpoApp Tickets tab renders. Derived, not stored: it folds the PSP state
 * of the ticket's order into the ticket status so the app does not have to join the
 * two itself.
 */
export type CustomerTicketState =
  /** The venue pulled this ticket back. No QR; the guest should contact the venue. */
  | 'BLOCKED'
  /** Claimed: QR available. */
  | 'CLAIMED'
  | 'REFUNDED'
  /** Hold expired or payment failed. */
  | 'RELEASED'
  /** Paid, claim fields not yet set. No QR yet. */
  | 'UNCLAIMED'
  /** Order placed, PSP still pending. Companion send is blocked until paid (6.6). */
  | 'WAITING_FOR_PAYMENT';

/**
 * One arm set per event. ExpoApp opens this field and nothing else.
 *
 * Cannot be an arm of `liveUpdated` (AGENTS.md §15.3):
 *
 *   1. `liveUpdated` takes a required `scopeId` that must match the JWT active
 *      scope. A customer JWT carries no scope (1.7); this stream is keyed on
 *      `users.id`. Catalog arms (night, rewards) fan out to every connected
 *      customer because the app is cross-scope.
 *   2. `liveUpdated` is gated on `pos:operate` / `scope:read`.
 *
 * Must not register device presence (presence is refcounted per live stream).
 */
export type CustomerUpdatePayload = {
  __typename?: 'CustomerUpdatePayload';
  /** Points balance (and the rest of the caller) after `points_awarded` / `points_adjusted`. */
  me?: Maybe<CustomerMe>;
  /** A public night changed: copy, going count, or remaining / sold-out stages. */
  night?: Maybe<CustomerNightUpdate>;
  /**
   * Global customer-realtime availability after any recognition day starts or
   * ends. False is the final payload before the server completes this stream.
   */
  realtimeAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Next-up reward tiles after a voucher rule is created, edited, or toggled, or after points move. */
  rewards?: Maybe<Array<RewardProgress>>;
  /** Door-scan waiting / ENJOY / refuse (6.7). */
  ticketScan?: Maybe<TicketScanEvent>;
  /** Voucher issued / reserved / redeemed / released / expired / revoked (6.2). */
  voucher?: Maybe<VoucherEvent>;
};

/** Half-open date range; either bound may be null. */
export type DateRangeInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  /**
   * Always true on success. Delete sets status DELETED, anonymizes loyalty ledger
   * rows, unlinks/anonymizes cards, and zeroes `user_value_stats`. Financial
   * payment and order records are deliberately NOT deleted (1.6 / 7.5).
   *
   * Customer.io suppression runs through the outbox, so a CIO outage can never
   * block or fail the delete.
   */
  deleted: Scalars['Boolean']['output'];
};

export type Device = {
  __typename?: 'Device';
  activeOrder?: Maybe<Order>;
  /** Standalone order locked on this register (e.g. partial_paid until fully paid). */
  activeOrderId?: Maybe<Scalars['UUID']['output']>;
  activePayment?: Maybe<Payment>;
  /** In-flight payment on this register (legacy Device.payment). */
  activePaymentId?: Maybe<Scalars['UUID']['output']>;
  activeRefund?: Maybe<Refund>;
  activeRefundId?: Maybe<Scalars['UUID']['output']>;
  allowCashPayments: Scalars['Boolean']['output'];
  /** When false, POS must pin the register to the device default category (no category switch or product search). */
  allowCategorySwitch: Scalars['Boolean']['output'];
  allowedActions: Array<DeviceAction>;
  /**
   * Terminal loyalty flow (2.1). When false, PIN uses today's direct
   * PaymentRequest and no loyalty screen is ever shown. When true, the payment is
   * wrapped in an Adyen Terminal API Admin session (WaitingScreen) and a
   * DisplayRequest follows on success — thank-you + points for a linked card, or a
   * single-use registration QR for an unlinked one.
   *
   * A plain boolean rather than a nested settings type like gratuity: there is
   * nothing per-device to tune here, only whether the session path runs.
   *
   * Included in the device SSE payload so a register picks the change up live.
   */
  askLoyalty: Scalars['Boolean']['output'];
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['UUID']['output']>;
  connectionStatus: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  gratuitySettings: DeviceGratuitySettings;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
  /** ACL role bindings for this device in its scope. */
  roleBindings: Array<ActorRoleBinding>;
  status: DeviceStatus;
  terminal?: Maybe<Terminal>;
  terminalId?: Maybe<Scalars['UUID']['output']>;
};

export type DeviceAction =
  | 'APPROVE_AS_CHECKOUT'
  | 'DENY'
  | 'RESET_DEVICE'
  | 'SET_ACTIVE'
  | 'SET_ASK_GRATUITY_OFF'
  | 'SET_ASK_GRATUITY_ON'
  | 'SET_ASK_LOYALTY_OFF'
  | 'SET_ASK_LOYALTY_ON'
  | 'SET_INACTIVE';

export type DeviceConnection = {
  __typename?: 'DeviceConnection';
  nodes: Array<Device>;
  pageInfo: PageMeta;
};

/** Returned by claimDevice (public). Contains the bearer credential. */
export type DeviceCredential = {
  __typename?: 'DeviceCredential';
  device: Device;
  deviceId: Scalars['UUID']['output'];
  secret: Scalars['String']['output'];
};

export type DeviceEventIntent =
  'DEVICE_PROFILE_UPDATED' | 'DEVICE_SESSION_RESET';

export type DeviceEventPayload = {
  __typename?: 'DeviceEventPayload';
  device: Device;
  intent: DeviceEventIntent;
};

export type DeviceFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  connection?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<DeviceStatus>>;
  terminalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeviceGratuitySettings = {
  __typename?: 'DeviceGratuitySettings';
  allowCustomTip: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  minimumAmountCents: Scalars['Cents']['output'];
  roundToHalf: Scalars['Boolean']['output'];
  tipPercent1: Scalars['Float']['output'];
  tipPercent2: Scalars['Float']['output'];
  tipPercent3: Scalars['Float']['output'];
};

export type DeviceGratuitySettingsInput = {
  allowCustomTip?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimumAmountCents?: InputMaybe<Scalars['Cents']['input']>;
  roundToHalf?: InputMaybe<Scalars['Boolean']['input']>;
  tipPercent1?: InputMaybe<Scalars['Float']['input']>;
  tipPercent2?: InputMaybe<Scalars['Float']['input']>;
  tipPercent3?: InputMaybe<Scalars['Float']['input']>;
};

/** Returned by createDevice/regenerateDevicePairingCode (admin). */
export type DevicePairing = {
  __typename?: 'DevicePairing';
  device: Device;
  expiresAt: Scalars['Time']['output'];
  pairingCode: Scalars['String']['output'];
};

export type DeviceStatus = 'CANCELED' | 'CHECKOUT' | 'REQUESTING';

export type Discount = {
  __typename?: 'Discount';
  /** Deprecated alias kept for POS compatibility. */
  active: Scalars['Boolean']['output'];
  /** JSON-encoded configuration, e.g. {"percentage":10} or {"amount":5.00}. */
  configuration: Scalars['String']['output'];
  /** Typed enum for POS. */
  discountType: DiscountType;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Approximate discount total over last 30 days (euros). */
  totalDiscount30d: Scalars['Float']['output'];
  /** String type (percentage | fixed_amount). */
  type: Scalars['String']['output'];
  /** Number of uses over last 30 days. */
  usageCount30d: Scalars['Int']['output'];
  /** Value in basis points (percentage) or cents (fixed_amount), for POS. */
  value: Scalars['Cents']['output'];
};

export type DiscountConnection = {
  __typename?: 'DiscountConnection';
  nodes: Array<Discount>;
  pageInfo: PageMeta;
};

export type DiscountFilter = {
  createdAt?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DiscountType = 'FIXED_AMOUNT' | 'PERCENTAGE';

/** Describes a discount type available for selection in the UI. */
export type DiscountTypeSpec = {
  __typename?: 'DiscountTypeSpec';
  label: Scalars['String']['output'];
  /** JSON-encoded JSON Schema of the configuration fields. */
  schema: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**
 * One synthetic button inside an `is_door` category: one eligible door *phase*,
 * not one night. Label is `{night title} - {phase name}`.
 */
export type DoorTicketButton = {
  __typename?: 'DoorTicketButton';
  /** End of the entry window (exclusive). Null = the night's doors close. */
  entryEndsAt?: Maybe<Scalars['Time']['output']>;
  /** When this stage's ticket admits (instant). Null = the night's doors open. */
  entryStartsAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Guest-facing wording of the entry window, Europe/Amsterdam. Null when the stage
   * has no entry window. Start equal to doors open: `Entry before HH:MM`. End equal
   * to doors close: `Entry after HH:MM`. Otherwise `Entry HH:MM–HH:MM` (en dash).
   */
  entryWindowLabel?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  nightId: Scalars['UUID']['output'];
  /** @deprecated Released iPad and Android builds only; use nightId. Removed with the R2e builds, see DEPRECATIONS.md#graphql-production-names */
  productionId: Scalars['UUID']['output'];
  /**
   * Tickets still sellable for this phase, and the client-side quantity cap
   * when a cap exists. Null when the stage `maxAmount` is not set — the 6-tickets-per-night cap is separate and is
   * not reported here. `0` means sold out: the phase is still returned so the
   * POS can show a disabled button rather than dropping it mid-shift.
   */
  remaining?: Maybe<Scalars['Int']['output']>;
  stageId: Scalars['UUID']['output'];
  /** Phase ticket price plus the fee, as one product-button price. */
  unitPriceCents: Scalars['Cents']['output'];
};

/**
 * A door ticket held at the register and not yet on an order. Hand `ticketId` to
 * `placeOrder` (`doorTicketIds`) to sell it, or to `releaseDoorTicket` to let it go.
 * The hold lapses at `holdExpiresAt` and the stock goes back on sale. Prices are
 * read from the stage; the client adds them to its basket locally.
 */
export type DoorTicketHold = {
  __typename?: 'DoorTicketHold';
  feePriceCents: Scalars['Cents']['output'];
  holdExpiresAt: Scalars['Time']['output'];
  nightId: Scalars['UUID']['output'];
  /** The line name, `{stage} ticket {night} {DD-MM}`. */
  productName: Scalars['String']['output'];
  /** @deprecated Released iPad and Android builds only; use nightId. Removed with the R2e builds, see DEPRECATIONS.md#graphql-production-names */
  productionId: Scalars['UUID']['output'];
  stageId: Scalars['UUID']['output'];
  ticketId: Scalars['UUID']['output'];
  ticketPriceCents: Scalars['Cents']['output'];
  /** ticketPriceCents + feePriceCents: what the line will charge. */
  totalCents: Scalars['Cents']['output'];
};

export type DoorTicketOrderPayload = {
  __typename?: 'DoorTicketOrderPayload';
  order: Order;
  payment?: Maybe<Payment>;
  tickets: Array<Ticket>;
};

/**
 * The DNS verdict on a typed address (`checkEmailAddress`): can its domain receive
 * mail at all. Facts about the domain only, nothing about the mailbox or whether an
 * account exists for it.
 */
export type EmailAddressCheck = {
  __typename?: 'EmailAddressCheck';
  /**
   * False only on a clear answer: the domain does not exist or publishes a null
   * MX in DNS, or it sits under a reserved suffix (`.internal`, `.local`,
   * `.localhost`, `.lan`, `.home.arpa`, `.test`, `.example`, `.invalid`), which is
   * refused without a lookup unless the server allowlists it. A timeout or any
   * other lookup trouble answers true (fail open), as does an unconfigured server.
   */
  deliverable: Scalars['Boolean']['output'];
  /**
   * The whole corrected address when the domain looks like a typo of a well-known
   * one (`name@gmail.con` -> `name@gmail.com`). Can be set while `deliverable` is
   * true (a registered look-alike domain); null when there is nothing to suggest.
   */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type EmailReceiptInput = {
  email: Scalars['String']['input'];
  marketingOptIn: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type EmailReceiptPayload = {
  __typename?: 'EmailReceiptPayload';
  sent: Scalars['Boolean']['output'];
};

export type EntranceDecision =
  /** Let in. Inserts `result = valid` and enqueues a user_value_stats recompute when a user resolves. */
  | 'ACCEPTED'
  /**
   * Turned away. Inserts `result = refused`, which **uses up the ticket** exactly
   * as Accepted does — it cannot be scanned again. It is **not** a visit (2.4) and
   * fires no `Ticket Scanned` event (7.1).
   */
  | 'REFUSED';

/**
 * Door insights of one night: how many tickets were sold per stage and how
 * many of them reached the door.
 *
 * Rows follow the stage order. A stage is listed when it has a sold or scanned
 * non-door ticket, or when it is active and sold through at least one non-door
 * channel (website, app, POS, member, guest list). A stage that is only a door
 * stage has no row of its own: its sales are in the Door row. Stage rows count
 * only tickets scanned with a QR, never door tickets. The Door row follows the
 * stages and the Golden ticket row is always last; both are present even at 0/0.
 * `total` sums every row.
 */
export type EntranceInsights = {
  __typename?: 'EntranceInsights';
  nightId: Scalars['UUID']['output'];
  nightTitle: Scalars['String']['output'];
  /** @deprecated Released iPad and Android builds only; use nightId. Removed with the R2e builds, see DEPRECATIONS.md#graphql-production-names */
  productionId: Scalars['UUID']['output'];
  /** @deprecated Released iPad and Android builds only; use nightTitle. Removed with the R2e builds, see DEPRECATIONS.md#graphql-production-names */
  productionTitle: Scalars['String']['output'];
  rows: Array<EntranceInsightsRow>;
  total: EntranceInsightsRow;
};

/**
 * One line of the door insights.
 *
 * A stage row counts its own non-door tickets. The Door row (`stageId` null)
 * counts the door-sale tickets of the night as `sold` and their admissions
 * as scanned; a door sale is admitted at payment, so the two are equal unless a
 * sale is refunded afterwards (the admission stays, the sale does not). The Golden
 * ticket row (`stageId` null) counts every active golden pass as `sold`, and this
 * night's golden entrance rows as scanned. The `total` row has a null
 * `stageId` too.
 */
export type EntranceInsightsRow = {
  __typename?: 'EntranceInsightsRow';
  /** Accepted at the door (result `valid`). */
  admitted: Scalars['Int']['output'];
  /** What the row is; clients group on this, never on the label. */
  kind: EntranceInsightsRowKind;
  /** The stage name, `Door`, `Golden ticket`, or `Total`. */
  label: Scalars['String']['output'];
  /** Refused at the door. A refused ticket is used up. */
  refused: Scalars['Int']['output'];
  /** Entrance rows that used up an admission: `admitted` + `refused`. */
  scanned: Scalars['Int']['output'];
  /**
   * Tickets that are purchased or claimed. A hold (not yet paid) and a released
   * or refunded ticket are not sold.
   */
  sold: Scalars['Int']['output'];
  /** Null on the Door row, the Golden ticket row and the total. */
  stageId?: Maybe<Scalars['UUID']['output']>;
};

/** What an insights row is. */
export type EntranceInsightsRowKind =
  /** Door sales, after the stages. */
  | 'DOOR'
  /** Golden passes, after Door. */
  | 'GOLDEN'
  /** A sale stage (door tickets left out). */
  | 'STAGE'
  /** The sum of every row. */
  | 'TOTAL';

export type EntranceKind = 'CLAIMED' | 'DOOR' | 'GOLDEN';

export type EntranceKindCount = {
  __typename?: 'EntranceKindCount';
  admitted: Scalars['Int']['output'];
  kind: EntranceKind;
  refused: Scalars['Int']['output'];
};

/** One append-only `entrance_logs` row, as the React Admin reports render it. */
export type EntranceLog = {
  __typename?: 'EntranceLog';
  goldenTicketId?: Maybe<Scalars['UUID']['output']>;
  /** Claim name, golden holder name, or null for an anonymous door sale. */
  guestName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  kind: EntranceKind;
  nightId?: Maybe<Scalars['UUID']['output']>;
  nightTitle?: Maybe<Scalars['String']['output']>;
  /** Seconds outside the entry window at the scan; null when inside or unknown */
  outsideWindowSeconds?: Maybe<Scalars['Int']['output']>;
  recognitionDate?: Maybe<Scalars['String']['output']>;
  refuseNote?: Maybe<Scalars['String']['output']>;
  refuseReason?: Maybe<RefuseReason>;
  result: EntranceResult;
  scannedAt: Scalars['Time']['output'];
  /** Staff user or device name that scanned. Null for door-sale rows written at payment. */
  scannerName?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['UUID']['output']>;
};

export type EntranceLogConnection = {
  __typename?: 'EntranceLogConnection';
  nodes: Array<EntranceLog>;
  pageInfo: PageMeta;
};

export type EntranceLogFilter = {
  kind?: InputMaybe<Array<EntranceKind>>;
  nightIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  recognitionDate?: InputMaybe<DateRangeInput>;
  refuseReason?: InputMaybe<Array<RefuseReason>>;
  result?: InputMaybe<Array<EntranceResult>>;
  scannedAt?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EntranceLogSort = {
  direction?: SortDirection;
  field: EntranceLogSortField;
};

export type EntranceLogSortField =
  'GUEST_NAME' | 'KIND' | 'RESULT' | 'SCANNED_AT';

export type EntranceResult =
  | 'ALREADY_SCANNED'
  | 'BLOCKED'
  | 'DECRYPT_FAILED'
  | 'EXPIRED_QR'
  | 'NO_DOORS_WINDOW'
  | 'REFUSED'
  | 'VALID'
  | 'WRONG_NIGHT'
  | 'WRONG_PRODUCTION';

/** Simple counts for the per-night entrance list header. */
export type EntranceSummary = {
  __typename?: 'EntranceSummary';
  admitted: Scalars['Int']['output'];
  /** Duplicate-scan attempts; these consumed no admission slot. */
  alreadyScanned: Scalars['Int']['output'];
  byKind: Array<EntranceKindCount>;
  /** expired_qr + decrypt_failed + no_doors_window + wrong_night. */
  invalid: Scalars['Int']['output'];
  nightId: Scalars['UUID']['output'];
  refused: Scalars['Int']['output'];
};

export type ExactAccount = {
  __typename?: 'ExactAccount';
  code: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type ExactConfiguration = {
  __typename?: 'ExactConfiguration';
  connectedAt?: Maybe<Scalars['String']['output']>;
  /** True when EXACT_CLIENT_ID + EXACT_CLIENT_SECRET are set in the environment. */
  credentialsConfigured: Scalars['Boolean']['output'];
  /** Per-scope Exact division; null means Exact is disabled for this scope. */
  division?: Maybe<Scalars['Int']['output']>;
  /** Environment gate (EXACT_ENABLED). */
  enabled: Scalars['Boolean']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  mapping?: Maybe<ExactMapping>;
  /** True when this scope has a division selected. */
  scopeEnabled: Scalars['Boolean']['output'];
  /** Global OAuth status: disconnected | connected | error. */
  status: Scalars['String']['output'];
};

export type ExactDivision = {
  __typename?: 'ExactDivision';
  code: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type ExactGlAccount = {
  __typename?: 'ExactGLAccount';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type ExactItem = {
  __typename?: 'ExactItem';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type ExactJournal = {
  __typename?: 'ExactJournal';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type ExactJournalEntry = {
  __typename?: 'ExactJournalEntry';
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entryNumber?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  exactEntryId?: Maybe<Scalars['UUID']['output']>;
  financialPeriod: Scalars['Int']['output'];
  financialYear: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  journalCode: Scalars['String']['output'];
  lines: Array<ExactJournalEntryLine>;
  recognitionDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ExactJournalEntryConnection = {
  __typename?: 'ExactJournalEntryConnection';
  nodes: Array<ExactJournalEntry>;
  pageInfo: PageMeta;
};

export type ExactJournalEntryFilter = {
  recognitionDate?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ExactJournalEntryLine = {
  __typename?: 'ExactJournalEntryLine';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  glAccountCode: Scalars['String']['output'];
  glAccountDescription: Scalars['String']['output'];
  glAccountId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  vatAmount?: Maybe<Scalars['Float']['output']>;
  vatCode?: Maybe<Scalars['String']['output']>;
  vatPercentage?: Maybe<Scalars['Float']['output']>;
};

export type ExactJournalEntrySort = {
  direction?: SortDirection;
  field: ExactJournalEntrySortField;
};

export type ExactJournalEntrySortField =
  'CREATED_AT' | 'RECOGNITION_DATE' | 'STATUS';

export type ExactMapping = {
  __typename?: 'ExactMapping';
  adyenGlCode: Scalars['String']['output'];
  adyenGlDescription: Scalars['String']['output'];
  adyenGlId?: Maybe<Scalars['UUID']['output']>;
  bookingFeeGlCode: Scalars['String']['output'];
  bookingFeeGlDescription: Scalars['String']['output'];
  /**
   * Booking-fee revenue GL. Optional: when unset the fee books to the ticket GL,
   * since it is Ferry revenue at the same rate unless configured otherwise (5.2).
   */
  bookingFeeGlId?: Maybe<Scalars['UUID']['output']>;
  cashGlCode: Scalars['String']['output'];
  cashGlDescription: Scalars['String']['output'];
  cashGlId?: Maybe<Scalars['UUID']['output']>;
  entryDescription: Scalars['String']['output'];
  itemHighCode: Scalars['String']['output'];
  itemHighDescription: Scalars['String']['output'];
  itemHighId?: Maybe<Scalars['UUID']['output']>;
  itemLowCode: Scalars['String']['output'];
  itemLowDescription: Scalars['String']['output'];
  itemLowId?: Maybe<Scalars['UUID']['output']>;
  journalCode: Scalars['String']['output'];
  paypalGlCode: Scalars['String']['output'];
  paypalGlDescription: Scalars['String']['output'];
  /**
   * PayPal payment bucket, mirroring `adyenGl*` / `cashGl*`. Required before PayPal
   * checkout ships — unmapped PSP labels are not booked.
   *
   * Online **Adyen** needs no bucket of its own: it reuses `psp = 'adyen'` and
   * therefore `adyenGl*` (6.3).
   */
  paypalGlId?: Maybe<Scalars['UUID']['output']>;
  revenueHighGlCode: Scalars['String']['output'];
  revenueHighGlDescription: Scalars['String']['output'];
  revenueHighGlId?: Maybe<Scalars['UUID']['output']>;
  revenueLowGlCode: Scalars['String']['output'];
  revenueLowGlDescription: Scalars['String']['output'];
  revenueLowGlId?: Maybe<Scalars['UUID']['output']>;
  /** Sales journal for Open SalesInvoices (default 70). */
  salesJournalCode: Scalars['String']['output'];
  tabsGlCode: Scalars['String']['output'];
  tabsGlDescription: Scalars['String']['output'];
  /** Clearing GL for turnover recognized on a tab but not yet received. */
  tabsGlId?: Maybe<Scalars['UUID']['output']>;
  ticketGlCode: Scalars['String']['output'];
  ticketGlDescription: Scalars['String']['output'];
  /** Ticket revenue (admission) GL. */
  ticketGlId?: Maybe<Scalars['UUID']['output']>;
  ticketItemCode: Scalars['String']['output'];
  ticketItemDescription: Scalars['String']['output'];
  ticketItemId?: Maybe<Scalars['UUID']['output']>;
  ticketVatCode: Scalars['String']['output'];
  ticketVatPercentage?: Maybe<Scalars['Float']['output']>;
  tipsGlCode: Scalars['String']['output'];
  tipsGlDescription: Scalars['String']['output'];
  tipsGlId?: Maybe<Scalars['UUID']['output']>;
  vatCodeHigh: Scalars['String']['output'];
  vatCodeLow: Scalars['String']['output'];
  vatPercentageHigh: Scalars['Float']['output'];
  vatPercentageLow: Scalars['Float']['output'];
};

export type ExactSalesInvoice = {
  __typename?: 'ExactSalesInvoice';
  attachmentError?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  exactDocumentId?: Maybe<Scalars['UUID']['output']>;
  exactInvoiceId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  recognitionDate: Scalars['String']['output'];
  salesJournalCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tabId: Scalars['UUID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ExactVatCode = {
  __typename?: 'ExactVATCode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  percentage: Scalars['Float']['output'];
};

/** Short-lived signed URL for a streamed CSV export. */
export type ExportJob = {
  __typename?: 'ExportJob';
  expiresAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * Input widget the client should render for a missing field.
 *
 * Kept small on purpose: the ExpoApp gate maps these onto its own components, and
 * a richer type would turn this into a form-builder DSL nobody maintains.
 */
export type FieldKind =
  /** A yes/no the holder must tick (the terms): save it by sending `true` (`termsAccepted` -> `UpdateCustomerProfileInput.acceptedTerms`). */
  'CHECKBOX' | 'DATE' | 'PHONE' | 'SELECT' | 'TEXT';

/**
 * Admin-assigned **personal** pass. Not a per-night ticket, never claimed, and
 * not gated on "I'm going". At most one `ACTIVE` golden ticket per user; revoking
 * frees the slot so the same holder can be re-assigned later.
 */
export type GoldenTicket = {
  __typename?: 'GoldenTicket';
  /** Count of `valid` entrance logs for this pass. */
  admissionCount: Scalars['Int']['output'];
  assignedAt: Scalars['Time']['output'];
  assignedByUserId?: Maybe<Scalars['UUID']['output']>;
  holderEmail?: Maybe<Scalars['String']['output']>;
  /** Holder name / email for the admin grid. */
  holderName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /**
   * False while the holder is missing a required profile field (last name, date of
   * birth — 1.3). The ExpoApp QR sheet stays blocked behind the dynamic
   * required-info gate until this is true.
   */
  profileComplete: Scalars['Boolean']['output'];
  revokedAt?: Maybe<Scalars['Time']['output']>;
  revokedByUserId?: Maybe<Scalars['UUID']['output']>;
  status: GoldenTicketStatus;
  userId: Scalars['UUID']['output'];
};

export type GoldenTicketConnection = {
  __typename?: 'GoldenTicketConnection';
  nodes: Array<GoldenTicket>;
  pageInfo: PageMeta;
};

export type GoldenTicketFilter = {
  assignedAt?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<GoldenTicketStatus>>;
};

/**
 * The rotating QR payload.
 *
 * * `payload` is an **AES-GCM ciphertext** of `{ golden_ticket_id, generated_at }`,
 *   encrypted with a **server-only** key from env / Secret Manager. Authenticated
 *   encryption, not a hash: neither the guest nor a scanner can read or forge the
 *   ticket id, and Go decrypts it on scan.
 * * `generatedAt` is Go server time at mint; the scan compares against Go server
 *   time, never a client clock.
 * * **Scan TTL is 3 minutes.** A screenshot taken inside that window still scans
 *   until it ages out — accepted, and the reason `FLAG_SECURE` / iOS screenshot
 *   blocking is explicitly **not** used as the anti-share control.
 * * The app re-pulls every **2 minutes** while the sheet is open. Go runs no timer
 *   job that regenerates codes.
 * * This payload is **never emailed and never put in Wallet**. Claimed night
 *   tickets keep their static QR in email (Wallet buttons email-only).
 */
export type GoldenTicketQr = {
  __typename?: 'GoldenTicketQr';
  /** generatedAt + 3 minutes. */
  expiresAt: Scalars['Time']['output'];
  generatedAt: Scalars['Time']['output'];
  payload: Scalars['String']['output'];
  /** Client refresh interval in seconds (120). */
  refreshAfterSeconds: Scalars['Int']['output'];
};

export type GoldenTicketStatus = 'ACTIVE' | 'REVOKED';

/**
 * The guest-list entry. It carries no link: the invite mail's button is the
 * invitee's own manage page, minted for them when the mail is sent, and staff are
 * never shown the invite token (it would open that address's whole manage page).
 * `resendGuestListInvite` mails a fresh invite.
 */
export type GuestListEntryPayload = {
  __typename?: 'GuestListEntryPayload';
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  quantity: Scalars['Int']['output'];
};

/**
 * ExpoApp guest-list entry for the verified customer. The entry email is not
 * a field. A different address is simply absent from `myGuestLists`.
 */
export type GuestListForCustomer = {
  __typename?: 'GuestListForCustomer';
  doorsOpen: Scalars['Time']['output'];
  /** night_guest_lists.id. Two entries on one night stay distinct. */
  entryId: Scalars['UUID']['output'];
  nightTitle: Scalars['String']['output'];
  startsAt: Scalars['Time']['output'];
  tickets: Array<GuestListInviteTicket>;
  venueName: Scalars['String']['output'];
};

/** One reserved guest-list ticket, as `myGuestLists` lists it. */
export type GuestListInviteTicket = {
  __typename?: 'GuestListInviteTicket';
  /**
   * True while the claim-link mail to `sentTo` failed: the address is stored but nothing
   * arrived. The app offers `sendGuestListForCustomer` again (the same or a corrected
   * address), and a successful send clears it. Always false for an unsent or claimed ticket.
   */
  claimMailFailed: Scalars['Boolean']['output'];
  /**
   * Friend claim link, `{WWW}/tickets/claim/{token}`, opened from the sealed
   * token stored beside `claim_token_hash`. Empty when the ticket is unsent (the
   * invitee's own link to copy or share is on the manage page) or claimed.
   */
  claimUrl?: Maybe<Scalars['String']['output']>;
  claimed: Scalars['Boolean']['output'];
  /** End of the entry window (exclusive). Null = the night's doors close. */
  entryEndsAt?: Maybe<Scalars['Time']['output']>;
  /** When this stage's ticket admits (instant). Null = the night's doors open. */
  entryStartsAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Guest-facing wording of the entry window, Europe/Amsterdam. Null when the stage
   * has no entry window. Start equal to doors open: `Entry before HH:MM`. End equal
   * to doors close: `Entry after HH:MM`. Otherwise `Entry HH:MM–HH:MM` (en dash).
   */
  entryWindowLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** The address the ticket was sent to. Absent while unsent. */
  sentTo?: Maybe<Scalars['String']['output']>;
  /** True while the ticket has not been sent on to anyone else. Every seat has a claim token from the day the entry is made, so this is not about the token. */
  unsent: Scalars['Boolean']['output'];
};

/** One reserved guest-list ticket. Scanned is an entrance_logs result of valid or refused. */
export type GuestListTicket = {
  __typename?: 'GuestListTicket';
  claimed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  /** night_guest_lists.id, so a reload can resend this entry. */
  entryId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  scanned: Scalars['Boolean']['output'];
};

export type GuestListTicketSendInput = {
  email: Scalars['String']['input'];
  ticketId: Scalars['UUID']['input'];
};

/** Single bootstrap payload returned to a POS device on wake (Section 3). */
export type HydrationState = {
  __typename?: 'HydrationState';
  /** Active categories plus this device's pinned category. Product ids are preloaded. */
  categories: Array<Category>;
  device?: Maybe<Device>;
  /** All devices in the scope (for history register filter, peer awareness). */
  devices: Array<Device>;
  discounts: Array<Discount>;
  /** In-play bar orders for the current recognition day. */
  orders: Array<Order>;
  /**
   * Buyer hand-off this register still owes an email for (6.3), or null. Set on
   * a cold start so an app restart cannot dismiss the QR.
   */
  pendingTicketHandoff?: Maybe<TicketBuyerHandoff>;
  products: Array<Product>;
  scope: Scope;
  tables: Array<Table>;
  /** In-play tabs for the current recognition day. */
  tabs: Array<Tab>;
  terminals: Array<Terminal>;
};

/** POS/Android client log batch forwarded into Cloud Logging via ingestDeviceLogs. */
export type IngestDeviceLogsInput = {
  /** Optional app build / version string. */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** JSON array of log lines (ts, level, category, message, durationMs, attrs). */
  linesJson: Scalars['String']['input'];
  /** Client platform: ios | android. */
  platform: Scalars['String']['input'];
};

export type IngestDeviceLogsResult = {
  __typename?: 'IngestDeviceLogsResult';
  accepted: Scalars['Int']['output'];
  dropped: Scalars['Int']['output'];
};

export type IssueVoucherInput = {
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<VoucherDiscountType>;
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Customer copy of this voucher (app tile, voucher mail). Max 80 characters. When
   * issuing from a rule it wins over the rule's label; otherwise the rule's label is
   * copied.
   */
  label?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Recipient. Exactly one of userId / email is required. `email` covers issuing to
   * someone with no account yet; Go creates a provisional customer if needed (later
   * signup on that address claims the same row). Blocked / deleted accounts refuse.
   */
  userId?: InputMaybe<Scalars['UUID']['input']>;
  validityDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Copy the benefit from this rule. When omitted, the benefit fields below are
   * required. Note that issuing from a rule does NOT consume the rule's
   * once-per-user slot — an admin-issued voucher carries no rule link.
   */
  voucherRuleId?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Admin-minted ExpoApp magic link (`/magic-link/{token}`), the same URL Customer.io
 * puts in the email. Not emailed from this mutation — the caller copies it.
 * Customer, employee, and contractor only; admin accounts are refused.
 */
export type IssuedMagicLink = {
  __typename?: 'IssuedMagicLink';
  expiresAt: Scalars['String']['output'];
  qrSvg: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * A night's lead event (the one that offers tickets, else the earliest) as the ticket surfaces name it: the
 * title, start, poster and slug that a ticket page, My tickets, the claim page, the ticket PDF
 * and the mails show instead of the night's. Deliberately not `PublicEvent`: no id (a client cache never
 * merges it with the agenda's event, whose goingCount and isGoing it does not carry) and nothing per viewer.
 */
export type LeadEvent = {
  __typename?: 'LeadEvent';
  /** The poster image at the asked size; the original when the size has no variant. */
  posterUrl?: Maybe<Scalars['String']['output']>;
  /** The lead event's page: www serves it at /events/{slug}. */
  slug: Scalars['String']['output'];
  startsAt: Scalars['Time']['output'];
  title: Scalars['String']['output'];
};

/**
 * A night's lead event (the one that offers tickets, else the earliest) as the ticket surfaces name it: the
 * title, start, poster and slug that a ticket page, My tickets, the claim page, the ticket PDF
 * and the mails show instead of the night's. Deliberately not `PublicEvent`: no id (a client cache never
 * merges it with the agenda's event, whose goingCount and isGoing it does not carry) and nothing per viewer.
 */
export type LeadEventPosterUrlArgs = {
  size?: InputMaybe<PosterSize>;
};

export type LedgerEventIntent =
  'LEDGER_DELETED' | 'LEDGER_RECORDED' | 'LEDGER_UPDATED';

export type LedgerEventPayload = {
  __typename?: 'LedgerEventPayload';
  intent: LedgerEventIntent;
  timestamp: Scalars['Time']['output'];
  /** Null when the ledger row was deleted (LEDGER_DELETED). */
  transaction?: Maybe<LedgerTransaction>;
};

export type LedgerTaxLine = {
  __typename?: 'LedgerTaxLine';
  salesExcl: Scalars['Float']['output'];
  salesExclCents: Scalars['Cents']['output'];
  salesIncl: Scalars['Float']['output'];
  salesInclCents: Scalars['Cents']['output'];
  tax: Scalars['Float']['output'];
  taxCents: Scalars['Cents']['output'];
  taxPercentage: Scalars['Float']['output'];
};

export type LedgerTransaction = {
  __typename?: 'LedgerTransaction';
  amountCashTrade: Scalars['Float']['output'];
  amountCashTradeCents: Scalars['Cents']['output'];
  amountReceived: Scalars['Float']['output'];
  amountReceivedCents: Scalars['Cents']['output'];
  amountRecognizedTotal: Scalars['Float']['output'];
  amountRecognizedTotalCents: Scalars['Cents']['output'];
  amountTip: Scalars['Float']['output'];
  amountTipCents: Scalars['Cents']['output'];
  categoryId?: Maybe<Scalars['UUID']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deviceId?: Maybe<Scalars['UUID']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['UUID']['output']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['UUID']['output']>;
  paymentMethod: Scalars['String']['output'];
  psp?: Maybe<Scalars['String']['output']>;
  recognitionDate: Scalars['String']['output'];
  recognitionMinute: Scalars['Int']['output'];
  refund?: Maybe<Refund>;
  refundId?: Maybe<Scalars['UUID']['output']>;
  tab?: Maybe<Tab>;
  tabId?: Maybe<Scalars['UUID']['output']>;
  taxLines: Array<LedgerTaxLine>;
  transactionId: Scalars['String']['output'];
};

export type LedgerTransactionConnection = {
  __typename?: 'LedgerTransactionConnection';
  nodes: Array<LedgerTransaction>;
  pageInfo: PageMeta;
};

export type LedgerTransactionFilter = {
  /** Filters on amountReceived (money that moved), in euros. */
  amount?: InputMaybe<NumberRangeInput>;
  createdAt?: InputMaybe<DateRangeInput>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Array<Scalars['String']['input']>>;
  psp?: InputMaybe<Array<Scalars['String']['input']>>;
  recognitionDate?: InputMaybe<DateRangeInput>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tabId?: InputMaybe<Scalars['String']['input']>;
};

export type LedgerTransactionSort = {
  direction?: SortDirection;
  field: LedgerTransactionSortField;
};

export type LedgerTransactionSortField =
  | 'AMOUNT'
  | 'AMOUNT_TIP'
  | 'CATEGORY_NAME'
  | 'CREATED_AT'
  | 'DEVICE_NAME'
  | 'PAYMENT_METHOD'
  | 'RECOGNITION_DATE'
  | 'TRANSACTION_ID';

export type Link = {
  __typename?: 'Link';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type LinkCardPayload = {
  __typename?: 'LinkCardPayload';
  card?: Maybe<LinkedCard>;
  linked: Scalars['Boolean']['output'];
  /**
   * Points awarded for the last successful payment on this card while it was
   * unlinked (2.1). Zero when there was none — the ExpoApp welcome screen omits the
   * points line in that case rather than showing a hardcoded number.
   */
  pointsAwarded: Scalars['Int']['output'];
  /** Set when linked is false. */
  rejection?: Maybe<CardClaimRejection>;
  /** The first-card-linked voucher, when a rule in the payment's scope fired (2.3). */
  voucher?: Maybe<Voucher>;
};

/**
 * A guest's linked payment instrument, read-only and masked.
 *
 * Never exposes PAR, alias, or anything that could reconstruct a PAN — only what
 * 4.4's "read-only linked bank cards" list needs to render a row.
 */
export type LinkedCard = {
  __typename?: 'LinkedCard';
  /** Issuer prefix (BIN/IIN) only. */
  bin?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  linkedAt?: Maybe<Scalars['Time']['output']>;
  /** e.g. visa, mc, maestro. */
  scheme?: Maybe<Scalars['String']['output']>;
};

/** One arm set per event. Permission-filtered on the server per subscriber. */
export type LiveUpdatePayload = {
  __typename?: 'LiveUpdatePayload';
  category?: Maybe<Category>;
  device?: Maybe<DeviceEventPayload>;
  discount?: Maybe<Discount>;
  /**
   * Full replace of the POS `is_door` category buttons. Sent when a stage's
   * door flag, doors window, or remaining stock changes (including sold out).
   * An empty list means no eligible phases — the register must clear its tiles.
   */
  doorTicketButtons?: Maybe<Array<DoorTicketButton>>;
  /**
   * Full replace of the door insights of one night. Sent on every consumed
   * entrance row (Accepted and Refused), on every ticket status change of that
   * night, and when a golden pass is assigned or revoked while its doors
   * are open. Allowed for `entrance:read` or `ticket:scan`.
   */
  entranceInsights?: Maybe<EntranceInsights>;
  ledger?: Maybe<LedgerEventPayload>;
  order?: Maybe<OrderEventPayload>;
  orderCreated?: Maybe<Order>;
  payment?: Maybe<PaymentUpdatePayload>;
  product?: Maybe<Product>;
  recognitionDay?: Maybe<RecognitionDayEventPayload>;
  refund?: Maybe<RefundUpdatePayload>;
  tab?: Maybe<TabEventPayload>;
  table?: Maybe<Table>;
  terminal?: Maybe<TerminalEventPayload>;
  ticketHandoff?: Maybe<TicketHandoffEventPayload>;
};

export type LoyaltyLedgerConnection = {
  __typename?: 'LoyaltyLedgerConnection';
  nodes: Array<LoyaltyLedgerEntry>;
  pageInfo: CursorPageInfo;
};

/**
 * One append-only ledger line. Signed: refunds, threshold-voucher redeems, and
 * ticket-admission spends write negatives. Refunds may take the balance negative
 * (closed business rule). Redeeming a threshold voucher never goes negative — the
 * till fails closed. Paying a ticket with points also fails closed.
 */
export type LoyaltyLedgerEntry = {
  __typename?: 'LoyaltyLedgerEntry';
  createdAt: Scalars['Time']['output'];
  id: Scalars['UUID']['output'];
  /** Admin justification on manual adjustments. */
  note?: Maybe<Scalars['String']['output']>;
  /** Order behind the payment or refund, when stored. Informational — no FK. */
  orderId?: Maybe<Scalars['UUID']['output']>;
  /** PIN or ticket payment that earned this line, when there is one. */
  paymentId?: Maybe<Scalars['UUID']['output']>;
  points: Scalars['Int']['output'];
  reason: LoyaltyLedgerReason;
  /** Refund that wrote this negative line, when there is one. */
  refundId?: Maybe<Scalars['UUID']['output']>;
  /**
   * Scope of the payment behind this line, when there is one. Informational only:
   * the balance itself is global and is never grouped by scope (2.2).
   */
  scope?: Maybe<ScopeRef>;
};

/**
 * Why a ledger line exists. A label for the ExpoApp transaction list (4.4), not a
 * discriminator the balance depends on — the balance is always SUM(points).
 */
export type LoyaltyLedgerReason =
  /** Manual admin adjustment (requires strong auth). */
  | 'ADMIN_ADJUSTMENT'
  /** Earned on a PIN (card) payment. */
  | 'PAYMENT'
  /** Negative line written when a refund lands. */
  | 'REFUND'
  /** Earned on an online ticket payment. Admission only — the booking fee earns nothing. */
  | 'TICKET'
  /** Ticket admission paid with points in ExpoApp. The booking fee is still charged. */
  | 'TICKET_ADMISSION'
  /** Threshold voucher redeemed at the bar — debit of the snapshotted threshold. */
  | 'VOUCHER_REDEEM';

export type LoyaltySettings = {
  __typename?: 'LoyaltySettings';
  /** Points awarded for each whole spend step. Default 1. */
  pointsPerStep: Scalars['Int']['output'];
  /**
   * Qualifying spend (integer cents) that makes one earning step. Default 100
   * (€1.00). Combined with pointsPerStep this is the pair that replaced the old
   * points-per-euro ratio (loyalty.md 2.2, extended at the operator's request).
   */
  spendStepCents: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** Whose manage page `createManageTicketsLink` opens. */
export type ManageLinkFor =
  /** The address that paid for the ticket (`buyerEmail`). */
  | 'BUYER'
  /** The address the ticket was sent to (`claimerEmail`); the ticket must have been sent. */
  | 'CLAIMER';

/**
 * The manage page of one e-mail address (www `/tickets/manage/{token}`): every
 * ticket that address paid for or holds, for nights that have not ended.
 */
export type ManageTicketsView = {
  __typename?: 'ManageTicketsView';
  /** The address the link was minted for, lower-cased. */
  email: Scalars['String']['output'];
  /**
   * Tickets the address bought or holds, oldest first, narrowed to the address
   * exactly like `myTickets`: `claim` and `qrPayload` only on tickets it holds,
   * `buyerEmail` only on tickets it paid for, and never a friend's identity on a
   * ticket the buyer sent on. Includes tickets already used at the door (`usedAt`);
   * held and released tickets and nights that have ended are not listed.
   * `claimUrl` / `claimToken` are set on purchased tickets the address bought
   * (an unsent spare has them), never on a ticket it only holds.
   */
  tickets: Array<Ticket>;
};

/**
 * Public member-sale invite screen (5.2 / 6.3). Token is the capability.
 * Never includes the buyer email or the token hash.
 */
export type MemberSaleInvite = {
  __typename?: 'MemberSaleInvite';
  feePriceCents: Scalars['Cents']['output'];
  maxQuantity: Scalars['Int']['output'];
  night: PublicNight;
  stageName: Scalars['String']['output'];
  ticketPriceCents: Scalars['Cents']['output'];
};

export type MemberSalePayload = {
  __typename?: 'MemberSalePayload';
  buyerEmail: Scalars['String']['output'];
  /** False when the Customer.io send failed; the URL is still valid and re-sendable. */
  invited: Scalars['Boolean']['output'];
  maxQuantity: Scalars['Int']['output'];
  stage: NightStage;
  /**
   * The secret checkout URL, `{www}/events/{slug}/tickets/member/{token}` with the slug of the event
   * that offers tickets (refused while none does).
   * Returned **once**, at create time: only the SHA-256 of its token is stored, so
   * it can never be read back and a lost link must be re-minted.
   */
  url: Scalars['String']['output'];
};

/**
 * One field the caller still has to fill in.
 *
 * `name` is the stable machine key the client sends back in
 * `UpdateCustomerProfileInput`; `label` is display copy and may be reworded freely.
 */
export type MissingField = {
  __typename?: 'MissingField';
  kind: FieldKind;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Choices when kind is SELECT. */
  options?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Whether the required-info / onboarding gate blocks on this field.
   * Optional missing fields still appear in `missingFields` for the Home
   * completeness nudge; ExpoApp `/required-info` and React `/onboarding`
   * render only `required: true`.
   */
  required: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Manually add or remove points. Writes a ledger line with `created_by_user_id`
   * and no `payment_id`.
   *
   * Requires strong auth (`loyalty:adjust`): this is the only path that creates
   * balance with no payment behind it, and points convert into vouchers through
   * threshold rules.
   */
  adjustUserPoints: UserLoyalty;
  /** Assigns a golden ticket on the user. Rejected when that user already has an active one. */
  assignGoldenTicket: GoldenTicket;
  assignTerminal: Device;
  /**
   * Links a paid POS ticket order to the buyer's own address, scanned from the
   * register's QR. Stamps `buyer_email` on every ticket, mints the claim token
   * withheld at payment, and closes the hand-off so the register's QR
   * disappears. The Manage & Claim mail follows about ten minutes later, from the
   * claim reminder sweep, and only for a night that still has an unclaimed ticket.
   *
   * Public when called with `token` (the buyer's phone, signed in or not); a
   * `ticket:manage` actor may instead pass `orderId` to unblock a register whose
   * buyer walked away. Single use: the second submit fails.
   */
  attachTicketOrderBuyer: AttachTicketOrderBuyerPayload;
  /**
   * Pull a purchased or claimed ticket back (door tickets cannot be blocked). The
   * seat is for sale again; the ticket's QR, PDF and voucher stop working and a
   * door scan answers RED `BLOCKED` without using anything up. Nothing is refunded
   * and the guest is not mailed. Reversible with `unblockTicket`.
   */
  blockTicket: AdminTicket;
  /**
   * Block an account: status -> BLOCKED, and all refresh tokens are revoked (1.2).
   * Allowed from CREATED or ACTIVE.
   */
  blockUser: User;
  bulkPerformDeviceAction: BulkResult;
  bulkPerformOrderAction: BulkResult;
  bulkPerformTabAction: BulkResult;
  /** Stateless: prices and discounts an order without persisting it. */
  calculateOrder: Order;
  /** Cancels an in-flight payment. When retainOrder is true, the order stays pending/partial_paid so another payment can be attached (method switch). */
  cancelPayment: Payment;
  cancelRefund: Refund;
  /**
   * Re-points one ticket at a different companion address while it is unclaimed.
   *
   * **Revokes the previous claim link immediately**: a fresh random claim token is
   * minted and `claim_token_hash` is overwritten in the same transaction, so every
   * previously sent link is dead and is never revived by changing the address back.
   * Rejected once the ticket is already claimed, and for `kind = door`.
   *
   * Authorization is any of:
   *
   * * the order access token (anonymous www checkout)
   * * the calling customer whose email matches the buyer (ExpoApp)
   * * `manageToken`: the manage-page capability of the buyer's address (a
   *   claimer's manage token is refused). Rate-limited by IP.
   * * a staff actor with `ticket:manage` whose JWT scope equals the ticket's
   *   `scope_id`
   *
   * `@hasPermission` cannot sit on this field: www has no session, and a customer
   * JWT has no `ticket:manage` grant. The staff arm is enforced in the service
   * (permission + `WHERE scope_id`). Every successful change is appended to
   * `ticket_email_changes`.
   */
  changeCompanionEmail: Ticket;
  claimDevice: DeviceCredential;
  /**
   * Claims one guest-list ticket for the verified customer. Same identity rules as
   * `claimTicket` (name, date of birth, under 18, attestation, one claim per person
   * per night); enqueues the `ticket_qr` mail. A different email is not found.
   */
  claimGuestListForCustomer: TicketClaimView;
  /**
   * Sets the required claim fields on one ticket and moves it to `CLAIMED`.
   *
   * Rejects a date of birth under 18 (6.6) and an unchecked attestation. Tracks
   * Customer.io `Ticket Claimed`. Only after this does the QR exist: the claim mail
   * always includes it, Wallet buttons appear **in email only**, and ExpoApp gets a
   * deep link with no Wallet button.
   *
   * Identify the ticket with the email `token` **or** `ticketId` (the signed-in
   * holder: the account whose email is the ticket's claimer, else its buyer). Door
   * tickets cannot be claimed. A signed-in claim also fills empty profile fields
   * from the form (never overwrites). One address is the claimer of at
   * most one live (purchased or claimed) ticket per night: a claim whose claimer or
   * account already holds another live ticket that night is refused
   * (`ErrClaimerAlreadyHasTicket`). Every call is rate-limited per client
   * address and per claim link (token), and may return the rate-limit error.
   */
  claimTicket: TicketClaimView;
  /** Clears the device's active payment pointer (legacy new_order / reset_payment). */
  clearDevicePayment: Device;
  clearDeviceRefund: Device;
  completeExactAuthorization: ExactConfiguration;
  confirmCashPayment: Payment;
  confirmCashRefund: Refund;
  /**
   * Creating a ticketed Blueprint seeds a default stage named `Regular` (first `sort`,
   * `websiteSale` and `appSale` both true).
   */
  createBlueprint: Blueprint;
  createBlueprintEvent: BlueprintEvent;
  createBlueprintStage: BlueprintStage;
  createCategory: Category;
  createDevice: DevicePairing;
  createDiscount: Discount;
  /**
   * Door sale on iPad / Android POS (device principal). Pays PIN or Cash through
   * the existing terminal flow.
   *
   * Tickets are created `HELD` (kind door, no QR, no claim). On payment success
   * they become `PURCHASED` and Go writes one **`valid`** `entrance_logs` row per
   * ticket (`kind: door`, `scanned_at` = payment time). A declined PIN releases
   * the hold — it must not leave a ticket or a logged admission.
   */
  createDoorTicketOrder: DoorTicketOrderPayload;
  /** Reserves tickets on the hidden Guest list stage and mails the invitee. No link is returned. */
  createGuestListEntry: GuestListEntryPayload;
  createLink: Link;
  /**
   * Staff mint the **manage page link** of one ticket's buyer (`BUYER`, the address
   * that paid) or of the address it was sent to (`CLAIMER`, `claimerEmail`), to
   * open it from the admin ticket detail. The link is the 90-day bearer token the
   * ticket mails carry, returned to the caller only: nothing is stored. The
   * ticket must be in the caller's scope; another scope's ticket, an unknown
   * ticket, and an audience with no address on the ticket (`CLAIMER` on a ticket
   * that was never sent) are all `NOT_FOUND`. Logged with the actor and ticket,
   * never the token.
   */
  createManageTicketsLink: Scalars['String']['output'];
  /** Mints the secret checkout URL and emails the buyer. Returns the URL once. */
  createMemberSale: MemberSalePayload;
  createNight: Night;
  createNightEvent: NightEvent;
  createNightStage: NightStage;
  /** Creates a new pending payment on an existing unpaid order (pending or partial_paid). */
  createOrderPayment: Payment;
  createPasskeyRegistrationLink: PasskeyRegistration;
  /**
   * POS ticket sale. Holds exactly the phases the cashier pressed (no spill),
   * creates claimable tickets (`kind = pos`, `orders.channel = ticket`) and
   * pays PIN/cash. No `entrance_logs` — admission is the later QR scan.
   *
   * **No buyer email.** The claim token is deliberately withheld at payment
   * (and with it the Manage & Claim mail, which is a delayed reminder): on success Go opens a
   * `TicketBuyerHandoff` and the register shows a QR until the buyer submits
   * their own address through `attachTicketOrderBuyer`.
   */
  createPosTicketOrder: PosTicketOrderPayload;
  /**
   * Mints a short-lived GCS signed PUT URL so React Admin can upload a poster
   * (5.1 / 5.3). Persist the returned `posterPath` on create/update Blueprint or
   * Night. Fails with a configuration error when `GCS_POSTER_BUCKET` is
   * unset or the runtime cannot sign URLs (needs a service-account key or
   * `iam.serviceAccounts.signBlob` on Cloud Run).
   */
  createPosterUploadUrl: PosterUpload;
  createProduct: Product;
  createRefund: Refund;
  createRole: Role;
  createTab: Tab;
  /** Creates a new pending payment against an open tab (pin/cash). Does not write to the ledger. */
  createTabPayment: Payment;
  createTable: Table;
  createTerminal: Terminal;
  /**
   * Creates the Order, its `order_items` and its `tickets` in one transaction.
   *
   * Rules, all enforced server-side and all fail-closed:
   *
   * * **Max 6 tickets per night on an order** (ExpoApp and www hard-reject above 6 for one night).
   * * **Cheapest eligible stage first, with spill**: when a stage runs out
   *   mid-quantity the remainder moves to the next eligible stage by `sort` on that
   *   channel. One order may therefore mix stages.
   * * Remaining stock (the per-stage `maxAmount`; a night has no cap of its own) is computed
   *   under a **row lock on the night**, with holds counting as sold, in the
   *   same transaction as the spill — otherwise concurrent checkouts oversell.
   * * A stage not flagged for `channel` is **rejected**, not silently substituted.
   * * A requested stage outside its sale window (not started yet, or ended) is
   *   **rejected** on the website/app channel, not silently substituted. The price
   *   ladder may list such a band; listing it does not make it buyable. Member
   *   stages are reached by their token and are not subject to this check.
   * * A `member` stage without a matching `memberSaleToken` is rejected; with one,
   *   the quantity may not exceed that stage's `memberMaxQuantity`.
   * * Order `scope_id` is the **venue's** scope: the one scope shared by every
   *   night on the order (a line in another scope is rejected), and the ticket
   *   tax rate is that scope's rate (5.2). The sale is rejected while that scope has
   *   no rate configured.
   * * `orders.channel` is `ticket`, which keeps the order out of the POS
   *   active-order hydrate.
   * * Ticket orders do **not** require an open recognition day.
   */
  createTicketOrder: TicketOrderPayload;
  /**
   * Returns Drop-in session config or a PayPal order id for an unpaid ticket order.
   * Rejected once the hold has expired.
   *
   * `payWithPoints` is ExpoApp-only: a verified customer, `channel = ticket`,
   * online/member tickets. Debits snapshotted admission points for **the
   * cheapest ticket only** (a line discount, not a payment method). Extra tickets
   * and every booking fee stay due in euros (or the order settles with no payment
   * row when remaining is €0). Website omits the flag and still pays the grand total.
   */
  createTicketPaymentIntent: TicketPaymentIntent;
  createUser: User;
  createVoucherRule: VoucherRule;
  deleteBlueprintEvent: Scalars['Boolean']['output'];
  deleteLink: Scalars['ID']['output'];
  /** Self-service account deletion. Customers only — not for employees, contractors or admins (1.6). */
  deleteMyAccount: DeleteAccountPayload;
  deleteNightEvent: Scalars['Boolean']['output'];
  deleteRole: Scalars['UUID']['output'];
  disconnectExact: ExactConfiguration;
  /**
   * Public: the token is the capability, same model as `receiptByToken`. Symfony
   * posts this from the receipt page. Rate-limited by IP + email.
   */
  emailReceipt: EmailReceiptPayload;
  /** Closes the open recognition-day session and signals peers to hibernate. */
  endRecognitionDay: RecognitionDaySession;
  exportExactDay?: Maybe<ExactJournalEntry>;
  /** Retry Exact SalesInvoice export for one settled invoice tab. */
  exportExactInvoiceTab?: Maybe<ExactSalesInvoice>;
  /**
   * Hands a ticket to someone else's address, claimed or not. `email` is the new
   * holder; the returned ticket is narrowed to the caller like `myTickets`.
   *
   * **A purchased ticket** behaves exactly like `changeCompanionEmail` (fresh
   * claim link, old link dead, `claim_link_revoked` to a previous claimer,
   * `companion_tickets` to the new address), and may in addition be handed on by
   * its current holder's `manageToken`.
   *
   * **A claimed ticket** is un-claimed in the same transaction: status goes back
   * to `PURCHASED`, the holder's claim (name, date of birth, contact data) is
   * deleted, the claim link and door QR stop working, then the ticket is
   * re-pointed as above. Only its **holder** may do this: their `manageToken`
   * (the manage-page capability of the address the ticket is on) or the
   * signed-in customer with that address. The buyer's token, the order access
   * token and staff are refused with `FORBIDDEN` on a ticket someone else holds.
   * The previous holder, and the buyer too when that is another person, are told
   * with a `ticket_handed_over` mail (once each, no link, no new address).
   * Marketing consent and profile fields from the old claim are not reversed.
   *
   * Refused (`BAD_USER_INPUT`) for a door, held, released or refunded ticket, one
   * already scanned at the door, a night that has ended, and the address the
   * ticket is already on. Calls with a `manageToken` are rate-limited by IP.
   */
  handOverTicket: Ticket;
  /**
   * Hold one door ticket for 15 minutes (a tap on a door button). Writes a ticket
   * row and nothing else: no order and no order line. The stock is taken now, so a
   * basket left open cannot oversell; the per-night cap of 6 is checked when
   * `placeOrder` carries the ticket. Send `ticketId` in `PlaceOrderInput.doorTicketIds`
   * to sell it, or call `releaseDoorTicket` to let it go. Refused when the stage is
   * sold out, the night is inactive or its doors are closed.
   */
  holdDoorTicket: DoorTicketHold;
  /** Forward buffered POS/Android client log lines into Cloud Logging (device auth only). */
  ingestDeviceLogs: IngestDeviceLogsResult;
  /**
   * Mint a magic-link login URL for this user (same token as the email). Super-admin
   * only (`user:issue_magic_link`). Does not send Customer.io mail.
   */
  issueMagicLink: IssuedMagicLink;
  /** Issue a voucher by hand and email it (Customer.io transactional, send_to_unsubscribed). Always includes the QR. */
  issueVoucher: Voucher;
  /**
   * Link the card behind a claim token to the calling customer, or decline it.
   *
   * `confirm: false` records the decline and invalidates the token IMMEDIATELY
   * (3.0) — a mis-matched deferred token must not stay alive for the provider to
   * hand to the next guest.
   *
   * On confirm the token is consumed atomically, so a replay cannot double-link.
   * Linking binds the card and ALL its aliases to at most one user; linking an
   * already-linked card is rejected (a partner's card keeps the partner's points).
   */
  linkCardByClaimToken: LinkCardPayload;
  /**
   * Sign out: revoke the refresh token behind this session. The credential is the
   * refresh token itself (like refreshSession, so no access token is needed): pass
   * it as `refreshToken`, or omit it on web to use the `ferry_refresh` cookie, which
   * is cleared. `everywhere: true` also ends the user's other sessions (service
   * credentials are untouched). An unknown or already-revoked token fails with
   * BAD_USER_INPUT; clients should treat that as signed out.
   */
  logout: Scalars['Boolean']['output'];
  /**
   * Records that the unsent ticket's claim link was handed out (Copy link or Share on
   * the manage page): `Ticket.claimLinkShared` turns true. A seat with the mark is not
   * the invitee's to claim from the manage form (`claimTicket` refuses it), so a friend's
   * link is never killed by the invitee claiming "their" seat. Only a purchased ticket
   * with no claimer, not a door ticket, with a live claim link is marked; anything else
   * is refused (`CLAIM_NOT_ALLOWED`, `CLAIM_ALREADY_COMPLETE`, `TICKET_BLOCKED`).
   * Repeating is a no-op. Sending the ticket (`sendCompanionTickets`,
   * `changeCompanionEmail`, the guest-list send) clears the mark.
   *
   * Same auth as `changeCompanionEmail`: order access token, the calling customer, a
   * `manageToken` of the buyer's address, or staff with `ticket:manage` in the ticket's
   * scope. A staff-minted (scoped) `manageToken` is refused (`CLAIM_NOT_ALLOWED`): it only
   * previews the page. Rate-limited like the other hand-outs.
   */
  markClaimLinkShared: Ticket;
  /**
   * First tap inserts a `night_event_goings` row for the calling guest and this event; idempotent. Answers with
   * the event: its `goingCount` and the caller's `isGoing`. Customer.io links the guest to the NIGHT: the guest's
   * first going on a night tracks `I'm Going` and `add_relationships` (`source: going`) through the outbox; a
   * further event of the same night adds no second relationship. An event of an unpublished or inactive night
   * is not found.
   */
  markGoing: PublicEvent;
  performDeviceAction: Device;
  performOrderAction: Order;
  performTabAction: Tab;
  /** Persists the order as pending and starts payment via the outbox. */
  placeOrder: PlaceOrderResult;
  prepareReceipt: ReceiptPayload;
  /** Makes the night visible to `publicNights` and upserts the Symfony cache row (5.5). Refused (`BAD_USER_INPUT`) while the night has no event. */
  publishNight: Night;
  /**
   * Step 2: record the doorman's decision, which is the moment the ticket is used.
   *
   * Inserts exactly one `entrance_logs` row. Both decisions consume the admission
   * slot; a second decision on the same ticket (or the same golden pass at the same
   * night) is rejected by the unique partial index and reported as
   * `already_scanned`. Tracks Customer.io `Ticket Scanned` on **ACCEPTED** only.
   */
  recordEntranceDecision: EntranceLog;
  refreshSession: Session;
  regenerateDevicePairingCode: DevicePairing;
  /**
   * Release a door ticket held with `holdDoorTicket` that is on no order. Idempotent
   * on a ticket that is already released. Refused for a ticket that is on an order
   * (a placed ticket is released with its order), of another venue, or not a door
   * ticket.
   */
  releaseDoorTicket: Scalars['Boolean']['output'];
  /**
   * Staff release of one held ticket. Frees that ticket's stock and removes its
   * order line. Other tickets on the order stay. A payment already started is
   * not cancelled; a later success does not purchase this ticket.
   */
  releaseHeldTicket: AdminTicket;
  /**
   * Release a reservation: RESERVED -> ISSUED. Called when the order is canceled or
   * the payment fails. The guest tapping 'cancel' on the ExpoApp loading animation
   * does NOT release the reservation (2.3).
   */
  releaseVoucherReservation: Voucher;
  /** Cancels an order on a tab and detaches it. Only allowed when the tab is editable (open/partial_paid on the current recognition day). */
  removeOrderFromTab: Tab;
  reorder: Scalars['Boolean']['output'];
  /** Rewrites `sort` to the given order. Ids not belonging to the blueprint are rejected. */
  reorderBlueprintStages: Array<BlueprintStage>;
  reorderNightStages: Array<NightStage>;
  /** POS presence write (hibernate / disconnected). Device auth only. */
  reportDevicePresence: Device;
  /**
   * Send a magic link. Deliberately PUBLIC and unauthenticated — it is how a
   * customer logs in for the first time.
   *
   * Rate-limited by IP + email on the same fixed-window helper as `claimDevice`
   * (20/min/IP, 1.2). Unknown email creates the user with status CREATED and
   * returns a limited 24h session on `RequestMagicLinkPayload.session`. Any existing
   * account (CREATED, ACTIVE, and also an IMPORTED or PROVISIONAL row, which can hold
   * a guest's vouchers and tickets) is only sent the link and `session` stays null;
   * an IMPORTED or PROVISIONAL row is claimed when the link is verified, not by this call. Never
   * elevates or applies to an admin account: magic link stays disabled for type
   * ADMIN, checked at session issuance so a stale `type` cannot downgrade the
   * required method.
   */
  requestMagicLink: RequestMagicLinkPayload;
  /** Mails the invitee a fresh invite and replaces the stored invite token, so an old /tickets/guest-list/ link in a mailbox stops redirecting. A manage link that was already mailed keeps working until it expires (it cannot be revoked). Sold count does not change. */
  resendGuestListInvite: GuestListEntryPayload;
  /** Re-mints the token and re-sends the invite for an existing member stage. The previous URL stops working; the new one is returned once. */
  resendMemberSaleInvite: MemberSalePayload;
  /** Ends the assignment. Existing `entrance_logs` rows are untouched — admission already happened. */
  revokeGoldenTicket: GoldenTicket;
  /**
   * Permanently remove a WebAuthn credential. The passkeys row is deleted
   * (there is no revoked_at on that table). Login and user.passkeys omit it
   * afterwards. The mutation response stamps revokedAt to now.
   */
  revokePasskey: Passkey;
  /**
   * Revoke an ISSUED or RESERVED voucher. Requires strong auth: it destroys a
   * guest's reward and re-issuing mints a different voucher, so it is not
   * self-correcting.
   */
  revokeVoucher: Voucher;
  /** Upserts the given kinds; kinds not present in the input are left untouched. */
  saveCustomerIoTemplates: Array<CustomerIoTemplateMapping>;
  /** Set the Exact division for the active scope. Pass null to disable Exact for this scope. */
  saveExactDivision: ExactConfiguration;
  saveExactMapping: ExactConfiguration;
  /** Ticket / booking-fee GL and the PayPal bucket for the active scope (7.2). */
  saveExactTicketMapping: ExactMapping;
  /**
   * Set the earning pair: per spendStepCents of qualifying spend, award
   * pointsPerStep points. Only whole steps count; leftover spend is discarded.
   *
   * Gated on `loyalty:adjust` rather than a read-level code because it re-prices
   * every future award, which is a larger act than a single manual adjustment.
   * Existing ledger lines are not rewritten — refunds reverse the stored award.
   */
  saveLoyaltySettings: LoyaltySettings;
  /**
   * Third tab on the existing Configuration hub (`?tab=tickets`), beside Exact
   * Online and Customer.io. Per active scope.
   */
  saveScopeTicketSettings: ScopeTicketSettings;
  /**
   * Step 1: decrypt / resolve the QR, find **the** night whose doors window
   * contains `now` in the scanner's scope, and decide admissibility.
   *
   * * Zero doors-window matches, or more than one, is `NO_DOORS_WINDOW` — the scan
   *   **fails closed** rather than guess (admins are prevented from overlapping by
   *   the database, 5.2).
   * * The scanner's scope narrows the doors-window lookup **only**; the holder's
   *   points and vouchers stay global (2.2 / 2.3).
   * * Offline is out of scope for v1: the client fails closed and shows a retry
   *   screen.
   * * Door-sold tickets have no QR and are not scanned here.
   */
  scanTicket: ScanResult;
  /**
   * Scan a voucher QR at the register: ISSUED -> RESERVED.
   *
   * Device principal. The device's scope comes from its pairing record, never from
   * client input, and the lookup is scope-filtered — so a voucher from another
   * scope returns WRONG_SCOPE naming the owning venue.
   *
   * `code` is a voucher id (bare uuid or a link ending in it) or a guest's ticket QR
   * `ferry:ticket:{uuid}`. A ticket QR acts on the ticket's live voucher in the
   * device's scope (several rules in one venue: a reserved one first, else the
   * usable one expiring soonest) and answers like a voucher QR; a ticket with no
   * live voucher is TICKET_NO_VOUCHER. The scan never admits the ticket at the
   * door. `placeOrder` takes the `voucher.id` this returns, never the ticket id.
   *
   * Reservation TTL is 15 minutes; the scheduled job releases it back to ISSUED
   * (2.3 / 2.5). Max one voucher per order, and it stacks with a catalog discount.
   */
  scanVoucher: VoucherScanResult;
  /**
   * Emails per-ticket claim links to companions (Customer.io transactional,
   * `send_to_unsubscribed`). Blocked while the order's PSP is still pending.
   * Companion emails are **not** marketing consent (7.1). Cannot email the
   * keep seat on a night until the buyer has claimed one for that night;
   * after they have, every remaining seat may be sent.
   *
   * Same auth as `changeCompanionEmail`: order access token or the calling
   * customer. Not `@ownsResource` — www checkout is anonymous.
   */
  sendCompanionTickets: Array<Ticket>;
  /**
   * Website service credential only (`contact:send` on `website_catalog`).
   * Sends the guest acknowledgement and the staff notification. Guest opt-in
   * records consent source `contact`. The staff send does not record marketing
   * consent. Rate-limited like `emailReceipt`.
   */
  sendContactMessage: SendContactMessagePayload;
  /**
   * Sends every listed guest-list ticket for the verified customer (no keep-one,
   * `companion_tickets`, not marketing consent), or re-points a sent, unclaimed
   * one (the old claim link dies, `claim_link_revoked` to the old address). A
   * different email is not found.
   */
  sendGuestListForCustomer: Array<GuestListForCustomer>;
  setCategoriesActive: BulkResult;
  setCategoryProducts: Category;
  setDeviceRoles: Device;
  setDevicesActive: BulkResult;
  setDiscountsActive: BulkResult;
  /**
   * Saves the night the Ticket sales block compares `nightId` with; `compareNightId: null` clears it (back to the suggestion).
   * Any other night of the venue can be picked, earlier or later. The night itself is `BAD_USER_INPUT`; a night of another
   * scope, on either side, is `NOT_FOUND` and reveals nothing of it. Queues no outbox event: nothing public changes.
   */
  setNightCompareNight: Night;
  setProductsActive: BulkResult;
  setTablesActive: BulkResult;
  setTerminalsActive: BulkResult;
  setUserRoles: User;
  setVoucherRulesActive: BulkResult;
  startExactAuthorization: Scalars['String']['output'];
  /** Opens a recognition-day session (idempotent if already open). */
  startRecognitionDay: RecognitionDaySession;
  /**
   * Website service credential only (`ticket_alerts:subscribe` on
   * `website_catalog`). The "keep me posted" form on an empty /tickets page.
   * Records consent source `ticket_shop` (checking the box is consent, no double
   * opt-in) and stamps `ticket_alerts` through the outbox Identify. Customer-global:
   * no scope. Idempotent; the first subscription's timestamp is kept. There is no
   * Go per-IP limiter: www shares one egress IP, so Symfony fronts it.
   */
  subscribeTicketAlerts: SubscribeTicketAlertsPayload;
  switchScope: Scope;
  /** Sync the staff token's scope with Adyen. Takes no scope argument. */
  syncTerminals: SyncTerminalsPayload;
  /**
   * Put a blocked ticket back as it was (claimed if it had been claimed). Refused
   * with `BAD_USER_INPUT` when the night or stage is full by now,
   * and when its claimer holds another live ticket that night. Vouchers revoked by
   * the block are not restored.
   */
  unblockTicket: AdminTicket;
  /**
   * Unblock an account: -> ACTIVE when `email_verified_at` is set, else CREATED
   * (1.2). Never silently marks an unverified account verified.
   */
  unblockUser: User;
  /**
   * Second tap deletes the row. Tracks `I'm Not Going` and `delete_relationships` only when it was the guest's
   * last going on the night; removing one of two events keeps the relationship. Idempotent on a public night when no row exists. On a night that is not published and active it works only for a guest taking back their own going; anyone else (no row, or a second tap) gets NOT_FOUND, so the id does not read an unpublished event.
   */
  unmarkGoing: PublicEvent;
  /** Hides it again and deletes the Symfony cache row. The Customer.io object stays. */
  unpublishNight: Night;
  updateBlueprint: Blueprint;
  updateBlueprintEvent: BlueprintEvent;
  updateBlueprintStage: BlueprintStage;
  updateCategory: Category;
  /** Update the calling customer's own profile (1.6 / 4.2). */
  updateCustomerProfile: CustomerMe;
  updateDevice: Device;
  updateDiscount: Discount;
  updateLink: Link;
  /** POS self-update for allowCategorySwitch (iPad Settings). Device auth only — own device. */
  updateMyAllowCategorySwitch: Device;
  updateMyProfile: User;
  /**
   * Edits this night only. It is independent of its blueprint, so this never
   * touches the Blueprint or any sibling night.
   *
   * Saving a doors window that overlaps another night in the same scope is
   * rejected (5.2) — the door scan depends on exactly one night matching
   * "now".
   */
  updateNight: Night;
  updateNightEvent: NightEvent;
  updateNightStage: NightStage;
  updateProduct: Product;
  updateRole: Role;
  updateScope: Scope;
  updateTab: Tab;
  updateTabOrderItem: Tab;
  updateTable: Table;
  updateTerminal: Terminal;
  updateUser: User;
  updateVoucherRule: VoucherRule;
  /**
   * Consume a magic-link token and issue a session. Public by necessity.
   *
   * The token is single-use, bound to the email it was issued for, and `used_at` is
   * consumed atomically with the login. Verifying sets `email_verified_at` and moves
   * CREATED -> ACTIVE, upgrading the limited session to the 1-year rolling customer
   * session. Returns `amr: MAGIC_LINK`.
   */
  verifyMagicLink: AuthPayload;
  wakeTerminal: Terminal;
};

export type MutationAdjustUserPointsArgs = {
  input: AdjustUserPointsInput;
};

export type MutationAssignGoldenTicketArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};

export type MutationAssignTerminalArgs = {
  deviceId: Scalars['UUID']['input'];
  terminalId: Scalars['UUID']['input'];
};

export type MutationAttachTicketOrderBuyerArgs = {
  input: AttachTicketOrderBuyerInput;
};

export type MutationBlockTicketArgs = {
  input: BlockTicketInput;
};

export type MutationBlockUserArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationBulkPerformDeviceActionArgs = {
  action: DeviceAction;
  ids: Array<Scalars['ID']['input']>;
};

export type MutationBulkPerformOrderActionArgs = {
  action: OrderAction;
  ids: Array<Scalars['ID']['input']>;
};

export type MutationBulkPerformTabActionArgs = {
  action: TabAction;
  ids: Array<Scalars['ID']['input']>;
};

export type MutationCalculateOrderArgs = {
  input: CalculateOrderInput;
};

export type MutationCancelPaymentArgs = {
  paymentId: Scalars['UUID']['input'];
  retainOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCancelRefundArgs = {
  refundId: Scalars['UUID']['input'];
};

export type MutationChangeCompanionEmailArgs = {
  email: Scalars['String']['input'];
  manageToken?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['UUID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationClaimDeviceArgs = {
  code: Scalars['String']['input'];
};

export type MutationClaimGuestListForCustomerArgs = {
  input: ClaimGuestListForCustomerInput;
};

export type MutationClaimTicketArgs = {
  input: ClaimTicketInput;
};

export type MutationCompleteExactAuthorizationArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type MutationConfirmCashPaymentArgs = {
  paymentId: Scalars['UUID']['input'];
};

export type MutationConfirmCashRefundArgs = {
  refundId: Scalars['UUID']['input'];
};

export type MutationCreateBlueprintArgs = {
  input: CreateBlueprintInput;
};

export type MutationCreateBlueprintEventArgs = {
  blueprintId: Scalars['UUID']['input'];
  input: BlueprintEventInput;
};

export type MutationCreateBlueprintStageArgs = {
  blueprintId: Scalars['UUID']['input'];
  input: BlueprintStageInput;
};

export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};

export type MutationCreateDeviceArgs = {
  input: CreateDeviceInput;
};

export type MutationCreateDiscountArgs = {
  input: CreateDiscountInput;
};

export type MutationCreateDoorTicketOrderArgs = {
  input: CreateDoorTicketOrderInput;
};

export type MutationCreateGuestListEntryArgs = {
  input: CreateGuestListEntryInput;
};

export type MutationCreateLinkArgs = {
  input: CreateLinkInput;
};

export type MutationCreateManageTicketsLinkArgs = {
  ticketId: Scalars['UUID']['input'];
  who: ManageLinkFor;
};

export type MutationCreateMemberSaleArgs = {
  input: CreateMemberSaleInput;
};

export type MutationCreateNightArgs = {
  input: CreateNightInput;
};

export type MutationCreateNightEventArgs = {
  input: NightEventInput;
  nightId: Scalars['UUID']['input'];
};

export type MutationCreateNightStageArgs = {
  input: NightStageInput;
  nightId: Scalars['UUID']['input'];
};

export type MutationCreateOrderPaymentArgs = {
  amountCents?: InputMaybe<Scalars['Cents']['input']>;
  amountTipCents?: InputMaybe<Scalars['Cents']['input']>;
  orderId: Scalars['UUID']['input'];
  paymentMethod: PaymentMethod;
};

export type MutationCreatePasskeyRegistrationLinkArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationCreatePosTicketOrderArgs = {
  input: CreatePosTicketOrderInput;
};

export type MutationCreatePosterUploadUrlArgs = {
  contentType: Scalars['String']['input'];
};

export type MutationCreateProductArgs = {
  input: CreateProductInput;
};

export type MutationCreateRefundArgs = {
  input: CreateRefundInput;
};

export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};

export type MutationCreateTabArgs = {
  input: CreateTabInput;
};

export type MutationCreateTabPaymentArgs = {
  amountCents?: InputMaybe<Scalars['Cents']['input']>;
  amountTipCents?: InputMaybe<Scalars['Cents']['input']>;
  paymentMethod: PaymentMethod;
  tabId: Scalars['UUID']['input'];
};

export type MutationCreateTableArgs = {
  input: CreateTableInput;
};

export type MutationCreateTerminalArgs = {
  input: CreateTerminalInput;
};

export type MutationCreateTicketOrderArgs = {
  input: CreateTicketOrderInput;
};

export type MutationCreateTicketPaymentIntentArgs = {
  orderId: Scalars['UUID']['input'];
  payWithPoints?: InputMaybe<Scalars['Boolean']['input']>;
  provider: PaymentProvider;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateVoucherRuleArgs = {
  input: CreateVoucherRuleInput;
};

export type MutationDeleteBlueprintEventArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteLinkArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteNightEventArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteRoleArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationEmailReceiptArgs = {
  input: EmailReceiptInput;
};

export type MutationExportExactDayArgs = {
  recognitionDate: Scalars['String']['input'];
};

export type MutationExportExactInvoiceTabArgs = {
  tabId: Scalars['UUID']['input'];
};

export type MutationHandOverTicketArgs = {
  email: Scalars['String']['input'];
  manageToken?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['UUID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationHoldDoorTicketArgs = {
  stageId: Scalars['UUID']['input'];
};

export type MutationIngestDeviceLogsArgs = {
  input: IngestDeviceLogsInput;
};

export type MutationIssueMagicLinkArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationIssueVoucherArgs = {
  input: IssueVoucherInput;
};

export type MutationLinkCardByClaimTokenArgs = {
  confirm: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type MutationLogoutArgs = {
  everywhere?: InputMaybe<Scalars['Boolean']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMarkClaimLinkSharedArgs = {
  manageToken?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['UUID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMarkGoingArgs = {
  eventId: Scalars['UUID']['input'];
};

export type MutationPerformDeviceActionArgs = {
  action: DeviceAction;
  id: Scalars['ID']['input'];
};

export type MutationPerformOrderActionArgs = {
  action: OrderAction;
  id: Scalars['ID']['input'];
};

export type MutationPerformTabActionArgs = {
  action: TabAction;
  id: Scalars['ID']['input'];
};

export type MutationPlaceOrderArgs = {
  input: PlaceOrderInput;
};

export type MutationPrepareReceiptArgs = {
  input: PrepareReceiptInput;
};

export type MutationPublishNightArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationRecordEntranceDecisionArgs = {
  input: RecordEntranceDecisionInput;
};

export type MutationRefreshSessionArgs = {
  refreshToken: Scalars['String']['input'];
};

export type MutationRegenerateDevicePairingCodeArgs = {
  deviceId: Scalars['UUID']['input'];
};

export type MutationReleaseDoorTicketArgs = {
  ticketId: Scalars['UUID']['input'];
};

export type MutationReleaseHeldTicketArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationReleaseVoucherReservationArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationRemoveOrderFromTabArgs = {
  orderId: Scalars['ID']['input'];
  tabId: Scalars['ID']['input'];
};

export type MutationReorderArgs = {
  entity: SortableEntity;
  orderedIds: Array<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationReorderBlueprintStagesArgs = {
  blueprintId: Scalars['UUID']['input'];
  orderedIds: Array<Scalars['UUID']['input']>;
};

export type MutationReorderNightStagesArgs = {
  nightId: Scalars['UUID']['input'];
  orderedIds: Array<Scalars['UUID']['input']>;
};

export type MutationReportDevicePresenceArgs = {
  status: Scalars['String']['input'];
};

export type MutationRequestMagicLinkArgs = {
  input: RequestMagicLinkInput;
};

export type MutationResendGuestListInviteArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationResendMemberSaleInviteArgs = {
  stageId: Scalars['UUID']['input'];
};

export type MutationRevokeGoldenTicketArgs = {
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRevokePasskeyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRevokeVoucherArgs = {
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSaveCustomerIoTemplatesArgs = {
  input: Array<CustomerIoTemplateInput>;
};

export type MutationSaveExactDivisionArgs = {
  division?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationSaveExactMappingArgs = {
  input: SaveExactMappingInput;
};

export type MutationSaveExactTicketMappingArgs = {
  input: SaveExactTicketMappingInput;
};

export type MutationSaveLoyaltySettingsArgs = {
  pointsPerStep: Scalars['Int']['input'];
  spendStepCents: Scalars['Int']['input'];
};

export type MutationSaveScopeTicketSettingsArgs = {
  feeTaxPercentage?: InputMaybe<Scalars['Float']['input']>;
  taxPercentage: Scalars['Float']['input'];
  ticketPointsPerEuro: Scalars['Int']['input'];
};

export type MutationScanTicketArgs = {
  input: ScanTicketInput;
};

export type MutationScanVoucherArgs = {
  code: Scalars['String']['input'];
};

export type MutationSendCompanionTicketsArgs = {
  input: SendCompanionTicketsInput;
};

export type MutationSendContactMessageArgs = {
  input: SendContactMessageInput;
};

export type MutationSendGuestListForCustomerArgs = {
  tickets: Array<GuestListTicketSendInput>;
};

export type MutationSetCategoriesActiveArgs = {
  ids: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};

export type MutationSetCategoryProductsArgs = {
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};

export type MutationSetDeviceRolesArgs = {
  deviceId: Scalars['UUID']['input'];
  roleId?: InputMaybe<Scalars['UUID']['input']>;
};

export type MutationSetDevicesActiveArgs = {
  ids: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};

export type MutationSetDiscountsActiveArgs = {
  ids: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};

export type MutationSetNightCompareNightArgs = {
  compareNightId?: InputMaybe<Scalars['UUID']['input']>;
  nightId: Scalars['UUID']['input'];
};

export type MutationSetProductsActiveArgs = {
  ids: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};

export type MutationSetTablesActiveArgs = {
  ids: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};

export type MutationSetTerminalsActiveArgs = {
  ids: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};

export type MutationSetUserRolesArgs = {
  bindings: Array<RoleBindingInput>;
  userId: Scalars['UUID']['input'];
};

export type MutationSetVoucherRulesActiveArgs = {
  active: Scalars['Boolean']['input'];
  ids: Array<Scalars['UUID']['input']>;
};

export type MutationSubscribeTicketAlertsArgs = {
  input: SubscribeTicketAlertsInput;
};

export type MutationSwitchScopeArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationUnblockTicketArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationUnblockUserArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationUnmarkGoingArgs = {
  eventId: Scalars['UUID']['input'];
};

export type MutationUnpublishNightArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationUpdateBlueprintArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateBlueprintInput;
};

export type MutationUpdateBlueprintEventArgs = {
  id: Scalars['UUID']['input'];
  input: BlueprintEventInput;
};

export type MutationUpdateBlueprintStageArgs = {
  id: Scalars['UUID']['input'];
  input: BlueprintStageInput;
};

export type MutationUpdateCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCategoryInput;
};

export type MutationUpdateCustomerProfileArgs = {
  input: UpdateCustomerProfileInput;
};

export type MutationUpdateDeviceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceInput;
};

export type MutationUpdateDiscountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDiscountInput;
};

export type MutationUpdateLinkArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLinkInput;
};

export type MutationUpdateMyAllowCategorySwitchArgs = {
  allow: Scalars['Boolean']['input'];
};

export type MutationUpdateMyProfileArgs = {
  input: UpdateProfileInput;
};

export type MutationUpdateNightArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateNightInput;
};

export type MutationUpdateNightEventArgs = {
  id: Scalars['UUID']['input'];
  input: NightEventInput;
};

export type MutationUpdateNightStageArgs = {
  id: Scalars['UUID']['input'];
  input: NightStageInput;
};

export type MutationUpdateProductArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProductInput;
};

export type MutationUpdateRoleArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateRoleInput;
};

export type MutationUpdateScopeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateScopeInput;
};

export type MutationUpdateTabArgs = {
  input: UpdateTabInput;
};

export type MutationUpdateTabOrderItemArgs = {
  orderItemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  tabId: Scalars['ID']['input'];
};

export type MutationUpdateTableArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTableInput;
};

export type MutationUpdateTerminalArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTerminalInput;
};

export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};

export type MutationUpdateVoucherRuleArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateVoucherRuleInput;
};

export type MutationVerifyMagicLinkArgs = {
  token: Scalars['String']['input'];
};

export type MutationWakeTerminalArgs = {
  terminalId: Scalars['UUID']['input'];
};

/**
 * One dated night: doors, tickets, stages. What the public reads (title, time,
 * description, poster, entrance price label) lives on its `events`.
 * Admin-facing: it exposes the internal channel flags and the `published` state,
 * so it must not be handed to guests — the public agenda uses `PublicNight`.
 */
export type Night = {
  __typename?: 'Night';
  blueprint?: Maybe<Blueprint>;
  /**
   * Series link only. Creating from a Blueprint **snapshots** it; the night is
   * independent afterwards and later Blueprint edits never rewrite it.
   */
  blueprintId?: Maybe<Scalars['UUID']['output']>;
  /**
   * The night the Ticket sales block compares this night with: the one a manager saved (`setNightCompareNight`), else the
   * most recent earlier night (doors open) of the same blueprint, active or not, else null. Resolved only when selected.
   * It is the night's own choice: never copied from a blueprint and never public. Needs `night:read` itself: `Night` is also
   * the type of `doorNights`, which a register or door principal reaches without it, and this field returns the full admin
   * night (the Link stages' URL, the member sale's buyer address, the ticket text), not the reduced door view.
   */
  compareNight?: Maybe<Night>;
  createdAt: Scalars['Time']['output'];
  doorsClose: Scalars['Time']['output'];
  /**
   * Doors window as real instants. Every night has one (`doorsClose` is when the
   * night ends). Within one scope, windows may not overlap — the database rejects
   * the save.
   */
  doorsOpen: Scalars['Time']['output'];
  /**
   * Shown on the website's Good to know and in the app; empty = "None, come as you are". The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 100 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  dresscode?: Maybe<Scalars['String']['output']>;
  /**
   * The public events of this night, earliest first. A night cannot be
   * published without one.
   */
  events: Array<NightEvent>;
  /** The Stager event id when the night was imported from Stager's history, else null. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Guests going to at least one event of the night (5.4): a guest going to two of its events counts once. The per-event count is `PublicEvent.goingCount`. */
  goingCount: Scalars['Int']['output'];
  /** Guest-list tickets that are purchased or claimed. Sold tickets + guest tickets = the tickets issued. Same lazy, one-statement rule as `soldTickets`. */
  guestTickets: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  /**
   * Independent of `published`. False retires the night: hidden from pickers and
   * new sales, still visible in admin/reporting. A sold-out past night can stay
   * published while going inactive.
   */
  isActive: Scalars['Boolean']['output'];
  /** True when the calling customer is going to any event of the night. Always false for staff/anonymous callers. */
  isGoing: Scalars['Boolean']['output'];
  minimumAge?: Maybe<Scalars['Int']['output']>;
  /** 5.5: nothing is public until this is true. */
  published: Scalars['Boolean']['output'];
  requireTicket: Scalars['Boolean']['output'];
  scope: ScopeRef;
  scopeId: Scalars['UUID']['output'];
  /**
   * The Nights grid's "Tickets sold": purchased, claimed or imported tickets of kind online, member, pos or door, over
   * every channel. Guest-list tickets, holds, released, refunded and blocked tickets are not in it (`ticketsSold` above
   * is the capacity figure and counts holds and guest-list tickets). Computed for the whole page in one statement, and
   * only when the query selects it, on `nights`, `night`, `doorNights` and the night mutations.
   */
  soldTickets: Scalars['Int']['output'];
  stages: Array<NightStage>;
  /** Always equals `doorsOpen` (Go writes it on every save); the calendar, POS lists and reports sort on it. Read-only. */
  startsAt: Scalars['Time']['output'];
  /**
   * Paid ticket amounts including VAT, over all channels, minus refunds, for the night's paid ticket orders: what stayed in
   * the till for the night. The booking fee is part of it (an admission line's total is the ticket price plus the fee). A
   * refund (status `refunded`, or the legacy `success`) nets off the night of the ticket it refunded: an order that holds
   * tickets of two nights splits the refund over the nights of its `refunded` tickets by line total, over all its tickets
   * when none is marked refunded. A refund carries only the order, so on a door basket that mixes tickets and bar items it
   * counts up to the `refunded` tickets' lines, or, when no ticket is marked refunded, scaled by the ticket lines' share of the
   * order (a refunded beer takes off only the ticket part). A night's share never goes below zero. Null without the `report:chart:read` permission
   * (the ticket sales chart's), with no error.
   */
  ticketRevenueCents?: Maybe<Scalars['Cents']['output']>;
  /**
   * Shown to the holder of a claimed ticket on the ticket e-mail, PDF, the www ticket pages and the app. Never public, never before the claim. The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 1000 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  ticketText?: Maybe<Scalars['String']['output']>;
  ticketsHeld: Scalars['Int']['output'];
  /** Tickets sold or held, for the admin capacity column. */
  ticketsSold: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type NightConnection = {
  __typename?: 'NightConnection';
  nodes: Array<Night>;
  pageInfo: PageMeta;
};

/**
 * One public event of a night ("Karaoke Contest" 18:00-20:00). Its times
 * sit inside the night's doors window, bounds inclusive: start >= doors open,
 * start < doors close, end after start and end <= doors close. Moving the doors so
 * an event falls outside is refused.
 */
export type NightEvent = {
  __typename?: 'NightEvent';
  description?: Maybe<Scalars['String']['output']>;
  /** Optional; empty shows only the start. */
  endsAt?: Maybe<Scalars['Time']['output']>;
  /** Display-only admission copy, e.g. Free till 12, after €5. Null when unset. */
  entrancePriceLabel?: Maybe<Scalars['String']['output']>;
  /** Shown in the homepage's Featured section. A marker only; any number of events may be featured. */
  featured: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  nightId: Scalars['UUID']['output'];
  /** At most one event per night offers tickets. */
  offersTickets: Scalars['Boolean']['output'];
  /** The poster image at the asked size; the original when the size has no variant. */
  posterUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Public URL key, minted once: www serves the event at /events/{slug}. The migrated event of an
   * existing night kept that night's slug. The night has no slug of its own.
   */
  slug: Scalars['String']['output'];
  startsAt: Scalars['Time']['output'];
  title: Scalars['String']['output'];
};

/**
 * One public event of a night ("Karaoke Contest" 18:00-20:00). Its times
 * sit inside the night's doors window, bounds inclusive: start >= doors open,
 * start < doors close, end after start and end <= doors close. Moving the doors so
 * an event falls outside is refused.
 */
export type NightEventPosterUrlArgs = {
  size?: InputMaybe<PosterSize>;
};

/**
 * The whole event form. `title`, `startsAt`, `endsAt` and `offersTickets` are
 * saved as given (an empty `endsAt` clears it; an omitted `offersTickets` is false).
 * `featured` is saved like `offersTickets` (omitted is false). `description`, `posterPath` and `entrancePriceLabel` are left alone when omitted on
 * update and cleared when blank. Refusals are `BAD_USER_INPUT`: outside the doors
 * window (also an end that is not after the start), a second event that offers
 * tickets.
 */
export type NightEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['Time']['input']>;
  entrancePriceLabel?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  offersTickets?: InputMaybe<Scalars['Boolean']['input']>;
  /** From `createPosterUploadUrl`. */
  posterPath?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['Time']['input'];
  title: Scalars['String']['input'];
};

export type NightFilter = {
  blueprintIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  requireTicket?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<DateRangeInput>;
  /**
   * True lists only the nights whose doors close is still ahead (a night running now stays, one that closes this very
   * second is gone), on the service clock. Absent or false leaves the list as it is. The Nights grid sets it.
   */
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NightSort = {
  direction?: SortDirection;
  field: NightSortField;
};

export type NightSortField =
  | 'CREATED_AT'
  | 'DOORS_CLOSE'
  /** Doors open: the Nights grid's default column, descending (the night furthest away first). */
  | 'DOORS_OPEN'
  | 'STARTS_AT'
  | 'TITLE'
  | 'UPDATED_AT';

export type NightStage = {
  __typename?: 'NightStage';
  appSale: Scalars['Boolean']['output'];
  door: Scalars['Boolean']['output'];
  /**
   * Sale ends, as stored. Null means "per channel": website, app and link stop at
   * the night's doors open, POS at its doors close. A set value wins on every
   * channel.
   */
  endsAt?: Maybe<Scalars['Time']['output']>;
  /** End of the entry window (exclusive). Null = the night's doors close. */
  entryEndsAt?: Maybe<Scalars['Time']['output']>;
  /** When this stage's ticket admits (instant). Null = the night's doors open. */
  entryStartsAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Guest-facing wording of the entry window, Europe/Amsterdam. Null when the stage
   * has no entry window. Start equal to doors open: `Entry before HH:MM`. End equal
   * to doors close: `Entry after HH:MM`. Otherwise `Entry HH:MM–HH:MM` (en dash).
   */
  entryWindowLabel?: Maybe<Scalars['String']['output']>;
  feePrice: Scalars['Float']['output'];
  feePriceCents: Scalars['Cents']['output'];
  /** Hidden admin reservation stage. Not a stage-editor checkbox; one per night. */
  guestList: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isInWindow: Scalars['Boolean']['output'];
  /**
   * A stage is current on a channel when it is flagged for that channel, not
   * a member sale, inside its window, and not sold out. When it falls out, the next stage
   * by `sort` **on that channel** becomes current.
   */
  isSoldOut: Scalars['Boolean']['output'];
  /** `lateFeeCents` in euros (admin). */
  lateFee?: Maybe<Scalars['Float']['output']>;
  /** Fee for arriving after the entry window. Null = none set. */
  lateFeeCents?: Maybe<Scalars['Cents']['output']>;
  /** Bought only through its own URL (`linkUrl`); listed on no other channel. Cannot be combined with website / app / pos / door. */
  linkSale: Scalars['Boolean']['output'];
  /**
   * `{www}/events/{slug}/tickets/{stageId}` with the slug of the event that offers tickets; null
   * unless `linkSale`, and null while no event of the night offers tickets. Anyone with the link can buy
   * this stage; it is listed nowhere else. Admin only.
   */
  linkUrl?: Maybe<Scalars['String']['output']>;
  maxAmount?: Maybe<Scalars['Int']['output']>;
  memberBuyerEmail?: Maybe<Scalars['String']['output']>;
  /** Member-sale cap; the guest picks a quantity up to this number. */
  memberMaxQuantity?: Maybe<Scalars['Int']['output']>;
  memberSale: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nightId: Scalars['UUID']['output'];
  /** Listed and buyable on the iPad hamburger Tickets sale (6.3). Independent of website / app / door. */
  posSale: Scalars['Boolean']['output'];
  /** Sold + held on this stage. */
  soldCount: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  /** Sale window; allowed here because a night is dated. Either bound may be null. */
  startsAt?: Maybe<Scalars['Time']['output']>;
  ticketPrice: Scalars['Float']['output'];
  ticketPriceCents: Scalars['Cents']['output'];
  websiteSale: Scalars['Boolean']['output'];
};

/**
 * Channel checkboxes (`websiteSale` / `appSale` / `posSale` / `door` / `linkSale`).
 * Two rules, both `BAD_USER_INPUT`: Link cannot be combined with other channels;
 * Website requires App.
 */
export type NightStageInput = {
  appSale?: Scalars['Boolean']['input'];
  door?: Scalars['Boolean']['input'];
  /** Sale ends. Empty: website, app and link sell until the night's doors open, POS until its doors close. A set value wins on every channel. */
  endsAt?: InputMaybe<Scalars['Time']['input']>;
  entryEndsAt?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Entry window (instants). Either bound optional: a missing bound is the
   * night's doors open / doors close. Both bounds must lie inside the
   * night's doors window (`BAD_USER_INPUT` otherwise) and the end must be
   * after the start.
   */
  entryStartsAt?: InputMaybe<Scalars['Time']['input']>;
  feePriceCents?: Scalars['Cents']['input'];
  isActive?: Scalars['Boolean']['input'];
  /**
   * Fee for arriving after the entry window; >= 0. **Required** (0 allowed) when
   * `entryEndsAt` is before the night's doors close; omitting it is then
   * `BAD_USER_INPUT`. Changing the night's doors re-checks every active stage.
   */
  lateFeeCents?: InputMaybe<Scalars['Cents']['input']>;
  /** Bought only through its own URL. Cannot be combined with the other channels. */
  linkSale?: Scalars['Boolean']['input'];
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  posSale?: Scalars['Boolean']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['Time']['input']>;
  ticketPriceCents: Scalars['Cents']['input'];
  websiteSale?: Scalars['Boolean']['input'];
};

/**
 * `NightTicketSummary.sold` split by `tickets.sale_channel`. Tickets sold before the channel was recorded count as `website`
 * unless they were bought on a Link stage (`link`); only sales since tell `website` and `app` apart.
 */
export type NightTicketChannelCounts = {
  __typename?: 'NightTicketChannelCounts';
  app: Scalars['Int']['output'];
  door: Scalars['Int']['output'];
  link: Scalars['Int']['output'];
  member: Scalars['Int']['output'];
  pos: Scalars['Int']['output'];
  website: Scalars['Int']['output'];
};

export type NightTicketFilter = {
  status?: InputMaybe<Array<TicketStatus>>;
};

/**
 * The numbers of a night's Ticket sales block. `sold`, `guest` and `revenueCents` are the Nights grid's `soldTickets`,
 * `guestTickets` and `ticketRevenueCents` of the same night (one statement behind both), so the two pages agree.
 */
export type NightTicketSummary = {
  __typename?: 'NightTicketSummary';
  /** Guest-list tickets that are purchased or claimed. */
  guest: Scalars['Int']['output'];
  /**
   * The sum of the stages' remaining tickets (the Max sold rule of the public night), over the stages that can sell: active,
   * not the guest-list stage, flagged for a channel. Null when such a stage has no Max sold: there is no real number then.
   */
  left?: Maybe<Scalars['Int']['output']>;
  /** `sold` by the ticket's sale channel. The six add up to `sold`; read from the same statement. */
  perChannel: NightTicketChannelCounts;
  /** Ticket revenue including VAT and booking fees, minus refunds, like the grid. Null without `report:chart:read` (absent, not an error). */
  revenueCents?: Maybe<Scalars['Cents']['output']>;
  /** Purchased, claimed or imported tickets of kind online, member, pos or door. Never guest-list, held, released, refunded or blocked tickets. */
  sold: Scalars['Int']['output'];
  /**
   * Purchased tickets that can still be claimed: not door tickets, which can never be claimed; guest-list tickets count.
   * `tickets(filter: { nightId, unclaimed: true })` lists exactly these.
   */
  unclaimed: Scalars['Int']['output'];
};

/** Half-open numeric range; either bound may be null. */
export type NumberRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type Order = {
  __typename?: 'Order';
  allowedActions: Array<OrderAction>;
  amountCanceled: Scalars['Float']['output'];
  amountDiscount: Scalars['Float']['output'];
  amountDiscountCents: Scalars['Cents']['output'];
  amountDue: Scalars['Float']['output'];
  amountDueCents: Scalars['Cents']['output'];
  amountPaid: Scalars['Float']['output'];
  amountPaidCents: Scalars['Cents']['output'];
  amountRefunded: Scalars['Float']['output'];
  amountRefundedCents: Scalars['Cents']['output'];
  /**
   * The one voucher applied to this order (6.1), or null. Max one per order, and it
   * **stacks with** the catalog discount in `discount`.
   *
   * Reuses the `Voucher` type from `loyalty.graphqls` rather than a slimmer
   * order-local shape: POS and admin need its `status` and `scope` for exactly the
   * reasons that type already documents (a voucher from another scope is rejected
   * with "voucher is for {scope name}"), and two types for one row would drift.
   */
  appliedVoucher?: Maybe<Voucher>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['UUID']['output']>;
  /** Sales surface (6.3). Existing bar orders are `BAR`. */
  channel: OrderChannel;
  createdAt: Scalars['String']['output'];
  device?: Maybe<Device>;
  deviceId?: Maybe<Scalars['UUID']['output']>;
  discount?: Maybe<Discount>;
  discountId?: Maybe<Scalars['UUID']['output']>;
  grandTotal: Scalars['Float']['output'];
  grandTotalCents: Scalars['Cents']['output'];
  id: Scalars['UUID']['output'];
  items: Array<OrderItem>;
  message?: Maybe<Scalars['String']['output']>;
  originalGrandTotal: Scalars['Float']['output'];
  originalGrandTotalCents: Scalars['Cents']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  payments: Array<Payment>;
  recognitionDate?: Maybe<Scalars['String']['output']>;
  recognizedTotal: Scalars['Float']['output'];
  refunds: Array<Refund>;
  status: OrderStatus;
  tab?: Maybe<Tab>;
  tabId?: Maybe<Scalars['UUID']['output']>;
  table?: Maybe<Table>;
  tableId?: Maybe<Scalars['UUID']['output']>;
  terminal?: Maybe<Terminal>;
  terminalId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type OrderAction =
  | 'CANCEL'
  | 'DOWNLOAD_RECEIPT'
  | 'FAIL'
  | 'MARK_PAID'
  | 'PARTIAL_PAID'
  | 'PARTIAL_REFUND'
  | 'PAY'
  | 'PLACE'
  | 'REFUND';

/**
 * Which sales surface produced the order. Discriminator for POS active-order
 * hydrate exclusion (POS filters to `BAR`), admin grids, exports and reporting
 * (6.3).
 */
export type OrderChannel =
  /** Bar sale from a POS device. */
  | 'BAR'
  /** Door ticket sale on iPad / Android POS (`createDoorTicketOrder`). */
  | 'DOOR'
  /** Online or member-link ticket sale (`createTicketOrder`). */
  | 'TICKET';

export type OrderConnection = {
  __typename?: 'OrderConnection';
  nodes: Array<Order>;
  pageInfo: PageMeta;
};

export type OrderEventIntent =
  | 'ORDER_CANCELATION_REQUESTED'
  | 'ORDER_CANCELED'
  | 'ORDER_CREATED'
  | 'ORDER_DISCOUNT_APPLIED'
  | 'ORDER_DISCOUNT_REMOVED'
  | 'ORDER_FAILED'
  | 'ORDER_FULLY_PAID'
  | 'ORDER_FULLY_REFUNDED'
  | 'ORDER_LOST'
  | 'ORDER_PARTIALLY_PAID'
  | 'ORDER_PARTIALLY_REFUNDED'
  | 'ORDER_PLACED'
  | 'ORDER_REFUNDED'
  | 'ORDER_REFUND_STARTED';

export type OrderEventPayload = {
  __typename?: 'OrderEventPayload';
  intent: OrderEventIntent;
  order: Order;
  previousStatus?: Maybe<OrderStatus>;
  timestamp: Scalars['Time']['output'];
};

export type OrderFilter = {
  amount?: InputMaybe<NumberRangeInput>;
  amountDue?: InputMaybe<NumberRangeInput>;
  createdAt?: InputMaybe<DateRangeInput>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  discountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentMethod?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recognitionDate?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<OrderStatus>>;
  tableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<DateRangeInput>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  amountDiscount: Scalars['Float']['output'];
  amountDiscountCents: Scalars['Cents']['output'];
  cashTrade: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  lineTotal: Scalars['Float']['output'];
  /** Stage of a ticket line, resolved through the ticket (`tickets.stage_id`). Null on product lines. Kept for POS/Android. */
  nightStageId?: Maybe<Scalars['UUID']['output']>;
  originalTotalCents: Scalars['Cents']['output'];
  price: Scalars['Float']['output'];
  /**
   * Internal product UUID (POS bar lines). Null on ticket/door lines, which
   * reference a night stage instead (6.3).
   */
  product?: Maybe<Scalars['UUID']['output']>;
  /** Catalog product name, or ticket-line label `{stage} ticket {night} {DD-MM}` (doors-open date in Europe/Amsterdam). */
  productName: Scalars['String']['output'];
  /** @deprecated Released iPad and Android builds only; use nightStageId. Removed with the R2e builds, see DEPRECATIONS.md#graphql-production-names */
  productionStageId?: Maybe<Scalars['UUID']['output']>;
  /** Cents fields for POS. */
  qty: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  recognizedTotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  taxPercentage: Scalars['Float']['output'];
  /**
   * The ticket a ticket line sells. Null on product lines. Needs `ticket:read` on top
   * of whatever granted the order: a ticket id is the door-QR capability
   * (`ferry:ticket:{id}`), so a role that may read orders but not tickets gets this
   * field as null plus a FORBIDDEN error and still receives the rest of the line.
   */
  ticketId?: Maybe<Scalars['UUID']['output']>;
  /** What a ticket line sells: the admission itself, or an upgrade of it. Null on product lines. */
  ticketRole?: Maybe<TicketLineRole>;
  totalCents: Scalars['Cents']['output'];
  unitPriceCents: Scalars['Cents']['output'];
};

export type OrderItemInput = {
  product: Scalars['UUID']['input'];
  qty: Scalars['Int']['input'];
};

export type OrderSort = {
  direction?: SortDirection;
  field: OrderSortField;
};

export type OrderSortField =
  | 'AMOUNT_DUE'
  | 'CREATED_AT'
  | 'DEVICE_NAME'
  | 'DISCOUNT_NAME'
  | 'GRAND_TOTAL'
  | 'ID'
  | 'PAYMENT_METHOD'
  | 'STATUS'
  | 'TABLE_NAME';

export type OrderStatus =
  | 'CANCELED'
  | 'CANCELING'
  | 'FAILED'
  | 'FULL_PAID'
  | 'FULL_REFUNDED'
  | 'LOSS'
  | 'NEW'
  | 'OPEN'
  | 'PARTIAL_PAID'
  | 'PARTIAL_REFUNDED'
  | 'PENDING'
  | 'REFUNDED'
  | 'REFUNDING';

/** Offset-based pagination metadata. */
export type PageMeta = {
  __typename?: 'PageMeta';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
};

export type Passkey = {
  __typename?: 'Passkey';
  createdAt: Scalars['String']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  /** Set on revokePasskey's response only; listed passkeys are live rows. */
  revokedAt?: Maybe<Scalars['String']['output']>;
};

/** One-time registration link for a user to add a new passkey. */
export type PasskeyRegistration = {
  __typename?: 'PasskeyRegistration';
  expiresAt: Scalars['String']['output'];
  qrSvg: Scalars['String']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PayPalOrderIntent = {
  __typename?: 'PayPalOrderIntent';
  amountCents: Scalars['Cents']['output'];
  approveUrl?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /** `sandbox` or `live`. */
  environment: Scalars['String']['output'];
  /** PayPal order id, for the JS / native SDK. */
  paypalOrderId: Scalars['String']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Cents']['output'];
  amountTip: Scalars['Float']['output'];
  amountTipCents: Scalars['Cents']['output'];
  /**
   * Masked card on this payment, when PIN captured a card (2.1). Null for cash
   * and for PIN rows that never produced a cards row.
   */
  card?: Maybe<PaymentCard>;
  cardAlias?: Maybe<Scalars['String']['output']>;
  /** Internal cards.id for the card field resolver. Not a PAN. */
  cardId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['String']['output'];
  device?: Maybe<Device>;
  deviceId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['UUID']['output']>;
  paymentMethod: Scalars['String']['output'];
  recognitionDate: Scalars['String']['output'];
  refunds: Array<Refund>;
  status: Scalars['String']['output'];
  tab?: Maybe<Tab>;
  tabId?: Maybe<Scalars['UUID']['output']>;
  terminal?: Maybe<Terminal>;
  terminalId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['String']['output'];
};

/**
 * Masked instrument on this payment (2.1). Scheme, BIN/IIN and whether the card
 * is linked to a user. Never PAN, PAR, alias, or any reconstructable credential.
 * The internal cards.id is not exposed here — only the masked view.
 */
export type PaymentCard = {
  __typename?: 'PaymentCard';
  /** Issuer BIN / IIN (first 6–8 digits). Not a PAN. */
  bin?: Maybe<Scalars['String']['output']>;
  /** True when the card row is bound to a users.id. */
  linked: Scalars['Boolean']['output'];
  scheme?: Maybe<Scalars['String']['output']>;
};

export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  nodes: Array<Payment>;
  pageInfo: PageMeta;
};

export type PaymentEventIntent =
  | 'PAYMENT_CANCELED'
  | 'PAYMENT_CANCELING'
  | 'PAYMENT_FAILED'
  | 'PAYMENT_PENDING'
  | 'PAYMENT_SUCCEEDED';

export type PaymentFilter = {
  amount?: InputMaybe<NumberRangeInput>;
  amountTip?: InputMaybe<NumberRangeInput>;
  createdAt?: InputMaybe<DateRangeInput>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Array<Scalars['String']['input']>>;
  recognitionDate?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  tabId?: InputMaybe<Scalars['String']['input']>;
  terminalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Lowercase values are the established convention on this enum and match the
 * database strings exactly; do not "modernise" them to SCREAMING_CASE.
 *
 * **iPad POS and Android must decode unknown enum values safely before `online` /
 * `paypal` ship** (6.3). `POS/POS/AppState.swift` reads `paymentMethod`, and a
 * strict Swift/Kotlin enum decode would break the whole hydrate response — not just
 * the ticket order — the first time a ticket sale appears in history. This is on
 * the Android sync-on-change list.
 */
export type PaymentMethod =
  | 'cash'
  | 'invoice'
  /**
   * Adyen **ecommerce** Drop-in (cards, wallets, iDEAL, Bancontact). Deliberately
   * not `pin`: pin requires a device with a paired terminal and binds a
   * per-terminal Adyen ServiceID. Books to the existing Adyen GL and the
   * `psp = 'adyen'` payment bucket (6.3 / 7.2).
   */
  | 'online'
  /** PayPal, bypassing Adyen. Needs its own Exact GL and payment bucket (7.2). */
  | 'paypal'
  | 'pin'
  | 'tab';

/** Per-method tip breakdown within a tip report. */
export type PaymentMethodTip = {
  __typename?: 'PaymentMethodTip';
  name: Scalars['String']['output'];
  tipAmountCents: Scalars['Cents']['output'];
  tippedPaymentCount: Scalars['Int']['output'];
  tippedPaymentPercentage: Scalars['Float']['output'];
};

export type PaymentProvider =
  /** Adyen Drop-in: cards, Apple Pay, Google Pay, iDEAL, Bancontact as configured. */
  | 'ADYEN'
  /** PayPal, which bypasses Adyen entirely. */
  | 'PAYPAL';

export type PaymentSort = {
  direction?: SortDirection;
  field: PaymentSortField;
};

export type PaymentSortField =
  | 'AMOUNT'
  | 'AMOUNT_TIP'
  | 'CREATED_AT'
  | 'ID'
  | 'ORDER_ID'
  | 'PAYMENT_METHOD'
  | 'RECOGNITION_DATE'
  | 'STATUS'
  | 'TAB_NAME'
  | 'TERMINAL_NAME'
  | 'UPDATED_AT';

export type PaymentStatus =
  | 'CANCELED'
  | 'CANCELING'
  | 'FAILURE'
  | 'NEW'
  | 'PENDING'
  | 'REFUNDED'
  | 'REFUNDING'
  | 'SUCCESS';

export type PaymentUpdatePayload = {
  __typename?: 'PaymentUpdatePayload';
  intent: PaymentEventIntent;
  payment: Payment;
  timestamp: Scalars['Time']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  action: Scalars['String']['output'];
  category: Scalars['String']['output'];
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /**
   * When true, @hasPermission rejects a session whose AMR is not passkey
   * (Deliverable 1.5). React Admin uses this to show which permissions demand a
   * passkey before the user tries the mutation.
   */
  requiresStrongAuth: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
};

/**
 * Vertical profile_personal (1.1). Absence of a row is modelled as all-null here.
 * `dateOfBirth` is ISO 8601 (YYYY-MM-DD). Editable at most once per 365 days (4.2).
 */
export type PersonalProfile = {
  __typename?: 'PersonalProfile';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfBirthUpdatedAt?: Maybe<Scalars['Time']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
};

export type PlaceOrderInput = {
  /** Payment principal in cents. Omit to pay the full order total. Tip is amountTipCents. */
  amountCents?: InputMaybe<Scalars['Cents']['input']>;
  amountTipCents?: InputMaybe<Scalars['Cents']['input']>;
  discountId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Door tickets held with `holdDoorTicket`, at most 6 per night. Their lines are
   * written with the order in one transaction, priced by the server from the
   * ticket's snapshot; a lapsed hold is refused (`ErrTicketHoldExpired`) and the
   * order is not created. Refused with a tab. Not for remote ticket sales
   * (`createTicketOrder`).
   */
  doorTicketIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * Entry upgrades of scanned guests, each `ScanUpgradeQuote.upgradeToken`. The
   * server verifies the token and prices the upgrade at Pay (never from the
   * token); the guest is admitted when the order is paid. Refused with a tab.
   */
  entryUpgradeTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['UUID']['input'];
  /** Catalog lines. May be empty when the basket carries `doorTicketIds` or `entryUpgradeTokens`; an order with neither is refused. */
  items: Array<OrderItemInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethod;
  tabId?: InputMaybe<Scalars['UUID']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Same rules as on `CalculateOrderInput`. Reserving the voucher (`issued` ->
   * `reserved`) happens here, inside the order transaction.
   *
   * The voucher discounts the catalog lines only, never a ticket line.
   */
  voucherId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Returned by placeOrder: persisted order plus the pending payment (null when charged to a tab). */
export type PlaceOrderResult = {
  __typename?: 'PlaceOrderResult';
  order: Order;
  payment?: Maybe<Payment>;
};

/**
 * One phase button on the POS ticket screen: one eligible `posSale` phase, of one
 * night, rendered like a catalog product. Label is composed client-side from
 * `nightTitle`, the doors-open calendar date, and `stageName`.
 */
export type PosTicketButton = {
  __typename?: 'PosTicketButton';
  /**
   * Calendar date of night `doors_open` in Europe/Amsterdam (`YYYY-MM-DD`).
   * Date only — never a time. Always set; nullable only for client compatibility.
   */
  doorsOpenDate?: Maybe<Scalars['String']['output']>;
  /** End of the entry window (exclusive). Null = the night's doors close. */
  entryEndsAt?: Maybe<Scalars['Time']['output']>;
  /** When this stage's ticket admits (instant). Null = the night's doors open. */
  entryStartsAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Guest-facing wording of the entry window, Europe/Amsterdam. Null when the stage
   * has no entry window. Start equal to doors open: `Entry before HH:MM`. End equal
   * to doors close: `Entry after HH:MM`. Otherwise `Entry HH:MM–HH:MM` (en dash).
   */
  entryWindowLabel?: Maybe<Scalars['String']['output']>;
  nightId: Scalars['UUID']['output'];
  nightTitle: Scalars['String']['output'];
  /** @deprecated Released iPad and Android builds only; use nightId. Removed with the R2e builds, see DEPRECATIONS.md#graphql-production-names */
  productionId: Scalars['UUID']['output'];
  /** @deprecated Released iPad and Android builds only; use nightTitle. Removed with the R2e builds, see DEPRECATIONS.md#graphql-production-names */
  productionTitle: Scalars['String']['output'];
  /**
   * Tickets still sellable for this phase, and the cashier's quantity cap
   * when a cap exists. Null when the stage `maxAmount` is not set — the 6-tickets-per-night cap is separate and is
   * not reported here. `0` means sold out: the phase is still returned so the
   * register shows a disabled button rather than dropping it mid-shift.
   */
  remaining?: Maybe<Scalars['Int']['output']>;
  stageId: Scalars['UUID']['output'];
  stageName: Scalars['String']['output'];
  /** Phase ticket price plus the fee, as one product-button price. */
  unitPriceCents: Scalars['Cents']['output'];
};

export type PosTicketLineInput = {
  quantity: Scalars['Int']['input'];
  stageId: Scalars['UUID']['input'];
};

export type PosTicketOrderPayload = {
  __typename?: 'PosTicketOrderPayload';
  order: Order;
  payment?: Maybe<Payment>;
  tickets: Array<Ticket>;
};

/**
 * The size of a poster image. `ORIGINAL` is the uploaded file. The others are JPEG variants Go makes after the
 * upload (240, 600 and 1200 px wide, same aspect, never upscaled): `THUMB` for lists and chips, `CARD` for
 * cards, `LARGE` for heroes. A poster without that variant (not generated yet, or a source narrower than the
 * width) answers with the original, so a client can always ask for the size its box needs.
 */
export type PosterSize = 'CARD' | 'LARGE' | 'ORIGINAL' | 'THUMB';

/**
 * Browser-upload handle for a night/event poster (5.1 / 5.3).
 *
 * React Admin PUTs the file to `uploadUrl`, then saves `posterPath` on the
 * Blueprint/Night. `posterUrl` is the public read URL minted from
 * POSTER_PUBLIC_BASE_URL (or the GCS bucket URL).
 */
export type PosterUpload = {
  __typename?: 'PosterUpload';
  posterPath: Scalars['String']['output'];
  posterUrl: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type PrepareReceiptInput = {
  orderId?: InputMaybe<Scalars['UUID']['input']>;
  tabId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PriceRule = {
  __typename?: 'PriceRule';
  id: Scalars['UUID']['output'];
  priceCents?: Maybe<Scalars['Cents']['output']>;
  quantity: Scalars['Int']['output'];
  totalCents?: Maybe<Scalars['Cents']['output']>;
};

export type Product = {
  __typename?: 'Product';
  /** Deprecated alias kept for POS compatibility. */
  active: Scalars['Boolean']['output'];
  allowTable: Scalars['Boolean']['output'];
  cashTrade: Scalars['Boolean']['output'];
  categories: Array<Category>;
  categoryIds: Array<Scalars['UUID']['output']>;
  consumptionName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isBottomBar: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceCents: Scalars['Cents']['output'];
  priceRules: Array<PriceRule>;
  sort: Scalars['Int']['output'];
  tax: Scalars['Float']['output'];
  unitAmount?: Maybe<Scalars['Float']['output']>;
  unitLabel?: Maybe<Scalars['String']['output']>;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  nodes: Array<Product>;
  pageInfo: PageMeta;
};

export type ProductFilter = {
  allowTable?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<NumberRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  tax?: InputMaybe<NumberRangeInput>;
};

export type ProductSort = {
  direction?: SortDirection;
  field: ProductSortField;
};

export type ProductSortField = 'IS_ACTIVE' | 'NAME' | 'PRICE' | 'TAX';

/**
 * Result of `CheckCompleteness`.
 *
 * The ExpoApp required-info gate renders **required** fields from this payload
 * **dynamically** (1.3) — it is not a hardcoded last-name/DOB screen, and it
 * does not ask for optional attributes listed for the Home nudge. That matters
 * because the required set varies by `type` (employees and contractors have
 * mandatory profile fields, and contractors additionally `profile_business`)
 * and by golden-ticket assignment (6.8: last name + date of birth required,
 * gate blocks the golden QR sheet). Any new rule must therefore ship as
 * payload, not as a client release.
 */
export type ProfileCompleteness = {
  __typename?: 'ProfileCompleteness';
  missingFields: Array<MissingField>;
  status: CompletenessStatus;
};

/**
 * One event of a published night, as the website and app show it: the
 * display fields only, never the night's internals.
 */
export type PublicEvent = {
  __typename?: 'PublicEvent';
  description?: Maybe<Scalars['String']['output']>;
  /** Optional; empty shows only the start. */
  endsAt?: Maybe<Scalars['Time']['output']>;
  /** Display-only admission copy, e.g. Free till 12, after €5. Null when unset. */
  entrancePriceLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Marked for the website homepage's Featured section. A marker only: the website shows
   * the first six upcoming featured events and falls back to the first six upcoming when none is
   * marked; visibility stays the night's `published`/`active`. No ticket surface reads it.
   */
  featured: Scalars['Boolean']['output'];
  /** Guests going to this event (a count; nobody can list who). Logged-out callers see it too. */
  goingCount: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  /** True only when an authenticated customer is calling and is going to this event (5.4). Never anyone else's. */
  isGoing: Scalars['Boolean']['output'];
  /** True for the one event that has the tickets panel and Get tickets. */
  offersTickets: Scalars['Boolean']['output'];
  /** The poster image at the asked size; the original when the size has no variant. */
  posterUrl?: Maybe<Scalars['String']['output']>;
  /** Public URL key: www serves the event at /events/{slug}. */
  slug: Scalars['String']['output'];
  startsAt: Scalars['Time']['output'];
  title: Scalars['String']['output'];
};

/**
 * One event of a published night, as the website and app show it: the
 * display fields only, never the night's internals.
 */
export type PublicEventPosterUrlArgs = {
  size?: InputMaybe<PosterSize>;
};

/** The link-sale checkout page: the night and the one stage its link names. */
export type PublicLinkStage = {
  __typename?: 'PublicLinkStage';
  night: PublicNight;
  /**
   * Server-side state of the link stage right now: sold out (remaining == 0) wins,
   * then not yet on sale (startsAt in the future), then ended (the stage's end has
   * passed: its Sale ends, or the night's doors open when that is empty), else
   * on sale. Clients must use this, never the device clock.
   */
  saleState: PublicSaleState;
  /** The one band: price, fee, window, remaining. */
  stage: PublicPriceBand;
};

/**
 * A night as the public sees it.
 *
 * Publishable fields only: no financial totals, no personal data, no `published`
 * flag, and **no `websiteSale` / `appSale` / `posSale` flags** — guests never see which channel
 * a stage belongs to; the channel argument filters for them.
 */
export type PublicNight = {
  __typename?: 'PublicNight';
  doorsClose: Scalars['Time']['output'];
  doorsOpen: Scalars['Time']['output'];
  /** Shown on the website's Good to know and in the app. Null when unset: www shows "None, come as you are". */
  dresscode?: Maybe<Scalars['String']['output']>;
  /**
   * The night's events, earliest first (www lists one card and one page
   * per event). Only the event that offers tickets has a tickets panel.
   * Reachable only through the public night queries and their published,
   * active and channel gates.
   */
  events: Array<PublicEvent>;
  /** Cheapest eligible stage price on the requested channel — the "From €…" copy. */
  fromPriceCents?: Maybe<Scalars['Cents']['output']>;
  /** Guests going to at least one event of the night, each counted once. The per-event count is on `events`. */
  goingCount: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  /** True only when an authenticated customer is calling and is going to any event of the night (5.4). The event's own is `PublicEvent.isGoing`. */
  isGoing: Scalars['Boolean']['output'];
  /**
   * The night's lead event for the ticket surfaces: its title, start, poster and slug. Filled on the
   * ticket types (`Ticket.night`, `TicketClaimView.night`, the member and link sale nights, the public night
   * queries); null for a night with no event. On the ticket types `title` and `startsAt` stay the night's (the scan
   * result and the released registers read them), so a ticket surface that names the event reads this. On the public
   * night queries (`publicNights`, `publicNight`, `publicNightBySlug`) `startsAt` is already the lead event's start.
   */
  leadEvent?: Maybe<LeadEvent>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  /**
   * Display-only price ladder on the requested channel (www ticket shop). Empty
   * unless a stage is eligible on that channel right now, so door-only nights leak
   * nothing. Unlike `stages` it also lists sold-out and not-yet-started bands and
   * the door prices, which are never buyable online.
   */
  priceBands: Array<PublicPriceBand>;
  requireTicket: Scalars['Boolean']['output'];
  /**
   * Venue, as the narrowed `ScopeRef` from `loyalty.graphqls`: name plus public
   * street, postal code, and city. Enough to label a cross-scope agenda tile.
   * Deliberately not `Scope`, which carries `adyenMerchantAccountCode`, `phone`,
   * `email`, and flags no guest should read.
   */
  scope: ScopeRef;
  /**
   * Only the stages eligible on the requested channel: flagged for that channel,
   * **never `member`**, in window, not sold out. Empty means ExpoApp shows
   * I'm going, not Buy tickets (5.4).
   */
  stages: Array<PublicNightStage>;
  startsAt: Scalars['Time']['output'];
  /**
   * Venue rate used to quote ExpoApp "Buy with points". Defaults to 35 when the
   * scope has no `scope_ticket_settings` row yet. Does not require `ticket:configure`.
   */
  ticketPointsPerEuro: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PublicNightConnection = {
  __typename?: 'PublicNightConnection';
  nodes: Array<PublicNight>;
  pageInfo: CursorPageInfo;
};

export type PublicNightStage = {
  __typename?: 'PublicNightStage';
  /** End of the entry window (exclusive). Null = the night's doors close. */
  entryEndsAt?: Maybe<Scalars['Time']['output']>;
  /** When this stage's ticket admits (instant). Null = the night's doors open. */
  entryStartsAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Guest-facing wording of the entry window, Europe/Amsterdam. Null when the stage
   * has no entry window. Start equal to doors open: `Entry before HH:MM`. End equal
   * to doors close: `Entry after HH:MM`. Otherwise `Entry HH:MM–HH:MM` (en dash).
   */
  entryWindowLabel?: Maybe<Scalars['String']['output']>;
  feePriceCents: Scalars['Cents']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** Remaining tickets on this stage; null when uncapped. */
  remaining?: Maybe<Scalars['Int']['output']>;
  sort: Scalars['Int']['output'];
  ticketPriceCents: Scalars['Cents']['output'];
};

/**
 * One row of the public price ladder. A new type rather than a wider
 * `PublicNightStage`, which stays "eligible only". Carries no sale flags: a
 * guest sees what a band costs and when, never which channel sells it.
 */
export type PublicPriceBand = {
  __typename?: 'PublicPriceBand';
  /** True for a door band: shown as DOOR ONLY, never buyable online. */
  door: Scalars['Boolean']['output'];
  /**
   * When the online sale of this band ends: the stage's Sale ends, or the
   * night's doors open when that is empty. Always set for a band sold online.
   */
  endsAt?: Maybe<Scalars['Time']['output']>;
  /** End of the entry window (exclusive). Null = the night's doors close. */
  entryEndsAt?: Maybe<Scalars['Time']['output']>;
  /** When this stage's ticket admits (instant). Null = the night's doors open. */
  entryStartsAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Guest-facing wording of the entry window, Europe/Amsterdam. Null when the stage
   * has no entry window. Start equal to doors open: `Entry before HH:MM`. End equal
   * to doors close: `Entry after HH:MM`. Otherwise `Entry HH:MM–HH:MM` (en dash).
   */
  entryWindowLabel?: Maybe<Scalars['String']['output']>;
  feePriceCents: Scalars['Cents']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** Remaining on this band; 0 when sold out, null when uncapped. */
  remaining?: Maybe<Scalars['Int']['output']>;
  sort: Scalars['Int']['output'];
  startsAt?: Maybe<Scalars['Time']['output']>;
  ticketPriceCents: Scalars['Cents']['output'];
};

export type PublicSaleState =
  'ENDED' | 'NOT_YET_ON_SALE' | 'ON_SALE' | 'SOLD_OUT';

export type Query = {
  __typename?: 'Query';
  /** Open recognition-day session for the actor scope, or null when hibernating. */
  activeRecognitionDay?: Maybe<RecognitionDaySession>;
  /** One ticket for the admin detail page. Scope-isolated. Never the claim token. */
  adminTicket?: Maybe<AdminTicket>;
  /**
   * Nights across all active scopes with this customer's going and
   * ticket-ownership state. Keyed on the caller's own `users.id`; the customer JWT
   * carries no scope and this resolver must never reach
   * `contextutil.GetScopeID` (1.7).
   *
   * Only nights that have not finished: still running (`doors_close > now`) or
   * entirely in the future. `publicNights` is *not* time-filtered — see 5.4 / 5.5.
   */
  agenda: AgendaConnection;
  blueprint?: Maybe<Blueprint>;
  blueprints: BlueprintConnection;
  categories: Array<Category>;
  category?: Maybe<Category>;
  chartAvailableDates: Array<Scalars['String']['output']>;
  chartSeries: ChartSeries;
  /**
   * Public, unauthenticated. Asks DNS whether the domain of a typed address can
   * receive mail and suggests the fix for a common typo (`gmail.con`). Call it at
   * submit time only (before the form posts), never per keystroke. Answers DNS
   * facts about the domain and nothing about the mailbox or any account, so it is
   * not an enumeration oracle. A malformed address is `BAD_USER_INPUT`.
   * Rate-limited 20/min/IP, checked before any lookup (`TOO_MANY_REQUESTS`).
   * The order paths (`createTicketOrder`, `attachTicketOrderBuyer`, member
   * sales) run the same check server-side and refuse with `EMAIL_UNDELIVERABLE`.
   */
  checkEmailAddress: EmailAddressCheck;
  consumptionReport: ConsumptionReport;
  /**
   * The same insights for the night whose doors are open now, for the
   * doorman. Null when no night, or more than one, is in its doors window.
   */
  currentEntranceInsights?: Maybe<EntranceInsights>;
  customerIoTemplates: Array<CustomerIoTemplateMapping>;
  /**
   * Live list from the Customer.io App API, wrapped by Go so no API key reaches the
   * browser (same pattern as the Exact pickers). API keys stay in env / Secret
   * Manager and are never editable in this UI.
   */
  customerIoTransactionalTemplates: Array<CustomerIoTransactionalTemplate>;
  /** Customer-safe `me` (1.6 / 1.7). */
  customerMe: CustomerMe;
  /**
   * Whether any venue has an open recognition day and customer realtime may be
   * connected. Global by design: customer JWTs carry no scope.
   */
  customerRealtimeAvailable: Scalars['Boolean']['output'];
  device?: Maybe<Device>;
  /** Status of an unpaired device (polled while showing the pairing screen). */
  deviceStatus: Device;
  devices: DeviceConnection;
  discount?: Maybe<Discount>;
  discountTypes: Array<DiscountTypeSpec>;
  discounts: DiscountConnection;
  /**
   * Public, unauthenticated. The ExpoApp types an email and this query decides
   * whether to collect signup fields, send a magic link, or start a passkey
   * ceremony. Rate-limited 20/min/IP on the same fixed-window helper as
   * `claimDevice` / `requestMagicLink`.
   */
  discoverAuthMethod: AuthMethodDiscovery;
  /**
   * Nights with at least one `door` stage in the device's scope, for the
   * legacy Door picker. Prefer `doorTicketButtons` for the is_door category.
   */
  doorNights: Array<Night>;
  /**
   * Old name of `doorNights`, kept for iPad builds from before the door ticket buttons. No current iPad or Android build selects it.
   * @deprecated Use doorNights. No current register selects it; removed with the R2e builds, see DEPRECATIONS.md#door-productions-query
   */
  doorProductions: Array<Night>;
  /**
   * Synthetic POS buttons for an `is_door` category: one per eligible door phase
   * whose night doors window contains now, including sold-out phases
   * (`remaining: 0`) so the POS can disable them. Uncapped phases return
   * `remaining: null`.
   * Sorted by night `starts_at`, then stage `sort`.
   */
  doorTicketButtons: Array<DoorTicketButton>;
  /**
   * Public, unauthenticated. True when this email already has marketing consent
   * (`users.marketing_opt_in` or `email_marketing_consents.opted_in`). For
   * ExpoApp and other clients where the email is typed later than
   * `discoverAuthMethod`. The Symfony www site no longer calls it. Rate-limited 20/min/IP (same helper as
   * `discoverAuthMethod` / `claimDevice`). Returns only the boolean — no extra PII.
   */
  emailHasMarketingConsent: Scalars['Boolean']['output'];
  /**
   * The **Entrance scans** report: every entrance scan of the scope across
   * nights, newest first by default. `filter.result` empty means **every**
   * result, the invalid attempts (`ALREADY_SCANNED`, `BLOCKED`, `EXPIRED_QR`, ...)
   * included; a set narrows it, and `[REFUSED]` is the former Refused tickets report
   * (reason code and free text). Also filters by kind, night, `scannedAt` /
   * `recognitionDate` range and guest name.
   */
  entranceLogs: EntranceLogConnection;
  /** CRM debtors for invoice-tab Exact Account picker (usable by tab creators). */
  exactAccounts: Array<ExactAccount>;
  exactConfiguration: ExactConfiguration;
  exactDivisions: Array<ExactDivision>;
  exactGLAccounts: Array<ExactGlAccount>;
  exactItems: Array<ExactItem>;
  exactJournalEntries: ExactJournalEntryConnection;
  exactJournalEntry?: Maybe<ExactJournalEntry>;
  exactJournals: Array<ExactJournal>;
  exactSalesInvoiceForTab?: Maybe<ExactSalesInvoice>;
  exactVATCodes: Array<ExactVatCode>;
  exportCategoriesCsv: ExportJob;
  exportDevicesCsv: ExportJob;
  exportDiscountsCsv: ExportJob;
  exportLedgerTransactionsCsv: ExportJob;
  /** AVG/GDPR export. Customers only (1.6). */
  exportMyData: CustomerDataExport;
  exportOrdersCsv: ExportJob;
  exportPaymentsCsv: ExportJob;
  exportProductsCsv: ExportJob;
  exportRefundsCsv: ExportJob;
  exportTablesCsv: ExportJob;
  exportTabsCsv: ExportJob;
  exportTerminalsCsv: ExportJob;
  exportVouchersCsv: ExportJob;
  goldenTicket?: Maybe<GoldenTicket>;
  /**
   * Owner-only mint. Returns a fresh ciphertext on every call; the app calls it on
   * sheet open and every 2 minutes while open.
   *
   * Blocked with `action_required` while the holder's profile is incomplete (1.3).
   */
  goldenTicketQr: GoldenTicketQr;
  goldenTickets: GoldenTicketConnection;
  /** Reserved guest-list tickets for this night. Another scope is not-found. */
  guestListEntries: Array<GuestListTicket>;
  /**
   * The manage page of the address behind an old guest-list invite link
   * (`/tickets/guest-list/{token}`, only ever in the invitee's mailbox: no staff
   * mutation returns it). The invite token is the credential. Returns a fresh
   * scope-less manage link `{WWW}/tickets/manage/{token}` on every call, valid 90
   * days from now, for the entry's address. An unknown token, one rotated by
   * `resendGuestListInvite`, a blank one, and one whose night ended more than a day
   * ago (doors close + 24h) are NOT_FOUND. Public, no session, no scope. Rate-limited by
   * IP like the other public ticket reads.
   */
  guestListManageUrl: Scalars['String']['output'];
  historyOrders: Array<Order>;
  historyTabs: Array<Tab>;
  /** Single bootstrap payload for a POS device (Section 3). */
  hydrate: HydrationState;
  ledgerTransaction?: Maybe<LedgerTransaction>;
  ledgerTransactions: LedgerTransactionConnection;
  link?: Maybe<Link>;
  links: Array<Link>;
  loyaltySettings: LoyaltySettings;
  /**
   * The manage page of one e-mail address. `token` is the per-address capability
   * from the ticket mails (`m.…`, sealed, 90 days). Returns null for an unknown,
   * tampered or expired token. Public: the token is the only credential, no
   * session and no `scope_id` (a customer-style read). Lists the tickets that
   * address paid for or holds, scoped to the address like `myTickets`, including
   * tickets already used at the door (`usedAt`). Rate-limited by IP.
   */
  manageTickets?: Maybe<ManageTicketsView>;
  /** Authenticated manager profile. */
  me: User;
  /**
   * Public member-sale invite. Token is the capability (same model as
   * `receiptByToken`). Returns null for an unknown token. Exposes only what the
   * invite screen needs — never the buyer email or the hash. `eventSlug` is the slug of the event
   * whose page the link was opened on: any event of the invite's night opens it, a slug of another
   * night's event is answered with null. Omitted skips that check. Also null while no event of the
   * night offers tickets; the member order is refused too. Rate-limited by IP.
   */
  memberSale?: Maybe<MemberSaleInvite>;
  /** Read-only masked linked cards (4.4). */
  myCards: Array<LinkedCard>;
  /** The caller's active golden ticket, or null. Drives the extra Tickets-tab card. */
  myGoldenTicket?: Maybe<GoldenTicket>;
  /**
   * Guest-list entries for the verified customer. No scope. The caller's email
   * is the capability. A different email is an empty list.
   */
  myGuestLists: Array<GuestListForCustomer>;
  /** Global points balance (2.2). */
  myPointsBalance: Scalars['Int']['output'];
  /**
   * Paginated points ledger (4.4) for the infinitely-scrolling ExpoApp tab.
   *
   * Cursor pagination (`first` / `after` + `CursorPageInfo`), matching `agenda`
   * and `publicNights`. Ledger rows are append-only; the cursor is
   * `created_at|id` (newest first). Admin grids (`users`, `orders`, `payments`,
   * voucher lists) keep offset `page` / `pageSize` + `PageMeta` so a manager can
   * jump to page N. See Go/AGENTS.md § GraphQL pagination.
   */
  myPointsLedger: LoyaltyLedgerConnection;
  /**
   * Onboarding guard payload for the calling customer (1.3). Also exposed as
   * `CustomerMe.completeness`; available standalone so a navigation guard can
   * re-check it without refetching the whole profile.
   *
   * Staff use `me { completeness }` instead — this field stays `@isCustomer`.
   */
  myProfileCompleteness: ProfileCompleteness;
  /** Up to five nearest locked thresholds across every scope (4.4). Each row is labelled with its venue. */
  myRewardProgress: Array<RewardProgress>;
  /**
   * Tickets this customer holds for nights that have not ended (claimed,
   * unclaimed, and WAITING_FOR_PAYMENT). A night ends when `doorsClose` passes
   * — same window as `agenda` (5.2).
   * A ticket used at the door (`entrance_logs` `valid` or `refused`) is omitted
   * immediately, even while doors are still open. Released / refunded rows are
   * omitted. Golden tickets are `myGoldenTicket`.
   */
  myTickets: Array<Ticket>;
  /**
   * Every voucher the caller holds, from EVERY scope.
   *
   * A documented read-only exception to AGENTS.md §9, keyed on the caller's own
   * `users.id` (1.7). Each entry carries its scope name so the app can say where it
   * is redeemable.
   */
  myVouchers: Array<Voucher>;
  night?: Maybe<Night>;
  /**
   * Sold / scanned / admitted / refused for one night: a row per stage
   * (door-only stages have none), then the Door row, then the Golden ticket row, and a total over all of them.
   * Live: `liveUpdated.entranceInsights`.
   */
  nightEntranceInsights: EntranceInsights;
  /**
   * Per-night entrance list: time, guest, kind, result (including refused),
   * scanner. This log's PII never goes to Customer.io.
   */
  nightEntranceLogs: EntranceLogConnection;
  nightEntranceSummary: EntranceSummary;
  /**
   * The numbers of one night's Ticket sales block. Another scope's night is NOT_FOUND. The revenue is null without
   * `report:chart:read`; the counts need only `ticket:read`. Totals only: no guest names or addresses.
   */
  nightTicketSummary: NightTicketSummary;
  /**
   * Per-night ticket grid. Filter by status to find unclaimed rows.
   * Offset pagination. Never returns the claim token or its hash.
   */
  nightTickets: AdminTicketConnection;
  nights: NightConnection;
  order?: Maybe<Order>;
  orderPayments: Array<Payment>;
  orders: OrderConnection;
  payments: PaymentConnection;
  /**
   * The buyer hand-off this register still owes an email for, or null. The
   * register is blocked on this: it re-reads it on every hydrate so the QR
   * survives an app restart.
   */
  pendingTicketHandoff?: Maybe<TicketBuyerHandoff>;
  permissions: Array<Permission>;
  /**
   * Phase buttons for the POS ticket screen: one per `posSale` phase currently
   * on sale in this scope, across every night whose `doors_close` is still
   * in the future (unset close is omitted), including sold-out phases
   * (`remaining: 0`) so the register can disable them. Uncapped phases return
   * `remaining: null`.
   * Sorted by night `starts_at`, then stage `sort`.
   */
  posTicketButtons: Array<PosTicketButton>;
  product?: Maybe<Product>;
  products: ProductConnection;
  /**
   * Link-sale checkout page. The stage id is the capability: anyone with the link
   * can buy this stage. Null for an unknown, inactive or non-link stage or an
   * unpublished night. Returned regardless of window and stock so the page can say
   * sold out / not yet on sale. `eventSlug` is the slug of the event whose page the link was opened
   * on: any event of the stage's night opens it (a link sent while another event offered tickets keeps
   * working), a slug of another night's event is answered with null. Omitted skips that check.
   * Also null while no event of the night offers tickets (no event offering tickets means no online
   * tickets), whatever the slug; `createTicketOrder` refuses the order too. Rate-limited by IP.
   */
  publicLinkStage?: Maybe<PublicLinkStage>;
  /** Public detail page. Returns null when the night is unpublished, inactive, or unknown. */
  publicNight?: Maybe<PublicNight>;
  /**
   * Same as publicNight, keyed on the public URL slug of one of its events (/events/{slug}). Null
   * for an unknown slug, or an unpublished or inactive night. Rate-limited by IP.
   */
  publicNightBySlug?: Maybe<PublicNight>;
  /**
   * Published nights across **all active scopes**, for the logged-out ExpoApp
   * Agenda and the Symfony www "Events" pages / cache resync.
   *
   * This is deliberately anonymous, in the same spirit as `receiptByToken`: the
   * data is public marketing data and a scoped manager credential could not return
   * it anyway, because a manager JWT is bound to exactly one active scope.
   *
   * * A documented exception to `Go/AGENTS.md` §9 (every query filters on
   *   `scope_id`), alongside the customer reads in 1.7. Read-only, public fields
   *   only, no financial or personal data.
   * * Filters on `published` **and** `active`; unpublished or inactive rows are
   *   invisible. A sold-out past night can stay published while going inactive.
   * * **Rate-limited by IP**, reusing `internal/platform/ratelimit` (the
   *   fixed-window helper behind `claimDevice`), because it is unauthenticated and
   *   internet-facing.
   * * `channel` narrows the returned stages and drops nights with no eligible
   *   stage; omit it to list nights without a buy CTA.
   */
  publicNights: PublicNightConnection;
  /** Public: token is the capability. Returns null when invalid or expired. */
  receiptByToken?: Maybe<CustomerReceipt>;
  /** Paginated recognition-day sessions for the actor scope (newest first). */
  recognitionDaySessions: RecognitionDaySessionConnection;
  refunds: RefundConnection;
  /**
   * Resolve a terminal claim token to the payment behind it (2.1 / 3.0).
   *
   * Deliberately PUBLIC: the token is the capability, the same model as
   * `receiptByToken`. It must be callable before the guest has an account, because
   * on the deferred deep-link path the app resolves the token on first launch —
   * before any signup has happened. Resolving is read-only and never links
   * anything; `linkCardByClaimToken` does that and requires a customer principal.
   */
  resolveCardClaimToken: CardClaimPreview;
  role?: Maybe<Role>;
  roles: Array<Role>;
  /** Ticket tax settings for the caller's active scope. */
  scopeTicketSettings: ScopeTicketSettings;
  scopes: Array<Scope>;
  tab?: Maybe<Tab>;
  tabOrders: Array<Order>;
  tabPayments: Array<Payment>;
  tables: Array<Table>;
  tabs: TabConnection;
  taxReport?: Maybe<TaxReport>;
  taxReportPeriods: TaxReportPeriodConnection;
  terminal?: Maybe<Terminal>;
  terminals: TerminalConnection;
  /**
   * Public view behind the hand-off QR. Returns null for an unknown or
   * already-answered token — a screenshot cannot be used to probe orders.
   */
  ticketBuyerHandoff?: Maybe<TicketHandoffSummary>;
  /** Public claim view. Returns null for an unknown, expired or revoked token. */
  ticketClaim?: Maybe<TicketClaimView>;
  /**
   * Poll PSP progress and the hold countdown. `token` is required for anonymous www
   * checkout; an authenticated buyer may omit it.
   */
  ticketOrder: TicketOrderStatus;
  ticketPresaleByDay: TicketPresaleChart;
  ticketSalesNights: Array<TicketSalesNight>;
  ticketSalesSeries: TicketSalesChart;
  /**
   * Scope-wide ticket grid. Empty filter lists every ticket in the caller's
   * active scope, newest first. Never returns the claim token or its hash.
   */
  tickets: AdminTicketConnection;
  tipReport: TipReport;
  /** Legacy compatibility — superseded by orders(filter: ...) in admin. */
  turnover: Array<TurnoverReport>;
  turnoverAvailableWeeks: Array<Scalars['Int']['output']>;
  turnoverWeek: TurnoverWeek;
  user?: Maybe<User>;
  /** Loyalty panel for the React admin user detail screen. */
  userLoyalty: UserLoyalty;
  /**
   * Roles that can be bound to users (actor kind user or any). For the users-grid
   * Role filter. `user:read` so venue admins can filter without `role:manage`.
   */
  userRoleOptions: Array<RoleOption>;
  users: UserConnection;
  voucher?: Maybe<Voucher>;
  voucherRule?: Maybe<VoucherRule>;
  /**
   * Active nights the rule form may offer: those in venues where the caller
   * holds `ticket:read` (any venue, not only the active one), newest first.
   * Staff only; a device gets an empty list.
   */
  voucherRuleNights: Array<VoucherRuleNight>;
  /** Voucher rules in the active scope. */
  voucherRules: Array<VoucherRule>;
  /** Issued-voucher grid for the active scope. */
  vouchers: VoucherConnection;
};

export type QueryAdminTicketArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryAgendaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryBlueprintArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryBlueprintsArgs = {
  filter?: InputMaybe<BlueprintFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BlueprintSort>;
};

export type QueryCategoriesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryChartAvailableDatesArgs = {
  preset: ChartPreset;
};

export type QueryChartSeriesArgs = {
  bucket: ChartBucket;
  preset: ChartPreset;
  recognitionDate: Scalars['String']['input'];
  windowEnd?: InputMaybe<Scalars['String']['input']>;
  windowStart?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckEmailAddressArgs = {
  email: Scalars['String']['input'];
};

export type QueryConsumptionReportArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
};

export type QueryDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDeviceStatusArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryDevicesArgs = {
  filter?: InputMaybe<DeviceFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDiscountArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDiscountsArgs = {
  filter?: InputMaybe<DiscountFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDiscoverAuthMethodArgs = {
  email: Scalars['String']['input'];
};

export type QueryEmailHasMarketingConsentArgs = {
  email: Scalars['String']['input'];
};

export type QueryEntranceLogsArgs = {
  filter?: InputMaybe<EntranceLogFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EntranceLogSort>;
};

export type QueryExactJournalEntriesArgs = {
  filter?: InputMaybe<ExactJournalEntryFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ExactJournalEntrySort>;
};

export type QueryExactJournalEntryArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryExactSalesInvoiceForTabArgs = {
  tabId: Scalars['UUID']['input'];
};

export type QueryExportDevicesCsvArgs = {
  filter?: InputMaybe<DeviceFilter>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExportDiscountsCsvArgs = {
  filter?: InputMaybe<DiscountFilter>;
};

export type QueryExportLedgerTransactionsCsvArgs = {
  filter?: InputMaybe<LedgerTransactionFilter>;
  sort?: InputMaybe<LedgerTransactionSort>;
};

export type QueryExportOrdersCsvArgs = {
  filter?: InputMaybe<OrderFilter>;
  sort?: InputMaybe<OrderSort>;
};

export type QueryExportPaymentsCsvArgs = {
  filter?: InputMaybe<PaymentFilter>;
  sort?: InputMaybe<PaymentSort>;
};

export type QueryExportProductsCsvArgs = {
  filter?: InputMaybe<ProductFilter>;
  sort?: InputMaybe<ProductSort>;
};

export type QueryExportRefundsCsvArgs = {
  filter?: InputMaybe<RefundFilter>;
  sort?: InputMaybe<RefundSort>;
};

export type QueryExportTabsCsvArgs = {
  filter?: InputMaybe<TabFilter>;
  sort?: InputMaybe<TabSort>;
  status?: InputMaybe<TabStatusGroup>;
};

export type QueryExportTerminalsCsvArgs = {
  filter?: InputMaybe<TerminalFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExportVouchersCsvArgs = {
  filter?: InputMaybe<VoucherFilter>;
};

export type QueryGoldenTicketArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryGoldenTicketsArgs = {
  filter?: InputMaybe<GoldenTicketFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGuestListEntriesArgs = {
  nightId: Scalars['UUID']['input'];
};

export type QueryGuestListManageUrlArgs = {
  token: Scalars['String']['input'];
};

export type QueryHistoryOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryHistoryTabsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLedgerTransactionArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryLedgerTransactionsArgs = {
  filter?: InputMaybe<LedgerTransactionFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LedgerTransactionSort>;
};

export type QueryLinkArgs = {
  id: Scalars['ID']['input'];
};

export type QueryManageTicketsArgs = {
  token: Scalars['String']['input'];
};

export type QueryMemberSaleArgs = {
  eventSlug?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type QueryMyPointsLedgerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMyVouchersArgs = {
  status?: InputMaybe<Array<VoucherStatus>>;
};

export type QueryNightArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryNightEntranceInsightsArgs = {
  nightId: Scalars['UUID']['input'];
};

export type QueryNightEntranceLogsArgs = {
  filter?: InputMaybe<EntranceLogFilter>;
  nightId: Scalars['UUID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EntranceLogSort>;
};

export type QueryNightEntranceSummaryArgs = {
  nightId: Scalars['UUID']['input'];
};

export type QueryNightTicketSummaryArgs = {
  nightId: Scalars['UUID']['input'];
};

export type QueryNightTicketsArgs = {
  filter?: InputMaybe<NightTicketFilter>;
  nightId: Scalars['UUID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryNightsArgs = {
  filter?: InputMaybe<NightFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<NightSort>;
};

export type QueryOrderArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryOrderPaymentsArgs = {
  orderId: Scalars['UUID']['input'];
};

export type QueryOrdersArgs = {
  filter?: InputMaybe<OrderFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OrderSort>;
};

export type QueryPaymentsArgs = {
  filter?: InputMaybe<PaymentFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PaymentSort>;
};

export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};

export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSort>;
};

export type QueryPublicLinkStageArgs = {
  eventSlug?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['UUID']['input'];
};

export type QueryPublicNightArgs = {
  channel?: InputMaybe<SalesChannel>;
  id: Scalars['UUID']['input'];
};

export type QueryPublicNightBySlugArgs = {
  channel?: InputMaybe<SalesChannel>;
  slug: Scalars['String']['input'];
};

export type QueryPublicNightsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<SalesChannel>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryReceiptByTokenArgs = {
  token: Scalars['String']['input'];
};

export type QueryRecognitionDaySessionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRefundsArgs = {
  filter?: InputMaybe<RefundFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RefundSort>;
};

export type QueryResolveCardClaimTokenArgs = {
  token: Scalars['String']['input'];
};

export type QueryRoleArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryRolesArgs = {
  actorKind?: InputMaybe<ActorKind>;
};

export type QueryTabArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTabOrdersArgs = {
  tabId: Scalars['UUID']['input'];
};

export type QueryTabPaymentsArgs = {
  tabId: Scalars['UUID']['input'];
};

export type QueryTablesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryTabsArgs = {
  filter?: InputMaybe<TabFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TabSort>;
  status?: InputMaybe<TabStatusGroup>;
};

export type QueryTaxReportArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  recognitionDate?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTaxReportPeriodsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTerminalArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTerminalsArgs = {
  filter?: InputMaybe<TerminalFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTicketBuyerHandoffArgs = {
  token: Scalars['String']['input'];
};

export type QueryTicketClaimArgs = {
  token: Scalars['String']['input'];
};

export type QueryTicketOrderArgs = {
  orderId: Scalars['UUID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTicketSalesSeriesArgs = {
  interval: TicketSalesInterval;
  nightIds: Array<Scalars['UUID']['input']>;
};

export type QueryTicketsArgs = {
  filter?: InputMaybe<TicketLookupFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTipReportArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  recognitionDate?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTurnoverArgs = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type QueryTurnoverAvailableWeeksArgs = {
  year: Scalars['Int']['input'];
};

export type QueryTurnoverWeekArgs = {
  compare?: InputMaybe<TurnoverCompare>;
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUserLoyaltyArgs = {
  userId: Scalars['UUID']['input'];
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVoucherArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryVoucherRuleArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryVoucherRuleNightsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVoucherRulesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryVouchersArgs = {
  filter?: InputMaybe<VoucherFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VoucherSort>;
};

export type ReceiptPayload = {
  __typename?: 'ReceiptPayload';
  expiresAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
};

export type RecognitionDayEventIntent =
  'RECOGNITION_DAY_ENDED' | 'RECOGNITION_DAY_STARTED';

export type RecognitionDayEventPayload = {
  __typename?: 'RecognitionDayEventPayload';
  intent: RecognitionDayEventIntent;
  session: RecognitionDaySession;
};

/** Open/close session for a recognition (trading) day — gates POS hibernate. */
export type RecognitionDaySession = {
  __typename?: 'RecognitionDaySession';
  closeReason?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['UUID']['output'];
  isOpen: Scalars['Boolean']['output'];
  openedAt: Scalars['Time']['output'];
  recognitionDate: Scalars['String']['output'];
};

export type RecognitionDaySessionConnection = {
  __typename?: 'RecognitionDaySessionConnection';
  nodes: Array<RecognitionDaySession>;
  pageInfo: PageMeta;
};

export type RecordEntranceDecisionInput = {
  decision: EntranceDecision;
  /** Optional short free text on a refusal. */
  refuseNote?: InputMaybe<Scalars['String']['input']>;
  /** Required when `decision` is REFUSED, rejected otherwise. */
  refuseReason?: InputMaybe<RefuseReason>;
  /** From `ScanResult.scanToken`. */
  scanToken: Scalars['String']['input'];
};

export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Cents']['output'];
  createdAt: Scalars['String']['output'];
  device?: Maybe<Device>;
  deviceId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['UUID']['output']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['UUID']['output']>;
  paymentMethod: Scalars['String']['output'];
  recognitionDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tab?: Maybe<Tab>;
  tabId?: Maybe<Scalars['UUID']['output']>;
  terminal?: Maybe<Terminal>;
  terminalId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type RefundConnection = {
  __typename?: 'RefundConnection';
  nodes: Array<Refund>;
  pageInfo: PageMeta;
};

export type RefundEventIntent =
  'REFUND_CANCELED' | 'REFUND_FAILED' | 'REFUND_PENDING' | 'REFUND_SUCCEEDED';

export type RefundFilter = {
  amount?: InputMaybe<NumberRangeInput>;
  createdAt?: InputMaybe<DateRangeInput>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Array<Scalars['String']['input']>>;
  recognitionDate?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  tabId?: InputMaybe<Scalars['String']['input']>;
  terminalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RefundSort = {
  direction?: SortDirection;
  field: RefundSortField;
};

export type RefundSortField =
  | 'AMOUNT'
  | 'CREATED_AT'
  | 'ID'
  | 'ORDER_ID'
  | 'PAYMENT_ID'
  | 'PAYMENT_METHOD'
  | 'RECOGNITION_DATE'
  | 'STATUS'
  | 'TAB_NAME'
  | 'TERMINAL_NAME'
  | 'UPDATED_AT';

export type RefundUpdatePayload = {
  __typename?: 'RefundUpdatePayload';
  intent: RefundEventIntent;
  refund: Refund;
  timestamp: Scalars['Time']['output'];
};

export type RefuseReason =
  'BEHAVIOUR_AT_DOOR' | 'ID_MISMATCH' | 'OTHER' | 'TOO_INTOXICATED';

/**
 * Sign-in asks only for the e-mail. The app never collects a name or the terms here:
 * a new address gets a bare customer and the required-fields gate
 * (`CustomerMe.completeness` / `myProfileCompleteness`) asks for what is missing —
 * first name and the terms (`termsAccepted`) — after login.
 */
export type RequestMagicLinkInput = {
  email: Scalars['String']['input'];
};

export type RequestMagicLinkPayload = {
  __typename?: 'RequestMagicLinkPayload';
  /** When sent, the token TTL (~15 minutes) so the app can show a resend countdown. */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  /**
   * True when the send was queued (outbox insert + publish succeeded). This is not
   * a Customer.io delivery receipt — the transactional send is asynchronous via
   * the email handler. Failures after queue (missing template Subject, bad App API
   * key, wrong region, unmapped id) are logged at ERROR with an actionable fix. An
   * unmapped `magic_link` kind is rejected here before queueing.
   */
  sent: Scalars['Boolean']['output'];
  /**
   * Limited 24h session, only for an address that had no account: it is created
   * as a customer with an empty first name and no accepted terms, and the app
   * enters at once (the completeness gate then asks for both). Null for every
   * known address — created, active, imported or provisional — so typing someone's
   * e-mail never logs the caller in as them: the emailed link is what claims an
   * imported / provisional row and upgrades `created` → `active`.
   */
  session?: Maybe<AuthPayload>;
};

/**
 * Progress toward a locked voucher threshold (4.4).
 *
 * Not a tier: thresholds are scoped rules evaluated against the one global balance.
 * `myRewardProgress` returns the five nearest locked rules across every scope,
 * nearest remaining points first, each labelled with its venue. Wording in the
 * app must be "next up", never "exchangeable". Minting a threshold voucher does
 * not spend points; redeeming it at the bar does (2.3).
 */
export type RewardProgress = {
  __typename?: 'RewardProgress';
  /** The caller's global balance, repeated per entry so a tile renders standalone. */
  currentPoints: Scalars['Int']['output'];
  /**
   * Compat alias of `label`.
   * @deprecated Renamed to label.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The rule's customer label, shown on the ExpoApp tile. The rule's internal `name` is deliberately not served here (a guest reads `label`). Null means the rule has no customer label: a next-up row then shows the points only, with no calculated text (a progress row has no benefit field to fall back to). */
  label?: Maybe<Scalars['String']['output']>;
  /** thresholdPoints - currentPoints, floored at 0. */
  remainingPoints: Scalars['Int']['output'];
  ruleId: Scalars['UUID']['output'];
  /**
   * Old ExpoApp builds only; the internal rule name is not customer copy. Compat alias, removed once the builds that read it are replaced.
   * @deprecated Old ExpoApp builds only; the internal rule name is not customer copy.
   */
  ruleName: Scalars['String']['output'];
  scope: ScopeRef;
  thresholdPoints: Scalars['Int']['output'];
};

export type Role = {
  __typename?: 'Role';
  actorKind: ActorKind;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  slug: Scalars['String']['output'];
};

export type RoleBindingInput = {
  roleId?: InputMaybe<Scalars['UUID']['input']>;
  scopeId: Scalars['UUID']['input'];
};

/** User-kind (and any-kind) roles for pickers. Names only — no permission codes. */
export type RoleOption = {
  __typename?: 'RoleOption';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/**
 * Public sales channel. The two flags are independent and both may be true; they
 * decide which nights/stages each channel offers and are **never shown to
 * guests**.
 */
export type SalesChannel =
  /** ExpoApp public checkout (6.4) — stages flagged `appSale`. */
  | 'APP'
  /** Symfony www public checkout (6.5) — stages flagged `websiteSale`. */
  | 'WEBSITE';

export type SaveExactMappingInput = {
  adyenGlCode: Scalars['String']['input'];
  adyenGlDescription: Scalars['String']['input'];
  adyenGlId: Scalars['UUID']['input'];
  cashGlCode: Scalars['String']['input'];
  cashGlDescription: Scalars['String']['input'];
  cashGlId: Scalars['UUID']['input'];
  entryDescription: Scalars['String']['input'];
  itemHighCode: Scalars['String']['input'];
  itemHighDescription: Scalars['String']['input'];
  itemHighId: Scalars['UUID']['input'];
  itemLowCode: Scalars['String']['input'];
  itemLowDescription: Scalars['String']['input'];
  itemLowId: Scalars['UUID']['input'];
  journalCode: Scalars['String']['input'];
  revenueHighGlCode: Scalars['String']['input'];
  revenueHighGlDescription: Scalars['String']['input'];
  revenueHighGlId: Scalars['UUID']['input'];
  revenueLowGlCode: Scalars['String']['input'];
  revenueLowGlDescription: Scalars['String']['input'];
  revenueLowGlId: Scalars['UUID']['input'];
  salesJournalCode: Scalars['String']['input'];
  tabsGlCode: Scalars['String']['input'];
  tabsGlDescription: Scalars['String']['input'];
  tabsGlId: Scalars['UUID']['input'];
  tipsGlCode: Scalars['String']['input'];
  tipsGlDescription: Scalars['String']['input'];
  tipsGlId: Scalars['UUID']['input'];
  vatCodeHigh: Scalars['String']['input'];
  vatCodeLow: Scalars['String']['input'];
  vatPercentageHigh: Scalars['Float']['input'];
  vatPercentageLow: Scalars['Float']['input'];
};

/**
 * Saved by its own mutation rather than folded into `SaveExactMappingInput`, so the
 * existing Exact save keeps its exact shape while these epics are in flight. The
 * orchestrator may merge the two inputs later; the stored columns are the same row
 * either way.
 */
export type SaveExactTicketMappingInput = {
  bookingFeeGlCode?: InputMaybe<Scalars['String']['input']>;
  bookingFeeGlDescription?: InputMaybe<Scalars['String']['input']>;
  bookingFeeGlId?: InputMaybe<Scalars['UUID']['input']>;
  paypalGlCode?: InputMaybe<Scalars['String']['input']>;
  paypalGlDescription?: InputMaybe<Scalars['String']['input']>;
  paypalGlId?: InputMaybe<Scalars['UUID']['input']>;
  ticketGlCode: Scalars['String']['input'];
  ticketGlDescription: Scalars['String']['input'];
  ticketGlId: Scalars['UUID']['input'];
  ticketItemCode: Scalars['String']['input'];
  ticketItemDescription: Scalars['String']['input'];
  ticketItemId: Scalars['UUID']['input'];
  ticketVatCode: Scalars['String']['input'];
  ticketVatPercentage: Scalars['Float']['input'];
};

/**
 * Guest identity on a green scan.
 *
 * For a **claimed** ticket these come from the claim row and the ticket. For a
 * **golden** pass the same fields come from `users` + `profile_personal`, with
 * `purchasedAt` / `claimedAt` null ("Golden") and `paymentMethod` = `golden`.
 */
export type ScanGuest = {
  __typename?: 'ScanGuest';
  claimedAt?: Maybe<Scalars['Time']['output']>;
  /** `YYYY-MM-DD`. The doorman's real age check. */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** `pin` / `cash` / `online` / `paypal`, or `golden` for a golden pass. */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  purchasedAt?: Maybe<Scalars['Time']['output']>;
};

export type ScanKind =
  /** Static QR on a claimed night ticket. */
  | 'CLAIMED'
  /** Rotating AES-GCM ciphertext from `goldenTicketQr`. */
  | 'GOLDEN';

export type ScanOutcome =
  /** Admissible. Show the guest fields and the Accepted / Refused actions. */
  | 'GREEN'
  /** Good ticket, but the server clock is outside the stage entry window: `window` says by how much and quotes the door upgrade. `scanToken` is present; Accepted / Refused work as on GREEN. */
  | 'OUTSIDE_WINDOW'
  /** Not admissible. `reason` says why; no Accepted / Refused actions. */
  | 'RED';

/**
 * Red reasons, 1:1 with the non-decision values of `entrance_logs.result`.
 *
 * `VALID` and `REFUSED` are absent on purpose: they are decisions, not scan
 * outcomes, and only `recordEntranceDecision` can produce them.
 */
export type ScanRejectReason =
  /** A used row (Accepted **or** Refused) already exists for this ticket / pass. */
  | 'ALREADY_SCANNED'
  /** The ticket is blocked. Logged as an invalid attempt; nothing is used up, so the same QR is green again once unblocked. */
  | 'BLOCKED'
  /** Golden ciphertext did not authenticate. */
  | 'DECRYPT_FAILED'
  /** Golden QR older than 3 minutes — a stale photo. */
  | 'EXPIRED_QR'
  /** No night has doors_open <= now < doors_close in the scanner's scope, or more than one does (fail closed). */
  | 'NO_DOORS_WINDOW'
  /** Claimed QR belongs to a different night than the one at the door. */
  | 'WRONG_NIGHT'
  | 'WRONG_PRODUCTION';

/**
 * Step 1 of the two-step admission.
 *
 * **Nothing is written to `entrance_logs` for a green scan.** The ticket is not used
 * until the doorman taps Accepted or Refused, so dismissing the screen leaves the
 * ticket unused. When the claim or golden holder has a `user_id`, a green scan
 * enqueues `ticket_scan_pending` so the guest phone can show waiting — that
 * outbox row is not an admission lock. Red scans are appended immediately (they
 * are the diagnostic record) and do not consume the admission slot.
 */
export type ScanResult = {
  __typename?: 'ScanResult';
  /** Guest fields for the green screen. Null on RED. */
  guest?: Maybe<ScanGuest>;
  kind: ScanKind;
  /** The doors-window night this scan resolved to. Null on NO_DOORS_WINDOW. */
  night?: Maybe<PublicNight>;
  outcome: ScanOutcome;
  /** @deprecated Released iPad and Android builds only; use night. Removed with the R2e builds, see DEPRECATIONS.md#graphql-production-names */
  production?: Maybe<PublicNight>;
  /** Set on RED only. */
  reason?: Maybe<ScanRejectReason>;
  /**
   * Short-lived handle binding this scan for step 2. Present on `GREEN` and `OUTSIDE_WINDOW`.
   *
   * It is an opaque, server-signed token (HMAC over the resolved ticket or golden
   * ticket id, the doors-window night, the scanner principal and an expiry) —
   * **not** a database row, which is why this migration set adds no `scan_intents`
   * table. Two consequences that matter:
   *
   * * `recordEntranceDecision` carries no client-supplied identity: the ticket,
   *   night and scanner all come out of the verified token, so a doorman
   *   cannot admit a ticket they never scanned.
   * * It is stateless, so it survives a Cloud Run instance change mid-scan.
   *
   * It expires with `scanTokenExpiresAt` (~2 minutes) and the admission lock is
   * still the unique partial index, so a replayed token loses to
   * `already_scanned`.
   */
  scanToken?: Maybe<Scalars['String']['output']>;
  scanTokenExpiresAt?: Maybe<Scalars['Time']['output']>;
  /** Set on OUTSIDE_WINDOW only. */
  window?: Maybe<ScanWindow>;
};

export type ScanTicketInput = {
  kind: ScanKind;
  /** Raw QR contents: the ticket QR payload, or the golden ciphertext. */
  payload: Scalars['String']['input'];
};

/**
 * The door upgrade offered on an outside-window scan: the price gap to the door
 * stage plus the late fee. Booking fees are ignored. A quote only: the scan sells
 * nothing. The register sells it by sending `upgradeToken` in
 * `PlaceOrderInput.entryUpgradeTokens`; the server recomputes the amount at Pay.
 */
export type ScanUpgradeQuote = {
  __typename?: 'ScanUpgradeQuote';
  /** max(0, door price - ticket price). */
  differenceCents: Scalars['Cents']['output'];
  doorStageId: Scalars['UUID']['output'];
  doorStageName: Scalars['String']['output'];
  doorTicketPriceCents: Scalars['Cents']['output'];
  lateFeeCents: Scalars['Cents']['output'];
  /** The name of the line the order will carry, e.g. `Upgrade Early ticket Night 28-08`. */
  lineName: Scalars['String']['output'];
  /** differenceCents + lateFeeCents; always above 0. */
  totalCents: Scalars['Cents']['output'];
  /**
   * The scan token re-signed for selling this upgrade: send it in
   * `PlaceOrderInput.entryUpgradeTokens`. It is not an admission handle
   * (`recordEntranceDecision` refuses it) and the amount is never read from it.
   */
  upgradeToken: Scalars['String']['output'];
  /** When `upgradeToken` stops being accepted (15 minutes after the scan). */
  upgradeTokenExpiresAt: Scalars['Time']['output'];
};

/**
 * Why an `OUTSIDE_WINDOW` scan is amber: the ticket's stage admits only inside
 * its entry window and the server clock is outside it. The cutoff is hard: at the
 * exact end instant the scan is already outside.
 */
export type ScanWindow = {
  __typename?: 'ScanWindow';
  entryEndsAt?: Maybe<Scalars['Time']['output']>;
  /** The stage's entry window start; a missing bound is the doors bound. Null when open-ended. */
  entryStartsAt?: Maybe<Scalars['Time']['output']>;
  /** `Entry before 21:00`, `Entry after 17:00` or `Entry 17:00–21:00` (Europe/Amsterdam). */
  entryWindowLabel?: Maybe<Scalars['String']['output']>;
  /** The stage's late fee; 0 when it has none. */
  lateFeeCents: Scalars['Cents']['output'];
  /** Positive: seconds after the window end (0 at the cutoff). Negative: seconds before the start. */
  offsetSeconds: Scalars['Int']['output'];
  stageName: Scalars['String']['output'];
  /** What the guest paid for this ticket, excluding the booking fee. */
  ticketPriceCents: Scalars['Cents']['output'];
  /** Null when no door stage is eligible now or the amount would be 0. */
  upgrade?: Maybe<ScanUpgradeQuote>;
};

export type Scope = {
  __typename?: 'Scope';
  address?: Maybe<Scalars['String']['output']>;
  adyenMerchantAccountCode?: Maybe<Scalars['String']['output']>;
  /** Venue iBeacon Major (0–65535). Null when unassigned. Unique across scopes. */
  beaconMajor?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

/**
 * Minimal scope reference for customer-facing payloads.
 *
 * Deliberately not `Scope`: 2.3 requires the scope name so ExpoApp can label each
 * voucher with the venue it is redeemable at. Street, postal code, and city
 * (`address`, `zipcode`, `city`) are public venue copy. `adyenMerchantAccountCode`,
 * `phone`, `email`, and flags stay on `Scope` because no guest should read them.
 * Narrowing the type is the enforcement.
 */
export type ScopeRef = {
  __typename?: 'ScopeRef';
  /** Street. Public venue copy. Null when the scope has no street. */
  address?: Maybe<Scalars['String']['output']>;
  /**
   * Venue iBeacon Major (0–65535). Null when this scope has no beacon assigned.
   * ExpoApp ranges UUID-only and uses this on-device to pin that venue's vouchers
   * (loyalty.md 3.3 / 4.1). Never a location upload.
   */
  beaconMajor?: Maybe<Scalars['Int']['output']>;
  /** City. Public venue copy. Null when unset. */
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** Postal code. Public venue copy. Null when unset. */
  zipcode?: Maybe<Scalars['String']['output']>;
};

/**
 * One tax rate per scope, applied to admission **and** the booking fee. Stages
 * carry prices only and have no tax fields — the rate is never per stage.
 *
 * Which scope applies: the **night's** scope, which is already the order's
 * `scope_id` for ticket sales (6.3). Not the buyer's — customers carry no scope
 * (1.7).
 */
export type ScopeTicketSettings = {
  __typename?: 'ScopeTicketSettings';
  /**
   * True once `taxPercentage` is set. **Fail closed**: while false, every ticket
   * sale in this scope is rejected — the same rule as an unmapped Customer.io
   * transactional template. The resolved rate is snapshotted onto each ticket order
   * item at checkout, exactly as catalog `tax` is, so a later change never alters
   * an existing order.
   */
  configured: Scalars['Boolean']['output'];
  /** What the fee is actually taxed at right now: `feeTaxPercentage` or `taxPercentage`. */
  effectiveFeeTaxPercentage?: Maybe<Scalars['Float']['output']>;
  /**
   * True once the scope's Exact ticket GL / Item / VAT code is also set (7.2).
   * Ticket sales cannot ship in a scope until both this and `configured` are true.
   */
  exactTicketMappingConfigured: Scalars['Boolean']['output'];
  /**
   * Optional second rate for the booking fee, for the case where a fee attracts a
   * different NL rate than admission. Falls back to `taxPercentage` when null.
   */
  feeTaxPercentage?: Maybe<Scalars['Float']['output']>;
  scopeId: Scalars['UUID']['output'];
  /** Null when never configured. Ticket sales in this scope are rejected while null. */
  taxPercentage?: Maybe<Scalars['Float']['output']>;
  /**
   * ExpoApp conversion for ticket admission (not the booking fee). Default 35.
   * A scope with no settings row still quotes 35 on public nights.
   */
  ticketPointsPerEuro: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  updatedByUserId?: Maybe<Scalars['UUID']['output']>;
};

export type SendCompanionTicketsInput = {
  emails: Array<Scalars['String']['input']>;
  /**
   * Manage-page capability (`m.…`) instead of `token`: its address must be the
   * buyer of the tickets' order. A claimer's manage token is refused. Rate-limited
   * by IP.
   */
  manageToken?: InputMaybe<Scalars['String']['input']>;
  ticketIds: Array<Scalars['UUID']['input']>;
  /** Buyer capability token; required for anonymous www buyers, optional in ExpoApp. */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type SendContactMessageInput = {
  email: Scalars['String']['input'];
  marketingOptIn: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Omitted from the staff mail when blank. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Club inbox from the Symfony CMS. Not a public relay. */
  staffEmail: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SendContactMessagePayload = {
  __typename?: 'SendContactMessagePayload';
  sent: Scalars['Boolean']['output'];
};

export type Session = {
  __typename?: 'Session';
  accessToken: Scalars['String']['output'];
  /**
   * Nullable since 1.7: a customer JWT carries no `scope_id` at all, because points
   * and accounts are global. Staff sessions still always resolve exactly one active
   * scope. React admin must handle null (it is part of the 1.1 cutover).
   */
  activeScope?: Maybe<Scope>;
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type SortDirection = 'ASC' | 'DESC';

export type SortableEntity = 'CATEGORY' | 'LINK' | 'PRODUCT_CATEGORY' | 'TABLE';

export type SubscribeTicketAlertsInput = {
  /** The visitor's address. Trimmed, lowercased, and validated server side. */
  email: Scalars['String']['input'];
};

export type SubscribeTicketAlertsPayload = {
  __typename?: 'SubscribeTicketAlertsPayload';
  /** True once the address is opted in. Repeating the call is safe. */
  subscribed: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Unified customer SSE. ExpoApp holds one GraphQL-SSE connection on this field.
   *
   * Personal arms (`voucher`, `ticketScan`, `me`) are keyed on ownership.
   * Catalog arms (`night`, `rewards`) fan out to every connected customer.
   * Subscribe path must bypass device presence.
   */
  customerUpdated: CustomerUpdatePayload;
  /** Unified live stream: one typed arm per event, ACL-filtered per subscriber. */
  liveUpdated: LiveUpdatePayload;
  /**
   * Compatibility alias of `customerUpdated.ticketScan`. ExpoApp must not open
   * this as a second connection — use `customerUpdated`.
   *
   * Keyed on `ticket_claims.user_id` / `golden_tickets.user_id`, not scope. Same
   * presence rule as `customerUpdated`: this stream must not register device
   * presence.
   *
   * ExpoApp: PENDING → waiting grid (like a reserved voucher); ACCEPTED → pink
   * ENJOY until tap; REFUSED → Home, no guest refuse UI. Never a timer. Hide
   * on waiting returns to the QR and does not cancel the doorman's scan.
   */
  ticketScanUpdated: TicketScanEvent;
  /**
   * Compatibility alias of `customerUpdated.voucher`. ExpoApp must not open this
   * as a second connection — use `customerUpdated`.
   */
  voucherUpdated: VoucherEvent;
};

export type SubscriptionLiveUpdatedArgs = {
  scopeId: Scalars['UUID']['input'];
};

export type SyncTerminalsPayload = {
  __typename?: 'SyncTerminalsPayload';
  added: Array<TerminalSyncLine>;
  deactivated: Array<TerminalSyncLine>;
  reactivated: Array<TerminalSyncLine>;
  skippedPoiids: Array<Scalars['String']['output']>;
};

export type Tab = {
  __typename?: 'Tab';
  allowedActions: Array<TabAction>;
  amountCanceled: Scalars['Float']['output'];
  amountDiscount: Scalars['Float']['output'];
  amountDue: Scalars['Float']['output'];
  amountDueCents: Scalars['Cents']['output'];
  amountPaid: Scalars['Float']['output'];
  amountPaidCents: Scalars['Cents']['output'];
  amountRefunded: Scalars['Float']['output'];
  canEditLineItems: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  discount?: Maybe<Discount>;
  discountId?: Maybe<Scalars['UUID']['output']>;
  /** Exact CRM Account GUID; set when isInvoice is true. */
  exactAccountId?: Maybe<Scalars['UUID']['output']>;
  grandTotal: Scalars['Float']['output'];
  grandTotalCents: Scalars['Cents']['output'];
  id: Scalars['UUID']['output'];
  isInvoice: Scalars['Boolean']['output'];
  maxAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  orders: Array<Order>;
  payments: Array<Payment>;
  recognitionDate?: Maybe<Scalars['String']['output']>;
  recognizedTotal: Scalars['Float']['output'];
  refunds: Array<Refund>;
  status: Scalars['String']['output'];
  table?: Maybe<Table>;
  tableId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type TabAction =
  | 'CANCEL'
  | 'CLOSE'
  | 'DOWNLOAD_RECEIPT'
  | 'MARK_LOSS'
  | 'MARK_PAID'
  | 'OPEN'
  | 'PARTIAL_PAID'
  | 'PARTIAL_REFUND'
  | 'PAY'
  | 'PAY_PARTIAL'
  | 'PLACE'
  | 'REFUND'
  | 'REOPEN';

export type TabConnection = {
  __typename?: 'TabConnection';
  nodes: Array<Tab>;
  pageInfo: PageMeta;
};

export type TabEventIntent =
  | 'TAB_CANCELED'
  | 'TAB_CHANGED'
  | 'TAB_CLOSED'
  | 'TAB_DISCOUNT_APPLIED'
  | 'TAB_DISCOUNT_REMOVED'
  | 'TAB_FULLY_PAID'
  | 'TAB_FULLY_REFUNDED'
  | 'TAB_LOST'
  | 'TAB_OPENED'
  | 'TAB_PARTIALLY_PAID'
  | 'TAB_PARTIALLY_REFUNDED'
  | 'TAB_PENDING'
  | 'TAB_RENAMED'
  | 'TAB_TABLE_ASSIGNED'
  | 'TAB_TABLE_UNASSIGNED';

export type TabEventPayload = {
  __typename?: 'TabEventPayload';
  intent: TabEventIntent;
  previousStatus?: Maybe<TabStatus>;
  tab: Tab;
  timestamp: Scalars['Time']['output'];
};

export type TabFilter = {
  amount?: InputMaybe<NumberRangeInput>;
  createdAt?: InputMaybe<DateRangeInput>;
  discountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<DateRangeInput>;
};

export type TabSort = {
  direction?: SortDirection;
  field: TabSortField;
};

export type TabSortField =
  'CREATED_AT' | 'GRAND_TOTAL' | 'NAME' | 'STATUS' | 'UPDATED_AT';

export type TabStatus =
  | 'CANCELED'
  | 'CLOSED'
  | 'FULL_PAID'
  | 'FULL_REFUNDED'
  | 'LOSS'
  | 'OPEN'
  | 'PARTIAL_PAID';

export type TabStatusGroup = 'ALL' | 'OTHERS' | 'UNPAID';

export type Table = {
  __typename?: 'Table';
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  tab?: Maybe<Tab>;
};

/** Omzetstaat turnover report for a day or calendar month. */
export type TaxReport = {
  __typename?: 'TaxReport';
  cashTrade: Scalars['Float']['output'];
  paymentMethodBreakdown: Array<TaxReportPaymentLine>;
  periodEnd?: Maybe<Scalars['String']['output']>;
  periodStart: Scalars['String']['output'];
  salesDays: Scalars['Int']['output'];
  salesIncludingTax: Scalars['Float']['output'];
  taxBreakdown: Array<TaxReportTaxLine>;
  /** Tip total (euros) for the period; same recognition window and invoice-tab filters as payment buckets. */
  tips: Scalars['Float']['output'];
  /** Written-off outstanding due (euros) on orders with status loss in the period; invoice tabs excluded. Display-only — not Exact. */
  totalLoss: Scalars['Float']['output'];
};

export type TaxReportPaymentLine = {
  __typename?: 'TaxReportPaymentLine';
  paymentMethod: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type TaxReportPeriod = {
  __typename?: 'TaxReportPeriod';
  generatedAt?: Maybe<Scalars['String']['output']>;
  kind: TaxReportPeriodKind;
  label: Scalars['String']['output'];
  month?: Maybe<Scalars['Int']['output']>;
  recognitionDate?: Maybe<Scalars['String']['output']>;
  salesIncludingTax: Scalars['Float']['output'];
  /** Ledger tip total (euros); same source as TaxReport.tips. */
  tips: Scalars['Float']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type TaxReportPeriodConnection = {
  __typename?: 'TaxReportPeriodConnection';
  nodes: Array<TaxReportPeriod>;
  pageInfo: PageMeta;
};

export type TaxReportPeriodKind = 'DAY' | 'MONTH';

export type TaxReportTaxLine = {
  __typename?: 'TaxReportTaxLine';
  salesExcludingTax: Scalars['Float']['output'];
  salesIncludingTax: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxPercentage: Scalars['Float']['output'];
};

export type Terminal = {
  __typename?: 'Terminal';
  /** Deprecated alias for POS compatibility. */
  active: Scalars['Boolean']['output'];
  batteryLevel?: Maybe<Scalars['Int']['output']>;
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastBatteryCheckAt?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
  poiid: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type TerminalConnection = {
  __typename?: 'TerminalConnection';
  nodes: Array<Terminal>;
  pageInfo: PageMeta;
};

export type TerminalEventIntent = 'TERMINAL_UPDATED';

export type TerminalEventPayload = {
  __typename?: 'TerminalEventPayload';
  intent: TerminalEventIntent;
  terminal: Terminal;
};

export type TerminalFilter = {
  battery?: InputMaybe<NumberRangeInput>;
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TerminalSyncLine = {
  __typename?: 'TerminalSyncLine';
  name: Scalars['String']['output'];
  poiid: Scalars['String']['output'];
};

export type ThemePreference = 'DARK' | 'LIGHT' | 'SYSTEM';

export type Ticket = {
  __typename?: 'Ticket';
  /**
   * Who paid. It never changes when the ticket is sent on to a friend: sending
   * sets `claimerEmail`, not this field. On `myTickets` it is null unless the
   * signed-in customer is the payer.
   */
  buyerEmail?: Maybe<Scalars['String']['output']>;
  /**
   * Claim details once set. Null until this ticket is claimed. On `myTickets` it
   * is null on a ticket the signed-in customer does not hold: a payer who sent a
   * ticket to a friend sees `claimerEmail`, `status` and the prices, never the
   * friend's identity. `ticketOrder` follows the same rule for the payer: a
   * ticket with a `claimerEmail` other than the payer's comes back without it.
   */
  claim?: Maybe<TicketClaim>;
  /**
   * True while the unsent ticket's claim link is known to have gone out: Copy link or
   * Share was pressed on the manage page (`markClaimLinkShared`). The invitee's "Claim
   * my ticket" form must skip such a seat, because claiming it would make the invitee
   * its claimer and kill the friend's link; every claim arm of the invitee refuses it
   * (`ErrClaimNotAllowed`): `claimTicket` with a `manageToken` and the app's
   * `claimGuestListForCustomer`. A send or a change of address clears it. Only ever
   * true on an unsent, unclaimed ticket (`status` PURCHASED, no `claimerEmail`).
   */
  claimLinkShared: Scalars['Boolean']['output'];
  /**
   * True while the claim-link mail to `claimerEmail` failed: the address is stored and
   * the previous link is dead, but nothing arrived (the mail is a critical mail, sent
   * inline when `sendCompanionTickets`, `changeCompanionEmail`, `handOverTicket` or a
   * guest-list send commits, and its failure is returned as an error naming the
   * address). Clients show the ticket as NOT SENT and offer the change-address flow:
   * `changeCompanionEmail` with the same or a corrected address re-sends (it rotates
   * the claim link), and a successful send clears the flag. Only ever true on a sent,
   * unclaimed ticket (`status` PURCHASED with a `claimerEmail`); always false once the
   * ticket is claimed.
   */
  claimMailFailed: Scalars['Boolean']['output'];
  /**
   * The plaintext token at the tail of `claimUrl`, so the app can build its own
   * deep link. Same gate as `claimUrl`: the order access token, the signed order
   * token, or the signed-in buyer (the payer, also on `myTickets`), never the
   * holder of a ticket sent to them.
   */
  claimToken?: Maybe<Scalars['String']['output']>;
  /**
   * Deep link to the www claim form, `{WWW}/tickets/claim/{token}`: the link the
   * buyer copies or shares. A purchased ticket the caller paid for has one on the
   * buyer's own views (`ticketOrder`, `manageTickets` of the address that paid,
   * `myTickets` for the signed-in payer's keep ticket, unsent spares and
   * sent-but-unclaimed spares, the guest-list views): the token is stored sealed beside its hash, so it
   * survives an outbox prune or a database restore. An unsent spare that lost its
   * token (bought before the sealed column, carrier pruned) gets a new one the
   * first time the page renders; nothing is mailed and the link is stable from
   * then on. A sent or own ticket with neither a stored token nor a carrier shows
   * none and is not rotated (its link is already in somebody's mailbox). The
   * payer keeps the link of a sent, still-unclaimed ticket (to copy it again)
   * until it is claimed. Staff opening a payer's manage page with a scope-bound
   * link see stored links but never trigger a rotation. Null once claimed, for
   * door tickets, for a holder who did not pay (including on `myTickets`), and on
   * reads that do not load an order (admin).
   */
  claimUrl?: Maybe<Scalars['String']['output']>;
  claimedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The person who will use the ticket (lower-cased). The buyer on their own ticket
   * (the first ticket of each night), the friend a ticket was sent to
   * (`sendCompanionTickets`, `changeCompanionEmail`, the guest-list send), or
   * whoever claimed a copied link. Null on a spare nobody has been sent or has
   * claimed yet.
   */
  claimerEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  customerState: CustomerTicketState;
  /** End of the entry window (exclusive). Null = the night's doors close. */
  entryEndsAt?: Maybe<Scalars['Time']['output']>;
  /** When this stage's ticket admits (instant). Null = the night's doors open. */
  entryStartsAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Guest-facing wording of the entry window, Europe/Amsterdam. Null when the stage
   * has no entry window. Start equal to doors open: `Entry before HH:MM`. End equal
   * to doors close: `Entry after HH:MM`. Otherwise `Entry HH:MM–HH:MM` (en dash).
   */
  entryWindowLabel?: Maybe<Scalars['String']['output']>;
  feePrice: Scalars['Float']['output'];
  /** Booking fee, per ticket. Earns no loyalty points (2.2) and is excluded from spend (2.4). */
  feePriceCents: Scalars['Cents']['output'];
  /** Set while `HELD`: the 15-minute stock reservation deadline. */
  holdExpiresAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Who holds the ticket: `claimerEmail` when set, else `buyerEmail`. Empty for a
   * POS sale whose buyer has not attached an address yet. On `myTickets` it is
   * empty unless the signed-in customer holds the ticket under their own address
   * or paid for it.
   */
  holderEmail: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  kind: TicketKind;
  /** Display nest (title, dates, scope). Not a channel-filtered catalogue — clients must not select `stages` here. */
  night: PublicNight;
  nightId: Scalars['UUID']['output'];
  orderId?: Maybe<Scalars['UUID']['output']>;
  purchasedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Static QR payload for the door scan. Withheld (null) until this ticket's
   * required claim fields are set (6.6), and always null for door tickets. On
   * `myTickets` it is null on a ticket the signed-in customer does not hold, and
   * `ticketOrder` omits it on a ticket sent to someone else: a door credential
   * belongs to its holder only.
   */
  qrPayload?: Maybe<Scalars['String']['output']>;
  stageId: Scalars['UUID']['output'];
  stageName: Scalars['String']['output'];
  status: TicketStatus;
  /** Admin-facing euro equivalents. */
  ticketPrice: Scalars['Float']['output'];
  /** Admission price snapshotted at checkout. A later stage price edit never changes it. */
  ticketPriceCents: Scalars['Cents']['output'];
  /** The night's ticket text. Null unless the ticket is claimed, not a door ticket, and the caller holds it (same gate as qrPayload). */
  ticketText?: Maybe<Scalars['String']['output']>;
  upgradeFee: Scalars['Float']['output'];
  /** Upgrade price stamped when the ticket is upgraded; 0 until then. */
  upgradeFeeCents: Scalars['Cents']['output'];
  /**
   * When the ticket was scanned at the door (first `valid` or `refused`
   * `entrance_logs` row). Null while it has not been, and always null on
   * `myTickets` and `ticketOrder`: only `manageTickets` lists used tickets.
   */
  usedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * What the LIVE (issued or reserved, not past its end) vouchers minted for this
   * ticket give its holder, soonest-expiring first; same shape and rules as
   * `TicketClaimView.voucherOffers` (benefit, venue and window only: never a voucher
   * id or QR). Filled on `manageTickets` and `myTickets`, and only on a CLAIMED
   * ticket the viewer HOLDS (its holder, like `qrPayload`): a payer who sent a
   * ticket to a friend does not see the friend's voucher. Always `[]` on
   * `ticketOrder`, admin reads and every ticket the viewer does not hold. Read once
   * per page, not per ticket.
   */
  voucherOffers: Array<TicketVoucherOffer>;
};

/**
 * One row of a ticket's block history. Append-only: unblocking closes the row, a
 * later block adds a new one.
 */
export type TicketBlock = {
  __typename?: 'TicketBlock';
  blockedAt: Scalars['Time']['output'];
  blockedByUserId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason: TicketBlockReason;
  /** Null while the block is open. */
  unblockedAt?: Maybe<Scalars['Time']['output']>;
  unblockedByUserId?: Maybe<Scalars['UUID']['output']>;
};

export type TicketBlockReason =
  /** The bank already paid the money back outside Ferry. */
  'BANK_REFUND' | 'FRAUD' | 'OTHER' | 'WRONG_SALE';

/**
 * The pending buyer hand-off for a paid POS ticket order (6.3): the QR the
 * selling register must display until the buyer submits their own address.
 *
 * `url` embeds the capability. It is only ever returned to the selling register
 * (or a `ticket:manage` actor), never to the buyer's phone.
 */
export type TicketBuyerHandoff = {
  __typename?: 'TicketBuyerHandoff';
  createdAt: Scalars['Time']['output'];
  grandTotalCents: Scalars['Cents']['output'];
  orderId: Scalars['UUID']['output'];
  ticketCount: Scalars['Int']['output'];
  /** The www buyer page, `{WWW_PUBLIC_BASE_URL}/tickets/buyer/{token}`: it shows the purchase, takes the buyer's address and continues in the checkout's paid claim flow. */
  url: Scalars['String']['output'];
};

export type TicketClaim = {
  __typename?: 'TicketClaim';
  /** Name matches the original ID / has read the house rules. */
  attested: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  claimedAt: Scalars['Time']['output'];
  country?: Maybe<Scalars['String']['output']>;
  /** `YYYY-MM-DD`. */
  dateOfBirth: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  /** Linked customer when the claim was made while signed in. */
  userId?: Maybe<Scalars['UUID']['output']>;
};

/**
 * What the claim screen needs, resolved from the claim token.
 *
 * Public: the token **is** the capability, the same model as `receiptByToken`. It
 * is stored SHA-256-only and is revoked immediately when the companion email
 * changes.
 */
export type TicketClaimView = {
  __typename?: 'TicketClaimView';
  /**
   * Deprecated alias of `holderEmail` (kept so older web builds keep working; it
   * is never the payer's address when the ticket was sent on). Use `holderEmail`.
   */
  buyerEmail?: Maybe<Scalars['String']['output']>;
  claim?: Maybe<TicketClaim>;
  claimed: Scalars['Boolean']['output'];
  /** End of the entry window (exclusive). Null = the night's doors close. */
  entryEndsAt?: Maybe<Scalars['Time']['output']>;
  /** When this stage's ticket admits (instant). Null = the night's doors open. */
  entryStartsAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Guest-facing wording of the entry window, Europe/Amsterdam. Null when the stage
   * has no entry window. Start equal to doors open: `Entry before HH:MM`. End equal
   * to doors close: `Entry after HH:MM`. Otherwise `Entry HH:MM–HH:MM` (en dash).
   */
  entryWindowLabel?: Maybe<Scalars['String']['output']>;
  /** The address this ticket belongs to: the claimer. Empty while `needsEmail` is true. */
  holderEmail: Scalars['String']['output'];
  /** Minimum age shown on the form. The hard rule is 18 regardless (see `claimTicket`). */
  minimumAge?: Maybe<Scalars['Int']['output']>;
  /**
   * True while the ticket is unclaimed and has no claimer yet (a copied or shared
   * link): the page must ask the claimer for their e-mail and send it as
   * `ClaimTicketInput.email`. `holderEmail` and `buyerEmail` are then empty, so a
   * link's bearer never sees who bought the ticket. False on a mailed link, which
   * already names its claimer, and on the buyer's own ticket.
   */
  needsEmail: Scalars['Boolean']['output'];
  night: PublicNight;
  /** QR payload, present only once this ticket is claimed. */
  qrPayload?: Maybe<Scalars['String']['output']>;
  stageName: Scalars['String']['output'];
  status: TicketStatus;
  ticketId: Scalars['UUID']['output'];
  /** The night's ticket text. Null unless the ticket is claimed, not a door ticket, and the caller holds it (same gate as qrPayload). */
  ticketText?: Maybe<Scalars['String']['output']>;
  /**
   * What the LIVE (issued or reserved, not yet past its end) vouchers minted for
   * this ticket give its holder, soonest-expiring first; empty when the claim
   * earned nothing, the night has no `ticket_claimed` rule, or the voucher was
   * revoked (hand-over, refund), spent or ended. A guest-facing line such as
   * "<label> at Elio, valid until Sat 31 Oct" is built from these; an offer whose
   * `label` is empty has no line, and `promotionLabel` is shown independently.
   * Public like the rest of this view (the claim token is the capability) and
   * limited to benefit, venue and window of THIS ticket: never a voucher id or
   * QR (the ticket QR is the key at the bar) and nothing about the holder's other
   * vouchers.
   */
  voucherOffers: Array<TicketVoucherOffer>;
};

/** One append-only companion-email change. Never includes the claim token or hash. */
export type TicketEmailChange = {
  __typename?: 'TicketEmailChange';
  actorKind: TicketEmailChangeActor;
  /** Staff user id, or the ExpoApp buyer when they were signed in. Null on the anonymous www token path. */
  actorUserId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['UUID']['output'];
  newEmail: Scalars['String']['output'];
  previousEmail?: Maybe<Scalars['String']['output']>;
  recognitionDate?: Maybe<Scalars['String']['output']>;
};

export type TicketEmailChangeActor =
  | 'BUYER'
  /** The person who claimed a copied or shared link and typed their own address. */
  | 'CLAIMER'
  | 'STAFF';

/** POS ticket sale buyer hand-off transitions (6.3). */
export type TicketHandoffEventIntent =
  /** Payment succeeded with no buyer yet: the selling register must show the QR. */
  | 'TICKET_HANDOFF_PENDING'
  /**
   * Buyer is known: linked PIN card, or the phone form was submitted. The
   * register drops the QR (if it was up) and shows a dismissable confirmation
   * with `email`.
   */
  | 'TICKET_HANDOFF_RESOLVED';

/**
 * Buyer hand-off arm. Delivered to the **selling device only** — this is the one
 * arm besides payment/refund that a device principal receives, because it is the
 * only thing that can unblock its screen. `handoff` is set on
 * `TICKET_HANDOFF_PENDING` and null once resolved. `email` is set on
 * `TICKET_HANDOFF_RESOLVED`.
 */
export type TicketHandoffEventPayload = {
  __typename?: 'TicketHandoffEventPayload';
  /** Selling register. Device subscribers only receive their own hand-offs. */
  deviceId?: Maybe<Scalars['UUID']['output']>;
  /** Address the tickets were linked to. Set on `TICKET_HANDOFF_RESOLVED`. */
  email?: Maybe<Scalars['String']['output']>;
  handoff?: Maybe<TicketBuyerHandoff>;
  intent: TicketHandoffEventIntent;
  orderId: Scalars['UUID']['output'];
};

/**
 * Public, pre-email view behind the hand-off QR. Enough for the buyer to
 * recognise the purchase and nothing more — no buyer, no claim token, no payment.
 */
export type TicketHandoffSummary = {
  __typename?: 'TicketHandoffSummary';
  grandTotalCents: Scalars['Cents']['output'];
  lines: Array<TicketHandoffSummaryLine>;
  orderId: Scalars['UUID']['output'];
  /** Venue that sold the tickets, so the buyer knows which club this is. */
  scopeName: Scalars['String']['output'];
  ticketCount: Scalars['Int']['output'];
};

export type TicketHandoffSummaryLine = {
  __typename?: 'TicketHandoffSummaryLine';
  nightId: Scalars['UUID']['output'];
  nightTitle: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  stageName: Scalars['String']['output'];
  unitPriceCents: Scalars['Cents']['output'];
};

export type TicketKind =
  /** Sold at the door on iPad / Android POS. No claim, no QR. */
  | 'DOOR'
  /** Admin guest-list reservation. Purchased immediately at €0. */
  | 'GUEST_LIST'
  /** Bought through a member-sale secret URL. */
  | 'MEMBER'
  /** Public checkout on ExpoApp or www. */
  | 'ONLINE'
  /** Claimable sale from the iPad hamburger Tickets screen. Not door (those skip claim). */
  | 'POS';

/** What an order line of a ticket sells. A ticket has at most one admission line. */
export type TicketLineRole = 'ADMISSION' | 'UPGRADE';

export type TicketLookupFilter = {
  /** Matches `buyerEmail` or `claimerEmail` (case-insensitive, exact). */
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Array<TicketKind>>;
  nightId?: InputMaybe<Scalars['UUID']['input']>;
  orderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Keeps only tickets sold through one of these channels. An empty list is no filter. */
  saleChannel?: InputMaybe<Array<TicketSaleChannel>>;
  /** Matches buyer or claimer e-mail, the ticket/order UUID, night title or stage name. */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TicketStatus>>;
  /**
   * True: only tickets that can still be claimed: purchased and not a door ticket (a door ticket is never claimed;
   * guest-list tickets count). It is the list behind `NightTicketSummary.unclaimed`, so the tile's link opens exactly
   * that many tickets. False or omitted: no narrowing.
   */
  unclaimed?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * One requested stage and quantity. The server expands this into `quantity`
 * `order_items` and `quantity` tickets, each with its own `stage_id` — a ticket is
 * never a line with qty > 1.
 */
export type TicketOrderLine = {
  quantity: Scalars['Int']['input'];
  stageId: Scalars['UUID']['input'];
};

export type TicketOrderPayload = {
  __typename?: 'TicketOrderPayload';
  /**
   * Capability token for this order, returned once. www checkout is anonymous, so
   * it passes this back to `ticketOrder` and `createTicketPaymentIntent` instead of
   * a session. ExpoApp customers may ignore it and rely on their session.
   */
  accessToken: Scalars['String']['output'];
  /** Sum of per-ticket booking fees. */
  feeTotalCents: Scalars['Cents']['output'];
  grandTotalCents: Scalars['Cents']['output'];
  /**
   * End of the 15-minute stock hold. When it passes, the tickets are released and
   * the guest is returned to ticket select.
   */
  holdExpiresAt: Scalars['Time']['output'];
  orderId: Scalars['UUID']['output'];
  /** Sum of admission amounts. */
  ticketTotalCents: Scalars['Cents']['output'];
  tickets: Array<Ticket>;
};

export type TicketOrderStatus = {
  __typename?: 'TicketOrderStatus';
  feeTotalCents: Scalars['Cents']['output'];
  grandTotalCents: Scalars['Cents']['output'];
  holdExpiresAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The www checkout page of this order (the post-payment claim and share steps),
   * available once paid (6.6). Not the per-address manage page: that link is
   * minted only into the ticket mails.
   */
  manageClaimUrl?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['UUID']['output'];
  paymentState: TicketPaymentState;
  /** Countdown for the checkout timer. 0 once expired or paid. */
  secondsUntilHoldExpiry: Scalars['Int']['output'];
  /** Snapshotted admission points when this order is paying with points; null otherwise. */
  ticketPointsSpent?: Maybe<Scalars['Int']['output']>;
  ticketTotalCents: Scalars['Cents']['output'];
  tickets: Array<Ticket>;
};

/**
 * Payment-intent result. Exactly one of `adyen` / `paypal` is set, matching
 * `provider`. A payment-intent **mutation**, not a REST endpoint (6.3).
 */
export type TicketPaymentIntent = {
  __typename?: 'TicketPaymentIntent';
  adyen?: Maybe<AdyenDropInSession>;
  /** Intent validity; never later than the ticket hold. */
  expiresAt: Scalars['Time']['output'];
  paypal?: Maybe<PayPalOrderIntent>;
  provider: PaymentProvider;
};

/**
 * PSP progress, polled by the web and app checkouts. Payment success is authoritative
 * from the PSP webhook, never from the client — this only reports what Go knows.
 */
export type TicketPaymentState =
  /** No payment intent created yet. */
  | 'AWAITING_PAYMENT'
  /** The 15-minute hold ran out; the tickets were released. */
  | 'EXPIRED'
  | 'FAILED'
  | 'PAID'
  /** Intent created, PSP result not in. ExpoApp shows WAITING FOR PAYMENT (4.3). */
  | 'PENDING'
  | 'REFUNDED';

/**
 * Tickets sold per day in the presale of the upcoming nights. Presale is online and
 * member tickets that are purchased or claimed; door, guest list, held, released
 * and refunded tickets never count. A night is upcoming while
 * doors_close is in the future; retired (inactive) nights
 * still count. A sale belongs to the recognition day of purchased_at (06:00 to
 * 05:59 Europe/Amsterdam). Categories start at the first sale day and skip days
 * without any sale; every series aligns to them.
 */
export type TicketPresaleChart = {
  __typename?: 'TicketPresaleChart';
  /** Recognition dates, YYYY-MM-DD, ascending. */
  categories: Array<Scalars['String']['output']>;
  /** One series per night with presale sales, by start time. */
  series: Array<TicketPresaleSeries>;
};

/** One night's presale tickets per category day (0 on days only other nights sold). */
export type TicketPresaleSeries = {
  __typename?: 'TicketPresaleSeries';
  data: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nightId: Scalars['UUID']['output'];
};

/**
 * How a ticket was sold. Written when the ticket is made, a hold included, and never changed: not by a claim, a hand-over, a
 * block or a refund. Staff only: no public, customer or guest type carries it.
 */
export type TicketSaleChannel =
  /** `createTicketOrder` from the app. Tickets sold before the channel was recorded read WEBSITE, whichever client sold them. */
  | 'APP'
  /** A walk-up door sale. */
  | 'DOOR'
  /** An admin guest-list entry. */
  | 'GUEST_LIST'
  /** A stage with the Link flag (its secret URL), whichever client sold it. */
  | 'LINK'
  /** A member sale, whichever client sold it. */
  | 'MEMBER'
  /** A ticket sold on the register's Tickets screen. */
  | 'POS'
  /** `createTicketOrder` from the website. */
  | 'WEBSITE';

/**
 * Counted tickets per unit before each night's own doors_close, so nights of
 * different dates line up. Counted are tickets that are purchased, claimed or
 * imported and of kind online, member, door or pos (door sales appear as their door
 * stage); guest list, held, released and refunded tickets never count. The bucket of
 * a ticket is the number of `interval` units between its purchase and the
 * night's doors_close (see TicketSalesInterval), 0 for a sale at or after doors
 * close. Categories are a continuous descending axis from the largest bucket down to
 * 0, every integer present, empty when nothing is counted; every series is
 * zero-filled on it. A night whose doors close at or after 06:00 has its day 0 on
 * the next recognition day. The selection only narrows inside the caller's scope:
 * ids of other scopes or unknown ids contribute nothing. At most 200 night ids
 * per request, more is a BAD_USER_INPUT error.
 */
export type TicketSalesChart = {
  __typename?: 'TicketSalesChart';
  /** Units before doors_close, descending, e.g. [20, 19, ..., 0]. */
  categories: Array<Scalars['Int']['output']>;
  /** One series per night and sale stage with counted tickets, by night start then stage order. */
  series: Array<TicketSalesSeries>;
};

/**
 * Unit of the ticket sales chart's relative axis: how long before a night's own
 * doors_close a ticket was bought. A sale after doors close counts in bucket 0.
 */
export type TicketSalesInterval =
  /** Recognition days (06:00 to 05:59 Europe/Amsterdam) before doors_close: day(doors_close) - day(purchased_at). */
  | 'DAY'
  /** Whole hours before doors_close, floor((doors_close - purchased_at) / 1 hour), in absolute time. */
  | 'HOUR'
  /** Whole weeks of those recognition days before doors_close: floor(DAY / 7). */
  | 'WEEK';

/**
 * A night the ticket sales chart can show: it has at least one counted ticket
 * (purchased, claimed or imported; online, member or pos) that was not sold at the
 * door. A night whose counted tickets are all door sales is left out, it has no
 * presale to compare. Inactive nights are kept.
 */
export type TicketSalesNight = {
  __typename?: 'TicketSalesNight';
  name: Scalars['String']['output'];
  nightId: Scalars['UUID']['output'];
  startsAt: Scalars['Time']['output'];
  /** True while doors_close is in the future. */
  upcoming: Scalars['Boolean']['output'];
};

/** One sale stage of one night, counted tickets per category bucket (0 where it did not sell). */
export type TicketSalesSeries = {
  __typename?: 'TicketSalesSeries';
  data: Array<Scalars['Int']['output']>;
  nightId: Scalars['UUID']['output'];
  nightName: Scalars['String']['output'];
  /** Trailing buckets still in the future for this night (0 once doors have closed); the bucket in progress is not pending. */
  pending: Scalars['Int']['output'];
  stageId: Scalars['UUID']['output'];
  stageName: Scalars['String']['output'];
};

export type TicketScanEvent = {
  __typename?: 'TicketScanEvent';
  /** Golden pass. Null on a claimed scan. */
  goldenTicketId?: Maybe<Scalars['UUID']['output']>;
  intent: TicketScanEventIntent;
  /** Claimed night ticket. Null on a golden scan. */
  ticketId?: Maybe<Scalars['UUID']['output']>;
};

/**
 * Facts the guest phone needs while a claimed or golden QR sheet is open.
 *
 * An arm of `customerUpdated` (and kept as `ticketScanUpdated` for compatibility).
 * Not an arm of `liveUpdated`: a customer JWT has no scope and must not touch
 * device presence (AGENTS.md §15.3).
 */
export type TicketScanEventIntent =
  /** recordEntranceDecision Accepted (`entrance_logs.result = valid`). */
  | 'TICKET_SCAN_ACCEPTED'
  /** Green scan: the doorman is looking at this QR. Admission slot is still unused. */
  | 'TICKET_SCAN_PENDING'
  /** recordEntranceDecision Refused (`entrance_logs.result = refused`). Ticket is used. */
  | 'TICKET_SCAN_REFUSED';

/**
 * Persisted ticket state (6.3):
 *
 *     held ──► purchased ──► claimed        online / member sales
 *       │           │
 *       │           └──────► refunded       PSP refund or chargeback
 *       └──────► released                   hold expiry or payment failed
 *
 * Door tickets start `HELD` on the POS basket (or `createDoorTicketOrder`) and
 * move to `PURCHASED` on payment success; they are never claimed. A doorman
 * scan does **not** change this value — a scanned ticket stays `CLAIMED` so the
 * emailed and Wallet QR keep working, and `entrance_logs` owns the admission lock
 * (6.7).
 */
export type TicketStatus =
  /** Pulled back by the venue (`blockTicket`). Not sold, no QR, refused at the door; `unblockTicket` puts it back. */
  | 'BLOCKED'
  | 'CLAIMED'
  | 'HELD'
  /** History imported from the former ticketing system (Stager), never a guest's claim. Sold (holds capacity, counts in the sales reports) but not claimable, hand-over-able, scannable or shown to guests. Only `blockTicket` and an order refund move it; `unblockTicket` puts a blocked one back as IMPORTED. */
  | 'IMPORTED'
  | 'PURCHASED'
  | 'REFUNDED'
  | 'RELEASED';

/**
 * The benefit a claimed ticket earned its holder, as a guest may read it. It
 * carries no voucher id, status or QR: scanning the ticket QR at the venue applies
 * the voucher.
 */
export type TicketVoucherOffer = {
  __typename?: 'TicketVoucherOffer';
  /** The benefit in one line, from the snapshotted discount: "€5 off", "20% off" or "Free <product name>". Calculated; never the rule's text. */
  description: Scalars['String']['output'];
  /**
   * Exclusive end: 06:00 Europe/Amsterdam after the last trading day. To show the
   * last day the guest can use it, show the TRADING DAY (06:00 to 05:59 Europe/Amsterdam)
   * of `expiresAt` minus one second, not its calendar date: a voucher ending
   * Sun 1 Nov 06:00 is valid until the night of Sat 31 Oct (05:59:59 is still the
   * calendar day Sun 1 Nov, but the trading day Sat 31 Oct).
   */
  expiresAt: Scalars['Time']['output'];
  /**
   * The rule's customer label (a snapshot): the voucher line to show. Null or empty
   * means show NO voucher line; `description` is not a fallback.
   */
  label?: Maybe<Scalars['String']['output']>;
  /** The rule's TICKET_CLAIMED promotion (a snapshot), shown with the ticket QR after the claim and in the ticket mail. Independent of `label`. */
  promotionLabel?: Maybe<Scalars['String']['output']>;
  /** First instant the voucher can be used (the claim, or the end of the night, per the rule). */
  validFrom: Scalars['Time']['output'];
  /** The venue that honours the voucher: the scope the voucher was minted in, which can differ from the venue that runs the night. */
  venueName: Scalars['String']['output'];
};

/** Tip report for a recognition day or calendar month (ledger-backed). */
export type TipReport = {
  __typename?: 'TipReport';
  lines: Array<TipReportLine>;
  nextRecognitionDate?: Maybe<Scalars['String']['output']>;
  paymentMethodTips: Array<PaymentMethodTip>;
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  previousRecognitionDate?: Maybe<Scalars['String']['output']>;
  recognitionDate?: Maybe<Scalars['String']['output']>;
  tippedPaymentCount: Scalars['Int']['output'];
  tippedPaymentPercentage: Scalars['Float']['output'];
  totalSuccessfulPaymentCount: Scalars['Int']['output'];
  totalTipAmountCents: Scalars['Cents']['output'];
};

/** One tipped ledger transaction for the POS tip report list. */
export type TipReportLine = {
  __typename?: 'TipReportLine';
  amountCents: Scalars['Cents']['output'];
  amountTipCents: Scalars['Cents']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['UUID']['output'];
  paymentMethod: Scalars['String']['output'];
};

export type TurnoverCompare = 'LAST_WEEK' | 'NONE' | 'SAME_WEEK_LAST_YEAR';

export type TurnoverComparison = {
  __typename?: 'TurnoverComparison';
  amount: Scalars['Float']['output'];
  averageValue: Scalars['Float']['output'];
  byDay: Array<TurnoverDay>;
  count: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  week: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type TurnoverDay = {
  __typename?: 'TurnoverDay';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type TurnoverReport = {
  __typename?: 'TurnoverReport';
  cashTotalCents: Scalars['Cents']['output'];
  grossTotalCents: Scalars['Cents']['output'];
  orderCount: Scalars['Int']['output'];
  pinTotalCents: Scalars['Cents']['output'];
  recognitionDate: Scalars['String']['output'];
  recognizedTotalCents: Scalars['Cents']['output'];
  refundTotalCents: Scalars['Cents']['output'];
  scopeId: Scalars['UUID']['output'];
  tipTotalCents: Scalars['Cents']['output'];
};

export type TurnoverSlice = {
  __typename?: 'TurnoverSlice';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** Live intraday stats for the current recognition day. */
export type TurnoverToday = {
  __typename?: 'TurnoverToday';
  amount: Scalars['Float']['output'];
  amountSoFar: Scalars['Float']['output'];
  compareMode: TurnoverCompare;
  comparisonAmountAtSameTime: Scalars['Float']['output'];
  comparisonCountAtSameTime: Scalars['Int']['output'];
  comparisonDay?: Maybe<TurnoverDay>;
  count: Scalars['Int']['output'];
  countSoFar: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  pacePercent?: Maybe<Scalars['Float']['output']>;
  /**
   * Presale tickets of the ticketed nights that start on this recognition
   * day; door sales are left out. Null when there is no such night or none
   * has a sold ticket.
   */
  tickets?: Maybe<TurnoverTodayTickets>;
};

export type TurnoverTodayTickets = {
  __typename?: 'TurnoverTodayTickets';
  /** entrance_logs valid + refused for those nights, golden scans included, door sales excluded */
  scanned: Scalars['Int']['output'];
  /** purchased + claimed presale tickets (holds, door sales and golden passes are not counted) */
  sold: Scalars['Int']['output'];
};

/** Aggregated weekly turnover with an optional comparison series. */
export type TurnoverWeek = {
  __typename?: 'TurnoverWeek';
  amount: Scalars['Float']['output'];
  averageValue: Scalars['Float']['output'];
  byCategory: Array<TurnoverSlice>;
  byDay: Array<TurnoverDay>;
  byPaymentMethod: Array<TurnoverSlice>;
  comparison?: Maybe<TurnoverComparison>;
  count: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  today?: Maybe<TurnoverToday>;
  week: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type UpdateBlueprintInput = {
  doorsClose?: InputMaybe<Scalars['String']['input']>;
  /** `HH:MM`; null leaves the default unchanged. A default can be moved, never cleared. */
  doorsOpen?: InputMaybe<Scalars['String']['input']>;
  /**
   * Shown on the website's Good to know and in the app; empty = "None, come as you are". The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 100 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  dresscode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  requireTicket?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Shown to the holder of a claimed ticket on the ticket e-mail, PDF, the www ticket pages and the app. Never public, never before the claim. The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 1000 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  ticketText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDoor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  showInMenu?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCustomerProfileInput = {
  /**
   * `true` records that the holder accepted the terms, i.e. the house rules plus the privacy statement (the `termsAccepted`
   * CHECKBOX of the required-fields gate): `users.terms_accepted_at` is stamped once.
   * `false` or absent changes nothing, and a stamp is never cleared.
   */
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** ISO 8601 date. Rejected when changed within 365 days of dateOfBirthUpdatedAt (4.2). */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Writes users.first_name. May be absent, but is rejected when sent blank. Counts toward CheckCompleteness. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Opting out sets marketing_opt_in false and keeps marketing_opt_in_at as the last opt-in (7.1). */
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pushOnRewardUnlock?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDeviceInput = {
  allowCategorySwitch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Terminal loyalty session + DisplayRequest path (2.1). See Device.askLoyalty. */
  askLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Manual presence override: connected | hibernate | disconnected. */
  connectionStatus?: InputMaybe<Scalars['String']['input']>;
  gratuitySettings?: InputMaybe<DeviceGratuitySettingsInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  terminalId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDiscountInput = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLinkInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNightInput = {
  doorsClose?: InputMaybe<Scalars['Time']['input']>;
  doorsOpen?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Shown on the website's Good to know and in the app; empty = "None, come as you are". The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 100 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  dresscode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  requireTicket?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Shown to the holder of a claimed ticket on the ticket e-mail, PDF, the www ticket pages and the app. Never public, never before the claim. The blueprint value is copied to a night created from it; later blueprint edits do not rewrite it.
   * At most 1000 characters; surrounding whitespace is trimmed and a blank value clears it.
   */
  ticketText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  allowTable?: InputMaybe<Scalars['Boolean']['input']>;
  cashTrade?: InputMaybe<Scalars['Boolean']['input']>;
  consumptionName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBottomBar?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
  unitAmount?: InputMaybe<Scalars['Float']['input']>;
  unitLabel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfileInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  chamberOfCommerce?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** ISO 8601 date. Rejected when changed within 365 days of dateOfBirthUpdatedAt (4.2). */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  defaultPage?: InputMaybe<Scalars['String']['input']>;
  defaultScopeId?: InputMaybe<Scalars['UUID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  themePreference?: InputMaybe<ThemePreference>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateScopeInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** Omit to leave unchanged. Null clears the venue iBeacon Major. */
  beaconMajor?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTabInput = {
  discountId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateTableInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTerminalInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  allowedScopeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  chamberOfCommerce?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  defaultPage?: InputMaybe<Scalars['String']['input']>;
  defaultScopeId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  /**
   * Omit to leave unchanged. Null is a customer. Employee / Contractor are the
   * hire switch. Admin is derived from an Admin / Super Admin ACL role — saving
   * ADMIN here only writes the column; assign the role on Access to promote.
   */
  type?: InputMaybe<UserType>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVoucherRuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<VoucherDiscountType>;
  /** Customer copy (app tile, voucher mail, ticket voucher line). Max 80 characters. Null leaves it alone; blank clears it. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Internal admin name and register chip. Max 80 characters. */
  name?: InputMaybe<Scalars['String']['input']>;
  nightId?: InputMaybe<Scalars['UUID']['input']>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  /** TICKET_CLAIMED only (ticket mail and ticket QR screens). Max 200 characters. Null leaves it alone; blank clears it; cleared when the trigger is not TICKET_CLAIMED. */
  promotionLabel?: InputMaybe<Scalars['String']['input']>;
  /** Null leaves the subset alone; an empty list means every stage. */
  stageIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  thresholdPoints?: InputMaybe<Scalars['Int']['input']>;
  trigger?: InputMaybe<VoucherRuleTrigger>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
  validityDays?: InputMaybe<Scalars['Int']['input']>;
  validityMode?: InputMaybe<VoucherValidityMode>;
};

/**
 * Admin-facing user. `username`, `name`, and `roles` were removed in the 1.1
 * cutover: email is the only login identifier and `actor_role_bindings` is the only
 * source of truth for permissions.
 */
export type User = {
  __typename?: 'User';
  allowedScopes: Array<Scope>;
  /** Lazy 1:1 profile_business. Always returned; unfilled columns are null. Only meaningful for employee / contractor. */
  business: BusinessProfile;
  /**
   * Onboarding completeness (1.3). Same payload as `myProfileCompleteness` /
   * `CustomerMe.completeness`, evaluated by CheckCompleteness for this user.
   * Staff React Admin uses `me { completeness }` as the action_required guard.
   */
  completeness: ProfileCompleteness;
  /** Active scope from the JWT session. */
  currentScope?: Maybe<Scope>;
  defaultPage?: Maybe<Scalars['String']['output']>;
  defaultScope?: Maybe<Scope>;
  /** The only login identifier. Unique, and required since 1.1. */
  email: Scalars['String']['output'];
  /** Set from the Customer.io bounce/drop webhook. */
  emailBouncedAt?: Maybe<Scalars['Time']['output']>;
  emailVerifiedAt?: Maybe<Scalars['Time']['output']>;
  firstName: Scalars['String']['output'];
  /**
   * The holder's active golden ticket, or null (6.8). Assigned from the admin
   * user list/detail. Loaded by field resolver so the user grid does not join
   * golden_tickets on every row.
   */
  goldenTicket?: Maybe<GoldenTicket>;
  id: Scalars['UUID']['output'];
  lastLoginAt?: Maybe<Scalars['String']['output']>;
  /** From profile_personal; null until the user fills it in. */
  lastName?: Maybe<Scalars['String']['output']>;
  lastVisitAt?: Maybe<Scalars['Time']['output']>;
  marketingOptIn: Scalars['Boolean']['output'];
  /** Last time they opted IN. Deliberately retained after an opt-out. */
  marketingOptInAt?: Maybe<Scalars['Time']['output']>;
  passkeyCount: Scalars['Int']['output'];
  passkeys: Array<Passkey>;
  /** Effective permission codes in the active scope. */
  permissions: Array<Scalars['String']['output']>;
  /** Lazy 1:1 profile_personal. Always returned; unfilled columns are null. */
  personal: PersonalProfile;
  /**
   * Global points balance, derived from the loyalty ledger (2.2). Points are earned
   * across every scope and held as one balance, so this field is deliberately not
   * scope-filtered.
   */
  pointsBalance: Scalars['Int']['output'];
  /** ExpoApp toggle: 'Push me when a reward unlocks' (4.2). */
  pushOnRewardUnlock: Scalars['Boolean']['output'];
  /** Role bindings across scopes. */
  roleBindings: Array<ActorRoleBinding>;
  spendCents: Scalars['Cents']['output'];
  status: UserStatus;
  themePreference: ThemePreference;
  tipCents: Scalars['Cents']['output'];
  /** Null means customer. See UserType. */
  type?: Maybe<UserType>;
  /** Distinct recognition days with a linked PIN payment or a valid entrance log. */
  visitCount: Scalars['Int']['output'];
};

export type UserConnection = {
  __typename?: 'UserConnection';
  nodes: Array<User>;
  pageInfo: PageMeta;
};

export type UserFilter = {
  /**
   * When true, return only customers (`type IS NULL`). Needed as its own flag
   * because `type: []` cannot express 'the null value' in GraphQL input lists.
   */
  customerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  defaultScopeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Active golden ticket (status = active). Omitted = any. Revoked assignments
   * count as not holding one. Golden tickets are personal, not per-scope.
   */
  hasGoldenTicket?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<DateRangeInput>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Role bound to the user in the caller's active admin scope
   * (`actor_role_bindings.scope_id` = session scope, not `defaultScopeId`).
   * Omitted = any role, including unbound customers.
   */
  roleId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Account lifecycle (1.1). Omitted = all statuses, including DELETED. */
  status?: InputMaybe<Array<UserStatus>>;
  /** Relationship filter. Note this cannot select customers — see customerOnly. */
  type?: InputMaybe<Array<UserType>>;
};

/**
 * Everything the React admin user-detail loyalty panel needs in one round trip
 * (balance + recent ledger + vouchers + value stats).
 */
export type UserLoyalty = {
  __typename?: 'UserLoyalty';
  lastVisitAt?: Maybe<Scalars['Time']['output']>;
  pointsBalance: Scalars['Int']['output'];
  recentLedger: Array<LoyaltyLedgerEntry>;
  spendCents: Scalars['Cents']['output'];
  tipCents: Scalars['Cents']['output'];
  userId: Scalars['UUID']['output'];
  visitCount: Scalars['Int']['output'];
  vouchers: Array<Voucher>;
};

/**
 * Account lifecycle. Replaces the former `isActive` boolean.
 *
 * Only ACTIVE and CREATED may obtain a session; IMPORTED, PROVISIONAL, BLOCKED
 * and DELETED all fail closed (1.2).
 */
export type UserStatus =
  /** Email verified. Full session rules by type. */
  | 'ACTIVE'
  /** Admin blocked. No login; refresh tokens revoked. */
  | 'BLOCKED'
  /** Account exists, email not verified. Limited 24h session with no rolling refresh. */
  | 'CREATED'
  /** Soft-deleted via customer self-service (1.6). No login. */
  | 'DELETED'
  /** Written by the 2026 contacts import from the former ticketing system (Stager). Signup not completed; no login until they start magic-link signup. */
  | 'IMPORTED'
  /** Created on the guest's behalf (admin voucher issue, ticket claim). No login until they start magic-link signup, which claims it to CREATED. */
  | 'PROVISIONAL';

/**
 * The person's highest relationship with Ferry. `null` means customer.
 *
 * Hierarchy: ADMIN implies employee implies customer. Auth method and onboarding
 * completeness derive from this, so it is not a free-form label:
 * granting the `admin` / `super_admin` ACL role sets ADMIN, and a user whose
 * bindings imply admin may never authenticate by magic link (1.1 / 1.2).
 */
export type UserType = 'ADMIN' | 'CONTRACTOR' | 'EMPLOYEE';

/**
 * An issued voucher.
 *
 * The benefit is a SNAPSHOT taken at issue time, so editing or deactivating the
 * rule never changes what a guest is already holding. `rule` is provenance only
 * and is null for admin-issued one-offs.
 */
export type Voucher = {
  __typename?: 'Voucher';
  /**
   * Compat alias of `label` (same value on every read, customer reads included) for the iPad, Android and ExpoApp builds that still select it.
   * @deprecated Renamed to label; removed once the iPad, Android and ExpoApp builds that read it are replaced.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** Set only for AMOUNT. */
  discountAmountCents?: Maybe<Scalars['Cents']['output']>;
  /** Whole percent. Set only for PERCENTAGE. */
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  discountType: VoucherDiscountType;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['UUID']['output'];
  issuedAt: Scalars['Time']['output'];
  /**
   * The customer label at issue (a snapshot): the ExpoApp tile, the `voucher` mail
   * and the ticket voucher line. Null or empty means no line.
   */
  label?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['UUID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  /**
   * TICKET_CLAIMED mints only (a snapshot): the promotion shown with the ticket QR
   * after the claim and in the ticket mail. Null for every other voucher.
   */
  promotionLabel?: Maybe<Scalars['String']['output']>;
  /**
   * QR payload for POS scan. A STATIC voucher id — see the accepted-risk note in
   * `internal/loyalty/README.md`. The state machine makes a voucher single-use, so
   * the worst case is one voucher spent by the wrong person, never a replay.
   */
  qrPayload: Scalars['String']['output'];
  redeemedAt?: Maybe<Scalars['Time']['output']>;
  reservedAt?: Maybe<Scalars['Time']['output']>;
  revokedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Provenance. Null for admin-issued vouchers, and always null on customer / POS
   * reads (`myVouchers`, `scanVoucher`, `Order.appliedVoucher`, the voucher stream):
   * only the admin reads (`vouchers`, `voucher`) populate it, with one batched
   * lookup per page. A ticket_claimed rule's `night` follows the viewer's
   * `night:read`.
   */
  rule?: Maybe<VoucherRule>;
  /**
   * The rule's name at issue (a snapshot): the chip the register prints after a
   * scan, and the admin label. Copied from the rule at issue, also for an admin
   * issue from a rule. Null for a manual voucher and for vouchers from before
   * migration 00115 that had no linked rule. Null on customer reads (`myVouchers`,
   * the customer voucher stream, the card-link welcome gift): guests see `label`.
   * Present on admin reads, `scanVoucher`, `Order.appliedVoucher` and the POS frames.
   */
  ruleName?: Maybe<Scalars['String']['output']>;
  /**
   * The venue this voucher is redeemable at, and nowhere else. POS rejects a
   * voucher from another scope (6.1), so ExpoApp must show this name on every tile
   * (4.1 / 4.4).
   */
  scope: ScopeRef;
  status: VoucherStatus;
  /**
   * The address this voucher was minted for — the "who got it" column in the admin
   * grid and CSV (2.3).
   *
   * Populated on the **admin** reads (`vouchers`, `voucher`) with one batched
   * lookup per page. Null on customer / POS reads (`myVouchers`, `scanVoucher`,
   * `Order.appliedVoucher`), which never need it, and null when the users row has
   * no address (placeholder rows from migration `00051`).
   */
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type VoucherConnection = {
  __typename?: 'VoucherConnection';
  nodes: Array<Voucher>;
  pageInfo: PageMeta;
};

export type VoucherDiscountType = 'AMOUNT' | 'FREE_PRODUCT' | 'PERCENTAGE';

export type VoucherEvent = {
  __typename?: 'VoucherEvent';
  intent: VoucherEventIntent;
  voucher: Voucher;
};

/** Past-tense intents, per AGENTS.md §15.3. */
export type VoucherEventIntent =
  | 'VOUCHER_EXPIRED'
  /** Issued threshold voucher forfeited after a balance drop. */
  | 'VOUCHER_FORFEITED'
  | 'VOUCHER_ISSUED'
  | 'VOUCHER_REDEEMED'
  /** reserved -> issued (order canceled, payment failed, or the 15-minute reservation TTL). */
  | 'VOUCHER_RELEASED'
  /** POS scanned it: issued -> reserved. */
  | 'VOUCHER_RESERVED'
  | 'VOUCHER_REVOKED';

export type VoucherFilter = {
  expiresAt?: InputMaybe<DateRangeInput>;
  issuedAt?: InputMaybe<DateRangeInput>;
  /** Label or rule name (case-insensitive substring), or a voucher id / UUID prefix (admin grid deep-links). */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<VoucherStatus>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  voucherRuleId?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Admin-configured rule. Scoped: configured within the active scope like every
 * other admin grid, and mints its voucher in its own scope.
 *
 * Money is euro `Float` here because React admin configures it; the issued
 * `Voucher` carries `Cents`.
 */
export type VoucherRule = {
  __typename?: 'VoucherRule';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  /** Euros. Set only for AMOUNT. */
  discountAmount?: Maybe<Scalars['Float']['output']>;
  /** Whole percent (e.g. 10.0). Set only for PERCENTAGE. */
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  discountType: VoucherDiscountType;
  id: Scalars['UUID']['output'];
  /** How many vouchers this rule has minted, for the admin grid. */
  issuedCount: Scalars['Int']['output'];
  /**
   * Customer copy: the ExpoApp tile, the `voucher` mail, and the voucher line of the
   * ticket mail and the www claim / manage pages. Empty means NO voucher line at
   * all (the calculated benefit is not a fallback).
   */
  label?: Maybe<Scalars['String']['output']>;
  /** Internal admin name (max 80 characters) AND the chip the iPad / Android register prints after a scan. */
  name: Scalars['String']['output'];
  /**
   * TICKET_CLAIMED only. Null unless the viewer holds `night:read` in the
   * night's venue (a device never sees it): the rule form does not become a
   * way to read other venues' calendars. Then id, title, start, venue name and
   * stages only.
   */
  night?: Maybe<VoucherRuleNight>;
  /**
   * TICKET_CLAIMED only: the night the rule points at (may be in another
   * venue). Always set for such a rule, so the client can tell "a night you cannot
   * see" (`night` null) from "no night".
   */
  nightId?: Maybe<Scalars['UUID']['output']>;
  /** Set only for FREE_PRODUCT. */
  productId?: Maybe<Scalars['UUID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  /**
   * TICKET_CLAIMED only: the promotion on the ticket mail and wherever the ticket QR
   * is shown after the claim (ExpoApp, claim and manage pages). Cleared (null) on
   * every other trigger.
   */
  promotionLabel?: Maybe<Scalars['String']['output']>;
  scope: ScopeRef;
  /** TICKET_CLAIMED only: the stage subset; empty means every stage. */
  stageIds: Array<Scalars['UUID']['output']>;
  /** Required for POINTS_THRESHOLD, null otherwise. */
  thresholdPoints?: Maybe<Scalars['Int']['output']>;
  trigger: VoucherRuleTrigger;
  updatedAt: Scalars['Time']['output'];
  /** YYYY-MM-DD; the rule is valid until the end of that trading day. Null for NIGHT. */
  validUntil?: Maybe<Scalars['String']['output']>;
  /** Sets the voucher's expiresAt at issue time. */
  validityDays: Scalars['Int']['output'];
  validityMode?: Maybe<VoucherValidityMode>;
};

/**
 * A night a ticket_claimed rule may point at: id, title, start, venue name
 * and stage names. Nothing else about the night is exposed here.
 */
export type VoucherRuleNight = {
  __typename?: 'VoucherRuleNight';
  id: Scalars['UUID']['output'];
  scope: VoucherRuleScope;
  stages: Array<VoucherRuleStage>;
  startsAt: Scalars['Time']['output'];
  title: Scalars['String']['output'];
};

/** The venue name of a night in the rule form. Id and name only, never the public address or beacon. */
export type VoucherRuleScope = {
  __typename?: 'VoucherRuleScope';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/** A ticket stage as the rule form lists it. */
export type VoucherRuleStage = {
  __typename?: 'VoucherRuleStage';
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/**
 * What fires a voucher rule.
 *
 * POINTS_THRESHOLD remints whenever the global balance is at/above the threshold
 * and the guest does not already hold a live (issued/reserved) voucher for that
 * rule. FIRST_CARD_LINKED fires once per user ever; BIRTHDAY fires once per user
 * per year, per configured scope.
 */
export type VoucherRuleTrigger =
  /** Weekly job, Wednesday 17:00 Europe/Amsterdam, for birthdays Wed-Tue inclusive. */
  | 'BIRTHDAY'
  /**
   * User linked their FIRST card, ever. Only reachable through the terminal
   * registration path (2.1) — an email signup or an imported user claiming by magic
   * link never links a card and so never matches.
   */
  | 'FIRST_CARD_LINKED'
  /** Global balance crossed `thresholdPoints`. Remints when they earn enough again without a live voucher. Fires per scope. */
  | 'POINTS_THRESHOLD'
  /**
   * A ticket of one night (in any venue the admin may read) was claimed.
   * Needs `nightId` and `validityMode` (+ `validUntil` for the open-ended
   * modes); `stageIds` narrows to some stages (empty = every stage). The voucher
   * is minted in the rule's own scope.
   */
  | 'TICKET_CLAIMED';

/**
 * Why a scan was rejected. Every value is staff-visible: the bartender needs to
 * know whether to apologise or to explain.
 */
export type VoucherScanRejection =
  | 'ALREADY_REDEEMED'
  /** Already reserved, possibly on another register. */
  | 'ALREADY_RESERVED'
  | 'EXPIRED'
  /** Balance (minus other reserved threshold costs) is below this voucher's snapshotted threshold. */
  | 'INSUFFICIENT_POINTS'
  | 'NOT_FOUND'
  /** A ticket voucher scanned before its `validFrom`. `message` says when it becomes valid. */
  | 'NOT_YET_VALID'
  | 'REVOKED'
  /**
   * A ticket QR (`ferry:ticket:{uuid}`) whose ticket has no live voucher: none was
   * minted, or every one is redeemed, revoked, expired or forfeited. An unknown
   * ticket answers the same.
   */
  | 'TICKET_NO_VOUCHER'
  /** The voucher belongs to another venue. `message` names it (6.1). */
  | 'WRONG_SCOPE';

export type VoucherScanResult = {
  __typename?: 'VoucherScanResult';
  accepted: Scalars['Boolean']['output'];
  /**
   * Human-readable line for the POS screen, always present. On WRONG_SCOPE it names
   * the owning scope ("voucher is for {scope name}"), which is why the resolver
   * looks the voucher up before deciding — a bare "not valid here" sends staff and
   * guest into an argument neither can settle.
   */
  message: Scalars['String']['output'];
  rejection?: Maybe<VoucherScanRejection>;
  /** Set when accepted; status is RESERVED. */
  voucher?: Maybe<Voucher>;
};

export type VoucherSort = {
  direction?: SortDirection;
  field: VoucherSortField;
};

export type VoucherSortField =
  'EXPIRES_AT' | 'ISSUED_AT' | 'STATUS' | 'USER_EMAIL';

export type VoucherStatus =
  | 'EXPIRED'
  /** Issued threshold voucher the guest can no longer afford after a balance drop. */
  | 'FORFEITED'
  | 'ISSUED'
  | 'REDEEMED'
  | 'RESERVED'
  | 'REVOKED';

/** When a ticket_claimed voucher can be used. */
export type VoucherValidityMode =
  /** From the claim until the end of the `validUntil` trading day (06:00 next morning). */
  | 'AFTER_CLAIM'
  /** From the end of the night until the end of the `validUntil` trading day. */
  | 'AFTER_NIGHT'
  /** Only during the night's own trading day. `validUntil` is ignored. */
  | 'NIGHT';

export type CategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type CategoriesQuery = {
  __typename?: 'Query';
  categories: Array<{
    __typename?: 'Category';
    id: any;
    name: string;
    sort: number;
    isActive: boolean;
    showInMenu: boolean;
    productCount: number;
  }>;
};

export type CreateCategoryMutationVariables = Exact<{
  input: CreateCategoryInput;
}>;

export type CreateCategoryMutation = {
  __typename?: 'Mutation';
  createCategory: { __typename?: 'Category'; id: any; name: string };
};

export type ReorderCategoriesMutationVariables = Exact<{
  entity: SortableEntity;
  orderedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ReorderCategoriesMutation = {
  __typename?: 'Mutation';
  reorder: boolean;
};

export type ExportCategoriesCsvQueryVariables = Exact<{ [key: string]: never }>;

export type ExportCategoriesCsvQuery = {
  __typename?: 'Query';
  exportCategoriesCsv: {
    __typename?: 'ExportJob';
    url: string;
    expiresAt: string;
  };
};

export type CategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CategoryQuery = {
  __typename?: 'Query';
  category?: {
    __typename?: 'Category';
    id: any;
    name: string;
    isActive: boolean;
    showInMenu: boolean;
    isDoor: boolean;
    products: Array<{ __typename?: 'Product'; id: any; name: string }>;
  } | null;
  products: {
    __typename?: 'ProductConnection';
    nodes: Array<{
      __typename?: 'Product';
      id: any;
      name: string;
      categories: Array<{ __typename?: 'Category'; id: any }>;
    }>;
  };
};

export type UpdateCategoryDetailsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCategoryInput;
}>;

export type UpdateCategoryDetailsMutation = {
  __typename?: 'Mutation';
  updateCategory: {
    __typename?: 'Category';
    id: any;
    name: string;
    isActive: boolean;
    showInMenu: boolean;
    isDoor: boolean;
  };
};

export type SetCategoryProductsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type SetCategoryProductsMutation = {
  __typename?: 'Mutation';
  setCategoryProducts: { __typename?: 'Category'; id: any };
};

export type ReorderProductCategoryMutationVariables = Exact<{
  entity: SortableEntity;
  orderedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ReorderProductCategoryMutation = {
  __typename?: 'Mutation';
  reorder: boolean;
};

export type ChartSeriesQueryVariables = Exact<{
  preset: ChartPreset;
  recognitionDate: Scalars['String']['input'];
  bucket: ChartBucket;
  windowStart?: InputMaybe<Scalars['String']['input']>;
  windowEnd?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChartSeriesQuery = {
  __typename?: 'Query';
  chartSeries: {
    __typename?: 'ChartSeries';
    preset: ChartPreset;
    recognitionDate: string;
    bucket: ChartBucket;
    availableWindowStart?: string | null;
    availableWindowEnd?: string | null;
    categories: Array<string>;
    series: Array<{
      __typename?: 'ChartSeriesItem';
      name: string;
      data: Array<number>;
    }>;
  };
};

export type ChartAvailableDatesQueryVariables = Exact<{
  preset: ChartPreset;
}>;

export type ChartAvailableDatesQuery = {
  __typename?: 'Query';
  chartAvailableDates: Array<string>;
};

export type TicketSalesNightsQueryVariables = Exact<{ [key: string]: never }>;

export type TicketSalesNightsQuery = {
  __typename?: 'Query';
  ticketSalesNights: Array<{
    __typename?: 'TicketSalesNight';
    nightId: any;
    name: string;
    startsAt: any;
    upcoming: boolean;
  }>;
};

export type TicketSalesSeriesQueryVariables = Exact<{
  nightIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  interval: TicketSalesInterval;
}>;

export type TicketSalesSeriesQuery = {
  __typename?: 'Query';
  ticketSalesSeries: {
    __typename?: 'TicketSalesChart';
    categories: Array<number>;
    series: Array<{
      __typename?: 'TicketSalesSeries';
      nightId: any;
      nightName: string;
      stageId: any;
      stageName: string;
      data: Array<number>;
      pending: number;
    }>;
  };
};

export type CustomerIoTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerIoTemplatesQuery = {
  __typename?: 'Query';
  customerIoTemplates: Array<{
    __typename?: 'CustomerIoTemplateMapping';
    kind: CustomerIoTemplateKind;
    transactionalMessageId?: number | null;
    templateName?: string | null;
    configured: boolean;
    updatedAt?: any | null;
  }>;
};

export type CustomerIoTransactionalTemplatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CustomerIoTransactionalTemplatesQuery = {
  __typename?: 'Query';
  customerIoTransactionalTemplates: Array<{
    __typename?: 'CustomerIoTransactionalTemplate';
    id: number;
    name: string;
    state?: string | null;
    sendToUnsubscribed?: boolean | null;
  }>;
};

export type SaveCustomerIoTemplatesMutationVariables = Exact<{
  input: Array<CustomerIoTemplateInput> | CustomerIoTemplateInput;
}>;

export type SaveCustomerIoTemplatesMutation = {
  __typename?: 'Mutation';
  saveCustomerIoTemplates: Array<{
    __typename?: 'CustomerIoTemplateMapping';
    kind: CustomerIoTemplateKind;
    transactionalMessageId?: number | null;
    templateName?: string | null;
    configured: boolean;
  }>;
};

export type ExactConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type ExactConfigurationQuery = {
  __typename?: 'Query';
  exactConfiguration: {
    __typename?: 'ExactConfiguration';
    enabled: boolean;
    credentialsConfigured: boolean;
    status: string;
    division?: number | null;
    scopeEnabled: boolean;
    lastError?: string | null;
    mapping?: {
      __typename?: 'ExactMapping';
      journalCode: string;
      entryDescription: string;
      revenueLowGlId?: any | null;
      revenueLowGlCode: string;
      revenueLowGlDescription: string;
      vatCodeLow: string;
      vatPercentageLow: number;
      revenueHighGlId?: any | null;
      revenueHighGlCode: string;
      revenueHighGlDescription: string;
      vatCodeHigh: string;
      vatPercentageHigh: number;
      adyenGlId?: any | null;
      adyenGlCode: string;
      adyenGlDescription: string;
      cashGlId?: any | null;
      cashGlCode: string;
      cashGlDescription: string;
      tipsGlId?: any | null;
      tipsGlCode: string;
      tipsGlDescription: string;
      tabsGlId?: any | null;
      tabsGlCode: string;
      tabsGlDescription: string;
      salesJournalCode: string;
      itemLowId?: any | null;
      itemLowCode: string;
      itemLowDescription: string;
      itemHighId?: any | null;
      itemHighCode: string;
      itemHighDescription: string;
      ticketGlId?: any | null;
      ticketGlCode: string;
      ticketGlDescription: string;
      ticketItemId?: any | null;
      ticketItemCode: string;
      ticketItemDescription: string;
      ticketVatCode: string;
      ticketVatPercentage?: number | null;
      bookingFeeGlId?: any | null;
      bookingFeeGlCode: string;
      bookingFeeGlDescription: string;
      paypalGlId?: any | null;
      paypalGlCode: string;
      paypalGlDescription: string;
    } | null;
  };
};

export type ExactDivisionsQueryVariables = Exact<{ [key: string]: never }>;

export type ExactDivisionsQuery = {
  __typename?: 'Query';
  exactDivisions: Array<{
    __typename?: 'ExactDivision';
    code: number;
    description: string;
  }>;
};

export type ExactGlAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type ExactGlAccountsQuery = {
  __typename?: 'Query';
  exactGLAccounts: Array<{
    __typename?: 'ExactGLAccount';
    id: any;
    code: string;
    description: string;
  }>;
};

export type ExactVatCodesQueryVariables = Exact<{ [key: string]: never }>;

export type ExactVatCodesQuery = {
  __typename?: 'Query';
  exactVATCodes: Array<{
    __typename?: 'ExactVATCode';
    id: any;
    code: string;
    description: string;
    percentage: number;
  }>;
};

export type ExactJournalsQueryVariables = Exact<{ [key: string]: never }>;

export type ExactJournalsQuery = {
  __typename?: 'Query';
  exactJournals: Array<{
    __typename?: 'ExactJournal';
    code: string;
    description: string;
  }>;
};

export type ExactItemsQueryVariables = Exact<{ [key: string]: never }>;

export type ExactItemsQuery = {
  __typename?: 'Query';
  exactItems: Array<{
    __typename?: 'ExactItem';
    id: any;
    code: string;
    description: string;
  }>;
};

export type StartExactAuthorizationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type StartExactAuthorizationMutation = {
  __typename?: 'Mutation';
  startExactAuthorization: string;
};

export type DisconnectExactMutationVariables = Exact<{ [key: string]: never }>;

export type DisconnectExactMutation = {
  __typename?: 'Mutation';
  disconnectExact: {
    __typename?: 'ExactConfiguration';
    status: string;
    division?: number | null;
    scopeEnabled: boolean;
    lastError?: string | null;
  };
};

export type SaveExactDivisionMutationVariables = Exact<{
  division?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SaveExactDivisionMutation = {
  __typename?: 'Mutation';
  saveExactDivision: {
    __typename?: 'ExactConfiguration';
    division?: number | null;
    scopeEnabled: boolean;
  };
};

export type SaveExactTicketMappingMutationVariables = Exact<{
  input: SaveExactTicketMappingInput;
}>;

export type SaveExactTicketMappingMutation = {
  __typename?: 'Mutation';
  saveExactTicketMapping: {
    __typename?: 'ExactMapping';
    ticketGlId?: any | null;
    ticketGlCode: string;
    ticketItemId?: any | null;
    ticketItemCode: string;
    ticketVatCode: string;
    ticketVatPercentage?: number | null;
    bookingFeeGlId?: any | null;
    bookingFeeGlCode: string;
    paypalGlId?: any | null;
    paypalGlCode: string;
  };
};

export type SaveExactMappingMutationVariables = Exact<{
  input: SaveExactMappingInput;
}>;

export type SaveExactMappingMutation = {
  __typename?: 'Mutation';
  saveExactMapping: {
    __typename?: 'ExactConfiguration';
    mapping?: {
      __typename?: 'ExactMapping';
      journalCode: string;
      entryDescription: string;
      revenueLowGlId?: any | null;
      revenueLowGlCode: string;
      vatCodeLow: string;
      vatPercentageLow: number;
      revenueHighGlId?: any | null;
      revenueHighGlCode: string;
      vatCodeHigh: string;
      vatPercentageHigh: number;
      adyenGlId?: any | null;
      adyenGlCode: string;
      cashGlId?: any | null;
      cashGlCode: string;
      tipsGlId?: any | null;
      tipsGlCode: string;
      tabsGlId?: any | null;
      tabsGlCode: string;
      salesJournalCode: string;
      itemLowId?: any | null;
      itemLowCode: string;
      itemHighId?: any | null;
      itemHighCode: string;
    } | null;
  };
};

export type CompleteExactAuthorizationMutationVariables = Exact<{
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
}>;

export type CompleteExactAuthorizationMutation = {
  __typename?: 'Mutation';
  completeExactAuthorization: {
    __typename?: 'ExactConfiguration';
    status: string;
    division?: number | null;
    connectedAt?: string | null;
    lastError?: string | null;
  };
};

export type LoyaltySettingsQueryVariables = Exact<{ [key: string]: never }>;

export type LoyaltySettingsQuery = {
  __typename?: 'Query';
  loyaltySettings: {
    __typename?: 'LoyaltySettings';
    spendStepCents: number;
    pointsPerStep: number;
    updatedAt: any;
  };
};

export type SaveLoyaltySettingsMutationVariables = Exact<{
  spendStepCents: Scalars['Int']['input'];
  pointsPerStep: Scalars['Int']['input'];
}>;

export type SaveLoyaltySettingsMutation = {
  __typename?: 'Mutation';
  saveLoyaltySettings: {
    __typename?: 'LoyaltySettings';
    spendStepCents: number;
    pointsPerStep: number;
    updatedAt: any;
  };
};

export type ScopeTicketSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type ScopeTicketSettingsQuery = {
  __typename?: 'Query';
  scopeTicketSettings: {
    __typename?: 'ScopeTicketSettings';
    scopeId: any;
    taxPercentage?: number | null;
    feeTaxPercentage?: number | null;
    effectiveFeeTaxPercentage?: number | null;
    ticketPointsPerEuro: number;
    configured: boolean;
    exactTicketMappingConfigured: boolean;
    updatedAt?: any | null;
  };
};

export type SaveScopeTicketSettingsMutationVariables = Exact<{
  taxPercentage: Scalars['Float']['input'];
  feeTaxPercentage?: InputMaybe<Scalars['Float']['input']>;
  ticketPointsPerEuro: Scalars['Int']['input'];
}>;

export type SaveScopeTicketSettingsMutation = {
  __typename?: 'Mutation';
  saveScopeTicketSettings: {
    __typename?: 'ScopeTicketSettings';
    taxPercentage?: number | null;
    feeTaxPercentage?: number | null;
    effectiveFeeTaxPercentage?: number | null;
    ticketPointsPerEuro: number;
    configured: boolean;
    exactTicketMappingConfigured: boolean;
  };
};

export type UpdateScopeBeaconMajorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  beaconMajor?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UpdateScopeBeaconMajorMutation = {
  __typename?: 'Mutation';
  updateScope: {
    __typename?: 'Scope';
    id: any;
    name: string;
    beaconMajor?: number | null;
  };
};

export type ConsumptionReportQueryVariables = Exact<{
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
}>;

export type ConsumptionReportQuery = {
  __typename?: 'Query';
  consumptionReport: {
    __typename?: 'ConsumptionReport';
    dateFrom: string;
    dateTo: string;
    rows: Array<{
      __typename?: 'ConsumptionReportRow';
      consumptionName: string;
      unitLabel: string;
      totalUnits: number;
      lines: Array<{
        __typename?: 'ConsumptionReportProductLine';
        productId: string;
        productName: string;
        unitAmount: number;
        qtySold: number;
        unitsContributed: number;
      }>;
    }>;
  };
};

export type DeviceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeviceQuery = {
  __typename?: 'Query';
  device?: {
    __typename?: 'Device';
    id: any;
    name: string;
    isActive: boolean;
    allowCategorySwitch: boolean;
    askLoyalty: boolean;
    roleBindings: Array<{
      __typename?: 'ActorRoleBinding';
      role: { __typename?: 'Role'; id: any; name: string; slug: string };
    }>;
    gratuitySettings: {
      __typename?: 'DeviceGratuitySettings';
      enabled: boolean;
      minimumAmountCents: any;
      tipPercent1: number;
      tipPercent2: number;
      tipPercent3: number;
      roundToHalf: boolean;
      allowCustomTip: boolean;
    };
    category?: { __typename?: 'Category'; id: any; name: string } | null;
    terminal?: { __typename?: 'Terminal'; id: any; name: string } | null;
  } | null;
  categories: Array<{ __typename?: 'Category'; id: any; name: string }>;
  terminals: {
    __typename?: 'TerminalConnection';
    nodes: Array<{ __typename?: 'Terminal'; id: any; name: string }>;
  };
};

export type DeviceRolesCatalogQueryVariables = Exact<{ [key: string]: never }>;

export type DeviceRolesCatalogQuery = {
  __typename?: 'Query';
  roles: Array<{ __typename?: 'Role'; id: any; name: string; slug: string }>;
};

export type SetDeviceRolesMutationVariables = Exact<{
  deviceId: Scalars['UUID']['input'];
  roleId?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type SetDeviceRolesMutation = {
  __typename?: 'Mutation';
  setDeviceRoles: {
    __typename?: 'Device';
    id: any;
    roleBindings: Array<{
      __typename?: 'ActorRoleBinding';
      role: { __typename?: 'Role'; id: any; name: string };
    }>;
  };
};

export type UpdateDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDeviceInput;
}>;

export type UpdateDeviceMutation = {
  __typename?: 'Mutation';
  updateDevice: {
    __typename?: 'Device';
    id: any;
    name: string;
    isActive: boolean;
    allowCategorySwitch: boolean;
    askLoyalty: boolean;
    gratuitySettings: {
      __typename?: 'DeviceGratuitySettings';
      enabled: boolean;
    };
  };
};

export type PerformDeviceResetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PerformDeviceResetMutation = {
  __typename?: 'Mutation';
  performDeviceAction: {
    __typename?: 'Device';
    id: any;
    name: string;
    isActive: boolean;
    askLoyalty: boolean;
    gratuitySettings: {
      __typename?: 'DeviceGratuitySettings';
      enabled: boolean;
    };
    category?: { __typename?: 'Category'; id: any; name: string } | null;
    terminal?: { __typename?: 'Terminal'; id: any; name: string } | null;
  };
};

export type RegenerateDevicePairingCodeMutationVariables = Exact<{
  deviceId: Scalars['UUID']['input'];
}>;

export type RegenerateDevicePairingCodeMutation = {
  __typename?: 'Mutation';
  regenerateDevicePairingCode: {
    __typename?: 'DevicePairing';
    pairingCode: string;
    expiresAt: any;
    device: { __typename?: 'Device'; id: any; name: string };
  };
};

export type DevicesQueryVariables = Exact<{
  filter?: InputMaybe<DeviceFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
}>;

export type DevicesQuery = {
  __typename?: 'Query';
  devices: {
    __typename?: 'DeviceConnection';
    nodes: Array<{
      __typename?: 'Device';
      id: any;
      name: string;
      status: DeviceStatus;
      connectionStatus: string;
      createdAt: string;
      isActive: boolean;
      askLoyalty: boolean;
      allowedActions: Array<DeviceAction>;
      gratuitySettings: {
        __typename?: 'DeviceGratuitySettings';
        enabled: boolean;
      };
      category?: { __typename?: 'Category'; id: any; name: string } | null;
      terminal?: { __typename?: 'Terminal'; id: any; name: string } | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type TerminalsForDeviceFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TerminalsForDeviceFilterQuery = {
  __typename?: 'Query';
  terminals: {
    __typename?: 'TerminalConnection';
    nodes: Array<{ __typename?: 'Terminal'; id: any; name: string }>;
  };
};

export type CategoriesForDeviceFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CategoriesForDeviceFilterQuery = {
  __typename?: 'Query';
  categories: Array<{ __typename?: 'Category'; id: any; name: string }>;
};

export type BulkPerformDeviceActionMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  action: DeviceAction;
}>;

export type BulkPerformDeviceActionMutation = {
  __typename?: 'Mutation';
  bulkPerformDeviceAction: {
    __typename?: 'BulkResult';
    succeeded: Array<string>;
    failed: Array<{ __typename?: 'BulkFailure'; id: string; reason: string }>;
  };
};

export type ExportDevicesCsvQueryVariables = Exact<{
  filter?: InputMaybe<DeviceFilter>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExportDevicesCsvQuery = {
  __typename?: 'Query';
  exportDevicesCsv: {
    __typename?: 'ExportJob';
    url: string;
    expiresAt: string;
  };
};

export type CreateDeviceMutationVariables = Exact<{
  input: CreateDeviceInput;
}>;

export type CreateDeviceMutation = {
  __typename?: 'Mutation';
  createDevice: {
    __typename?: 'DevicePairing';
    pairingCode: string;
    expiresAt: any;
    device: { __typename?: 'Device'; id: any; name: string };
  };
};

export type DiscountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DiscountQuery = {
  __typename?: 'Query';
  discount?: {
    __typename?: 'Discount';
    id: any;
    name: string;
    type: string;
    isActive: boolean;
    configuration: string;
  } | null;
  discountTypes: Array<{
    __typename?: 'DiscountTypeSpec';
    type: string;
    label: string;
    schema: string;
  }>;
};

export type DiscountTypesQueryVariables = Exact<{ [key: string]: never }>;

export type DiscountTypesQuery = {
  __typename?: 'Query';
  discountTypes: Array<{
    __typename?: 'DiscountTypeSpec';
    type: string;
    label: string;
    schema: string;
  }>;
};

export type CreateDiscountMutationVariables = Exact<{
  input: CreateDiscountInput;
}>;

export type CreateDiscountMutation = {
  __typename?: 'Mutation';
  createDiscount: { __typename?: 'Discount'; id: any };
};

export type UpdateDiscountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDiscountInput;
}>;

export type UpdateDiscountMutation = {
  __typename?: 'Mutation';
  updateDiscount: {
    __typename?: 'Discount';
    id: any;
    name: string;
    type: string;
    isActive: boolean;
    configuration: string;
  };
};

export type DiscountsQueryVariables = Exact<{
  filter?: InputMaybe<DiscountFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DiscountsQuery = {
  __typename?: 'Query';
  discounts: {
    __typename?: 'DiscountConnection';
    nodes: Array<{
      __typename?: 'Discount';
      id: any;
      name: string;
      type: string;
      isActive: boolean;
      totalDiscount30d: number;
      usageCount30d: number;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type DiscountTypesForFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DiscountTypesForFilterQuery = {
  __typename?: 'Query';
  discountTypes: Array<{
    __typename?: 'DiscountTypeSpec';
    type: string;
    label: string;
  }>;
};

export type SetDiscountsActiveMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
}>;

export type SetDiscountsActiveMutation = {
  __typename?: 'Mutation';
  setDiscountsActive: {
    __typename?: 'BulkResult';
    succeeded: Array<string>;
    failed: Array<{ __typename?: 'BulkFailure'; id: string; reason: string }>;
  };
};

export type ExportDiscountsCsvQueryVariables = Exact<{
  filter?: InputMaybe<DiscountFilter>;
}>;

export type ExportDiscountsCsvQuery = {
  __typename?: 'Query';
  exportDiscountsCsv: {
    __typename?: 'ExportJob';
    url: string;
    expiresAt: string;
  };
};

export type ExactJournalEntriesQueryVariables = Exact<{
  filter?: InputMaybe<ExactJournalEntryFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ExactJournalEntrySort>;
}>;

export type ExactJournalEntriesQuery = {
  __typename?: 'Query';
  exactJournalEntries: {
    __typename?: 'ExactJournalEntryConnection';
    nodes: Array<{
      __typename?: 'ExactJournalEntry';
      id: any;
      recognitionDate: string;
      status: string;
      journalCode: string;
      description: string;
      financialYear: number;
      financialPeriod: number;
      exactEntryId?: any | null;
      entryNumber?: number | null;
      error?: string | null;
      createdAt: string;
      updatedAt: string;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type ExportExactDayMutationVariables = Exact<{
  recognitionDate: Scalars['String']['input'];
}>;

export type ExportExactDayMutation = {
  __typename?: 'Mutation';
  exportExactDay?: {
    __typename?: 'ExactJournalEntry';
    id: any;
    status: string;
    error?: string | null;
  } | null;
};

export type ExactJournalEntryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type ExactJournalEntryQuery = {
  __typename?: 'Query';
  exactJournalEntry?: {
    __typename?: 'ExactJournalEntry';
    id: any;
    recognitionDate: string;
    status: string;
    journalCode: string;
    description: string;
    financialYear: number;
    financialPeriod: number;
    exactEntryId?: any | null;
    entryNumber?: number | null;
    error?: string | null;
    createdAt: string;
    updatedAt: string;
    lines: Array<{
      __typename?: 'ExactJournalEntryLine';
      id: any;
      lineNumber: number;
      glAccountCode: string;
      glAccountDescription: string;
      description: string;
      amount: number;
      vatCode?: string | null;
      vatPercentage?: number | null;
      vatAmount?: number | null;
    }>;
  } | null;
};

export type ExportExactDayRetryMutationVariables = Exact<{
  recognitionDate: Scalars['String']['input'];
}>;

export type ExportExactDayRetryMutation = {
  __typename?: 'Mutation';
  exportExactDay?: {
    __typename?: 'ExactJournalEntry';
    id: any;
    status: string;
    error?: string | null;
  } | null;
};

export type LedgerTransactionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type LedgerTransactionQuery = {
  __typename?: 'Query';
  ledgerTransaction?: {
    __typename?: 'LedgerTransaction';
    id: any;
    transactionId: string;
    amountReceived: number;
    amountTip: number;
    amountCashTrade: number;
    amountRecognizedTotal: number;
    psp?: string | null;
    paymentMethod: string;
    recognitionDate: string;
    recognitionMinute: number;
    createdAt: string;
    categoryName?: string | null;
    deviceName?: string | null;
    categoryId?: any | null;
    deviceId?: any | null;
    order?: { __typename?: 'Order'; id: any } | null;
    tab?: { __typename?: 'Tab'; id: any; name: string } | null;
    payment?: { __typename?: 'Payment'; id: any } | null;
    refund?: { __typename?: 'Refund'; id: any } | null;
    taxLines: Array<{
      __typename?: 'LedgerTaxLine';
      taxPercentage: number;
      salesExcl: number;
      tax: number;
      salesIncl: number;
    }>;
  } | null;
};

export type LedgerTransactionsQueryVariables = Exact<{
  filter?: InputMaybe<LedgerTransactionFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LedgerTransactionSort>;
}>;

export type LedgerTransactionsQuery = {
  __typename?: 'Query';
  ledgerTransactions: {
    __typename?: 'LedgerTransactionConnection';
    nodes: Array<{
      __typename?: 'LedgerTransaction';
      id: any;
      transactionId: string;
      amountReceived: number;
      amountTip: number;
      amountCashTrade: number;
      amountRecognizedTotal: number;
      psp?: string | null;
      paymentMethod: string;
      recognitionDate: string;
      createdAt: string;
      categoryName?: string | null;
      deviceName?: string | null;
      categoryId?: any | null;
      deviceId?: any | null;
      order?: { __typename?: 'Order'; id: any } | null;
      tab?: { __typename?: 'Tab'; id: any; name: string } | null;
      payment?: { __typename?: 'Payment'; id: any } | null;
      refund?: { __typename?: 'Refund'; id: any } | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type ExportLedgerTransactionsCsvQueryVariables = Exact<{
  filter?: InputMaybe<LedgerTransactionFilter>;
  sort?: InputMaybe<LedgerTransactionSort>;
}>;

export type ExportLedgerTransactionsCsvQuery = {
  __typename?: 'Query';
  exportLedgerTransactionsCsv: {
    __typename?: 'ExportJob';
    url: string;
    expiresAt: string;
  };
};

export type LinksQueryVariables = Exact<{ [key: string]: never }>;

export type LinksQuery = {
  __typename?: 'Query';
  links: Array<{
    __typename?: 'Link';
    id: string;
    name: string;
    url: string;
    sort: number;
  }>;
};

export type CreateLinkMutationVariables = Exact<{
  input: CreateLinkInput;
}>;

export type CreateLinkMutation = {
  __typename?: 'Mutation';
  createLink: { __typename?: 'Link'; id: string; name: string; url: string };
};

export type UpdateLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLinkInput;
}>;

export type UpdateLinkMutation = {
  __typename?: 'Mutation';
  updateLink: { __typename?: 'Link'; id: string; name: string; url: string };
};

export type DeleteLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteLinkMutation = {
  __typename?: 'Mutation';
  deleteLink: string;
};

export type ReorderLinksMutationVariables = Exact<{
  entity: SortableEntity;
  orderedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ReorderLinksMutation = {
  __typename?: 'Mutation';
  reorder: boolean;
};

export type VoucherRuleNightsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type VoucherRuleNightsQuery = {
  __typename?: 'Query';
  voucherRuleNights: Array<{
    __typename?: 'VoucherRuleNight';
    id: any;
    title: string;
    startsAt: any;
    scope: { __typename?: 'VoucherRuleScope'; id: any; name: string };
    stages: Array<{
      __typename?: 'VoucherRuleStage';
      id: any;
      name: string;
      isActive: boolean;
    }>;
  }>;
};

export type VoucherRuleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type VoucherRuleQuery = {
  __typename?: 'Query';
  voucherRule?: {
    __typename?: 'VoucherRule';
    id: any;
    name: string;
    trigger: VoucherRuleTrigger;
    thresholdPoints?: number | null;
    validityDays: number;
    discountType: VoucherDiscountType;
    discountPercentage?: number | null;
    discountAmount?: number | null;
    productId?: any | null;
    productName?: string | null;
    label?: string | null;
    promotionLabel?: string | null;
    active: boolean;
    nightId?: any | null;
    stageIds: Array<any>;
    validityMode?: VoucherValidityMode | null;
    validUntil?: string | null;
    night?: {
      __typename?: 'VoucherRuleNight';
      id: any;
      title: string;
      startsAt: any;
      scope: { __typename?: 'VoucherRuleScope'; id: any; name: string };
      stages: Array<{
        __typename?: 'VoucherRuleStage';
        id: any;
        name: string;
        isActive: boolean;
      }>;
    } | null;
  } | null;
};

export type ProductsForVoucherRuleQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ProductsForVoucherRuleQuery = {
  __typename?: 'Query';
  products: {
    __typename?: 'ProductConnection';
    nodes: Array<{ __typename?: 'Product'; id: any; name: string }>;
  };
};

export type CreateVoucherRuleMutationVariables = Exact<{
  input: CreateVoucherRuleInput;
}>;

export type CreateVoucherRuleMutation = {
  __typename?: 'Mutation';
  createVoucherRule: { __typename?: 'VoucherRule'; id: any };
};

export type UpdateVoucherRuleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateVoucherRuleInput;
}>;

export type UpdateVoucherRuleMutation = {
  __typename?: 'Mutation';
  updateVoucherRule: { __typename?: 'VoucherRule'; id: any; active: boolean };
};

export type VoucherRulesQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type VoucherRulesQuery = {
  __typename?: 'Query';
  voucherRules: Array<{
    __typename?: 'VoucherRule';
    id: any;
    name: string;
    label?: string | null;
    trigger: VoucherRuleTrigger;
    thresholdPoints?: number | null;
    validityDays: number;
    discountType: VoucherDiscountType;
    discountPercentage?: number | null;
    discountAmount?: number | null;
    productName?: string | null;
    active: boolean;
    issuedCount: number;
    nightId?: any | null;
    validityMode?: VoucherValidityMode | null;
    validUntil?: string | null;
    scope: { __typename?: 'ScopeRef'; id: any; name: string };
    night?: {
      __typename?: 'VoucherRuleNight';
      id: any;
      title: string;
      scope: { __typename?: 'VoucherRuleScope'; id: any; name: string };
    } | null;
  }>;
};

export type SetVoucherRulesActiveMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  active: Scalars['Boolean']['input'];
}>;

export type SetVoucherRulesActiveMutation = {
  __typename?: 'Mutation';
  setVoucherRulesActive: {
    __typename?: 'BulkResult';
    succeeded: Array<string>;
  };
};

export type VouchersQueryVariables = Exact<{
  filter?: InputMaybe<VoucherFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VoucherSort>;
}>;

export type VouchersQuery = {
  __typename?: 'Query';
  vouchers: {
    __typename?: 'VoucherConnection';
    nodes: Array<{
      __typename?: 'Voucher';
      id: any;
      status: VoucherStatus;
      userEmail?: string | null;
      discountType: VoucherDiscountType;
      discountPercentage?: number | null;
      discountAmountCents?: any | null;
      productName?: string | null;
      label?: string | null;
      ruleName?: string | null;
      issuedAt: any;
      expiresAt?: any | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type VoucherRulesForIssueQueryVariables = Exact<{
  [key: string]: never;
}>;

export type VoucherRulesForIssueQuery = {
  __typename?: 'Query';
  voucherRules: Array<{ __typename?: 'VoucherRule'; id: any; name: string }>;
};

export type IssueVoucherMutationVariables = Exact<{
  input: IssueVoucherInput;
}>;

export type IssueVoucherMutation = {
  __typename?: 'Mutation';
  issueVoucher: { __typename?: 'Voucher'; id: any; status: VoucherStatus };
};

export type RevokeVoucherMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;

export type RevokeVoucherMutation = {
  __typename?: 'Mutation';
  revokeVoucher: { __typename?: 'Voucher'; id: any; status: VoucherStatus };
};

export type ExportVouchersCsvQueryVariables = Exact<{
  filter?: InputMaybe<VoucherFilter>;
}>;

export type ExportVouchersCsvQuery = {
  __typename?: 'Query';
  exportVouchersCsv: {
    __typename?: 'ExportJob';
    url: string;
    expiresAt: string;
  };
};

export type BlueprintQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type BlueprintQuery = {
  __typename?: 'Query';
  blueprint?: {
    __typename?: 'Blueprint';
    id: any;
    title: string;
    requireTicket: boolean;
    minimumAge?: number | null;
    doorsOpen: string;
    doorsClose: string;
    ticketText?: string | null;
    dresscode?: string | null;
    isActive: boolean;
    nightCount: number;
    events: Array<{
      __typename?: 'BlueprintEvent';
      id: any;
      title: string;
      startTime: string;
      endTime?: string | null;
      description?: string | null;
      posterUrl?: string | null;
      entrancePriceLabel?: string | null;
      offersTickets: boolean;
    }>;
    stages: Array<{
      __typename?: 'BlueprintStage';
      id: any;
      name: string;
      sort: number;
      ticketPrice: number;
      feePrice: number;
      maxAmount?: number | null;
      websiteSale: boolean;
      appSale: boolean;
      posSale: boolean;
      linkSale: boolean;
      door: boolean;
      memberSale: boolean;
      isActive: boolean;
      entryFrom?: string | null;
      entryUntil?: string | null;
      lateFee?: number | null;
    }>;
  } | null;
};

export type CreateBlueprintMutationVariables = Exact<{
  input: CreateBlueprintInput;
}>;

export type CreateBlueprintMutation = {
  __typename?: 'Mutation';
  createBlueprint: { __typename?: 'Blueprint'; id: any };
};

export type UpdateBlueprintMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateBlueprintInput;
}>;

export type UpdateBlueprintMutation = {
  __typename?: 'Mutation';
  updateBlueprint: { __typename?: 'Blueprint'; id: any; isActive: boolean };
};

export type CreateBlueprintStageMutationVariables = Exact<{
  blueprintId: Scalars['UUID']['input'];
  input: BlueprintStageInput;
}>;

export type CreateBlueprintStageMutation = {
  __typename?: 'Mutation';
  createBlueprintStage: { __typename?: 'BlueprintStage'; id: any };
};

export type UpdateBlueprintStageMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: BlueprintStageInput;
}>;

export type UpdateBlueprintStageMutation = {
  __typename?: 'Mutation';
  updateBlueprintStage: {
    __typename?: 'BlueprintStage';
    id: any;
    isActive: boolean;
  };
};

export type ReorderBlueprintStagesMutationVariables = Exact<{
  blueprintId: Scalars['UUID']['input'];
  orderedIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type ReorderBlueprintStagesMutation = {
  __typename?: 'Mutation';
  reorderBlueprintStages: Array<{
    __typename?: 'BlueprintStage';
    id: any;
    sort: number;
  }>;
};

export type CreateBlueprintEventMutationVariables = Exact<{
  blueprintId: Scalars['UUID']['input'];
  input: BlueprintEventInput;
}>;

export type CreateBlueprintEventMutation = {
  __typename?: 'Mutation';
  createBlueprintEvent: { __typename?: 'BlueprintEvent'; id: any };
};

export type UpdateBlueprintEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: BlueprintEventInput;
}>;

export type UpdateBlueprintEventMutation = {
  __typename?: 'Mutation';
  updateBlueprintEvent: { __typename?: 'BlueprintEvent'; id: any };
};

export type DeleteBlueprintEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type DeleteBlueprintEventMutation = {
  __typename?: 'Mutation';
  deleteBlueprintEvent: boolean;
};

export type BlueprintsQueryVariables = Exact<{
  filter?: InputMaybe<BlueprintFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BlueprintSort>;
}>;

export type BlueprintsQuery = {
  __typename?: 'Query';
  blueprints: {
    __typename?: 'BlueprintConnection';
    nodes: Array<{
      __typename?: 'Blueprint';
      id: any;
      title: string;
      requireTicket: boolean;
      minimumAge?: number | null;
      nightCount: number;
      doorsOpen: string;
      doorsClose: string;
      isActive: boolean;
      updatedAt: any;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type BlueprintsForCreateNightQueryVariables = Exact<{
  [key: string]: never;
}>;

export type BlueprintsForCreateNightQuery = {
  __typename?: 'Query';
  blueprints: {
    __typename?: 'BlueprintConnection';
    nodes: Array<{
      __typename?: 'Blueprint';
      id: any;
      title: string;
      requireTicket: boolean;
      doorsOpen: string;
      doorsClose: string;
    }>;
  };
};

export type CreateNightMutationVariables = Exact<{
  input: CreateNightInput;
}>;

export type CreateNightMutation = {
  __typename?: 'Mutation';
  createNight: { __typename?: 'Night'; id: any };
};

export type EntranceLogsQueryVariables = Exact<{
  filter?: InputMaybe<EntranceLogFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type EntranceLogsQuery = {
  __typename?: 'Query';
  entranceLogs: {
    __typename?: 'EntranceLogConnection';
    nodes: Array<{
      __typename?: 'EntranceLog';
      id: any;
      scannedAt: any;
      kind: EntranceKind;
      result: EntranceResult;
      guestName?: string | null;
      nightId?: any | null;
      nightTitle?: string | null;
      scannerName?: string | null;
      refuseReason?: RefuseReason | null;
      refuseNote?: string | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type NightsForEntranceFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type NightsForEntranceFilterQuery = {
  __typename?: 'Query';
  nights: {
    __typename?: 'NightConnection';
    nodes: Array<{
      __typename?: 'Night';
      id: any;
      title: string;
      startsAt: any;
    }>;
  };
};

export type NightsCalendarQueryVariables = Exact<{
  filter?: InputMaybe<NightFilter>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type NightsCalendarQuery = {
  __typename?: 'Query';
  nights: {
    __typename?: 'NightConnection';
    nodes: Array<{
      __typename?: 'Night';
      id: any;
      title: string;
      startsAt: any;
      published: boolean;
      requireTicket: boolean;
      ticketText?: string | null;
      dresscode?: string | null;
      isActive: boolean;
    }>;
    pageInfo: { __typename?: 'PageMeta'; totalRows: number };
  };
};

export type NightQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type NightQuery = {
  __typename?: 'Query';
  night?: {
    __typename?: 'Night';
    id: any;
    blueprintId?: any | null;
    startsAt: any;
    title: string;
    requireTicket: boolean;
    ticketText?: string | null;
    dresscode?: string | null;
    minimumAge?: number | null;
    doorsOpen: any;
    doorsClose: any;
    published: boolean;
    isActive: boolean;
    externalId?: string | null;
    goingCount: number;
    soldTickets: number;
    guestTickets: number;
    blueprint?: { __typename?: 'Blueprint'; id: any; title: string } | null;
    events: Array<{
      __typename?: 'NightEvent';
      id: any;
      title: string;
      startsAt: any;
      endsAt?: any | null;
      description?: string | null;
      posterUrl?: string | null;
      entrancePriceLabel?: string | null;
      offersTickets: boolean;
      featured: boolean;
    }>;
    stages: Array<{
      __typename?: 'NightStage';
      id: any;
      name: string;
      sort: number;
      ticketPrice: number;
      feePrice: number;
      maxAmount?: number | null;
      startsAt?: any | null;
      endsAt?: any | null;
      entryStartsAt?: any | null;
      entryEndsAt?: any | null;
      entryWindowLabel?: string | null;
      lateFee?: number | null;
      websiteSale: boolean;
      appSale: boolean;
      posSale: boolean;
      linkSale: boolean;
      linkUrl?: string | null;
      memberSale: boolean;
      door: boolean;
      guestList: boolean;
      memberMaxQuantity?: number | null;
      memberBuyerEmail?: string | null;
      soldCount: number;
      isSoldOut: boolean;
      isActive: boolean;
    }>;
  } | null;
};

export type UpdateNightMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateNightInput;
}>;

export type UpdateNightMutation = {
  __typename?: 'Mutation';
  updateNight: {
    __typename?: 'Night';
    id: any;
    doorsOpen: any;
    doorsClose: any;
    isActive: boolean;
  };
};

export type PublishNightMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type PublishNightMutation = {
  __typename?: 'Mutation';
  publishNight: { __typename?: 'Night'; id: any; published: boolean };
};

export type UnpublishNightMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type UnpublishNightMutation = {
  __typename?: 'Mutation';
  unpublishNight: { __typename?: 'Night'; id: any; published: boolean };
};

export type CreateNightEventMutationVariables = Exact<{
  nightId: Scalars['UUID']['input'];
  input: NightEventInput;
}>;

export type CreateNightEventMutation = {
  __typename?: 'Mutation';
  createNightEvent: { __typename?: 'NightEvent'; id: any };
};

export type UpdateNightEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: NightEventInput;
}>;

export type UpdateNightEventMutation = {
  __typename?: 'Mutation';
  updateNightEvent: { __typename?: 'NightEvent'; id: any };
};

export type DeleteNightEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type DeleteNightEventMutation = {
  __typename?: 'Mutation';
  deleteNightEvent: boolean;
};

export type CreateNightStageMutationVariables = Exact<{
  nightId: Scalars['UUID']['input'];
  input: NightStageInput;
}>;

export type CreateNightStageMutation = {
  __typename?: 'Mutation';
  createNightStage: { __typename?: 'NightStage'; id: any };
};

export type UpdateNightStageMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: NightStageInput;
}>;

export type UpdateNightStageMutation = {
  __typename?: 'Mutation';
  updateNightStage: { __typename?: 'NightStage'; id: any; isActive: boolean };
};

export type ReorderNightStagesMutationVariables = Exact<{
  nightId: Scalars['UUID']['input'];
  orderedIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type ReorderNightStagesMutation = {
  __typename?: 'Mutation';
  reorderNightStages: Array<{ __typename?: 'NightStage'; id: any }>;
};

export type CreateMemberSaleMutationVariables = Exact<{
  input: CreateMemberSaleInput;
}>;

export type CreateMemberSaleMutation = {
  __typename?: 'Mutation';
  createMemberSale: {
    __typename?: 'MemberSalePayload';
    url: string;
    buyerEmail: string;
    maxQuantity: number;
    invited: boolean;
    stage: { __typename?: 'NightStage'; id: any; name: string };
  };
};

export type GuestListEntriesQueryVariables = Exact<{
  nightId: Scalars['UUID']['input'];
}>;

export type GuestListEntriesQuery = {
  __typename?: 'Query';
  guestListEntries: Array<{
    __typename?: 'GuestListTicket';
    id: any;
    entryId: any;
    email: string;
    claimed: boolean;
    scanned: boolean;
  }>;
};

export type CreateGuestListEntryMutationVariables = Exact<{
  input: CreateGuestListEntryInput;
}>;

export type CreateGuestListEntryMutation = {
  __typename?: 'Mutation';
  createGuestListEntry: {
    __typename?: 'GuestListEntryPayload';
    id: any;
    email: string;
    quantity: number;
  };
};

export type ResendGuestListInviteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type ResendGuestListInviteMutation = {
  __typename?: 'Mutation';
  resendGuestListInvite: {
    __typename?: 'GuestListEntryPayload';
    id: any;
    email: string;
    quantity: number;
  };
};

export type NightTicketSummaryQueryVariables = Exact<{
  nightId: Scalars['UUID']['input'];
}>;

export type NightTicketSummaryQuery = {
  __typename?: 'Query';
  nightTicketSummary: {
    __typename?: 'NightTicketSummary';
    sold: number;
    guest: number;
    unclaimed: number;
    left?: number | null;
    revenueCents?: any | null;
    perChannel: {
      __typename?: 'NightTicketChannelCounts';
      website: number;
      app: number;
      link: number;
      member: number;
      pos: number;
      door: number;
    };
  };
};

export type NightCompareQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type NightCompareQuery = {
  __typename?: 'Query';
  night?: {
    __typename?: 'Night';
    id: any;
    compareNight?: { __typename?: 'Night'; id: any; title: string } | null;
  } | null;
};

export type SetNightCompareNightMutationVariables = Exact<{
  nightId: Scalars['UUID']['input'];
  compareNightId?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type SetNightCompareNightMutation = {
  __typename?: 'Mutation';
  setNightCompareNight: {
    __typename?: 'Night';
    id: any;
    compareNight?: { __typename?: 'Night'; id: any; title: string } | null;
  };
};

export type NightsGridQueryVariables = Exact<{
  filter?: InputMaybe<NightFilter>;
  sort?: InputMaybe<NightSort>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type NightsGridQuery = {
  __typename?: 'Query';
  nights: {
    __typename?: 'NightConnection';
    pageInfo: {
      __typename?: 'PageMeta';
      totalRows: number;
      totalPages: number;
      page: number;
      pageSize: number;
    };
    nodes: Array<{
      __typename?: 'Night';
      id: any;
      title: string;
      doorsOpen: any;
      doorsClose: any;
      isActive: boolean;
      published: boolean;
      soldTickets: number;
      guestTickets: number;
      ticketRevenueCents?: any | null;
    }>;
  };
};

export type CreatePosterUploadUrlMutationVariables = Exact<{
  contentType: Scalars['String']['input'];
}>;

export type CreatePosterUploadUrlMutation = {
  __typename?: 'Mutation';
  createPosterUploadUrl: {
    __typename?: 'PosterUpload';
    uploadUrl: string;
    posterPath: string;
    posterUrl: string;
  };
};

export type TicketsQueryVariables = Exact<{
  filter?: InputMaybe<TicketLookupFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TicketsQuery = {
  __typename?: 'Query';
  tickets: {
    __typename?: 'AdminTicketConnection';
    nodes: Array<{
      __typename?: 'AdminTicket';
      id: any;
      nightId: any;
      nightTitle: string;
      stageId: any;
      stageName: string;
      status: TicketStatus;
      kind: TicketKind;
      saleChannel: TicketSaleChannel;
      buyerEmail?: string | null;
      claimerEmail?: string | null;
      holderEmail: string;
      purchasedAt?: any | null;
      claimedAt?: any | null;
      orderId?: any | null;
      createdAt: any;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type AdminTicketQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type AdminTicketQuery = {
  __typename?: 'Query';
  adminTicket?: {
    __typename?: 'AdminTicket';
    id: any;
    nightId: any;
    nightTitle: string;
    stageId: any;
    stageName: string;
    status: TicketStatus;
    kind: TicketKind;
    saleChannel: TicketSaleChannel;
    buyerEmail?: string | null;
    claimerEmail?: string | null;
    holderEmail: string;
    purchasedAt?: any | null;
    claimedAt?: any | null;
    refundedAt?: any | null;
    releasedAt?: any | null;
    holdExpiresAt?: any | null;
    externalCode?: string | null;
    orderId?: any | null;
    createdAt: any;
    updatedAt: any;
    recognitionDate: string;
    ticketPrice: number;
    feePrice: number;
    userId?: any | null;
    claim?: {
      __typename?: 'TicketClaim';
      firstName: string;
      lastName: string;
      dateOfBirth: string;
      phone?: string | null;
      city?: string | null;
      country?: string | null;
      userId?: any | null;
      attested: boolean;
      claimedAt: any;
    } | null;
    payments: Array<{
      __typename?: 'AdminTicketPayment';
      id: any;
      status: string;
      paymentMethod: string;
      amount: number;
    }>;
    entranceLogs: Array<{
      __typename?: 'EntranceLog';
      id: any;
      scannedAt: any;
      kind: EntranceKind;
      result: EntranceResult;
      guestName?: string | null;
      scannerName?: string | null;
      refuseReason?: RefuseReason | null;
      refuseNote?: string | null;
      recognitionDate?: string | null;
    }>;
    blocks: Array<{
      __typename?: 'TicketBlock';
      id: any;
      reason: TicketBlockReason;
      note?: string | null;
      blockedAt: any;
      blockedByUserId?: any | null;
      unblockedAt?: any | null;
      unblockedByUserId?: any | null;
    }>;
    emailChanges: Array<{
      __typename?: 'TicketEmailChange';
      id: any;
      previousEmail?: string | null;
      newEmail: string;
      actorKind: TicketEmailChangeActor;
      actorUserId?: any | null;
      createdAt: any;
    }>;
  } | null;
};

export type ChangeCompanionEmailMutationVariables = Exact<{
  ticketId: Scalars['UUID']['input'];
  email: Scalars['String']['input'];
}>;

export type ChangeCompanionEmailMutation = {
  __typename?: 'Mutation';
  changeCompanionEmail: { __typename?: 'Ticket'; id: any };
};

export type CreateManageTicketsLinkMutationVariables = Exact<{
  ticketId: Scalars['UUID']['input'];
  who: ManageLinkFor;
}>;

export type CreateManageTicketsLinkMutation = {
  __typename?: 'Mutation';
  createManageTicketsLink: string;
};

export type ReleaseHeldTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type ReleaseHeldTicketMutation = {
  __typename?: 'Mutation';
  releaseHeldTicket: {
    __typename?: 'AdminTicket';
    id: any;
    status: TicketStatus;
    releasedAt?: any | null;
    holdExpiresAt?: any | null;
  };
};

export type BlockTicketMutationVariables = Exact<{
  input: BlockTicketInput;
}>;

export type BlockTicketMutation = {
  __typename?: 'Mutation';
  blockTicket: { __typename?: 'AdminTicket'; id: any; status: TicketStatus };
};

export type UnblockTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type UnblockTicketMutation = {
  __typename?: 'Mutation';
  unblockTicket: { __typename?: 'AdminTicket'; id: any; status: TicketStatus };
};

export type NightsForTicketsFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type NightsForTicketsFilterQuery = {
  __typename?: 'Query';
  nights: {
    __typename?: 'NightConnection';
    nodes: Array<{
      __typename?: 'Night';
      id: any;
      title: string;
      startsAt: any;
    }>;
  };
};

export type NightEntranceInsightsQueryVariables = Exact<{
  nightId: Scalars['UUID']['input'];
}>;

export type NightEntranceInsightsQuery = {
  __typename?: 'Query';
  nightEntranceInsights: {
    __typename?: 'EntranceInsights';
    nightId: any;
    nightTitle: string;
    rows: Array<{
      __typename?: 'EntranceInsightsRow';
      stageId?: any | null;
      label: string;
      sold: number;
      scanned: number;
      admitted: number;
      refused: number;
    }>;
    total: {
      __typename?: 'EntranceInsightsRow';
      stageId?: any | null;
      label: string;
      sold: number;
      scanned: number;
      admitted: number;
      refused: number;
    };
  };
};

export type StaffCompletenessQueryVariables = Exact<{ [key: string]: never }>;

export type StaffCompletenessQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    completeness: {
      __typename?: 'ProfileCompleteness';
      status: CompletenessStatus;
      missingFields: Array<{
        __typename?: 'MissingField';
        name: string;
        label: string;
        kind: FieldKind;
        required: boolean;
        options?: Array<string> | null;
      }>;
    };
  };
};

export type OnboardingCompletenessQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OnboardingCompletenessQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    completeness: {
      __typename?: 'ProfileCompleteness';
      status: CompletenessStatus;
      missingFields: Array<{
        __typename?: 'MissingField';
        name: string;
        label: string;
        kind: FieldKind;
        required: boolean;
        options?: Array<string> | null;
      }>;
    };
  };
};

export type OnboardingUpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;

export type OnboardingUpdateProfileMutation = {
  __typename?: 'Mutation';
  updateMyProfile: {
    __typename?: 'User';
    id: any;
    firstName: string;
    lastName?: string | null;
  };
};

export type OrderQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type OrderQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    id: any;
    status: OrderStatus;
    paymentStatus: string;
    paymentMethod?: string | null;
    createdAt: string;
    updatedAt: string;
    recognitionDate?: string | null;
    grandTotal: number;
    recognizedTotal: number;
    originalGrandTotal: number;
    amountDiscount: number;
    amountPaid: number;
    amountRefunded: number;
    amountCanceled: number;
    amountDue: number;
    allowedActions: Array<OrderAction>;
    discount?: { __typename?: 'Discount'; id: any; name: string } | null;
    appliedVoucher?: {
      __typename?: 'Voucher';
      id: any;
      label?: string | null;
      ruleName?: string | null;
    } | null;
    device?: { __typename?: 'Device'; id: any; name: string } | null;
    table?: { __typename?: 'Table'; id: any; name: string } | null;
    tab?: { __typename?: 'Tab'; id: any; name: string } | null;
    category?: { __typename?: 'Category'; id: any; name: string } | null;
    items: Array<{
      __typename?: 'OrderItem';
      id: any;
      productName: string;
      quantity: number;
      price: number;
      tax: number;
      lineTotal: number;
      amountDiscount: number;
    }>;
    payments: Array<{
      __typename?: 'Payment';
      id: any;
      status: string;
      paymentMethod: string;
      amount: number;
      amountTip: number;
      createdAt: string;
    }>;
    refunds: Array<{
      __typename?: 'Refund';
      id: any;
      status: string;
      paymentMethod: string;
      amount: number;
      createdAt: string;
    }>;
  } | null;
};

export type PerformOrderActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  action: OrderAction;
}>;

export type PerformOrderActionMutation = {
  __typename?: 'Mutation';
  performOrderAction: {
    __typename?: 'Order';
    id: any;
    status: OrderStatus;
    paymentStatus: string;
    allowedActions: Array<OrderAction>;
  };
};

export type OrdersQueryVariables = Exact<{
  filter?: InputMaybe<OrderFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OrderSort>;
}>;

export type OrdersQuery = {
  __typename?: 'Query';
  orders: {
    __typename?: 'OrderConnection';
    nodes: Array<{
      __typename?: 'Order';
      id: any;
      status: OrderStatus;
      paymentStatus: string;
      paymentMethod?: string | null;
      createdAt: string;
      updatedAt: string;
      grandTotal: number;
      amountPaid: number;
      amountDue: number;
      allowedActions: Array<OrderAction>;
      discount?: { __typename?: 'Discount'; id: any; name: string } | null;
      device?: { __typename?: 'Device'; id: any; name: string } | null;
      table?: { __typename?: 'Table'; id: any; name: string } | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type ExportOrdersCsvQueryVariables = Exact<{
  filter?: InputMaybe<OrderFilter>;
  sort?: InputMaybe<OrderSort>;
}>;

export type ExportOrdersCsvQuery = {
  __typename?: 'Query';
  exportOrdersCsv: { __typename?: 'ExportJob'; url: string; expiresAt: string };
};

export type BulkPerformOrderActionMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  action: OrderAction;
}>;

export type BulkPerformOrderActionMutation = {
  __typename?: 'Mutation';
  bulkPerformOrderAction: {
    __typename?: 'BulkResult';
    succeeded: Array<string>;
    failed: Array<{ __typename?: 'BulkFailure'; id: string; reason: string }>;
  };
};

export type DevicesForOrdersFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DevicesForOrdersFilterQuery = {
  __typename?: 'Query';
  devices: {
    __typename?: 'DeviceConnection';
    nodes: Array<{ __typename?: 'Device'; id: any; name: string }>;
  };
};

export type TablesForOrdersFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TablesForOrdersFilterQuery = {
  __typename?: 'Query';
  tables: Array<{ __typename?: 'Table'; id: any; name: string }>;
};

export type DiscountsForOrdersFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DiscountsForOrdersFilterQuery = {
  __typename?: 'Query';
  discounts: {
    __typename?: 'DiscountConnection';
    nodes: Array<{ __typename?: 'Discount'; id: any; name: string }>;
  };
};

export type ProductsForOrdersFilterQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
  includeInactive: Scalars['Boolean']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type ProductsForOrdersFilterQuery = {
  __typename?: 'Query';
  products: {
    __typename?: 'ProductConnection';
    nodes: Array<{ __typename?: 'Product'; id: any; name: string }>;
  };
};

export type PaymentsQueryVariables = Exact<{
  filter?: InputMaybe<PaymentFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PaymentSort>;
}>;

export type PaymentsQuery = {
  __typename?: 'Query';
  payments: {
    __typename?: 'PaymentConnection';
    nodes: Array<{
      __typename?: 'Payment';
      id: any;
      status: string;
      paymentMethod: string;
      amount: number;
      amountTip: number;
      createdAt: string;
      updatedAt: string;
      recognitionDate: string;
      message?: string | null;
      cardAlias?: string | null;
      order?: { __typename?: 'Order'; id: any } | null;
      tab?: { __typename?: 'Tab'; id: any; name: string } | null;
      terminal?: { __typename?: 'Terminal'; id: any; name: string } | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type ExportPaymentsCsvQueryVariables = Exact<{
  filter?: InputMaybe<PaymentFilter>;
  sort?: InputMaybe<PaymentSort>;
}>;

export type ExportPaymentsCsvQuery = {
  __typename?: 'Query';
  exportPaymentsCsv: {
    __typename?: 'ExportJob';
    url: string;
    expiresAt: string;
  };
};

export type TerminalsForPaymentsFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TerminalsForPaymentsFilterQuery = {
  __typename?: 'Query';
  terminals: {
    __typename?: 'TerminalConnection';
    nodes: Array<{ __typename?: 'Terminal'; id: any; name: string }>;
  };
};

export type ProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ProductQuery = {
  __typename?: 'Query';
  product?: {
    __typename?: 'Product';
    id: any;
    name: string;
    price: number;
    tax: number;
    isActive: boolean;
    allowTable: boolean;
    isBottomBar: boolean;
    cashTrade: boolean;
    consumptionName?: string | null;
    unitLabel?: string | null;
    unitAmount?: number | null;
  } | null;
};

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;

export type CreateProductMutation = {
  __typename?: 'Mutation';
  createProduct: { __typename?: 'Product'; id: any };
};

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateProductInput;
}>;

export type UpdateProductMutation = {
  __typename?: 'Mutation';
  updateProduct: {
    __typename?: 'Product';
    id: any;
    name: string;
    price: number;
    tax: number;
    isActive: boolean;
    consumptionName?: string | null;
    unitLabel?: string | null;
    unitAmount?: number | null;
  };
};

export type ProductsQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSort>;
}>;

export type ProductsQuery = {
  __typename?: 'Query';
  products: {
    __typename?: 'ProductConnection';
    nodes: Array<{
      __typename?: 'Product';
      id: any;
      name: string;
      price: number;
      tax: number;
      isActive: boolean;
      categories: Array<{ __typename?: 'Category'; id: any; name: string }>;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type CategoriesForProductFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CategoriesForProductFilterQuery = {
  __typename?: 'Query';
  categories: Array<{ __typename?: 'Category'; id: any; name: string }>;
};

export type SetProductsActiveMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
}>;

export type SetProductsActiveMutation = {
  __typename?: 'Mutation';
  setProductsActive: {
    __typename?: 'BulkResult';
    succeeded: Array<string>;
    failed: Array<{ __typename?: 'BulkFailure'; id: string; reason: string }>;
  };
};

export type ExportProductsCsvQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
  sort?: InputMaybe<ProductSort>;
}>;

export type ExportProductsCsvQuery = {
  __typename?: 'Query';
  exportProductsCsv: {
    __typename?: 'ExportJob';
    url: string;
    expiresAt: string;
  };
};

export type UpdateMyProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;

export type UpdateMyProfileMutation = {
  __typename?: 'Mutation';
  updateMyProfile: {
    __typename?: 'User';
    id: any;
    email: string;
    firstName: string;
    lastName?: string | null;
    themePreference: ThemePreference;
    defaultPage?: string | null;
    defaultScope?: { __typename?: 'Scope'; id: any; name: string } | null;
    personal: {
      __typename?: 'PersonalProfile';
      lastName?: string | null;
      dateOfBirth?: string | null;
      dateOfBirthUpdatedAt?: any | null;
      phone?: string | null;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      gender?: string | null;
      pronouns?: string | null;
    };
    business: {
      __typename?: 'BusinessProfile';
      iban?: string | null;
      chamberOfCommerce?: string | null;
      vatNumber?: string | null;
      invoiceEmail?: string | null;
    };
  };
};

export type MyVerticalProfileQueryVariables = Exact<{ [key: string]: never }>;

export type MyVerticalProfileQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    type?: UserType | null;
    personal: {
      __typename?: 'PersonalProfile';
      lastName?: string | null;
      dateOfBirth?: string | null;
      dateOfBirthUpdatedAt?: any | null;
      phone?: string | null;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      gender?: string | null;
      pronouns?: string | null;
    };
    business: {
      __typename?: 'BusinessProfile';
      iban?: string | null;
      chamberOfCommerce?: string | null;
      vatNumber?: string | null;
      invoiceEmail?: string | null;
    };
  };
};

export type RefundsQueryVariables = Exact<{
  filter?: InputMaybe<RefundFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RefundSort>;
}>;

export type RefundsQuery = {
  __typename?: 'Query';
  refunds: {
    __typename?: 'RefundConnection';
    nodes: Array<{
      __typename?: 'Refund';
      id: any;
      status: string;
      paymentMethod: string;
      amount: number;
      createdAt: string;
      updatedAt: string;
      recognitionDate: string;
      message?: string | null;
      order?: { __typename?: 'Order'; id: any } | null;
      tab?: { __typename?: 'Tab'; id: any; name: string } | null;
      payment?: { __typename?: 'Payment'; id: any } | null;
      terminal?: { __typename?: 'Terminal'; id: any; name: string } | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type ExportRefundsCsvQueryVariables = Exact<{
  filter?: InputMaybe<RefundFilter>;
  sort?: InputMaybe<RefundSort>;
}>;

export type ExportRefundsCsvQuery = {
  __typename?: 'Query';
  exportRefundsCsv: {
    __typename?: 'ExportJob';
    url: string;
    expiresAt: string;
  };
};

export type TerminalsForRefundsFilterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TerminalsForRefundsFilterQuery = {
  __typename?: 'Query';
  terminals: {
    __typename?: 'TerminalConnection';
    nodes: Array<{ __typename?: 'Terminal'; id: any; name: string }>;
  };
};

export type PermissionCatalogQueryVariables = Exact<{ [key: string]: never }>;

export type PermissionCatalogQuery = {
  __typename?: 'Query';
  permissions: Array<{
    __typename?: 'Permission';
    code: string;
    resource: string;
    action: string;
    description: string;
    category: string;
    requiresStrongAuth: boolean;
  }>;
};

export type RoleDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type RoleDetailQuery = {
  __typename?: 'Query';
  role?: {
    __typename?: 'Role';
    id: any;
    name: string;
    slug: string;
    description: string;
    actorKind: ActorKind;
    isSystem: boolean;
    permissions: Array<{ __typename?: 'Permission'; code: string }>;
  } | null;
};

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;

export type CreateRoleMutation = {
  __typename?: 'Mutation';
  createRole: { __typename?: 'Role'; id: any };
};

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateRoleInput;
}>;

export type UpdateRoleMutation = {
  __typename?: 'Mutation';
  updateRole: { __typename?: 'Role'; id: any };
};

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type DeleteRoleMutation = { __typename?: 'Mutation'; deleteRole: any };

export type RolesListQueryVariables = Exact<{ [key: string]: never }>;

export type RolesListQuery = {
  __typename?: 'Query';
  roles: Array<{
    __typename?: 'Role';
    id: any;
    name: string;
    slug: string;
    description: string;
    actorKind: ActorKind;
    isSystem: boolean;
    permissions: Array<{
      __typename?: 'Permission';
      code: string;
      requiresStrongAuth: boolean;
    }>;
  }>;
};

export type RecognitionDaySessionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RecognitionDaySessionsQuery = {
  __typename?: 'Query';
  recognitionDaySessions: {
    __typename?: 'RecognitionDaySessionConnection';
    nodes: Array<{
      __typename?: 'RecognitionDaySession';
      id: any;
      recognitionDate: string;
      isOpen: boolean;
      openedAt: any;
      closedAt?: any | null;
      closeReason?: string | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type EndRecognitionDayMutationVariables = Exact<{
  [key: string]: never;
}>;

export type EndRecognitionDayMutation = {
  __typename?: 'Mutation';
  endRecognitionDay: {
    __typename?: 'RecognitionDaySession';
    id: any;
    recognitionDate: string;
    isOpen: boolean;
    openedAt: any;
    closedAt?: any | null;
    closeReason?: string | null;
  };
};

export type SwitchScopeMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type SwitchScopeMutation = {
  __typename?: 'Mutation';
  switchScope: { __typename?: 'Scope'; id: any; name: string };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: any;
    email: string;
    firstName: string;
    lastName?: string | null;
    type?: UserType | null;
    status: UserStatus;
    permissions: Array<string>;
    themePreference: ThemePreference;
    defaultPage?: string | null;
    lastLoginAt?: string | null;
    passkeyCount: number;
    roleBindings: Array<{
      __typename?: 'ActorRoleBinding';
      role: { __typename?: 'Role'; id: any; name: string; slug: string };
      scope: { __typename?: 'Scope'; id: any; name: string };
    }>;
    currentScope?: {
      __typename?: 'Scope';
      id: any;
      name: string;
      beaconMajor?: number | null;
    } | null;
    defaultScope?: { __typename?: 'Scope'; id: any; name: string } | null;
    allowedScopes: Array<{ __typename?: 'Scope'; id: any; name: string }>;
  };
};

export type ActiveRecognitionDayQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ActiveRecognitionDayQuery = {
  __typename?: 'Query';
  activeRecognitionDay?: {
    __typename?: 'RecognitionDaySession';
    id: any;
    recognitionDate: string;
    isOpen: boolean;
    openedAt: any;
    closedAt?: any | null;
  } | null;
};

export type TablesQueryVariables = Exact<{ [key: string]: never }>;

export type TablesQuery = {
  __typename?: 'Query';
  tables: Array<{
    __typename?: 'Table';
    id: any;
    name: string;
    sort: number;
    isActive: boolean;
  }>;
};

export type CreateTableMutationVariables = Exact<{
  input: CreateTableInput;
}>;

export type CreateTableMutation = {
  __typename?: 'Mutation';
  createTable: {
    __typename?: 'Table';
    id: any;
    name: string;
    sort: number;
    isActive: boolean;
  };
};

export type UpdateTableMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTableInput;
}>;

export type UpdateTableMutation = {
  __typename?: 'Mutation';
  updateTable: {
    __typename?: 'Table';
    id: any;
    name: string;
    isActive: boolean;
  };
};

export type ReorderTablesMutationVariables = Exact<{
  entity: SortableEntity;
  orderedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ReorderTablesMutation = {
  __typename?: 'Mutation';
  reorder: boolean;
};

export type ExportTablesCsvQueryVariables = Exact<{ [key: string]: never }>;

export type ExportTablesCsvQuery = {
  __typename?: 'Query';
  exportTablesCsv: { __typename?: 'ExportJob'; url: string; expiresAt: string };
};

export type TabQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type TabQuery = {
  __typename?: 'Query';
  tab?: {
    __typename?: 'Tab';
    id: any;
    name: string;
    status: string;
    canEditLineItems: boolean;
    createdAt: string;
    updatedAt: string;
    recognitionDate?: string | null;
    grandTotal: number;
    recognizedTotal: number;
    amountDiscount: number;
    amountPaid: number;
    amountRefunded: number;
    amountCanceled: number;
    amountDue: number;
    maxAmount?: number | null;
    isInvoice: boolean;
    exactAccountId?: any | null;
    allowedActions: Array<TabAction>;
    discount?: { __typename?: 'Discount'; id: any; name: string } | null;
    table?: { __typename?: 'Table'; id: any; name: string } | null;
    orders: Array<{
      __typename?: 'Order';
      id: any;
      status: OrderStatus;
      grandTotal: number;
      amountDue: number;
      createdAt: string;
      items: Array<{
        __typename?: 'OrderItem';
        id: any;
        productName: string;
        quantity: number;
        price: number;
        lineTotal: number;
      }>;
    }>;
    payments: Array<{
      __typename?: 'Payment';
      id: any;
      status: string;
      paymentMethod: string;
      amount: number;
      amountTip: number;
      createdAt: string;
    }>;
    refunds: Array<{
      __typename?: 'Refund';
      id: any;
      status: string;
      paymentMethod: string;
      amount: number;
      createdAt: string;
    }>;
  } | null;
};

export type ExactSalesInvoiceForTabQueryVariables = Exact<{
  tabId: Scalars['UUID']['input'];
}>;

export type ExactSalesInvoiceForTabQuery = {
  __typename?: 'Query';
  exactSalesInvoiceForTab?: {
    __typename?: 'ExactSalesInvoice';
    id: any;
    status: string;
    salesJournalCode: string;
    description: string;
    exactInvoiceId?: any | null;
    invoiceNumber?: number | null;
    error?: string | null;
    recognitionDate: string;
    updatedAt: string;
  } | null;
};

export type ExportExactInvoiceTabMutationVariables = Exact<{
  tabId: Scalars['UUID']['input'];
}>;

export type ExportExactInvoiceTabMutation = {
  __typename?: 'Mutation';
  exportExactInvoiceTab?: {
    __typename?: 'ExactSalesInvoice';
    id: any;
    status: string;
    invoiceNumber?: number | null;
    error?: string | null;
  } | null;
};

export type PerformTabActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  action: TabAction;
}>;

export type PerformTabActionMutation = {
  __typename?: 'Mutation';
  performTabAction: {
    __typename?: 'Tab';
    id: any;
    status: string;
    allowedActions: Array<TabAction>;
  };
};

export type UpdateTabDiscountMutationVariables = Exact<{
  input: UpdateTabInput;
}>;

export type UpdateTabDiscountMutation = {
  __typename?: 'Mutation';
  updateTab: {
    __typename?: 'Tab';
    id: any;
    amountDiscount: number;
    grandTotal: number;
    amountDue: number;
    canEditLineItems: boolean;
    discount?: { __typename?: 'Discount'; id: any; name: string } | null;
    orders: Array<{
      __typename?: 'Order';
      id: any;
      status: OrderStatus;
      grandTotal: number;
      amountDue: number;
      createdAt: string;
      items: Array<{
        __typename?: 'OrderItem';
        id: any;
        productName: string;
        quantity: number;
        price: number;
        lineTotal: number;
      }>;
    }>;
  };
};

export type DiscountsForTabEditQueryVariables = Exact<{ [key: string]: never }>;

export type DiscountsForTabEditQuery = {
  __typename?: 'Query';
  discounts: {
    __typename?: 'DiscountConnection';
    nodes: Array<{
      __typename?: 'Discount';
      id: any;
      name: string;
      isActive: boolean;
    }>;
  };
};

export type UpdateTabOrderItemMutationVariables = Exact<{
  tabId: Scalars['ID']['input'];
  orderItemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
}>;

export type UpdateTabOrderItemMutation = {
  __typename?: 'Mutation';
  updateTabOrderItem: {
    __typename?: 'Tab';
    id: any;
    status: string;
    canEditLineItems: boolean;
    grandTotal: number;
    amountPaid: number;
    amountDue: number;
    amountDiscount: number;
    discount?: { __typename?: 'Discount'; id: any; name: string } | null;
    orders: Array<{
      __typename?: 'Order';
      id: any;
      status: OrderStatus;
      grandTotal: number;
      amountDue: number;
      createdAt: string;
      items: Array<{
        __typename?: 'OrderItem';
        id: any;
        productName: string;
        quantity: number;
        price: number;
        lineTotal: number;
      }>;
    }>;
  };
};

export type RemoveOrderFromTabMutationVariables = Exact<{
  tabId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
}>;

export type RemoveOrderFromTabMutation = {
  __typename?: 'Mutation';
  removeOrderFromTab: {
    __typename?: 'Tab';
    id: any;
    status: string;
    canEditLineItems: boolean;
    grandTotal: number;
    amountPaid: number;
    amountDue: number;
    amountDiscount: number;
    orders: Array<{
      __typename?: 'Order';
      id: any;
      status: OrderStatus;
      grandTotal: number;
      amountDue: number;
      createdAt: string;
      items: Array<{
        __typename?: 'OrderItem';
        id: any;
        productName: string;
        quantity: number;
        price: number;
        lineTotal: number;
      }>;
    }>;
  };
};

export type TabsQueryVariables = Exact<{
  filter?: InputMaybe<TabFilter>;
  status?: InputMaybe<TabStatusGroup>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TabSort>;
}>;

export type TabsQuery = {
  __typename?: 'Query';
  tabs: {
    __typename?: 'TabConnection';
    nodes: Array<{
      __typename?: 'Tab';
      id: any;
      name: string;
      status: string;
      createdAt: string;
      updatedAt: string;
      grandTotal: number;
      amountPaid: number;
      amountDue: number;
      allowedActions: Array<TabAction>;
      table?: { __typename?: 'Table'; id: any; name: string } | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type ExportTabsCsvQueryVariables = Exact<{
  filter?: InputMaybe<TabFilter>;
  status?: InputMaybe<TabStatusGroup>;
  sort?: InputMaybe<TabSort>;
}>;

export type ExportTabsCsvQuery = {
  __typename?: 'Query';
  exportTabsCsv: { __typename?: 'ExportJob'; url: string; expiresAt: string };
};

export type BulkPerformTabActionMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  action: TabAction;
}>;

export type BulkPerformTabActionMutation = {
  __typename?: 'Mutation';
  bulkPerformTabAction: {
    __typename?: 'BulkResult';
    succeeded: Array<string>;
    failed: Array<{ __typename?: 'BulkFailure'; id: string; reason: string }>;
  };
};

export type CreateTabMutationVariables = Exact<{
  input: CreateTabInput;
}>;

export type CreateTabMutation = {
  __typename?: 'Mutation';
  createTab: {
    __typename?: 'Tab';
    id: any;
    name: string;
    isInvoice: boolean;
    exactAccountId?: any | null;
  };
};

export type ExactAccountsForTabQueryVariables = Exact<{ [key: string]: never }>;

export type ExactAccountsForTabQuery = {
  __typename?: 'Query';
  exactAccounts: Array<{
    __typename?: 'ExactAccount';
    id: any;
    code: string;
    name: string;
  }>;
};

export type TaxReportDayQueryVariables = Exact<{
  recognitionDate: Scalars['String']['input'];
}>;

export type TaxReportDayQuery = {
  __typename?: 'Query';
  taxReport?: {
    __typename?: 'TaxReport';
    periodStart: string;
    periodEnd?: string | null;
    salesDays: number;
    salesIncludingTax: number;
    totalLoss: number;
    cashTrade: number;
    tips: number;
    taxBreakdown: Array<{
      __typename?: 'TaxReportTaxLine';
      taxPercentage: number;
      salesExcludingTax: number;
      taxAmount: number;
      salesIncludingTax: number;
    }>;
    paymentMethodBreakdown: Array<{
      __typename?: 'TaxReportPaymentLine';
      paymentMethod: string;
      total: number;
    }>;
  } | null;
};

export type TaxReportMonthQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
}>;

export type TaxReportMonthQuery = {
  __typename?: 'Query';
  taxReport?: {
    __typename?: 'TaxReport';
    periodStart: string;
    periodEnd?: string | null;
    salesDays: number;
    salesIncludingTax: number;
    totalLoss: number;
    cashTrade: number;
    tips: number;
    taxBreakdown: Array<{
      __typename?: 'TaxReportTaxLine';
      taxPercentage: number;
      salesExcludingTax: number;
      taxAmount: number;
      salesIncludingTax: number;
    }>;
    paymentMethodBreakdown: Array<{
      __typename?: 'TaxReportPaymentLine';
      paymentMethod: string;
      total: number;
    }>;
  } | null;
};

export type TaxReportPeriodsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type TaxReportPeriodsQuery = {
  __typename?: 'Query';
  taxReportPeriods: {
    __typename?: 'TaxReportPeriodConnection';
    nodes: Array<{
      __typename?: 'TaxReportPeriod';
      kind: TaxReportPeriodKind;
      recognitionDate?: string | null;
      year?: number | null;
      month?: number | null;
      label: string;
      salesIncludingTax: number;
      tips: number;
      generatedAt?: string | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type TerminalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type TerminalQuery = {
  __typename?: 'Query';
  terminal?: {
    __typename?: 'Terminal';
    id: any;
    name: string;
    poiid: string;
    isActive: boolean;
  } | null;
};

export type CreateTerminalMutationVariables = Exact<{
  input: CreateTerminalInput;
}>;

export type CreateTerminalMutation = {
  __typename?: 'Mutation';
  createTerminal: { __typename?: 'Terminal'; id: any };
};

export type UpdateTerminalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTerminalInput;
}>;

export type UpdateTerminalMutation = {
  __typename?: 'Mutation';
  updateTerminal: {
    __typename?: 'Terminal';
    id: any;
    name: string;
    isActive: boolean;
  };
};

export type TerminalsQueryVariables = Exact<{
  filter?: InputMaybe<TerminalFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
}>;

export type TerminalsQuery = {
  __typename?: 'Query';
  terminals: {
    __typename?: 'TerminalConnection';
    nodes: Array<{
      __typename?: 'Terminal';
      id: any;
      name: string;
      poiid: string;
      isActive: boolean;
      connected: boolean;
      batteryLevel?: number | null;
      createdAt: string;
      updatedAt: string;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type SetTerminalsActiveMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
}>;

export type SetTerminalsActiveMutation = {
  __typename?: 'Mutation';
  setTerminalsActive: {
    __typename?: 'BulkResult';
    succeeded: Array<string>;
    failed: Array<{ __typename?: 'BulkFailure'; id: string; reason: string }>;
  };
};

export type SyncTerminalsMutationVariables = Exact<{ [key: string]: never }>;

export type SyncTerminalsMutation = {
  __typename?: 'Mutation';
  syncTerminals: {
    __typename?: 'SyncTerminalsPayload';
    skippedPoiids: Array<string>;
    added: Array<{
      __typename?: 'TerminalSyncLine';
      name: string;
      poiid: string;
    }>;
    reactivated: Array<{
      __typename?: 'TerminalSyncLine';
      name: string;
      poiid: string;
    }>;
    deactivated: Array<{
      __typename?: 'TerminalSyncLine';
      name: string;
      poiid: string;
    }>;
  };
};

export type ExportTerminalsCsvQueryVariables = Exact<{
  filter?: InputMaybe<TerminalFilter>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExportTerminalsCsvQuery = {
  __typename?: 'Query';
  exportTerminalsCsv: {
    __typename?: 'ExportJob';
    url: string;
    expiresAt: string;
  };
};

export type TurnoverWeekQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  week: Scalars['Int']['input'];
  compare?: InputMaybe<TurnoverCompare>;
}>;

export type TurnoverWeekQuery = {
  __typename?: 'Query';
  turnoverWeek: {
    __typename?: 'TurnoverWeek';
    year: number;
    week: number;
    startDate: string;
    endDate: string;
    amount: number;
    count: number;
    averageValue: number;
    byDay: Array<{
      __typename?: 'TurnoverDay';
      date: string;
      amount: number;
      count: number;
    }>;
    byPaymentMethod: Array<{
      __typename?: 'TurnoverSlice';
      label: string;
      amount: number;
      count: number;
    }>;
    byCategory: Array<{
      __typename?: 'TurnoverSlice';
      label: string;
      amount: number;
      count: number;
    }>;
    today?: {
      __typename?: 'TurnoverToday';
      date: string;
      amount: number;
      count: number;
      amountSoFar: number;
      countSoFar: number;
      comparisonAmountAtSameTime: number;
      comparisonCountAtSameTime: number;
      pacePercent?: number | null;
      compareMode: TurnoverCompare;
      comparisonDay?: {
        __typename?: 'TurnoverDay';
        date: string;
        amount: number;
        count: number;
      } | null;
      tickets?: {
        __typename?: 'TurnoverTodayTickets';
        sold: number;
        scanned: number;
      } | null;
    } | null;
    comparison?: {
      __typename?: 'TurnoverComparison';
      year: number;
      week: number;
      startDate: string;
      endDate: string;
      amount: number;
      count: number;
      averageValue: number;
      byDay: Array<{
        __typename?: 'TurnoverDay';
        date: string;
        amount: number;
        count: number;
      }>;
    } | null;
  };
};

export type TurnoverAvailableWeeksQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;

export type TurnoverAvailableWeeksQuery = {
  __typename?: 'Query';
  turnoverAvailableWeeks: Array<number>;
};

export type TicketPresaleByDayQueryVariables = Exact<{ [key: string]: never }>;

export type TicketPresaleByDayQuery = {
  __typename?: 'Query';
  ticketPresaleByDay: {
    __typename?: 'TicketPresaleChart';
    categories: Array<string>;
    series: Array<{
      __typename?: 'TicketPresaleSeries';
      nightId: any;
      name: string;
      data: Array<number>;
    }>;
  };
};

export type UsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<UserFilter>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
}>;

export type UsersQuery = {
  __typename?: 'Query';
  users: {
    __typename?: 'UserConnection';
    nodes: Array<{
      __typename?: 'User';
      id: any;
      firstName: string;
      lastName?: string | null;
      email: string;
      type?: UserType | null;
      status: UserStatus;
      marketingOptIn: boolean;
      passkeyCount: number;
      lastLoginAt?: string | null;
      defaultScope?: { __typename?: 'Scope'; id: any; name: string } | null;
    }>;
    pageInfo: {
      __typename?: 'PageMeta';
      page: number;
      pageSize: number;
      totalRows: number;
      totalPages: number;
    };
  };
};

export type UserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: any;
    email: string;
    firstName: string;
    lastName?: string | null;
    type?: UserType | null;
    status: UserStatus;
    marketingOptIn: boolean;
    marketingOptInAt?: any | null;
    emailBouncedAt?: any | null;
    pointsBalance: number;
    visitCount: number;
    spendCents: any;
    tipCents: any;
    lastVisitAt?: any | null;
    defaultPage?: string | null;
    lastLoginAt?: string | null;
    roleBindings: Array<{
      __typename?: 'ActorRoleBinding';
      role: { __typename?: 'Role'; id: any; name: string; slug: string };
      scope: { __typename?: 'Scope'; id: any; name: string };
    }>;
    defaultScope?: { __typename?: 'Scope'; id: any; name: string } | null;
    allowedScopes: Array<{ __typename?: 'Scope'; id: any; name: string }>;
    passkeys: Array<{
      __typename?: 'Passkey';
      id: string;
      deviceType?: string | null;
      createdAt: string;
      lastUsedAt?: string | null;
    }>;
    goldenTicket?: {
      __typename?: 'GoldenTicket';
      id: any;
      userId: any;
      holderName: string;
      holderEmail?: string | null;
      status: GoldenTicketStatus;
      assignedAt: any;
      note?: string | null;
      profileComplete: boolean;
    } | null;
    personal: {
      __typename?: 'PersonalProfile';
      lastName?: string | null;
      dateOfBirth?: string | null;
      dateOfBirthUpdatedAt?: any | null;
      phone?: string | null;
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      gender?: string | null;
      pronouns?: string | null;
    };
    business: {
      __typename?: 'BusinessProfile';
      iban?: string | null;
      chamberOfCommerce?: string | null;
      vatNumber?: string | null;
      invoiceEmail?: string | null;
    };
  } | null;
};

export type UserLoyaltyQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;

export type UserLoyaltyQuery = {
  __typename?: 'Query';
  userLoyalty: {
    __typename?: 'UserLoyalty';
    userId: any;
    pointsBalance: number;
    visitCount: number;
    spendCents: any;
    tipCents: any;
    lastVisitAt?: any | null;
    recentLedger: Array<{
      __typename?: 'LoyaltyLedgerEntry';
      id: any;
      points: number;
      reason: LoyaltyLedgerReason;
      note?: string | null;
      createdAt: any;
      paymentId?: any | null;
      refundId?: any | null;
      orderId?: any | null;
      scope?: { __typename?: 'ScopeRef'; id: any; name: string } | null;
    }>;
    vouchers: Array<{
      __typename?: 'Voucher';
      id: any;
      status: VoucherStatus;
      discountType: VoucherDiscountType;
      discountPercentage?: number | null;
      discountAmountCents?: any | null;
      productName?: string | null;
      label?: string | null;
      ruleName?: string | null;
      issuedAt: any;
      expiresAt?: any | null;
      scope: { __typename?: 'ScopeRef'; id: any; name: string };
    }>;
  };
};

export type UserGoldenTicketsQueryVariables = Exact<{
  filter?: InputMaybe<GoldenTicketFilter>;
}>;

export type UserGoldenTicketsQuery = {
  __typename?: 'Query';
  goldenTickets: {
    __typename?: 'GoldenTicketConnection';
    nodes: Array<{
      __typename?: 'GoldenTicket';
      id: any;
      userId: any;
      holderName: string;
      holderEmail?: string | null;
      status: GoldenTicketStatus;
      assignedAt: any;
      note?: string | null;
      profileComplete: boolean;
    }>;
  };
};

export type UserRolesCatalogQueryVariables = Exact<{ [key: string]: never }>;

export type UserRolesCatalogQuery = {
  __typename?: 'Query';
  roles: Array<{ __typename?: 'Role'; id: any; name: string; slug: string }>;
};

export type UserRoleOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type UserRoleOptionsQuery = {
  __typename?: 'Query';
  userRoleOptions: Array<{
    __typename?: 'RoleOption';
    id: any;
    name: string;
    slug: string;
  }>;
};

export type SetUserRolesMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  bindings: Array<RoleBindingInput> | RoleBindingInput;
}>;

export type SetUserRolesMutation = {
  __typename?: 'Mutation';
  setUserRoles: {
    __typename?: 'User';
    id: any;
    roleBindings: Array<{
      __typename?: 'ActorRoleBinding';
      role: { __typename?: 'Role'; id: any; name: string };
      scope: { __typename?: 'Scope'; id: any; name: string };
    }>;
  };
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser: { __typename?: 'User'; id: any; email: string };
};

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: any;
    email: string;
    firstName: string;
    lastName?: string | null;
    type?: UserType | null;
    personal: {
      __typename?: 'PersonalProfile';
      dateOfBirth?: string | null;
      phone?: string | null;
    };
    business: { __typename?: 'BusinessProfile'; iban?: string | null };
  };
};

export type BlockUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type BlockUserMutation = {
  __typename?: 'Mutation';
  blockUser: { __typename?: 'User'; id: any; status: UserStatus };
};

export type UnblockUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type UnblockUserMutation = {
  __typename?: 'Mutation';
  unblockUser: { __typename?: 'User'; id: any; status: UserStatus };
};

export type IssueMagicLinkMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type IssueMagicLinkMutation = {
  __typename?: 'Mutation';
  issueMagicLink: {
    __typename?: 'IssuedMagicLink';
    url: string;
    qrSvg: string;
    expiresAt: string;
  };
};

export type AdjustUserPointsMutationVariables = Exact<{
  input: AdjustUserPointsInput;
}>;

export type AdjustUserPointsMutation = {
  __typename?: 'Mutation';
  adjustUserPoints: {
    __typename?: 'UserLoyalty';
    userId: any;
    pointsBalance: number;
    visitCount: number;
    spendCents: any;
    tipCents: any;
    lastVisitAt?: any | null;
  };
};

export type AssignGoldenTicketMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;

export type AssignGoldenTicketMutation = {
  __typename?: 'Mutation';
  assignGoldenTicket: {
    __typename?: 'GoldenTicket';
    id: any;
    status: GoldenTicketStatus;
    assignedAt: any;
  };
};

export type RevokeGoldenTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;

export type RevokeGoldenTicketMutation = {
  __typename?: 'Mutation';
  revokeGoldenTicket: {
    __typename?: 'GoldenTicket';
    id: any;
    status: GoldenTicketStatus;
    revokedAt?: any | null;
  };
};

export type CreatePasskeyRegistrationLinkMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type CreatePasskeyRegistrationLinkMutation = {
  __typename?: 'Mutation';
  createPasskeyRegistrationLink: {
    __typename?: 'PasskeyRegistration';
    url: string;
    qrSvg: string;
    expiresAt: string;
  };
};

export type RevokePasskeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RevokePasskeyMutation = {
  __typename?: 'Mutation';
  revokePasskey: {
    __typename?: 'Passkey';
    id: string;
    revokedAt?: string | null;
  };
};

export type LiveUpdatedSubscriptionVariables = Exact<{
  scopeId: Scalars['UUID']['input'];
}>;

export type LiveUpdatedSubscription = {
  __typename?: 'Subscription';
  liveUpdated: {
    __typename?: 'LiveUpdatePayload';
    payment?: {
      __typename?: 'PaymentUpdatePayload';
      intent: PaymentEventIntent;
      payment: {
        __typename?: 'Payment';
        id: any;
        status: string;
        paymentMethod: string;
        amount: number;
        amountTip: number;
        updatedAt: string;
        message?: string | null;
        cardAlias?: string | null;
      };
    } | null;
    refund?: {
      __typename?: 'RefundUpdatePayload';
      intent: RefundEventIntent;
      refund: {
        __typename?: 'Refund';
        id: any;
        status: string;
        paymentMethod: string;
        amount: number;
        message?: string | null;
        createdAt: string;
        updatedAt: string;
        recognitionDate: string;
        order?: { __typename?: 'Order'; id: any } | null;
        tab?: { __typename?: 'Tab'; id: any; name: string } | null;
        payment?: { __typename?: 'Payment'; id: any; status: string } | null;
        terminal?: { __typename?: 'Terminal'; id: any; name: string } | null;
      };
    } | null;
    order?: {
      __typename?: 'OrderEventPayload';
      intent: OrderEventIntent;
      timestamp: any;
      order: {
        __typename?: 'Order';
        id: any;
        status: OrderStatus;
        paymentStatus: string;
        paymentMethod?: string | null;
        updatedAt: string;
        grandTotal: number;
        amountPaid: number;
        amountDue: number;
        allowedActions: Array<OrderAction>;
      };
    } | null;
    orderCreated?: {
      __typename?: 'Order';
      id: any;
      status: OrderStatus;
      paymentStatus: string;
      paymentMethod?: string | null;
      createdAt: string;
      updatedAt: string;
      grandTotal: number;
      amountPaid: number;
      amountDue: number;
      allowedActions: Array<OrderAction>;
    } | null;
    tab?: {
      __typename?: 'TabEventPayload';
      intent: TabEventIntent;
      tab: {
        __typename?: 'Tab';
        id: any;
        name: string;
        status: string;
        updatedAt: string;
        grandTotal: number;
        amountPaid: number;
        amountDue: number;
        canEditLineItems: boolean;
        allowedActions: Array<TabAction>;
      };
    } | null;
    category?: {
      __typename?: 'Category';
      id: any;
      name: string;
      isActive: boolean;
      showInMenu: boolean;
      productCount: number;
    } | null;
    product?: {
      __typename?: 'Product';
      id: any;
      name: string;
      price: number;
      tax: number;
      isActive: boolean;
    } | null;
    discount?: {
      __typename?: 'Discount';
      id: any;
      name: string;
      type: string;
      isActive: boolean;
      totalDiscount30d: number;
      usageCount30d: number;
    } | null;
    table?: {
      __typename?: 'Table';
      id: any;
      name: string;
      isActive: boolean;
    } | null;
    device?: {
      __typename?: 'DeviceEventPayload';
      intent: DeviceEventIntent;
      device: {
        __typename?: 'Device';
        id: any;
        name: string;
        status: DeviceStatus;
        isActive: boolean;
        connectionStatus: string;
        allowedActions: Array<DeviceAction>;
        askLoyalty: boolean;
        gratuitySettings: {
          __typename?: 'DeviceGratuitySettings';
          enabled: boolean;
        };
        category?: { __typename?: 'Category'; id: any; name: string } | null;
        terminal?: { __typename?: 'Terminal'; id: any; name: string } | null;
      };
    } | null;
    terminal?: {
      __typename?: 'TerminalEventPayload';
      intent: TerminalEventIntent;
      terminal: {
        __typename?: 'Terminal';
        id: any;
        name: string;
        poiid: string;
        isActive: boolean;
        connected: boolean;
        batteryLevel?: number | null;
        updatedAt: string;
      };
    } | null;
    ledger?: {
      __typename?: 'LedgerEventPayload';
      intent: LedgerEventIntent;
      timestamp: any;
      transaction?: {
        __typename?: 'LedgerTransaction';
        id: any;
        transactionId: string;
        amountReceived: number;
        amountTip: number;
        amountCashTrade: number;
        amountRecognizedTotal: number;
        psp?: string | null;
        paymentMethod: string;
        recognitionDate: string;
        createdAt: string;
        categoryName?: string | null;
        deviceName?: string | null;
        categoryId?: any | null;
        deviceId?: any | null;
      } | null;
    } | null;
    recognitionDay?: {
      __typename?: 'RecognitionDayEventPayload';
      intent: RecognitionDayEventIntent;
      session: {
        __typename?: 'RecognitionDaySession';
        id: any;
        recognitionDate: string;
        isOpen: boolean;
        openedAt: any;
        closedAt?: any | null;
      };
    } | null;
    entranceInsights?: {
      __typename?: 'EntranceInsights';
      nightId: any;
      nightTitle: string;
      rows: Array<{
        __typename?: 'EntranceInsightsRow';
        stageId?: any | null;
        label: string;
        sold: number;
        scanned: number;
        admitted: number;
        refused: number;
      }>;
      total: {
        __typename?: 'EntranceInsightsRow';
        stageId?: any | null;
        label: string;
        sold: number;
        scanned: number;
        admitted: number;
        refused: number;
      };
    } | null;
  };
};

export type PrepareReceiptMutationVariables = Exact<{
  input: PrepareReceiptInput;
}>;

export type PrepareReceiptMutation = {
  __typename?: 'Mutation';
  prepareReceipt: {
    __typename?: 'ReceiptPayload';
    url: string;
    expiresAt: any;
  };
};

export type CheckEmailAddressQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type CheckEmailAddressQuery = {
  __typename?: 'Query';
  checkEmailAddress: {
    __typename?: 'EmailAddressCheck';
    deliverable: boolean;
    suggestion?: string | null;
  };
};

export const CategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Categories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showInMenu' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'productCount' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CategoriesQuery, CategoriesQueryVariables>;
export const CreateCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateCategoryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCategory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCategoryMutation,
  CreateCategoryMutationVariables
>;
export const ReorderCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReorderCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entity' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SortableEntity' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderedIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'entity' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderedIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderedIds' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReorderCategoriesMutation,
  ReorderCategoriesMutationVariables
>;
export const ExportCategoriesCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportCategoriesCsv' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportCategoriesCsv' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportCategoriesCsvQuery,
  ExportCategoriesCsvQueryVariables
>;
export const CategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Category' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showInMenu' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDoor' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '500' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CategoryQuery, CategoryQueryVariables>;
export const UpdateCategoryDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCategoryDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateCategoryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCategory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showInMenu' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDoor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCategoryDetailsMutation,
  UpdateCategoryDetailsMutationVariables
>;
export const SetCategoryProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCategoryProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'productIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCategoryProducts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'productIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetCategoryProductsMutation,
  SetCategoryProductsMutationVariables
>;
export const ReorderProductCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReorderProductCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entity' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SortableEntity' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderedIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'parentId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'entity' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderedIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderedIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'parentId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'parentId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReorderProductCategoryMutation,
  ReorderProductCategoryMutationVariables
>;
export const ChartSeriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChartSeries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preset' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChartPreset' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recognitionDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bucket' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChartBucket' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'windowStart' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'windowEnd' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chartSeries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preset' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preset' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recognitionDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bucket' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bucket' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'windowStart' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'windowStart' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'windowEnd' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'windowEnd' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preset' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableWindowStart' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableWindowEnd' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'series' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChartSeriesQuery, ChartSeriesQueryVariables>;
export const ChartAvailableDatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChartAvailableDates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preset' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChartPreset' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chartAvailableDates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preset' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preset' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChartAvailableDatesQuery,
  ChartAvailableDatesQueryVariables
>;
export const TicketSalesNightsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TicketSalesNights' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ticketSalesNights' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nightId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upcoming' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TicketSalesNightsQuery,
  TicketSalesNightsQueryVariables
>;
export const TicketSalesSeriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TicketSalesSeries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nightIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UUID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'interval' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TicketSalesInterval' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ticketSalesSeries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nightIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'nightIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interval' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'interval' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'series' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stageId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stageName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pending' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TicketSalesSeriesQuery,
  TicketSalesSeriesQueryVariables
>;
export const CustomerIoTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CustomerIoTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerIoTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionalMessageId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'templateName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'configured' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerIoTemplatesQuery,
  CustomerIoTemplatesQueryVariables
>;
export const CustomerIoTransactionalTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CustomerIoTransactionalTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerIoTransactionalTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendToUnsubscribed' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerIoTransactionalTemplatesQuery,
  CustomerIoTransactionalTemplatesQueryVariables
>;
export const SaveCustomerIoTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveCustomerIoTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CustomerIoTemplateInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveCustomerIoTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionalMessageId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'templateName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'configured' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveCustomerIoTemplatesMutation,
  SaveCustomerIoTemplatesMutationVariables
>;
export const ExactConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactConfiguration' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactConfiguration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credentialsConfigured' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'division' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scopeEnabled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastError' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mapping' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'journalCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entryDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revenueLowGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revenueLowGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'revenueLowGlDescription',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatCodeLow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatPercentageLow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revenueHighGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revenueHighGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'revenueHighGlDescription',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatCodeHigh' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatPercentageHigh' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adyenGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adyenGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adyenGlDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cashGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cashGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cashGlDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tipsGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tipsGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tipsGlDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tabsGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tabsGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tabsGlDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesJournalCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemLowId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemLowCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemLowDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemHighId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemHighCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemHighDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketGlDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketItemId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketItemCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketItemDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketVatCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketVatPercentage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookingFeeGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookingFeeGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'bookingFeeGlDescription',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paypalGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paypalGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paypalGlDescription' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExactConfigurationQuery,
  ExactConfigurationQueryVariables
>;
export const ExactDivisionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactDivisions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactDivisions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExactDivisionsQuery, ExactDivisionsQueryVariables>;
export const ExactGlAccountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactGLAccounts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactGLAccounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExactGlAccountsQuery,
  ExactGlAccountsQueryVariables
>;
export const ExactVatCodesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactVATCodes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactVATCodes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExactVatCodesQuery, ExactVatCodesQueryVariables>;
export const ExactJournalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactJournals' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactJournals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExactJournalsQuery, ExactJournalsQueryVariables>;
export const ExactItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactItems' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExactItemsQuery, ExactItemsQueryVariables>;
export const StartExactAuthorizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartExactAuthorization' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startExactAuthorization' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartExactAuthorizationMutation,
  StartExactAuthorizationMutationVariables
>;
export const DisconnectExactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DisconnectExact' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disconnectExact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'division' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scopeEnabled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastError' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DisconnectExactMutation,
  DisconnectExactMutationVariables
>;
export const SaveExactDivisionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveExactDivision' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'division' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveExactDivision' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'division' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'division' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'division' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scopeEnabled' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveExactDivisionMutation,
  SaveExactDivisionMutationVariables
>;
export const SaveExactTicketMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveExactTicketMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SaveExactTicketMappingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveExactTicketMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ticketGlId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ticketGlCode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ticketItemId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ticketItemCode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ticketVatCode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ticketVatPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookingFeeGlId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookingFeeGlCode' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'paypalGlId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paypalGlCode' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveExactTicketMappingMutation,
  SaveExactTicketMappingMutationVariables
>;
export const SaveExactMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveExactMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SaveExactMappingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveExactMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mapping' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'journalCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entryDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revenueLowGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revenueLowGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatCodeLow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatPercentageLow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revenueHighGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revenueHighGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatCodeHigh' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatPercentageHigh' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adyenGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adyenGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cashGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cashGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tipsGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tipsGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tabsGlId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tabsGlCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesJournalCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemLowId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemLowCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemHighId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemHighCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveExactMappingMutation,
  SaveExactMappingMutationVariables
>;
export const CompleteExactAuthorizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteExactAuthorization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeExactAuthorization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'code' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'state' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'state' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'division' } },
                { kind: 'Field', name: { kind: 'Name', value: 'connectedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastError' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteExactAuthorizationMutation,
  CompleteExactAuthorizationMutationVariables
>;
export const LoyaltySettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LoyaltySettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loyaltySettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'spendStepCents' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsPerStep' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LoyaltySettingsQuery,
  LoyaltySettingsQueryVariables
>;
export const SaveLoyaltySettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveLoyaltySettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'spendStepCents' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pointsPerStep' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveLoyaltySettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'spendStepCents' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'spendStepCents' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pointsPerStep' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pointsPerStep' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'spendStepCents' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsPerStep' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveLoyaltySettingsMutation,
  SaveLoyaltySettingsMutationVariables
>;
export const ScopeTicketSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScopeTicketSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scopeTicketSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scopeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feeTaxPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'effectiveFeeTaxPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ticketPointsPerEuro' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'configured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exactTicketMappingConfigured' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScopeTicketSettingsQuery,
  ScopeTicketSettingsQueryVariables
>;
export const SaveScopeTicketSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveScopeTicketSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taxPercentage' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'feeTaxPercentage' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ticketPointsPerEuro' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveScopeTicketSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taxPercentage' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'taxPercentage' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'feeTaxPercentage' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'feeTaxPercentage' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ticketPointsPerEuro' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ticketPointsPerEuro' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feeTaxPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'effectiveFeeTaxPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ticketPointsPerEuro' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'configured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exactTicketMappingConfigured' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveScopeTicketSettingsMutation,
  SaveScopeTicketSettingsMutationVariables
>;
export const UpdateScopeBeaconMajorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateScopeBeaconMajor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'beaconMajor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateScope' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'beaconMajor' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'beaconMajor' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beaconMajor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateScopeBeaconMajorMutation,
  UpdateScopeBeaconMajorMutationVariables
>;
export const ConsumptionReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConsumptionReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dateFrom' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dateTo' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumptionReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateFrom' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dateFrom' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateTo' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dateTo' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateFrom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dateTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consumptionName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unitLabel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalUnits' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unitAmount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'qtySold' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unitsContributed' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConsumptionReportQuery,
  ConsumptionReportQueryVariables
>;
export const DeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Device' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'device' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowCategorySwitch' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'askLoyalty' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roleBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gratuitySettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minimumAmountCents' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tipPercent1' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tipPercent2' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tipPercent3' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roundToHalf' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowCustomTip' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'terminal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terminals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '500' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceQuery, DeviceQueryVariables>;
export const DeviceRolesCatalogDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeviceRolesCatalog' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorKind' },
                value: { kind: 'EnumValue', value: 'DEVICE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeviceRolesCatalogQuery,
  DeviceRolesCatalogQueryVariables
>;
export const SetDeviceRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetDeviceRoles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'deviceId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'roleId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDeviceRoles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deviceId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'deviceId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'roleId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roleBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetDeviceRolesMutation,
  SetDeviceRolesMutationVariables
>;
export const UpdateDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateDeviceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowCategorySwitch' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'askLoyalty' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gratuitySettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabled' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDeviceMutation,
  UpdateDeviceMutationVariables
>;
export const PerformDeviceResetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PerformDeviceReset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'performDeviceAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action' },
                value: { kind: 'EnumValue', value: 'RESET_DEVICE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'askLoyalty' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gratuitySettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabled' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'terminal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PerformDeviceResetMutation,
  PerformDeviceResetMutationVariables
>;
export const RegenerateDevicePairingCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegenerateDevicePairingCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'deviceId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regenerateDevicePairingCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deviceId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'deviceId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pairingCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'device' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegenerateDevicePairingCodeMutation,
  RegenerateDevicePairingCodeMutationVariables
>;
export const DevicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Devices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DeviceFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeInactive' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortField' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortDir' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeInactive' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortField' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortField' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDir' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortDir' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'connectionStatus' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'askLoyalty' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gratuitySettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'enabled' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowedActions' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'terminal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DevicesQuery, DevicesQueryVariables>;
export const TerminalsForDeviceFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TerminalsForDeviceFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terminals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'ObjectValue', fields: [] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '500' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TerminalsForDeviceFilterQuery,
  TerminalsForDeviceFilterQueryVariables
>;
export const CategoriesForDeviceFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CategoriesForDeviceFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CategoriesForDeviceFilterQuery,
  CategoriesForDeviceFilterQueryVariables
>;
export const BulkPerformDeviceActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BulkPerformDeviceAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'action' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeviceAction' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkPerformDeviceAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'action' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'succeeded' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failed' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BulkPerformDeviceActionMutation,
  BulkPerformDeviceActionMutationVariables
>;
export const ExportDevicesCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportDevicesCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DeviceFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortField' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortDir' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportDevicesCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortField' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortField' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDir' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortDir' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportDevicesCsvQuery,
  ExportDevicesCsvQueryVariables
>;
export const CreateDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateDeviceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pairingCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'device' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateDeviceMutation,
  CreateDeviceMutationVariables
>;
export const DiscountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Discount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'configuration' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discountTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schema' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscountQuery, DiscountQueryVariables>;
export const DiscountTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DiscountTypes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discountTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schema' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscountTypesQuery, DiscountTypesQueryVariables>;
export const CreateDiscountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDiscount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateDiscountInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDiscount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateDiscountMutation,
  CreateDiscountMutationVariables
>;
export const UpdateDiscountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDiscount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateDiscountInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDiscount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'configuration' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDiscountMutation,
  UpdateDiscountMutationVariables
>;
export const DiscountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Discounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DiscountFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeInactive' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeInactive' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalDiscount30d' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'usageCount30d' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscountsQuery, DiscountsQueryVariables>;
export const DiscountTypesForFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DiscountTypesForFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discountTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiscountTypesForFilterQuery,
  DiscountTypesForFilterQueryVariables
>;
export const SetDiscountsActiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetDiscountsActive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isActive' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDiscountsActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isActive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isActive' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'succeeded' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failed' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetDiscountsActiveMutation,
  SetDiscountsActiveMutationVariables
>;
export const ExportDiscountsCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportDiscountsCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DiscountFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportDiscountsCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportDiscountsCsvQuery,
  ExportDiscountsCsvQueryVariables
>;
export const ExactJournalEntriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactJournalEntries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ExactJournalEntryFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ExactJournalEntrySort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactJournalEntries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recognitionDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'journalCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financialYear' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financialPeriod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exactEntryId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entryNumber' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExactJournalEntriesQuery,
  ExactJournalEntriesQueryVariables
>;
export const ExportExactDayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportExactDay' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recognitionDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportExactDay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recognitionDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportExactDayMutation,
  ExportExactDayMutationVariables
>;
export const ExactJournalEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactJournalEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactJournalEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'journalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'financialYear' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'financialPeriod' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exactEntryId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'entryNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lineNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'glAccountCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'glAccountDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatPercentage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatAmount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExactJournalEntryQuery,
  ExactJournalEntryQueryVariables
>;
export const ExportExactDayRetryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportExactDayRetry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recognitionDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportExactDay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recognitionDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportExactDayRetryMutation,
  ExportExactDayRetryMutationVariables
>;
export const LedgerTransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LedgerTransaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerTransaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountReceived' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'amountTip' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountCashTrade' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountRecognizedTotal' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'psp' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentMethod' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionMinute' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categoryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tab' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refund' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxLines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxPercentage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesExcl' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tax' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesIncl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LedgerTransactionQuery,
  LedgerTransactionQueryVariables
>;
export const LedgerTransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LedgerTransactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'LedgerTransactionFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'LedgerTransactionSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerTransactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountReceived' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountTip' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountCashTrade' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountRecognizedTotal' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'psp' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recognitionDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deviceName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deviceId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tab' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refund' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LedgerTransactionsQuery,
  LedgerTransactionsQueryVariables
>;
export const ExportLedgerTransactionsCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportLedgerTransactionsCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'LedgerTransactionFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'LedgerTransactionSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportLedgerTransactionsCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportLedgerTransactionsCsvQuery,
  ExportLedgerTransactionsCsvQueryVariables
>;
export const LinksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Links' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinksQuery, LinksQueryVariables>;
export const CreateLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateLinkInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLinkMutation, CreateLinkMutationVariables>;
export const UpdateLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateLinkInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLinkMutation, UpdateLinkMutationVariables>;
export const DeleteLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteLinkMutation, DeleteLinkMutationVariables>;
export const ReorderLinksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReorderLinks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entity' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SortableEntity' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderedIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'entity' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderedIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderedIds' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReorderLinksMutation,
  ReorderLinksMutationVariables
>;
export const VoucherRuleNightsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VoucherRuleNights' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'limit' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voucherRuleNights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'limit' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scope' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VoucherRuleNightsQuery,
  VoucherRuleNightsQueryVariables
>;
export const VoucherRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VoucherRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voucherRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thresholdPoints' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validityDays' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountAmount' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'promotionLabel' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nightId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'night' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startsAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scope' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stages' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isActive' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stageIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validityMode' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'validUntil' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VoucherRuleQuery, VoucherRuleQueryVariables>;
export const ProductsForVoucherRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductsForVoucherRule' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '200' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProductsForVoucherRuleQuery,
  ProductsForVoucherRuleQueryVariables
>;
export const CreateVoucherRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateVoucherRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateVoucherRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createVoucherRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateVoucherRuleMutation,
  CreateVoucherRuleMutationVariables
>;
export const UpdateVoucherRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateVoucherRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateVoucherRuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVoucherRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateVoucherRuleMutation,
  UpdateVoucherRuleMutationVariables
>;
export const VoucherRulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VoucherRules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeInactive' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voucherRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeInactive' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thresholdPoints' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validityDays' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountPercentage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountAmount' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'productName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuedCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scope' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nightId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'night' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scope' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validityMode' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'validUntil' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VoucherRulesQuery, VoucherRulesQueryVariables>;
export const SetVoucherRulesActiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetVoucherRulesActive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UUID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'active' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setVoucherRulesActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'active' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'active' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'succeeded' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetVoucherRulesActiveMutation,
  SetVoucherRulesActiveMutationVariables
>;
export const VouchersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Vouchers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'VoucherFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'VoucherSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vouchers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountPercentage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountAmountCents' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'productName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ruleName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VouchersQuery, VouchersQueryVariables>;
export const VoucherRulesForIssueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VoucherRulesForIssue' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voucherRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VoucherRulesForIssueQuery,
  VoucherRulesForIssueQueryVariables
>;
export const IssueVoucherDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IssueVoucher' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IssueVoucherInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issueVoucher' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IssueVoucherMutation,
  IssueVoucherMutationVariables
>;
export const RevokeVoucherDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevokeVoucher' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokeVoucher' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'note' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'note' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RevokeVoucherMutation,
  RevokeVoucherMutationVariables
>;
export const ExportVouchersCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportVouchersCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'VoucherFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportVouchersCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportVouchersCsvQuery,
  ExportVouchersCsvQueryVariables
>;
export const BlueprintDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Blueprint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blueprint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requireTicket' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minimumAge' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doorsOpen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doorsClose' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ticketText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dresscode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nightCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'posterUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entrancePriceLabel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'offersTickets' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feePrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'websiteSale' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appSale' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'posSale' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkSale' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'door' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'memberSale' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entryFrom' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entryUntil' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lateFee' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlueprintQuery, BlueprintQueryVariables>;
export const CreateBlueprintDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBlueprint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateBlueprintInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBlueprint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBlueprintMutation,
  CreateBlueprintMutationVariables
>;
export const UpdateBlueprintDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBlueprint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBlueprintInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBlueprint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBlueprintMutation,
  UpdateBlueprintMutationVariables
>;
export const CreateBlueprintStageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBlueprintStage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'blueprintId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BlueprintStageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBlueprintStage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'blueprintId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'blueprintId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBlueprintStageMutation,
  CreateBlueprintStageMutationVariables
>;
export const UpdateBlueprintStageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBlueprintStage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BlueprintStageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBlueprintStage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBlueprintStageMutation,
  UpdateBlueprintStageMutationVariables
>;
export const ReorderBlueprintStagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReorderBlueprintStages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'blueprintId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderedIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UUID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorderBlueprintStages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'blueprintId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'blueprintId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderedIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderedIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReorderBlueprintStagesMutation,
  ReorderBlueprintStagesMutationVariables
>;
export const CreateBlueprintEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBlueprintEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'blueprintId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BlueprintEventInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBlueprintEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'blueprintId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'blueprintId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBlueprintEventMutation,
  CreateBlueprintEventMutationVariables
>;
export const UpdateBlueprintEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBlueprintEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BlueprintEventInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBlueprintEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBlueprintEventMutation,
  UpdateBlueprintEventMutationVariables
>;
export const DeleteBlueprintEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBlueprintEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBlueprintEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteBlueprintEventMutation,
  DeleteBlueprintEventMutationVariables
>;
export const BlueprintsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Blueprints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BlueprintFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BlueprintSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blueprints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requireTicket' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minimumAge' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doorsOpen' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doorsClose' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlueprintsQuery, BlueprintsQueryVariables>;
export const BlueprintsForCreateNightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BlueprintsForCreateNight' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blueprints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isActive' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '100' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'TITLE' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'ASC' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requireTicket' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doorsOpen' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doorsClose' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BlueprintsForCreateNightQuery,
  BlueprintsForCreateNightQueryVariables
>;
export const CreateNightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateNightInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNightMutation, CreateNightMutationVariables>;
export const EntranceLogsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntranceLogs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'EntranceLogFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entranceLogs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'SCANNED_AT' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'DESC' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scannedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightTitle' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scannerName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refuseReason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refuseNote' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EntranceLogsQuery, EntranceLogsQueryVariables>;
export const NightsForEntranceFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NightsForEntranceFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '100' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'STARTS_AT' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'DESC' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startsAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NightsForEntranceFilterQuery,
  NightsForEntranceFilterQueryVariables
>;
export const NightsCalendarDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NightsCalendar' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'NightFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'STARTS_AT' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'ASC' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startsAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'published' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requireTicket' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dresscode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NightsCalendarQuery, NightsCalendarQueryVariables>;
export const NightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Night' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'night' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blueprintId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'blueprint' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requireTicket' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ticketText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dresscode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minimumAge' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doorsOpen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doorsClose' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goingCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'soldTickets' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'guestTickets' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startsAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endsAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'posterUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entrancePriceLabel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'offersTickets' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featured' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feePrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startsAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endsAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entryStartsAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entryEndsAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entryWindowLabel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lateFee' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'websiteSale' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appSale' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'posSale' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkSale' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'memberSale' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'door' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestList' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'memberMaxQuantity' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'memberBuyerEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'soldCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isSoldOut' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NightQuery, NightQueryVariables>;
export const UpdateNightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateNightInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doorsOpen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doorsClose' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNightMutation, UpdateNightMutationVariables>;
export const PublishNightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PublishNight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishNight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishNightMutation,
  PublishNightMutationVariables
>;
export const UnpublishNightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnpublishNight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unpublishNight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnpublishNightMutation,
  UnpublishNightMutationVariables
>;
export const CreateNightEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNightEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nightId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NightEventInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNightEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nightId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'nightId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNightEventMutation,
  CreateNightEventMutationVariables
>;
export const UpdateNightEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNightEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NightEventInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNightEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateNightEventMutation,
  UpdateNightEventMutationVariables
>;
export const DeleteNightEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteNightEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteNightEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteNightEventMutation,
  DeleteNightEventMutationVariables
>;
export const CreateNightStageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNightStage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nightId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NightStageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNightStage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nightId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'nightId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNightStageMutation,
  CreateNightStageMutationVariables
>;
export const UpdateNightStageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNightStage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NightStageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNightStage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateNightStageMutation,
  UpdateNightStageMutationVariables
>;
export const ReorderNightStagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReorderNightStages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nightId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderedIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UUID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorderNightStages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nightId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'nightId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderedIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderedIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReorderNightStagesMutation,
  ReorderNightStagesMutationVariables
>;
export const CreateMemberSaleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateMemberSale' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateMemberSaleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMemberSale' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buyerEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxQuantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invited' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateMemberSaleMutation,
  CreateMemberSaleMutationVariables
>;
export const GuestListEntriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GuestListEntries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nightId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestListEntries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nightId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'nightId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'claimed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanned' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GuestListEntriesQuery,
  GuestListEntriesQueryVariables
>;
export const CreateGuestListEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateGuestListEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateGuestListEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createGuestListEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateGuestListEntryMutation,
  CreateGuestListEntryMutationVariables
>;
export const ResendGuestListInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResendGuestListInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resendGuestListInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResendGuestListInviteMutation,
  ResendGuestListInviteMutationVariables
>;
export const NightTicketSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NightTicketSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nightId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightTicketSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nightId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'nightId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sold' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unclaimed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'left' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'revenueCents' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perChannel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'website' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'member' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pos' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'door' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NightTicketSummaryQuery,
  NightTicketSummaryQueryVariables
>;
export const NightCompareDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NightCompare' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'night' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'compareNight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NightCompareQuery, NightCompareQueryVariables>;
export const SetNightCompareNightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetNightCompareNight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nightId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'compareNightId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setNightCompareNight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nightId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'nightId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'compareNightId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'compareNightId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'compareNight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetNightCompareNightMutation,
  SetNightCompareNightMutationVariables
>;
export const NightsGridDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NightsGrid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'NightFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'NightSort' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doorsOpen' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doorsClose' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'published' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'soldTickets' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestTickets' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketRevenueCents' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NightsGridQuery, NightsGridQueryVariables>;
export const CreatePosterUploadUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePosterUploadUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contentType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPosterUploadUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contentType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'posterPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'posterUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePosterUploadUrlMutation,
  CreatePosterUploadUrlMutationVariables
>;
export const TicketsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Tickets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TicketLookupFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tickets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightTitle' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stageId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stageName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'saleChannel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buyerEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'claimerEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holderEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'purchasedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'claimedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TicketsQuery, TicketsQueryVariables>;
export const AdminTicketDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminTicket' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminTicket' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nightId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nightTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stageName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'saleChannel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buyerEmail' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'claimerEmail' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'holderEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchasedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'claimedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'refundedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'releasedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holdExpiresAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalCode' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ticketPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feePrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'claim' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateOfBirth' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attested' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'claimedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entranceLogs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scannedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scannerName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refuseReason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refuseNote' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recognitionDate' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'blocks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blockedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blockedByUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unblockedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unblockedByUserId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailChanges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previousEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actorKind' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actorUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminTicketQuery, AdminTicketQueryVariables>;
export const ChangeCompanionEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeCompanionEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ticketId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeCompanionEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ticketId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ticketId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeCompanionEmailMutation,
  ChangeCompanionEmailMutationVariables
>;
export const CreateManageTicketsLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateManageTicketsLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ticketId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'who' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManageLinkFor' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createManageTicketsLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ticketId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ticketId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'who' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'who' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateManageTicketsLinkMutation,
  CreateManageTicketsLinkMutationVariables
>;
export const ReleaseHeldTicketDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseHeldTicket' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'releaseHeldTicket' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'releasedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holdExpiresAt' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseHeldTicketMutation,
  ReleaseHeldTicketMutationVariables
>;
export const BlockTicketDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BlockTicket' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BlockTicketInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blockTicket' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlockTicketMutation, BlockTicketMutationVariables>;
export const UnblockTicketDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnblockTicket' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unblockTicket' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnblockTicketMutation,
  UnblockTicketMutationVariables
>;
export const NightsForTicketsFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NightsForTicketsFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '200' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'STARTS_AT' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'DESC' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startsAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NightsForTicketsFilterQuery,
  NightsForTicketsFilterQueryVariables
>;
export const NightEntranceInsightsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NightEntranceInsights' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nightId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightEntranceInsights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nightId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'nightId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nightId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nightTitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stageId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scanned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'admitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refused' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stageId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scanned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'admitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refused' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NightEntranceInsightsQuery,
  NightEntranceInsightsQueryVariables
>;
export const StaffCompletenessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCompleteness' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completeness' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'missingFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kind' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'required' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaffCompletenessQuery,
  StaffCompletenessQueryVariables
>;
export const OnboardingCompletenessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OnboardingCompleteness' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completeness' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'missingFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kind' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'required' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnboardingCompletenessQuery,
  OnboardingCompletenessQueryVariables
>;
export const OnboardingUpdateProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OnboardingUpdateProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateProfileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMyProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnboardingUpdateProfileMutation,
  OnboardingUpdateProfileMutationVariables
>;
export const OrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Order' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'order' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentStatus' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentMethod' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'grandTotal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognizedTotal' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalGrandTotal' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountDiscount' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'amountPaid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountRefunded' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountCanceled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'amountDue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appliedVoucher' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ruleName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'device' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'table' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tab' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'productName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quantity' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tax' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lineTotal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountDiscount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountTip' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refunds' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedActions' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderQuery, OrderQueryVariables>;
export const PerformOrderActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PerformOrderAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'action' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OrderAction' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'performOrderAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'action' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentStatus' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedActions' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PerformOrderActionMutation,
  PerformOrderActionMutationVariables
>;
export const OrdersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Orders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'OrderFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'OrderSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentStatus' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grandTotal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountPaid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountDue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowedActions' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'device' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'table' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrdersQuery, OrdersQueryVariables>;
export const ExportOrdersCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportOrdersCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'OrderFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'OrderSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportOrdersCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportOrdersCsvQuery,
  ExportOrdersCsvQueryVariables
>;
export const BulkPerformOrderActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BulkPerformOrderAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'action' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OrderAction' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkPerformOrderAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'action' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'succeeded' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failed' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BulkPerformOrderActionMutation,
  BulkPerformOrderActionMutationVariables
>;
export const DevicesForOrdersFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DevicesForOrdersFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'ObjectValue', fields: [] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '500' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DevicesForOrdersFilterQuery,
  DevicesForOrdersFilterQueryVariables
>;
export const TablesForOrdersFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TablesForOrdersFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tables' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TablesForOrdersFilterQuery,
  TablesForOrdersFilterQueryVariables
>;
export const DiscountsForOrdersFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DiscountsForOrdersFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'ObjectValue', fields: [] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '500' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiscountsForOrdersFilterQuery,
  DiscountsForOrdersFilterQueryVariables
>;
export const ProductsForOrdersFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductsForOrdersFilter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ProductFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeInactive' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeInactive' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProductsForOrdersFilterQuery,
  ProductsForOrdersFilterQueryVariables
>;
export const PaymentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Payments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PaymentFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PaymentSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountTip' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recognitionDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cardAlias' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tab' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'terminal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentsQuery, PaymentsQueryVariables>;
export const ExportPaymentsCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportPaymentsCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PaymentFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PaymentSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportPaymentsCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportPaymentsCsvQuery,
  ExportPaymentsCsvQueryVariables
>;
export const TerminalsForPaymentsFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TerminalsForPaymentsFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terminals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'ObjectValue', fields: [] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '500' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TerminalsForPaymentsFilterQuery,
  TerminalsForPaymentsFilterQueryVariables
>;
export const ProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Product' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'product' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tax' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowTable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isBottomBar' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cashTrade' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumptionName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'unitLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unitAmount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductQuery, ProductQueryVariables>;
export const CreateProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateProductInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createProduct' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateProductMutation,
  CreateProductMutationVariables
>;
export const UpdateProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateProductInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProduct' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tax' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumptionName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'unitLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unitAmount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateProductMutation,
  UpdateProductMutationVariables
>;
export const ProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Products' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ProductFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeInactive' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ProductSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeInactive' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tax' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const CategoriesForProductFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CategoriesForProductFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CategoriesForProductFilterQuery,
  CategoriesForProductFilterQueryVariables
>;
export const SetProductsActiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetProductsActive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isActive' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setProductsActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isActive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isActive' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'succeeded' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failed' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetProductsActiveMutation,
  SetProductsActiveMutationVariables
>;
export const ExportProductsCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportProductsCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ProductFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ProductSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportProductsCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportProductsCsvQuery,
  ExportProductsCsvQueryVariables
>;
export const UpdateMyProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMyProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateProfileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMyProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'themePreference' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultScope' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateOfBirth' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateOfBirthUpdatedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postalCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pronouns' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'chamberOfCommerce' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'invoiceEmail' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMyProfileMutation,
  UpdateMyProfileMutationVariables
>;
export const MyVerticalProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyVerticalProfile' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateOfBirth' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateOfBirthUpdatedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postalCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pronouns' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'chamberOfCommerce' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'invoiceEmail' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MyVerticalProfileQuery,
  MyVerticalProfileQueryVariables
>;
export const RefundsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Refunds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RefundFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RefundSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recognitionDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tab' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'terminal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefundsQuery, RefundsQueryVariables>;
export const ExportRefundsCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportRefundsCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RefundFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RefundSort' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportRefundsCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportRefundsCsvQuery,
  ExportRefundsCsvQueryVariables
>;
export const TerminalsForRefundsFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TerminalsForRefundsFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terminals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'ObjectValue', fields: [] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '500' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TerminalsForRefundsFilterQuery,
  TerminalsForRefundsFilterQueryVariables
>;
export const PermissionCatalogDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PermissionCatalog' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requiresStrongAuth' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PermissionCatalogQuery,
  PermissionCatalogQueryVariables
>;
export const RoleDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorKind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoleDetailQuery, RoleDetailQueryVariables>;
export const CreateRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateRoleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateRoleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const RolesListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RolesList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorKind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requiresStrongAuth' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RolesListQuery, RolesListQueryVariables>;
export const RecognitionDaySessionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RecognitionDaySessions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recognitionDaySessions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recognitionDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isOpen' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'openedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'closedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'closeReason' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RecognitionDaySessionsQuery,
  RecognitionDaySessionsQueryVariables
>;
export const EndRecognitionDayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EndRecognitionDay' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'endRecognitionDay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isOpen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closeReason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EndRecognitionDayMutation,
  EndRecognitionDayMutationVariables
>;
export const SwitchScopeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SwitchScope' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchScope' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchScopeMutation, SwitchScopeMutationVariables>;
export const MeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Me' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roleBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scope' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'themePreference' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentScope' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beaconMajor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultScope' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedScopes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'passkeyCount' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const ActiveRecognitionDayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActiveRecognitionDay' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeRecognitionDay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isOpen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActiveRecognitionDayQuery,
  ActiveRecognitionDayQueryVariables
>;
export const TablesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Tables' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tables' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TablesQuery, TablesQueryVariables>;
export const CreateTableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTableInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTableMutation, CreateTableMutationVariables>;
export const UpdateTableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTableInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTableMutation, UpdateTableMutationVariables>;
export const ReorderTablesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReorderTables' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entity' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SortableEntity' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderedIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'entity' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderedIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderedIds' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReorderTablesMutation,
  ReorderTablesMutationVariables
>;
export const ExportTablesCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportTablesCsv' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportTablesCsv' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportTablesCsvQuery,
  ExportTablesCsvQueryVariables
>;
export const TabDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Tab' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tab' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canEditLineItems' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'grandTotal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognizedTotal' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountDiscount' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'amountPaid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountRefunded' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountCanceled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'amountDue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInvoice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exactAccountId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'table' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grandTotal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountDue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'quantity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lineTotal' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountTip' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refunds' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedActions' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TabQuery, TabQueryVariables>;
export const ExactSalesInvoiceForTabDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactSalesInvoiceForTab' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tabId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactSalesInvoiceForTab' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tabId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tabId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'salesJournalCode' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exactInvoiceId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invoiceNumber' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExactSalesInvoiceForTabQuery,
  ExactSalesInvoiceForTabQueryVariables
>;
export const ExportExactInvoiceTabDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportExactInvoiceTab' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tabId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportExactInvoiceTab' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tabId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tabId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invoiceNumber' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportExactInvoiceTabMutation,
  ExportExactInvoiceTabMutationVariables
>;
export const PerformTabActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PerformTabAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'action' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TabAction' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'performTabAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'action' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedActions' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PerformTabActionMutation,
  PerformTabActionMutationVariables
>;
export const UpdateTabDiscountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTabDiscount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTabInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTab' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountDiscount' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'grandTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountDue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canEditLineItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grandTotal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountDue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'quantity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lineTotal' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTabDiscountMutation,
  UpdateTabDiscountMutationVariables
>;
export const DiscountsForTabEditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DiscountsForTabEdit' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'ObjectValue', fields: [] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: { kind: 'BooleanValue', value: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '200' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiscountsForTabEditQuery,
  DiscountsForTabEditQueryVariables
>;
export const UpdateTabOrderItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTabOrderItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tabId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderItemId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'quantity' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTabOrderItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tabId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tabId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderItemId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderItemId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'quantity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'quantity' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canEditLineItems' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'grandTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountPaid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountDue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountDiscount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grandTotal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountDue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'quantity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lineTotal' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTabOrderItemMutation,
  UpdateTabOrderItemMutationVariables
>;
export const RemoveOrderFromTabDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveOrderFromTab' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tabId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeOrderFromTab' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tabId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tabId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canEditLineItems' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'grandTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountPaid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountDue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountDiscount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grandTotal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountDue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'quantity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lineTotal' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveOrderFromTabMutation,
  RemoveOrderFromTabMutationVariables
>;
export const TabsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Tabs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TabFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TabStatusGroup' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TabSort' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tabs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grandTotal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountPaid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountDue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowedActions' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'table' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TabsQuery, TabsQueryVariables>;
export const ExportTabsCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportTabsCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TabFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TabStatusGroup' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TabSort' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportTabsCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportTabsCsvQuery, ExportTabsCsvQueryVariables>;
export const BulkPerformTabActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BulkPerformTabAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'action' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TabAction' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkPerformTabAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'action' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'succeeded' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failed' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BulkPerformTabActionMutation,
  BulkPerformTabActionMutationVariables
>;
export const CreateTabDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTab' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTabInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTab' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInvoice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exactAccountId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTabMutation, CreateTabMutationVariables>;
export const ExactAccountsForTabDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExactAccountsForTab' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exactAccounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExactAccountsForTabQuery,
  ExactAccountsForTabQueryVariables
>;
export const TaxReportDayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaxReportDay' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recognitionDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recognitionDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recognitionDate' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'periodStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'periodEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'salesDays' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'salesIncludingTax' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalLoss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cashTrade' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tips' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxBreakdown' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxPercentage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesExcludingTax' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesIncludingTax' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentMethodBreakdown' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaxReportDayQuery, TaxReportDayQueryVariables>;
export const TaxReportMonthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaxReportMonth' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'month' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'year' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'month' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'month' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'periodStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'periodEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'salesDays' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'salesIncludingTax' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalLoss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cashTrade' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tips' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxBreakdown' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxPercentage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesExcludingTax' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesIncludingTax' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentMethodBreakdown' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaxReportMonthQuery, TaxReportMonthQueryVariables>;
export const TaxReportPeriodsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaxReportPeriods' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxReportPeriods' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recognitionDate' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesIncludingTax' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tips' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'generatedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TaxReportPeriodsQuery,
  TaxReportPeriodsQueryVariables
>;
export const TerminalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Terminal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terminal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'poiid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TerminalQuery, TerminalQueryVariables>;
export const CreateTerminalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTerminal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTerminalInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTerminal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateTerminalMutation,
  CreateTerminalMutationVariables
>;
export const UpdateTerminalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTerminal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTerminalInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTerminal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTerminalMutation,
  UpdateTerminalMutationVariables
>;
export const TerminalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Terminals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TerminalFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeInactive' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortField' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortDir' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terminals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeInactive' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortField' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortField' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDir' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortDir' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poiid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'connected' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'batteryLevel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TerminalsQuery, TerminalsQueryVariables>;
export const SetTerminalsActiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetTerminalsActive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isActive' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setTerminalsActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isActive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isActive' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'succeeded' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failed' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetTerminalsActiveMutation,
  SetTerminalsActiveMutationVariables
>;
export const SyncTerminalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SyncTerminals' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syncTerminals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'added' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poiid' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactivated' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poiid' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deactivated' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poiid' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skippedPoiids' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SyncTerminalsMutation,
  SyncTerminalsMutationVariables
>;
export const ExportTerminalsCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportTerminalsCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TerminalFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeInactive' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortField' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortDir' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportTerminalsCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeInactive' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortField' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortField' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDir' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortDir' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportTerminalsCsvQuery,
  ExportTerminalsCsvQueryVariables
>;
export const TurnoverWeekDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TurnoverWeek' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'week' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'compare' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TurnoverCompare' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'turnoverWeek' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'year' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'week' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'week' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'compare' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'compare' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'week' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'averageValue' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'byDay' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'byPaymentMethod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'byCategory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'today' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountSoFar' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'countSoFar' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'comparisonAmountAtSameTime',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'comparisonCountAtSameTime',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pacePercent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'compareMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'comparisonDay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'count' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tickets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sold' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'scanned' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'comparison' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'week' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'averageValue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'byDay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'count' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TurnoverWeekQuery, TurnoverWeekQueryVariables>;
export const TurnoverAvailableWeeksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TurnoverAvailableWeeks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'turnoverAvailableWeeks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'year' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TurnoverAvailableWeeksQuery,
  TurnoverAvailableWeeksQueryVariables
>;
export const TicketPresaleByDayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TicketPresaleByDay' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ticketPresaleByDay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'series' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TicketPresaleByDayQuery,
  TicketPresaleByDayQueryVariables
>;
export const UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Users' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UserFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortField' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortDir' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortField' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortField' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDir' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortDir' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketingOptIn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passkeyCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastLoginAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultScope' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageSize' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRows' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const UserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'User' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketingOptIn' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketingOptInAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailBouncedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsBalance' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visitCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spendCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tipCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVisitAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roleBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scope' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultScope' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedScopes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'passkeys' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deviceType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUsedAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLoginAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'goldenTicket' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holderName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holderEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileComplete' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateOfBirth' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateOfBirthUpdatedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postalCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pronouns' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'chamberOfCommerce' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vatNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'invoiceEmail' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const UserLoyaltyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserLoyalty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userLoyalty' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsBalance' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visitCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spendCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tipCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVisitAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recentLedger' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'points' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refundId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scope' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vouchers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountPercentage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountAmountCents' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'productName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ruleName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scope' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserLoyaltyQuery, UserLoyaltyQueryVariables>;
export const UserGoldenTicketsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserGoldenTickets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'GoldenTicketFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'goldenTickets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'IntValue', value: '25' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holderName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holderEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileComplete' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserGoldenTicketsQuery,
  UserGoldenTicketsQueryVariables
>;
export const UserRolesCatalogDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserRolesCatalog' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorKind' },
                value: { kind: 'EnumValue', value: 'USER' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserRolesCatalogQuery,
  UserRolesCatalogQueryVariables
>;
export const UserRoleOptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserRoleOptions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userRoleOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserRoleOptionsQuery,
  UserRoleOptionsQueryVariables
>;
export const SetUserRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetUserRoles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bindings' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'RoleBindingInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setUserRoles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bindings' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bindings' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roleBindings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scope' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetUserRolesMutation,
  SetUserRolesMutationVariables
>;
export const CreateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateUserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateOfBirth' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const BlockUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BlockUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blockUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlockUserMutation, BlockUserMutationVariables>;
export const UnblockUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnblockUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unblockUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnblockUserMutation, UnblockUserMutationVariables>;
export const IssueMagicLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IssueMagicLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issueMagicLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qrSvg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IssueMagicLinkMutation,
  IssueMagicLinkMutationVariables
>;
export const AdjustUserPointsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AdjustUserPoints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdjustUserPointsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adjustUserPoints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsBalance' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visitCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spendCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tipCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVisitAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdjustUserPointsMutation,
  AdjustUserPointsMutationVariables
>;
export const AssignGoldenTicketDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignGoldenTicket' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignGoldenTicket' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'note' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'note' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignGoldenTicketMutation,
  AssignGoldenTicketMutationVariables
>;
export const RevokeGoldenTicketDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevokeGoldenTicket' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokeGoldenTicket' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'note' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'note' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'revokedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RevokeGoldenTicketMutation,
  RevokeGoldenTicketMutationVariables
>;
export const CreatePasskeyRegistrationLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePasskeyRegistrationLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPasskeyRegistrationLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qrSvg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePasskeyRegistrationLinkMutation,
  CreatePasskeyRegistrationLinkMutationVariables
>;
export const RevokePasskeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevokePasskey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokePasskey' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'revokedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RevokePasskeyMutation,
  RevokePasskeyMutationVariables
>;
export const LiveUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'LiveUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'scopeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'liveUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scopeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'scopeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentMethod' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountTip' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cardAlias' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refund' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refund' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentMethod' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recognitionDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'order' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tab' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'payment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'terminal' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timestamp' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentStatus' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentMethod' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'grandTotal' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountPaid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountDue' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'allowedActions' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderCreated' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentStatus' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grandTotal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountPaid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountDue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowedActions' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tab' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tab' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'grandTotal' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountPaid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountDue' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'canEditLineItems' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'allowedActions' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showInMenu' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'productCount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tax' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalDiscount30d' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'usageCount30d' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'table' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'device' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'device' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isActive' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'connectionStatus' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'allowedActions' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'askLoyalty' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gratuitySettings' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'enabled' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'terminal' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'terminal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'terminal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'poiid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isActive' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'connected' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'batteryLevel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ledger' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timestamp' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transaction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountReceived' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountTip' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountCashTrade' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'amountRecognizedTotal',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'psp' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentMethod' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recognitionDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'categoryName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deviceName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'categoryId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deviceId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recognitionDay' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'session' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recognitionDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isOpen' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'openedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closedAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entranceInsights' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightTitle' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stageId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sold' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'scanned' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'admitted' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'refused' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stageId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sold' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'scanned' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'admitted' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'refused' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LiveUpdatedSubscription,
  LiveUpdatedSubscriptionVariables
>;
export const PrepareReceiptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PrepareReceipt' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PrepareReceiptInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prepareReceipt' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PrepareReceiptMutation,
  PrepareReceiptMutationVariables
>;
export const CheckEmailAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckEmailAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkEmailAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'deliverable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestion' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckEmailAddressQuery,
  CheckEmailAddressQueryVariables
>;
